/* @formatter:off */
/* tslint:disable */
/* eslint-disable */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ActionPermissionsModelScalar: { input: any; output: any; }
  BigDecimal: { input: number; output: number; }
  CustomResourcePermissionsModelScalar: { input: { [index: string]: { [key in PermissionAction]: VerificationDecisionModel } }; output: { [index: string]: { [key in PermissionAction]: VerificationDecisionModel } }; }
  CustomTimeSeriesValueModelScalar: { input: any; output: any; }
  DeliveredFieldDefinitionsModelScalar: { input: any; output: any; }
  Duration: { input: any; output: any; }
  LocalDate: { input: string; output: string; }
  LocalDateTime: { input: string; output: string; }
  LocalTime: { input: string; output: string; }
  Long: { input: number; output: number; }
  Map_ClassificationTypeModel_IntegerScalar: { input: { [type in ClassificationTypeModel]: number }; output: { [type in ClassificationTypeModel]: number }; }
  Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar: { input: any; output: any; }
  Map_DayOfWeek_DoubleScalar: { input: Record<string, number>; output: Record<string, number>; }
  Map_LocalDate_StringScalar: { input: Record<string, string>; output: Record<string, string>; }
  Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar: { input: any; output: any; }
  Map_String_AmountModelScalar: { input: Record<string, AmountModel>; output: Record<string, AmountModel>; }
  Map_String_IntegerScalar: { input: Record<string, number>; output: Record<string, number>; }
  Map_String_List_StringScalar: { input: Record<string, string[]>; output: Record<string, string[]>; }
  Map_String_ObjectScalar: { input: Record<string, any>; output: Record<string, any>; }
  Map_String_Set_StringScalar: { input: Record<string, any>; output: Record<string, any>; }
  Map_String_StringScalar: { input: Record<string, string>; output: Record<string, string>; }
  Map_String_TenantFeatureModelScalar: { input: Record<string, TenantFeatureModel>; output: Record<string, TenantFeatureModel>; }
  Map_UserRoleModel_IntegerScalar: { input: { [role in UserRoleModel]: number }; output: { [role in UserRoleModel]: number }; }
  OffsetDateTime: { input: string; output: string; }
  PermissionsModelScalar: { input: { [name in PermissionName]: { [action in PermissionAction]: VerificationDecisionModel } }; output: { [name in PermissionName]: { [action in PermissionAction]: VerificationDecisionModel } }; }
  URI: { input: any; output: any; }
};

export enum AccumulationPeriodModel {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export type ActiveWorkersChartModel = {
  __typename?: 'ActiveWorkersChartModel';
  accumulation?: Maybe<AccumulationPeriodModel>;
  data?: Maybe<Array<Maybe<ActiveWorkersModel>>>;
  range?: Maybe<DateRangeModel>;
};

export type ActiveWorkersModel = {
  __typename?: 'ActiveWorkersModel';
  activeCount: Scalars['Int']['output'];
  date?: Maybe<Scalars['LocalDate']['output']>;
};

export type AddressGeolocationModel = {
  __typename?: 'AddressGeolocationModel';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
};

export type AddressGeolocationModelInput = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLineModel = {
  __typename?: 'AddressLineModel';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AddressLineModelInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AddressModel = {
  __typename?: 'AddressModel';
  countryCode?: Maybe<Scalars['String']['output']>;
  geolocation?: Maybe<AddressGeolocationModel>;
  lines?: Maybe<Array<Maybe<AddressLineModel>>>;
  municipality?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  subMunicipality?: Maybe<Scalars['String']['output']>;
  subRegion?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type AddressModelInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geolocation?: InputMaybe<AddressGeolocationModelInput>;
  lines?: InputMaybe<Array<InputMaybe<AddressLineModelInput>>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  subMunicipality?: InputMaybe<Scalars['String']['input']>;
  subRegion?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AllInvoicesQueryModelInput = {
  approvalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  approvalDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  includeBatchInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  includeLineItems?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatusModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AllocationActionModel {
  Add = 'ADD',
  Delete = 'DELETE',
  Replace = 'REPLACE'
}

export type AllocationModel = {
  __typename?: 'AllocationModel';
  allocationCode?: Maybe<UidNameModel>;
  amount?: Maybe<AmountModel>;
  clientInvoice?: Maybe<Scalars['Float']['output']>;
  clockInTime?: Maybe<Scalars['LocalTime']['output']>;
  clockOutTime?: Maybe<Scalars['LocalTime']['output']>;
  costCenter?: Maybe<UidNameModel>;
  costCenterCode?: Maybe<Scalars['String']['output']>;
  costCenterName?: Maybe<Scalars['String']['output']>;
  costCenterReferenceId?: Maybe<Scalars['String']['output']>;
  costCenterUid?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  feesBreakdown?: Maybe<Scalars['Map_String_AmountModelScalar']['output']>;
  financialObjects?: Maybe<Array<Maybe<FinancialObjectModel>>>;
  hours?: Maybe<Scalars['Float']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationRefId?: Maybe<Scalars['String']['output']>;
  previousAllocationReferenceCode?: Maybe<Scalars['String']['output']>;
  projectTaskName?: Maybe<Scalars['String']['output']>;
  projectTaskRefId?: Maybe<Scalars['String']['output']>;
  ratePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ruleReference?: Maybe<RuleReferenceModel>;
  seconds?: Maybe<Scalars['Long']['output']>;
  supplierAmount?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxesBreakdown?: Maybe<Scalars['Map_String_AmountModelScalar']['output']>;
  timeCode?: Maybe<TimeCodeModel>;
  timeEntryType?: Maybe<TimeEntryTypeModel>;
  units?: Maybe<Scalars['Float']['output']>;
};

export type AllocationModelInput = {
  allocationCode?: InputMaybe<UidNameModelInput>;
  amount?: InputMaybe<AmountModelInput>;
  clientInvoice?: InputMaybe<Scalars['Float']['input']>;
  clockInTime?: InputMaybe<Scalars['LocalTime']['input']>;
  clockOutTime?: InputMaybe<Scalars['LocalTime']['input']>;
  costCenter?: InputMaybe<UidNameModelInput>;
  costCenterCode?: InputMaybe<Scalars['String']['input']>;
  costCenterName?: InputMaybe<Scalars['String']['input']>;
  costCenterReferenceId?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Scalars['Float']['input']>;
  feesBreakdown?: InputMaybe<Scalars['Map_String_AmountModelScalar']['input']>;
  financialObjects?: InputMaybe<Array<InputMaybe<FinancialObjectModelInput>>>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  locationRefId?: InputMaybe<Scalars['String']['input']>;
  previousAllocationReferenceCode?: InputMaybe<Scalars['String']['input']>;
  projectTaskName?: InputMaybe<Scalars['String']['input']>;
  projectTaskRefId?: InputMaybe<Scalars['String']['input']>;
  ratePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ruleReference?: InputMaybe<RuleReferenceModelInput>;
  seconds?: InputMaybe<Scalars['Long']['input']>;
  supplierAmount?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  taxesBreakdown?: InputMaybe<Scalars['Map_String_AmountModelScalar']['input']>;
  timeCode?: InputMaybe<TimeCodeModelInput>;
  timeEntryType?: InputMaybe<TimeEntryTypeModel>;
  units?: InputMaybe<Scalars['Float']['input']>;
};

export type AllocationPatchModelInput = {
  costCenterReferenceId?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  referenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AllowedRelationshipModel {
  AccountablePersonOf = 'ACCOUNTABLE_PERSON_OF',
  Creator = 'CREATOR',
  InOrgWith = 'IN_ORG_WITH',
  ManagerOf = 'MANAGER_OF',
  MspFor = 'MSP_FOR',
  PrimaryManagerOf = 'PRIMARY_MANAGER_OF',
  ProjectController = 'PROJECT_CONTROLLER',
  ProjectManager = 'PROJECT_MANAGER',
  Role = 'ROLE',
  Self = 'SELF',
  SupplierFor = 'SUPPLIER_FOR',
  TaskAssigneeFor = 'TASK_ASSIGNEE_FOR'
}

export type AmountModel = {
  __typename?: 'AmountModel';
  currency?: Maybe<CurrencyModel>;
  feesType?: Maybe<FeesTypeModel>;
  rateAmount?: Maybe<Scalars['Float']['output']>;
  rateCode?: Maybe<Scalars['String']['output']>;
  rateFrequency?: Maybe<RatePeriodModel>;
  value: Scalars['Float']['output'];
};

export type AmountModelInput = {
  currency?: InputMaybe<CurrencyModelInput>;
  feesType?: InputMaybe<FeesTypeModel>;
  rateAmount?: InputMaybe<Scalars['Float']['input']>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
  rateFrequency?: InputMaybe<RatePeriodModel>;
  value: Scalars['Float']['input'];
};

export type AnalyticsCloudDashboardModel = {
  __typename?: 'AnalyticsCloudDashboardModel';
  arn?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  dashboardId?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['OffsetDateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsCloudDashboardsModel = {
  __typename?: 'AnalyticsCloudDashboardsModel';
  items?: Maybe<Array<Maybe<AnalyticsCloudDashboardModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsCloudDashboardsQueryModelInput = {
  includeNotYetPublished: Scalars['Boolean']['input'];
};

export type AnalyticsDashboardCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  roles?: InputMaybe<Array<InputMaybe<AnalyticsDashboardRolesMappingModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<AnalyticsDashboardUserMappingModelInput>>>;
};

export type AnalyticsDashboardModel = {
  __typename?: 'AnalyticsDashboardModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  dashboardId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  roles?: Maybe<Array<Maybe<AnalyticsDashboardRolesMappingModel>>>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  users?: Maybe<Array<Maybe<AnalyticsDashboardUserMappingModel>>>;
};


export type AnalyticsDashboardModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsDashboardPatchModelInput = {
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<AnalyticsDashboardRolesMappingModelInput>>>;
  users?: InputMaybe<Array<InputMaybe<AnalyticsDashboardUserMappingModelInput>>>;
};

export type AnalyticsDashboardRolesMappingModel = {
  __typename?: 'AnalyticsDashboardRolesMappingModel';
  arns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<RoleModel>;
  type?: Maybe<AnalyticsDashboardUserMappingType>;
};

export type AnalyticsDashboardRolesMappingModelInput = {
  arns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<RoleModelInput>;
  type?: InputMaybe<AnalyticsDashboardUserMappingType>;
};

export type AnalyticsDashboardUserMappingModel = {
  __typename?: 'AnalyticsDashboardUserMappingModel';
  arns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<AnalyticsDashboardUserMappingType>;
  user?: Maybe<PersonModel>;
};

export type AnalyticsDashboardUserMappingModelInput = {
  arns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<AnalyticsDashboardUserMappingType>;
  user?: InputMaybe<PersonModelInput>;
};

export enum AnalyticsDashboardUserMappingType {
  AnonymousUser = 'ANONYMOUS_USER',
  RegisteredUser = 'REGISTERED_USER'
}

export type AnalyticsDashboardsModel = {
  __typename?: 'AnalyticsDashboardsModel';
  items?: Maybe<Array<Maybe<AnalyticsDashboardModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardsQueryModelInput = {
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type AnomaliesTotalCountModel = {
  __typename?: 'AnomaliesTotalCountModel';
  advisoryTotal: Scalars['Long']['output'];
  criticalTotal: Scalars['Long']['output'];
  total: Scalars['Long']['output'];
  warningTotal: Scalars['Long']['output'];
};

export type AnomalyDefinitionCreateModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdBy?: InputMaybe<PersonModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  severity?: InputMaybe<AnomalySeverityModel>;
  status?: InputMaybe<AnomalyDefinitionStatusModel>;
  tagInstances?: InputMaybe<Array<InputMaybe<TagInstanceAssignmentModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AnomalyDefinitionModel = {
  __typename?: 'AnomalyDefinitionModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  createdBy?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  severity?: Maybe<AnomalySeverityModel>;
  status?: Maybe<AnomalyDefinitionStatusModel>;
  tagInstances?: Maybe<Array<Maybe<TagInstanceModel>>>;
  uid: Scalars['String']['output'];
};


export type AnomalyDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnomalyDefinitionModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdBy?: InputMaybe<PersonModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  severity?: InputMaybe<AnomalySeverityModel>;
  status?: InputMaybe<AnomalyDefinitionStatusModel>;
  tagInstances?: InputMaybe<Array<InputMaybe<TagInstanceModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum AnomalyDefinitionStatusModel {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Hidden = 'HIDDEN'
}

export type AnomalyDefinitionUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  severity?: InputMaybe<AnomalySeverityModel>;
  status?: InputMaybe<AnomalyDefinitionStatusModel>;
  tagInstances?: InputMaybe<Array<InputMaybe<TagInstanceAssignmentModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AnomalyDefinitionsModel = {
  __typename?: 'AnomalyDefinitionsModel';
  definitions?: Maybe<Array<Maybe<AnomalyDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnomalyModel = {
  __typename?: 'AnomalyModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  definition?: Maybe<AnomalyDefinitionModel>;
  detectedTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  engagement?: Maybe<EngagementModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
};


export type AnomalyModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnomalyModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  definition?: InputMaybe<AnomalyDefinitionModelInput>;
  detectedTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  engagement?: InputMaybe<EngagementModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AnomalyPageModel = {
  __typename?: 'AnomalyPageModel';
  items?: Maybe<Array<Maybe<AnomalyModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnomalyQueryModelInput = {
  anomalyDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  detectedDates?: InputMaybe<TimestampRangeModelInput>;
  detectedRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  severities?: InputMaybe<Array<InputMaybe<AnomalySeverityModel>>>;
  subjectUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AnomalySeverityModel {
  Advisory = 'ADVISORY',
  Critical = 'CRITICAL',
  None = 'NONE',
  Warning = 'WARNING'
}

export type AnomalySortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<AnomalySortTypeModel>;
};

export enum AnomalySortTypeModel {
  DetectedTime = 'DETECTED_TIME'
}

export type AppendixRequestModel = {
  __typename?: 'AppendixRequestModel';
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type AppendixRequestModelInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type ApprovalLimitModel = {
  __typename?: 'ApprovalLimitModel';
  amount?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<ObjectTypeModel>;
};

export type ApprovalLimitModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<ObjectTypeModel>;
};

export type ApprovalModel = {
  __typename?: 'ApprovalModel';
  approvalDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  approver?: Maybe<PersonModel>;
  comment?: Maybe<Scalars['String']['output']>;
  systemGenerated: Scalars['Boolean']['output'];
};

export type ApprovalModelInput = {
  approvalDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  approver?: InputMaybe<PersonModelInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  systemGenerated: Scalars['Boolean']['input'];
};

export type AssigneeModel = {
  __typename?: 'AssigneeModel';
  workerId?: Maybe<Scalars['String']['output']>;
};

export type AssigneeModelInput = {
  workerId?: InputMaybe<Scalars['String']['input']>;
};

export enum AssigneeTypeModel {
  AccountablePerson = 'ACCOUNTABLE_PERSON',
  ExternalApprover = 'EXTERNAL_APPROVER',
  FifthLevelManager = 'FIFTH_LEVEL_MANAGER',
  FirstLevelManager = 'FIRST_LEVEL_MANAGER',
  FourthLevelManager = 'FOURTH_LEVEL_MANAGER',
  ProcessInitiator = 'PROCESS_INITIATOR',
  ProjectController = 'PROJECT_CONTROLLER',
  ProjectManager = 'PROJECT_MANAGER',
  Role = 'ROLE',
  SecondLevelManager = 'SECOND_LEVEL_MANAGER',
  ThirdLevelManager = 'THIRD_LEVEL_MANAGER'
}

export type AssignmentConfigurationModel = {
  __typename?: 'AssignmentConfigurationModel';
  externalAccessDuration?: Maybe<Scalars['String']['output']>;
  externalApproverType?: Maybe<ExternalApproverTypeModel>;
  roleUid?: Maybe<Scalars['String']['output']>;
  roleUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<AssigneeTypeModel>;
  types?: Maybe<Array<Maybe<AssigneeTypeModel>>>;
};

export type AssignmentConfigurationModelInput = {
  externalAccessDuration?: InputMaybe<Scalars['String']['input']>;
  externalApproverType?: InputMaybe<ExternalApproverTypeModel>;
  roleUid?: InputMaybe<Scalars['String']['input']>;
  roleUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<AssigneeTypeModel>;
  types?: InputMaybe<Array<InputMaybe<AssigneeTypeModel>>>;
};

export type AuditReportInfoModel = {
  __typename?: 'AuditReportInfoModel';
  dataRange?: Maybe<DateRangeModel>;
};

export type AuditReportMetadataModel = {
  __typename?: 'AuditReportMetadataModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creatorUid?: Maybe<Scalars['String']['output']>;
  info?: Maybe<AuditReportInfoModel>;
  status?: Maybe<AuditReportStatusModel>;
  targetEntity?: Maybe<AuditReportTargetEntityModel>;
  uid: Scalars['String']['output'];
};

export type AuditReportMetadataModels = {
  __typename?: 'AuditReportMetadataModels';
  reports?: Maybe<Array<Maybe<AuditReportMetadataModel>>>;
};

export enum AuditReportStatusModel {
  FinishedError = 'FINISHED_ERROR',
  FinishedSuccess = 'FINISHED_SUCCESS',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export enum AuditReportTargetEntityModel {
  CostCenter = 'COST_CENTER',
  CustomField = 'CUSTOM_FIELD',
  CustomFieldDefinition = 'CUSTOM_FIELD_DEFINITION',
  CustomFieldDefinitionGroup = 'CUSTOM_FIELD_DEFINITION_GROUP',
  CustomObjects = 'CUSTOM_OBJECTS',
  CustomObjectDefinition = 'CUSTOM_OBJECT_DEFINITION',
  Engagement = 'ENGAGEMENT',
  FinancialField = 'FINANCIAL_FIELD',
  HolidaySchedule = 'HOLIDAY_SCHEDULE',
  Invoice = 'INVOICE',
  Payment = 'PAYMENT',
  Person = 'PERSON',
  PolicyRule = 'POLICY_RULE',
  Rate = 'RATE',
  Role = 'ROLE',
  Supplier = 'SUPPLIER',
  TimesheetSettings = 'TIMESHEET_SETTINGS',
  TimeCode = 'TIME_CODE',
  User = 'USER',
  WorkRequest = 'WORK_REQUEST',
  WorkSchedule = 'WORK_SCHEDULE'
}

export type AvailableCostCenterModel = {
  __typename?: 'AvailableCostCenterModel';
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type AvailableCostCenterModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AvailableValueModel = {
  __typename?: 'AvailableValueModel';
  label?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type AvailableValueModelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type BaseEngagementDiagnosticsModel = {
  __typename?: 'BaseEngagementDiagnosticsModel';
  badgeId?: Maybe<Scalars['String']['output']>;
  classificationUid?: Maybe<Scalars['String']['output']>;
  companyUid?: Maybe<Scalars['String']['output']>;
  costCenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  engagementId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  jobProfileUid?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationModel>;
  locationUid?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  offboarded?: Maybe<Scalars['OffsetDateTime']['output']>;
  originalStartDate?: Maybe<Scalars['LocalDate']['output']>;
  personUid?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierWorkerId?: Maybe<Scalars['String']['output']>;
  terminationReasonUid?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  workEmail?: Maybe<Scalars['String']['output']>;
  workPhones?: Maybe<Array<Maybe<PhoneNumberModel>>>;
};

export type BaseOrgMembershipDiagnosticsModel = {
  __typename?: 'BaseOrgMembershipDiagnosticsModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  memberPersonUid?: Maybe<Scalars['String']['output']>;
  memberUid?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  orgUid?: Maybe<Scalars['String']['output']>;
  /** @deprecated always true */
  primaryOrg?: Maybe<Scalars['Boolean']['output']>;
  workdaySyncStatus?: Maybe<Scalars['String']['output']>;
};

export type BasePersonFacetDiagnosticsModel = {
  __typename?: 'BasePersonFacetDiagnosticsModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  emergencyContacts?: Maybe<Array<Maybe<EmergencyContactModel>>>;
  id?: Maybe<Scalars['Long']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  personUid?: Maybe<Scalars['String']['output']>;
  profileMediaUid?: Maybe<Scalars['String']['output']>;
  rehireEligibility?: Maybe<Scalars['String']['output']>;
  revisions?: Maybe<Array<Maybe<PersonFacetsRevisionsDiagnosticsModel>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  workerDuplicates?: Maybe<Array<Maybe<WorkerDuplicateModel>>>;
};

export type BatchDefinitionFilterModel = {
  __typename?: 'BatchDefinitionFilterModel';
  fieldType?: Maybe<FilterFieldTypeModel>;
  key?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  multivalued: Scalars['Boolean']['output'];
};

export type BatchDefinitionFiltersModel = {
  __typename?: 'BatchDefinitionFiltersModel';
  items?: Maybe<Array<Maybe<BatchDefinitionFilterModel>>>;
};

export type BatchInvoiceModel = {
  __typename?: 'BatchInvoiceModel';
  attachments?: Maybe<Array<Maybe<InvoiceAttachmentModel>>>;
  batchDefinitionUid?: Maybe<Scalars['String']['output']>;
  batchExecutionStatus?: Maybe<InvoicingExecutionStatusModel>;
  batchName?: Maybe<Scalars['String']['output']>;
  blueprintExecutionUid?: Maybe<Scalars['String']['output']>;
  clientAmount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  invoiceStatus?: Maybe<BatchInvoiceStatusModel>;
  reportDownloadLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use batchExecutionStatus instead */
  status?: Maybe<InvoicingExecutionStatusModel>;
  submittedAt?: Maybe<Scalars['String']['output']>;
  submittedByEmail?: Maybe<Scalars['String']['output']>;
  submittedByName?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierAmount?: Maybe<Scalars['Float']['output']>;
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  supplierUid?: Maybe<Scalars['String']['output']>;
  taeInvoiceUid?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  uid: Scalars['String']['output'];
};


export type BatchInvoiceModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export enum BatchInvoiceStatusModel {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export enum BatchScopeModel {
  Dynamic = 'DYNAMIC',
  Specific = 'SPECIFIC'
}

export type BillingConfigurationModel = {
  __typename?: 'BillingConfigurationModel';
  factors?: Maybe<Array<Maybe<FactorBillingVariableModel>>>;
  rates?: Maybe<Array<Maybe<RateBillingVariableModel>>>;
};

export type BillingConfigurationQueryModelInput = {
  excludeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingVariableModel = {
  __typename?: 'BillingVariableModel';
  code?: Maybe<Scalars['String']['output']>;
  feesType?: Maybe<FeesTypeModel>;
  name?: Maybe<Scalars['String']['output']>;
  payBillRateType?: Maybe<PayBillRateTypeModel>;
  rateType?: Maybe<RateTypeModel>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BillingVariableModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  feesType?: InputMaybe<FeesTypeModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  payBillRateType?: InputMaybe<PayBillRateTypeModel>;
  rateType?: InputMaybe<RateTypeModel>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BillingVariableUpdateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  feesType?: InputMaybe<FeesTypeModel>;
  payBillRateType?: InputMaybe<PayBillRateTypeModel>;
  rateType?: InputMaybe<RateTypeModel>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BlueprintInvoiceModel = {
  __typename?: 'BlueprintInvoiceModel';
  batches?: Maybe<Array<Maybe<BatchInvoiceModel>>>;
  batchesCount?: Maybe<Scalars['Int']['output']>;
  billingPeriodEndDate?: Maybe<Scalars['LocalDate']['output']>;
  blueprintDefinition?: Maybe<InvoicingBlueprintDefinitionModel>;
  blueprintDefinitionUid?: Maybe<Scalars['String']['output']>;
  blueprintDefinitionVersion: Scalars['Int']['output'];
  blueprintName?: Maybe<Scalars['String']['output']>;
  clientAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  currency?: Maybe<Scalars['String']['output']>;
  executionMode?: Maybe<InvoicingBlueprintExecutionModeModel>;
  executionTriggerType?: Maybe<InvoicingBlueprintExecutionTriggerTypeModel>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  reportDownloadLink?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InvoicingExecutionStatusModel>;
  supplierAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  uid: Scalars['String']['output'];
};

export type BlueprintInvoicePageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Long']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<BlueprintInvoiceSortModelInput>>>;
};

export type BlueprintInvoiceQueryModelInput = {
  billingPeriodEndDateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  billingPeriodEndDateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  blueprintDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creatorUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  executionMode?: InputMaybe<InvoicingBlueprintExecutionModeModel>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<InvoicingExecutionStatusModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlueprintInvoiceSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<BlueprintInvoiceSortTypeModel>;
};

export enum BlueprintInvoiceSortTypeModel {
  BillingPeriodEndDate = 'BILLING_PERIOD_END_DATE',
  CreatedAt = 'CREATED_AT'
}

export type BlueprintInvoicesModel = {
  __typename?: 'BlueprintInvoicesModel';
  elements?: Maybe<Array<Maybe<BlueprintInvoiceModel>>>;
  items?: Maybe<Array<Maybe<BlueprintInvoiceModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BooleanFilterModelInput = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<Scalars['Boolean']['input']>;
  notIncludes?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type BpmnShapeModel = {
  __typename?: 'BpmnShapeModel';
  elementId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type BpmnShapeModelInput = {
  elementId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export enum BriefingItemCategory {
  Compliance = 'COMPLIANCE',
  Offboarding = 'OFFBOARDING',
  Onboarding = 'ONBOARDING',
  Other = 'OTHER',
  Process = 'PROCESS',
  System = 'SYSTEM',
  Task = 'TASK'
}

export type BriefingReference = {
  __typename?: 'BriefingReference';
  personUid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BriefingReferenceType>;
  uid: Scalars['String']['output'];
};

export enum BriefingReferenceType {
  Contract = 'CONTRACT',
  Engagement = 'ENGAGEMENT',
  JobApplication = 'JOB_APPLICATION',
  JobPosting = 'JOB_POSTING',
  Milestone = 'MILESTONE',
  Person = 'PERSON',
  Process = 'PROCESS',
  Supplier = 'SUPPLIER',
  System = 'SYSTEM',
  Task = 'TASK',
  WorkRequest = 'WORK_REQUEST'
}

export enum BriefingSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type BudgetAmountModel = {
  __typename?: 'BudgetAmountModel';
  amount?: Maybe<Scalars['Float']['output']>;
  breakdown?: Maybe<Array<Maybe<BudgetBreakdownModel>>>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BudgetBreakdownModel = {
  __typename?: 'BudgetBreakdownModel';
  amount: Scalars['Float']['output'];
  rate?: Maybe<ComplexRateModel>;
  type?: Maybe<BudgetBreakdownTypeModel>;
};

export enum BudgetBreakdownTypeModel {
  AdditionalCost = 'ADDITIONAL_COST',
  Base = 'BASE',
  Fee = 'FEE',
  Tax = 'TAX'
}

export type BudgetCalculationModelInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  feesRates?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  holidayScheduleUid?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<ComplexRateModelInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  taxRates?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  workScheduleUid?: InputMaybe<Scalars['String']['input']>;
};

export type BudgetModel = {
  __typename?: 'BudgetModel';
  /** @deprecated Use newApprovedAmount instead */
  amount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use originalAmount instead */
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  approvedCalculationDetails?: Maybe<CalculationDetailsModel>;
  calculationDetails?: Maybe<CalculationDetailsModel>;
  currency?: Maybe<Scalars['String']['output']>;
  newApprovedAmount?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
};

export type BudgetModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approvedAmount?: InputMaybe<Scalars['Float']['input']>;
  approvedCalculationDetails?: InputMaybe<CalculationDetailsModelInput>;
  calculationDetails?: InputMaybe<CalculationDetailsModelInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  newApprovedAmount?: InputMaybe<Scalars['Float']['input']>;
  originalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type BulkRoleAssignmentsModel = {
  __typename?: 'BulkRoleAssignmentsModel';
  roleAssignments?: Maybe<Array<Maybe<RoleAssignmentModel>>>;
};

export type BulkSmsSendReportModel = {
  __typename?: 'BulkSmsSendReportModel';
  invalidPhoneNumber: Scalars['Int']['output'];
  noPhoneNumber: Scalars['Int']['output'];
  sentSuccessfully: Scalars['Int']['output'];
  totalTargetted: Scalars['Int']['output'];
};

export enum BusinessEventEntityTypeModel {
  Engagement = 'ENGAGEMENT',
  Expense = 'EXPENSE',
  JobApplication = 'JOB_APPLICATION',
  JobPosting = 'JOB_POSTING',
  Timesheet = 'TIMESHEET',
  WorkRequest = 'WORK_REQUEST'
}

export enum BusinessEventFieldKeyModel {
  EngagementStatus = 'ENGAGEMENT_STATUS',
  EngagementSupervisoryOrg = 'ENGAGEMENT_SUPERVISORY_ORG',
  ExpenseStatus = 'EXPENSE_STATUS',
  JobApplicationStage = 'JOB_APPLICATION_STAGE',
  JobApplicationStatus = 'JOB_APPLICATION_STATUS',
  JobPostingStatus = 'JOB_POSTING_STATUS',
  TimesheetStatus = 'TIMESHEET_STATUS',
  WorkRequestStatus = 'WORK_REQUEST_STATUS'
}

export type BusinessEventFieldModel = {
  __typename?: 'BusinessEventFieldModel';
  fieldKey?: Maybe<BusinessEventFieldKeyModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BusinessEventModel = {
  __typename?: 'BusinessEventModel';
  actor?: Maybe<PersonModel>;
  comment?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  engagement?: Maybe<EngagementModel>;
  entityFields?: Maybe<Array<Maybe<BusinessEventFieldModel>>>;
  entityType?: Maybe<BusinessEventEntityTypeModel>;
  entityUid?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<ExpenseModel>;
  jobApplication?: Maybe<JobApplicationModel>;
  jobPosting?: Maybe<WorkPostingModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  previousEntityFields?: Maybe<Array<Maybe<BusinessEventFieldModel>>>;
  reason?: Maybe<BusinessEventReasonModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  timesheet?: Maybe<TimesheetModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  type?: Maybe<BusinessEventTypeModel>;
  uid: Scalars['String']['output'];
  workRequest?: Maybe<WorkRequestModel>;
};


export type BusinessEventModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BusinessEventModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type BusinessEventReasonCreateModelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<SentimentModel>;
  type?: InputMaybe<BusinessEventTypeModel>;
};

export type BusinessEventReasonModel = {
  __typename?: 'BusinessEventReasonModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<BusinessEventEntityTypeModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<SentimentModel>;
  status?: Maybe<StatusModel>;
  type?: Maybe<BusinessEventTypeModel>;
  uid: Scalars['String']['output'];
};


export type BusinessEventReasonModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessEventReasonModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<BusinessEventEntityTypeModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<SentimentModel>;
  status?: InputMaybe<StatusModel>;
  type?: InputMaybe<BusinessEventTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessEventReasonUpdateModelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<SentimentModel>;
};

export type BusinessEventReasonsModel = {
  __typename?: 'BusinessEventReasonsModel';
  items?: Maybe<Array<Maybe<BusinessEventReasonModel>>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BusinessEventReasonsQueryModelInput = {
  entityTypes?: InputMaybe<Array<InputMaybe<BusinessEventEntityTypeModel>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
  types?: InputMaybe<Array<InputMaybe<BusinessEventTypeModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum BusinessEventTypeModel {
  EngagementOffboarded = 'ENGAGEMENT_OFFBOARDED',
  EngagementOnboarded = 'ENGAGEMENT_ONBOARDED',
  EngagementOrganizationChanged = 'ENGAGEMENT_ORGANIZATION_CHANGED',
  ExpenseApproved = 'EXPENSE_APPROVED',
  ExpenseRejected = 'EXPENSE_REJECTED',
  ExpenseSubmitted = 'EXPENSE_SUBMITTED',
  JobApplicationApproved = 'JOB_APPLICATION_APPROVED',
  JobApplicationCreated = 'JOB_APPLICATION_CREATED',
  JobApplicationRejected = 'JOB_APPLICATION_REJECTED',
  JobApplicationStageChanged = 'JOB_APPLICATION_STAGE_CHANGED',
  JobPostingCancelled = 'JOB_POSTING_CANCELLED',
  JobPostingDistributedToSupplier = 'JOB_POSTING_DISTRIBUTED_TO_SUPPLIER',
  JobPostingFilled = 'JOB_POSTING_FILLED',
  JobPostingPaused = 'JOB_POSTING_PAUSED',
  JobPostingPositionFilled = 'JOB_POSTING_POSITION_FILLED',
  JobPostingResumed = 'JOB_POSTING_RESUMED',
  TimesheetApproved = 'TIMESHEET_APPROVED',
  TimesheetRejected = 'TIMESHEET_REJECTED',
  TimesheetSubmitted = 'TIMESHEET_SUBMITTED',
  WorkRequestApproved = 'WORK_REQUEST_APPROVED',
  WorkRequestCancelled = 'WORK_REQUEST_CANCELLED',
  WorkRequestFilled = 'WORK_REQUEST_FILLED',
  WorkRequestRejected = 'WORK_REQUEST_REJECTED'
}

export type BusinessEventsModel = {
  __typename?: 'BusinessEventsModel';
  items?: Maybe<Array<Maybe<BusinessEventModel>>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BusinessEventsQueryModelInput = {
  entityType?: InputMaybe<BusinessEventEntityTypeModel>;
  entityUid?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  type?: InputMaybe<BusinessEventTypeModel>;
};

export type BusinessSiteCitiesModel = {
  __typename?: 'BusinessSiteCitiesModel';
  cities?: Maybe<Array<Maybe<BusinessSiteCityModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BusinessSiteCityModel = {
  __typename?: 'BusinessSiteCityModel';
  name?: Maybe<Scalars['String']['output']>;
};

export type BusinessSiteRegionModel = {
  __typename?: 'BusinessSiteRegionModel';
  name?: Maybe<Scalars['String']['output']>;
};

export type BusinessSiteRegionsModel = {
  __typename?: 'BusinessSiteRegionsModel';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  regions?: Maybe<Array<Maybe<BusinessSiteRegionModel>>>;
  totalCount: Scalars['Int']['output'];
};

export type CalculationDetailsModel = {
  __typename?: 'CalculationDetailsModel';
  changedBy?: Maybe<PersonModel>;
  changes?: Maybe<CalculationParamsModel>;
  engagementBudgetModifier?: Maybe<PersonModel>;
  issues?: Maybe<Array<Maybe<CalculationIssueModel>>>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type CalculationDetailsModelInput = {
  changedBy?: InputMaybe<PersonModelInput>;
  changes?: InputMaybe<CalculationParamsModelInput>;
  issues?: InputMaybe<Array<InputMaybe<CalculationIssueModel>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export enum CalculationIssueModel {
  MissingBillRate = 'MISSING_BILL_RATE',
  MissingEndDate = 'MISSING_END_DATE',
  MissingEngagementEndDate = 'MISSING_ENGAGEMENT_END_DATE',
  MissingEngagementStartDate = 'MISSING_ENGAGEMENT_START_DATE',
  MissingStartDate = 'MISSING_START_DATE',
  MissingWorkScheduleWorkHours = 'MISSING_WORK_SCHEDULE_WORK_HOURS',
  OnInvoiceRateFrequencyIsNotSupported = 'ON_INVOICE_RATE_FREQUENCY_IS_NOT_SUPPORTED'
}

export type CalculationModel = {
  __typename?: 'CalculationModel';
  evaluationType?: Maybe<CustomFieldDefinitionEvaluationTypeModel>;
  expression?: Maybe<Scalars['String']['output']>;
};

export type CalculationModelInput = {
  evaluationType?: InputMaybe<CustomFieldDefinitionEvaluationTypeModel>;
  expression?: InputMaybe<Scalars['String']['input']>;
};

export type CalculationParamsModel = {
  __typename?: 'CalculationParamsModel';
  dayWorkingHours?: Maybe<Scalars['Map_DayOfWeek_DoubleScalar']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /** @deprecated 'engagementEndDate' is deprecated, use 'endDate' */
  engagementEndDate?: Maybe<Scalars['LocalDate']['output']>;
  /** @deprecated 'engagementStartDate' is deprecated, use 'startDate' */
  engagementStartDate?: Maybe<Scalars['LocalDate']['output']>;
  estimatedAdditionalCosts?: Maybe<Scalars['Float']['output']>;
  feesRates?: Maybe<Array<Maybe<ComplexRateModel>>>;
  holidays?: Maybe<Scalars['Map_LocalDate_StringScalar']['output']>;
  rate?: Maybe<ComplexRateModel>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  taxRates?: Maybe<Array<Maybe<ComplexRateModel>>>;
};

export type CalculationParamsModelInput = {
  dayWorkingHours?: InputMaybe<Scalars['Map_DayOfWeek_DoubleScalar']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagementEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagementStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  feesRates?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  holidays?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  rate?: InputMaybe<ComplexRateModelInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  taxRates?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
};

export type CellLayoutModel = {
  __typename?: 'CellLayoutModel';
  fixedPosition?: Maybe<Scalars['Boolean']['output']>;
  h?: Maybe<Scalars['Float']['output']>;
  maxHeight?: Maybe<Scalars['Float']['output']>;
  maxWidth?: Maybe<Scalars['Float']['output']>;
  minHeight?: Maybe<Scalars['Float']['output']>;
  minWidth?: Maybe<Scalars['Float']['output']>;
  w?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type CellLayoutModelInput = {
  fixedPosition?: InputMaybe<Scalars['Boolean']['input']>;
  h?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  maxWidth?: InputMaybe<Scalars['Float']['input']>;
  minHeight?: InputMaybe<Scalars['Float']['input']>;
  minWidth?: InputMaybe<Scalars['Float']['input']>;
  w?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type CertificationCreateModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type CertificationModel = EligibilityRequirementModel & {
  __typename?: 'CertificationModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  jobProfileEligibilityRequirement?: Maybe<Array<Maybe<JobProfileEligibilityRequirementModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  regionCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type CertificationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificationModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type CertificationsModel = {
  __typename?: 'CertificationsModel';
  items?: Maybe<Array<Maybe<CertificationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ChangeRequestModel = {
  __typename?: 'ChangeRequestModel';
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type ChangeRequestModelInput = {
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type ChangeSetModel = {
  __typename?: 'ChangeSetModel';
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  person?: Maybe<PersonModel>;
  process?: Maybe<ProcessModel>;
  requester?: Maybe<PersonModel>;
  startEventType?: Maybe<StartEventTypeModel>;
  status?: Maybe<ChangeSetStatusModel>;
  uid: Scalars['String']['output'];
};

export type ChangeSetModelInput = {
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  process?: InputMaybe<ProcessModelInput>;
  requester?: InputMaybe<PersonModelInput>;
  startEventType?: InputMaybe<StartEventTypeModel>;
  status?: InputMaybe<ChangeSetStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeSetPatchModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum ChangeSetStatusModel {
  Approved = 'APPROVED',
  Committed = 'COMMITTED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ChangeSetsModel = {
  __typename?: 'ChangeSetsModel';
  items?: Maybe<Array<Maybe<ChangeSetModel>>>;
};

export type ChartModel = {
  __typename?: 'ChartModel';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ChartSourceModel>;
  type?: Maybe<ChartTypeModel>;
};

export type ChartModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ChartSourceModel>;
  type?: InputMaybe<ChartTypeModel>;
};

export enum ChartSourceModel {
  JobRequests = 'JOB_REQUESTS',
  Orgs = 'ORGS',
  Payments = 'PAYMENTS',
  People = 'PEOPLE',
  Suppliers = 'SUPPLIERS'
}

export enum ChartTypeModel {
  Donut = 'DONUT',
  HorizontalBar = 'HORIZONTAL_BAR',
  Line = 'LINE',
  Map = 'MAP',
  Number = 'NUMBER',
  StakedArea = 'STAKED_AREA',
  VerticalBar = 'VERTICAL_BAR'
}

export type CitizenshipCountryModel = {
  __typename?: 'CitizenshipCountryModel';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CitizenshipCountryModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CitizenshipModel = {
  __typename?: 'CitizenshipModel';
  country?: Maybe<CitizenshipCountryModel>;
  status?: Maybe<StatusModel>;
  type?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type CitizenshipModelInput = {
  country?: InputMaybe<CitizenshipCountryModelInput>;
  status?: InputMaybe<StatusModel>;
  type?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ClassificationCountModel = {
  __typename?: 'ClassificationCountModel';
  classifications?: Maybe<Scalars['Map_String_IntegerScalar']['output']>;
  types?: Maybe<Scalars['Map_ClassificationTypeModel_IntegerScalar']['output']>;
};

export type ClassificationCountModelInput = {
  classifications?: InputMaybe<Scalars['Map_String_IntegerScalar']['input']>;
  types?: InputMaybe<Scalars['Map_ClassificationTypeModel_IntegerScalar']['input']>;
};

export type ClassificationImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ClassificationModel = {
  __typename?: 'ClassificationModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated as part of ref_id unification */
  code?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceIdsContext?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClassificationStatusModel>;
  type?: Maybe<ClassificationTypeModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
  workerCount?: Maybe<Scalars['Int']['output']>;
};


export type ClassificationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClassificationModelWorkerCountArgs = {
  activeEngagementsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  orgUid?: InputMaybe<Scalars['String']['input']>;
  primaryEngagementsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassificationModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceIdsContext?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ClassificationStatusModel>;
  type?: InputMaybe<ClassificationTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
  workerCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassificationQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  forceJobProfileRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  jobProfileUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ClassificationStatusModel>>>;
  type?: InputMaybe<ClassificationTypeModel>;
};

export enum ClassificationStatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum ClassificationTypeModel {
  Employee = 'EMPLOYEE',
  NonEmployee = 'NON_EMPLOYEE',
  Unknown = 'UNKNOWN'
}

export type ClassificationsModel = {
  __typename?: 'ClassificationsModel';
  classifications?: Maybe<Array<Maybe<ClassificationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum CollectionFilterModel {
  MatchAll = 'MATCH_ALL',
  MatchAny = 'MATCH_ANY',
  MatchNone = 'MATCH_NONE'
}

export enum CombinedEngagementStatusModel {
  Active = 'ACTIVE',
  ActiveAndOffboarded = 'ACTIVE_AND_OFFBOARDED',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

export type CommentModel = {
  __typename?: 'CommentModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type CommentModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creatorName?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsModel = {
  __typename?: 'CommentsModel';
  comments?: Maybe<Array<Maybe<CommentModel>>>;
};

export type CommentsModelInput = {
  comments?: InputMaybe<Array<InputMaybe<CommentModelInput>>>;
};

export type CommonFieldDefinitionModel = {
  __typename?: 'CommonFieldDefinitionModel';
  enabled: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  multivalued: Scalars['Boolean']['output'];
  regex?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  rules?: Maybe<Array<Maybe<FieldRule>>>;
  type?: Maybe<CommonFieldTypeModel>;
  urn?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<CommonFieldDefinitionValueModel>>>;
};

export type CommonFieldDefinitionValueModel = {
  __typename?: 'CommonFieldDefinitionValueModel';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CommonFieldDefinitionsModel = {
  __typename?: 'CommonFieldDefinitionsModel';
  definitions?: Maybe<Array<Maybe<CommonFieldDefinitionModel>>>;
};

export enum CommonFieldTypeModel {
  Boolean = 'BOOLEAN',
  CostCenter = 'COST_CENTER',
  Custom = 'CUSTOM',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Document = 'DOCUMENT',
  Enum = 'ENUM',
  Hyperlink = 'HYPERLINK',
  Integer = 'INTEGER',
  MultiValueTyped = 'MULTI_VALUE_TYPED',
  Number = 'NUMBER',
  Object = 'OBJECT',
  PhoneNumber = 'PHONE_NUMBER',
  Rate = 'RATE',
  RecommendationOptionScore = 'RECOMMENDATION_OPTION_SCORE',
  String = 'STRING',
  Text = 'TEXT',
  Time = 'TIME'
}

export type CompaniesModel = {
  __typename?: 'CompaniesModel';
  items?: Maybe<Array<Maybe<CompanyModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyCreationModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatusModel>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyModel = {
  __typename?: 'CompanyModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favour of reference_code */
  code?: Maybe<Scalars['String']['output']>;
  costCenters?: Maybe<Array<Maybe<CostCenterModel>>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favour of reference_id and WID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favour of reference_id and WID */
  externalIds?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CompanyStatusModel>;
  subtype?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type CompanyModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  costCenters?: InputMaybe<Array<InputMaybe<CostCenterModelInput>>>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatusModel>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forceCompanyCostCenterRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchUseCode?: InputMaybe<Scalars['Boolean']['input']>;
  searchUseReferenceCode?: InputMaybe<Scalars['Boolean']['input']>;
  searchUseReferenceId?: InputMaybe<Scalars['Boolean']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanySortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<CompanySortTypeModel>;
};

export enum CompanySortTypeModel {
  CreatedDate = 'CREATED_DATE',
  LastModified = 'LAST_MODIFIED',
  Name = 'NAME'
}

export enum CompanyStatusModel {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type CompanyUpdateModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatusModel>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ComplexRateModel = {
  __typename?: 'ComplexRateModel';
  cachedTypedUid?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  feesType?: Maybe<FeesTypeModel>;
  formula?: Maybe<FormulaRateModel>;
  invoiceMapping?: Maybe<RateBillingVariableInvoiceMappingModel>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated SD-32143 pay bill types are going to be deleted */
  payBillRateType?: Maybe<PayBillRateTypeModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  rateType?: Maybe<RateTypeModel>;
  static?: Maybe<StaticRateModel>;
  type?: Maybe<ComplexRateTypeModel>;
  uid: Scalars['String']['output'];
};


export type ComplexRateModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplexRateModelInput = {
  cachedTypedUid?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  feesType?: InputMaybe<FeesTypeModel>;
  formula?: InputMaybe<FormulaRateModelInput>;
  invoiceMapping?: InputMaybe<RateBillingVariableInvoiceMappingModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  payBillRateType?: InputMaybe<PayBillRateTypeModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  rateType?: InputMaybe<RateTypeModel>;
  static?: InputMaybe<StaticRateModelInput>;
  type?: InputMaybe<ComplexRateTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum ComplexRateTypeModel {
  Formula = 'FORMULA',
  Static = 'STATIC'
}

export type ComplianceAndRiskDefinitionsQueryModelInput = {
  statuses?: InputMaybe<Array<InputMaybe<AnomalyDefinitionStatusModel>>>;
};

export type ComplianceStatusFilterModelInput = {
  equals?: InputMaybe<ComplianceStatusModel>;
  includes?: InputMaybe<Array<InputMaybe<ComplianceStatusModel>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<ComplianceStatusModel>;
  notIncludes?: InputMaybe<Array<InputMaybe<ComplianceStatusModel>>>;
};

export enum ComplianceStatusModel {
  Compliant = 'COMPLIANT',
  NonCompliant = 'NON_COMPLIANT'
}

export enum ConfigurableDeliveredFieldsModel {
  PhoneDeviceType = 'PHONE_DEVICE_TYPE',
  RehireEligibility = 'REHIRE_ELIGIBILITY'
}

export type ContactInfoModel = {
  __typename?: 'ContactInfoModel';
  address?: Maybe<AddressModel>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<NameModel>;
  phoneNumber?: Maybe<PhoneNumberModel>;
};

export type ContactInfoModelInput = {
  address?: InputMaybe<AddressModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
};

export enum ContingentTypeModel {
  IndependentContractor = 'INDEPENDENT_CONTRACTOR',
  Other = 'OTHER',
  OutsourcedServices = 'OUTSOURCED_SERVICES',
  Partner = 'PARTNER',
  ProjectConsultant = 'PROJECT_CONSULTANT',
  TemporaryWorker = 'TEMPORARY_WORKER'
}

export type ContractCreateModelInput = {
  accountablePerson?: InputMaybe<PersonImportableReferenceModelInput>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  businessSite?: InputMaybe<LocationImportableReferenceModelInput>;
  company?: InputMaybe<CompanyImportableReferenceModelInput>;
  contractingPartyUid?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<CostCenterImportableReferenceModelInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<ContractDocumentCreateModelInput>>>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  parentContract?: InputMaybe<ContractImportableReferenceModelInput>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  primaryDocumentMediaUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  supervisoryOrg?: InputMaybe<OrgImportableReferenceModelInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContractTypeModel>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
};

export type ContractDocumentCreateModelInput = {
  mediaUid?: InputMaybe<Scalars['String']['input']>;
};

export type ContractDocumentModel = {
  __typename?: 'ContractDocumentModel';
  id: Scalars['Long']['output'];
  media?: Maybe<MediaModel>;
};

export type ContractDocumentModelInput = {
  id: Scalars['Long']['input'];
  media?: InputMaybe<MediaModelInput>;
};

export type ContractDocumentsPatchModelInput = {
  add?: InputMaybe<Array<InputMaybe<ContractDocumentCreateModelInput>>>;
  remove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContractImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ContractModel = {
  __typename?: 'ContractModel';
  accountablePerson?: Maybe<PersonModel>;
  budget?: Maybe<BudgetModel>;
  budgetOverAllocated?: Maybe<Scalars['Boolean']['output']>;
  businessSite?: Maybe<LocationModel>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  contractingParty?: Maybe<ContractingPartyModel>;
  costCenter?: Maybe<CostCenterModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<ContractDocumentModel>>>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  engagementCount?: Maybe<Scalars['Int']['output']>;
  engagements?: Maybe<EngagementsModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  hasOpenChangeSets?: Maybe<Scalars['Boolean']['output']>;
  holidaySchedule?: Maybe<HolidayScheduleModel>;
  id?: Maybe<Scalars['Long']['output']>;
  isBudgetOverAllocated?: Maybe<Scalars['Boolean']['output']>;
  milestones?: Maybe<MilestonesModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  parentContract?: Maybe<ContractModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  primaryDocument?: Maybe<ContractPrimaryDocumentModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourcingType?: Maybe<SourcingTypeModel>;
  spend?: Maybe<ContractSpendModel>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<ContractStatusModel>;
  supervisoryOrg?: Maybe<OrgModel>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContractTypeModel>;
  uid: Scalars['String']['output'];
  workSchedule?: Maybe<WorkScheduleModel>;
};


export type ContractModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type ContractModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ContractModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ContractModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ContractModelMilestonesArgs = {
  includeSuperseded?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageModelInput>;
};


export type ContractModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  budget?: InputMaybe<BudgetModelInput>;
  budgetOverAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  businessSite?: InputMaybe<LocationModelInput>;
  company?: InputMaybe<CompanyModelInput>;
  contractingParty?: InputMaybe<ContractingPartyModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<ContractDocumentModelInput>>>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagementCount?: InputMaybe<Scalars['Int']['input']>;
  engagements?: InputMaybe<EngagementsModelInput>;
  hasOpenChangeSets?: InputMaybe<Scalars['Boolean']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleModelInput>;
  id?: InputMaybe<Scalars['Long']['input']>;
  isBudgetOverAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  milestones?: InputMaybe<MilestonesModelInput>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  parentContract?: InputMaybe<ContractModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  primaryDocument?: InputMaybe<ContractPrimaryDocumentModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  spend?: InputMaybe<ContractSpendModelInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<ContractStatusModel>;
  supervisoryOrg?: InputMaybe<OrgModelInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContractTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleModelInput>;
};

export type ContractPatchModelInput = {
  accountablePerson?: InputMaybe<PersonImportableReferenceModelInput>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  businessSite?: InputMaybe<LocationImportableReferenceModelInput>;
  company?: InputMaybe<CompanyImportableReferenceModelInput>;
  contractingPartyUid?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<CostCenterImportableReferenceModelInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<ContractDocumentsPatchModelInput>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  parentContract?: InputMaybe<ContractImportableReferenceModelInput>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  primaryDocumentMediaUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<ContractStatusModel>;
  supervisoryOrgUid?: InputMaybe<OrgImportableReferenceModelInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContractTypeModel>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
};

export type ContractPrimaryDocumentModel = {
  __typename?: 'ContractPrimaryDocumentModel';
  media?: Maybe<MediaModel>;
  revisionTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  revisionVersion: Scalars['Int']['output'];
};

export type ContractPrimaryDocumentModelInput = {
  media?: InputMaybe<MediaModelInput>;
  revisionTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  revisionVersion: Scalars['Int']['input'];
};

export type ContractRevisionModel = RevisionModel & {
  __typename?: 'ContractRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  contract?: Maybe<ContractModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousContract?: Maybe<ContractModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type ContractSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<ContractSortTypeModel>;
};

export enum ContractSortTypeModel {
  Created = 'CREATED',
  Id = 'ID',
  Modified = 'MODIFIED',
  ParentContractId = 'PARENT_CONTRACT_ID',
  ReferenceId = 'REFERENCE_ID',
  Status = 'STATUS',
  Title = 'TITLE',
  Type = 'TYPE'
}

export type ContractSpendItemModel = {
  __typename?: 'ContractSpendItemModel';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ContractSpendStatusModel>;
  tax?: Maybe<Scalars['Float']['output']>;
};

export type ContractSpendItemModelInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<ContractSpendStatusModel>;
  tax?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractSpendModel = {
  __typename?: 'ContractSpendModel';
  items?: Maybe<Array<Maybe<ContractSpendItemModel>>>;
};

export type ContractSpendModelInput = {
  items?: InputMaybe<Array<InputMaybe<ContractSpendItemModelInput>>>;
};

export enum ContractSpendStatusModel {
  Approved = 'APPROVED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  Pending = 'PENDING',
  Total = 'TOTAL'
}

export type ContractStatusChangeFilterModelInput = {
  range?: InputMaybe<DateRangeModelInput>;
  type?: InputMaybe<ContractStatusChangeTypeModel>;
};

export enum ContractStatusChangeTypeModel {
  AllChanges = 'ALL_CHANGES',
  ContractEnded = 'CONTRACT_ENDED',
  ContractStarted = 'CONTRACT_STARTED'
}

export enum ContractStatusModel {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PreStart = 'PRE_START',
  Rejected = 'REJECTED'
}

export enum ContractTypeModel {
  Freelance = 'FREELANCE',
  Msa = 'MSA',
  Sow = 'SOW'
}

export type ContractingPartyModel = {
  __typename?: 'ContractingPartyModel';
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  type?: Maybe<ContractingPartyTypeModel>;
};


export type ContractingPartyModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type ContractingPartyModelInput = {
  supplier?: InputMaybe<SupplierModelInput>;
  type?: InputMaybe<ContractingPartyTypeModel>;
};

export enum ContractingPartyTypeModel {
  Supplier = 'SUPPLIER'
}

export type ContractsModel = {
  __typename?: 'ContractsModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ContractModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContractsQueryModelInput = {
  contractingPartyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  creatorUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  endDates?: InputMaybe<DateRangeModelInput>;
  excludeDescendantsOf?: InputMaybe<Scalars['String']['input']>;
  parentContractUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  startDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  startDates?: InputMaybe<DateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<ContractStatusModel>>>;
  types?: InputMaybe<Array<InputMaybe<ContractTypeModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CostCenterCreateModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<CompanyModelInput>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  managerUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCostCenterUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterModel = {
  __typename?: 'CostCenterModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Maybe<CompanyModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  /** @deprecated Use externalIds */
  externalId?: Maybe<Scalars['String']['output']>;
  externalIds?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  managerUid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentCostCenterUid?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  roleAssignments?: Maybe<Array<Maybe<RoleAssignmentsModel>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type CostCenterModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CostCenterModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<CompanyModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  managerUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCostCenterUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  roleAssignments?: InputMaybe<Array<InputMaybe<RoleAssignmentsModelInput>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterPatchModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<CompanyModelInput>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  managerUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCostCenterUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  forceCompanyCostCenterRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CostCenterRoleAssignmentsModel = {
  __typename?: 'CostCenterRoleAssignmentsModel';
  assignees?: Maybe<Array<Maybe<PersonModel>>>;
  costCenter?: Maybe<CostCenterModel>;
};

export type CostCenterRoleAssignmentsModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  costCenter?: InputMaybe<CostCenterModelInput>;
};

export type CostCenterSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<CostCenterSortTypeModel>;
};

export enum CostCenterSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  LastModified = 'LAST_MODIFIED',
  Name = 'NAME'
}

export type CostCenterUidsModelInput = {
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CostCenterUnavailableModel = {
  __typename?: 'CostCenterUnavailableModel';
  assignedCostCenterName?: Maybe<Scalars['String']['output']>;
  assignedCostCenterUid?: Maybe<Scalars['String']['output']>;
  availableCostCenters?: Maybe<Array<Maybe<AvailableCostCenterModel>>>;
};

export type CostCenterUnavailableModelInput = {
  assignedCostCenterName?: InputMaybe<Scalars['String']['input']>;
  assignedCostCenterUid?: InputMaybe<Scalars['String']['input']>;
  availableCostCenters?: InputMaybe<Array<InputMaybe<AvailableCostCenterModelInput>>>;
};

export type CostCentersMergeModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  items?: InputMaybe<Array<InputMaybe<CostCenterModelInput>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type CostCentersModel = {
  __typename?: 'CostCentersModel';
  defaultCostCenter?: Maybe<CostCenterModel>;
  elements?: Maybe<Array<Maybe<CostCenterModel>>>;
  items?: Maybe<Array<Maybe<CostCenterModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CostCentersModelInput = {
  defaultCostCenter?: InputMaybe<CostCenterModelInput>;
  items?: InputMaybe<Array<InputMaybe<CostCenterModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CostModel = {
  __typename?: 'CostModel';
  allocationDate?: Maybe<Scalars['LocalDate']['output']>;
  allocationModel?: Maybe<AllocationModel>;
  engagementRates?: Maybe<Array<Maybe<ComplexRateModel>>>;
  expense?: Maybe<ExpenseModel>;
  invoicing?: Maybe<InvoicingModel>;
  milestone?: Maybe<MilestoneModel>;
  timesheet?: Maybe<TimesheetModel>;
};

export enum CostStatus {
  Approved = 'APPROVED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum CountConditionOperatorModel {
  Equal = 'EQUAL',
  MajorEqual = 'MAJOR_EQUAL'
}

export type CountFilterModelInput = {
  comparisonOperator?: InputMaybe<CountConditionOperatorModel>;
  value: Scalars['Int']['input'];
};

export type CountriesModel = {
  __typename?: 'CountriesModel';
  items?: Maybe<Array<Maybe<CountryModel>>>;
};

export type CountryModel = {
  __typename?: 'CountryModel';
  businessSites?: Maybe<Array<Maybe<LocationModel>>>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalIdTypes?: Maybe<Array<Maybe<NationalIdTypeModel>>>;
};

export type CountryModelInput = {
  businessSites?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalIdTypes?: InputMaybe<Array<InputMaybe<NationalIdTypeModelInput>>>;
};

export type CountryRoleAssignmentsModel = {
  __typename?: 'CountryRoleAssignmentsModel';
  assignees?: Maybe<Array<Maybe<PersonModel>>>;
  country?: Maybe<CountryModel>;
};

export type CountryRoleAssignmentsModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  country?: InputMaybe<CountryModelInput>;
};

export type CreateSftpSshKeyModelInput = {
  sftpUserUid?: InputMaybe<Scalars['String']['input']>;
  sshPublicKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierContactModelInput = {
  businessSiteUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
};

export type CsvTemplateCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  templateMediaUid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CsvTemplateTypeModel>;
};

export type CsvTemplateModel = {
  __typename?: 'CsvTemplateModel';
  default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  subType?: Maybe<CsvTemplateSubTypeModel>;
  template?: Maybe<MediaModel>;
  type?: Maybe<CsvTemplateTypeModel>;
  uid: Scalars['String']['output'];
};

export type CsvTemplateQueryModelInput = {
  subType?: InputMaybe<CsvTemplateSubTypeModel>;
  type?: InputMaybe<CsvTemplateTypeModel>;
};

export enum CsvTemplateSubTypeModel {
  Retroactive = 'RETROACTIVE'
}

export enum CsvTemplateTypeModel {
  BusinessSite = 'BUSINESS_SITE',
  Classification = 'CLASSIFICATION',
  Company = 'COMPANY',
  Contract = 'CONTRACT',
  CostCenter = 'COST_CENTER',
  CustomFieldObjectValue = 'CUSTOM_FIELD_OBJECT_VALUE',
  CustomObject = 'CUSTOM_OBJECT',
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobFamily = 'JOB_FAMILY',
  JobFamilyGroup = 'JOB_FAMILY_GROUP',
  JobProfile = 'JOB_PROFILE',
  Milestone = 'MILESTONE',
  Organization = 'ORGANIZATION',
  Payment = 'PAYMENT',
  Quickstart = 'QUICKSTART',
  RateCard = 'RATE_CARD',
  SpendApprovalLimit = 'SPEND_APPROVAL_LIMIT',
  Supplier = 'SUPPLIER',
  Timesheet = 'TIMESHEET',
  User = 'USER'
}

export type CsvTemplatesModel = {
  __typename?: 'CsvTemplatesModel';
  items?: Maybe<Array<Maybe<CsvTemplateModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CurrenciesModel = {
  __typename?: 'CurrenciesModel';
  items?: Maybe<Array<Maybe<CurrencyModel>>>;
};

export type CurrencyModel = {
  __typename?: 'CurrencyModel';
  code?: Maybe<Scalars['String']['output']>;
  favored?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrencyModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  favored?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CursorPageRequestModelInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDocumentModel = {
  __typename?: 'CustomDocumentModel';
  contentType?: Maybe<Scalars['String']['output']>;
  documentUid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentEntityUid?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  uploaderUid?: Maybe<Scalars['String']['output']>;
};

export type CustomDocumentModelInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  documentUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  presignedUrl?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  uploaderUid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDocumentsInputModelInput = {
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  documentsUid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDocumentsModel = {
  __typename?: 'CustomDocumentsModel';
  customFieldDefinitionUid?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<CustomDocumentModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomDocumentsModelInput = {
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<CustomDocumentModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomFieldConditionOperatorModel {
  Equal = 'EQUAL',
  InEnumeration = 'IN_ENUMERATION',
  InRange = 'IN_RANGE',
  Major = 'MAJOR',
  MajorEqual = 'MAJOR_EQUAL',
  Minor = 'MINOR',
  MinorEqual = 'MINOR_EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export enum CustomFieldDefinitionDataTypeModel {
  CostCenter = 'COST_CENTER',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Document = 'DOCUMENT',
  Enum = 'ENUM',
  Hyperlink = 'HYPERLINK',
  Integer = 'INTEGER',
  Object = 'OBJECT',
  Rate = 'RATE',
  String = 'STRING',
  Time = 'TIME'
}

export enum CustomFieldDefinitionEntityTypeModel {
  Contract = 'CONTRACT',
  CustomObject = 'CUSTOM_OBJECT',
  Engagement = 'ENGAGEMENT',
  JobApplication = 'JOB_APPLICATION',
  JobProfile = 'JOB_PROFILE',
  JobRequest = 'JOB_REQUEST',
  Milestone = 'MILESTONE',
  Msp = 'MSP',
  Org = 'ORG',
  Person = 'PERSON',
  PhoneNumber = 'PHONE_NUMBER',
  Project = 'PROJECT',
  SowResponse = 'SOW_RESPONSE',
  Supplier = 'SUPPLIER',
  WorkRequest = 'WORK_REQUEST'
}

export enum CustomFieldDefinitionEvaluationTypeModel {
  OnRead = 'ON_READ'
}

export type CustomFieldDefinitionGroupModel = {
  __typename?: 'CustomFieldDefinitionGroupModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
};


export type CustomFieldDefinitionGroupModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFieldDefinitionGroupModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldDefinitionGroupsModel = {
  __typename?: 'CustomFieldDefinitionGroupsModel';
  customFieldDefinitionGroups?: Maybe<Array<Maybe<CustomFieldDefinitionGroupModel>>>;
};

export type CustomFieldDefinitionModel = {
  __typename?: 'CustomFieldDefinitionModel';
  calculation?: Maybe<CalculationModel>;
  code?: Maybe<Scalars['String']['output']>;
  customObjectDefinition?: Maybe<CustomObjectDefinitionModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  dataType?: Maybe<CustomFieldDefinitionDataTypeModel>;
  financialFieldDefinition?: Maybe<FinancialFieldDefinitionModel>;
  financialObject?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<CustomFieldDefinitionGroupModel>;
  helperText?: Maybe<Scalars['String']['output']>;
  linkedCustomFieldDefinitionUid?: Maybe<Scalars['String']['output']>;
  multivalued?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentCustomObjectDefinition?: Maybe<CustomObjectDefinitionModel>;
  parentEntityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  rateDefinition?: Maybe<RateDefinitionModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  timeSeries?: Maybe<Scalars['Boolean']['output']>;
  uid: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<ValueModel>>>;
};


export type CustomFieldDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CustomFieldDefinitionModelValuesArgs = {
  query?: InputMaybe<CustomFieldDefinitionQueryModelInput>;
};

export type CustomFieldDefinitionModelInput = {
  calculation?: InputMaybe<CalculationModelInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  customObjectDefinition?: InputMaybe<CustomObjectDefinitionModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  dataType?: InputMaybe<CustomFieldDefinitionDataTypeModel>;
  financialFieldDefinition?: InputMaybe<FinancialFieldDefinitionModelInput>;
  financialObject?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<CustomFieldDefinitionGroupModelInput>;
  helperText?: InputMaybe<Scalars['String']['input']>;
  linkedCustomFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  multivalued?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCustomObjectDefinition?: InputMaybe<CustomObjectDefinitionModelInput>;
  parentEntityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  rateDefinition?: InputMaybe<RateDefinitionModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  timeSeries?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<ValueModelInput>>>;
};

export type CustomFieldDefinitionQueryModelInput = {
  configurationMode?: InputMaybe<Scalars['Boolean']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomFieldDefinitionsModel = {
  __typename?: 'CustomFieldDefinitionsModel';
  customFieldDefinitions?: Maybe<Array<Maybe<CustomFieldDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomFieldFilterModelInput = {
  bounds?: InputMaybe<Pair_String_StringInput>;
  comparisonOperator?: InputMaybe<CustomFieldConditionOperatorModel>;
  definitionUid?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<ValueModelInput>>>;
};

export type CustomFieldModel = {
  __typename?: 'CustomFieldModel';
  complexValue?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  definition?: Maybe<CustomFieldDefinitionModel>;
  displayValue?: Maybe<Scalars['String']['output']>;
  displayValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  documents?: Maybe<CustomDocumentsModel>;
  label?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['ActionPermissionsModelScalar']['output']>;
  resolvedValue?: Maybe<CustomObjectModel>;
  resolvedValues?: Maybe<Array<Maybe<CustomObjectModel>>>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CustomFieldModelInput = {
  complexValue?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  definition?: InputMaybe<CustomFieldDefinitionModelInput>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  displayValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documents?: InputMaybe<CustomDocumentsModelInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['ActionPermissionsModelScalar']['input']>;
  resolvedValue?: InputMaybe<CustomObjectModelInput>;
  resolvedValues?: InputMaybe<Array<InputMaybe<CustomObjectModelInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomObjectActiveStatusModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectCreateOrUpdateModelInput = {
  customFieldDefinitionReferenceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  status?: InputMaybe<UpdatableStatusModel>;
};

export type CustomObjectCreationModelInput = {
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customObjectDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatusModel>;
};

export type CustomObjectDefinitionCreationModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<CustomFieldDefinitionModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectDefinitionModel = {
  __typename?: 'CustomObjectDefinitionModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<Maybe<CustomFieldDefinitionModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type CustomObjectDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomObjectDefinitionModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<CustomFieldDefinitionModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectDefinitionQueryModelInput = {
  financialObject?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomObjectDefinitionsModel = {
  __typename?: 'CustomObjectDefinitionsModel';
  customObjectDefinitions?: Maybe<Array<Maybe<CustomObjectDefinitionModel>>>;
};

export type CustomObjectModel = {
  __typename?: 'CustomObjectModel';
  /** @deprecated Use reference code */
  code?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customObjectDefinitionUid?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  linkedCustomObjectUid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type CustomObjectModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CustomObjectModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CustomObjectModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CustomObjectModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomObjectModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customObjectDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  linkedCustomObjectUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectQueryModelInput = {
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectUpdateModelInput = {
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomObjectsModel = {
  __typename?: 'CustomObjectsModel';
  elements?: Maybe<Array<Maybe<CustomObjectModel>>>;
  items?: Maybe<Array<Maybe<CustomObjectModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomReportScheduleModelInput = {
  fileFormat?: InputMaybe<OcExportTypeModel>;
  nextTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  startTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  targetSftpDirectoryUid?: InputMaybe<Scalars['String']['input']>;
  timeInterval?: InputMaybe<ScheduleTimeIntervalModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomTimeSeriesEventModel = {
  __typename?: 'CustomTimeSeriesEventModel';
  eventSource?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  uid: Scalars['String']['output'];
  value?: Maybe<Scalars['CustomTimeSeriesValueModelScalar']['output']>;
};

export type CustomTimeSeriesEventModelInput = {
  eventSource?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['CustomTimeSeriesValueModelScalar']['input']>;
};

export type CustomTimeSeriesModel = {
  __typename?: 'CustomTimeSeriesModel';
  definition?: Maybe<CustomFieldDefinitionModel>;
  events?: Maybe<Array<Maybe<CustomTimeSeriesEventModel>>>;
  label?: Maybe<Scalars['String']['output']>;
  latestTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  latestValue?: Maybe<Scalars['CustomTimeSeriesValueModelScalar']['output']>;
};

export type CustomTimeSeriesModelInput = {
  definition?: InputMaybe<CustomFieldDefinitionModelInput>;
  events?: InputMaybe<Array<InputMaybe<CustomTimeSeriesEventModelInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  latestTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  latestValue?: InputMaybe<Scalars['CustomTimeSeriesValueModelScalar']['input']>;
};

export type DailyAllocationModel = {
  __typename?: 'DailyAllocationModel';
  allocations?: Maybe<Array<Maybe<AllocationModel>>>;
  hours?: Maybe<Scalars['Float']['output']>;
  maxHours?: Maybe<Scalars['Float']['output']>;
  seconds?: Maybe<Scalars['Long']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  workday?: Maybe<Scalars['LocalDate']['output']>;
};

export type DailyAllocationModelInput = {
  allocations?: InputMaybe<Array<InputMaybe<AllocationModelInput>>>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  maxHours?: InputMaybe<Scalars['Float']['input']>;
  seconds?: InputMaybe<Scalars['Long']['input']>;
  units?: InputMaybe<Scalars['Float']['input']>;
  workday?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type DailyAllocationPatchModelInput = {
  allocations?: InputMaybe<Array<InputMaybe<AllocationPatchModelInput>>>;
  workday?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type DailyBriefingActionItemModel = {
  __typename?: 'DailyBriefingActionItemModel';
  category?: Maybe<BriefingItemCategory>;
  explanation?: Maybe<Scalars['String']['output']>;
  missingInformation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rank: Scalars['Int']['output'];
  recommendedAction?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<BriefingReference>>>;
  severity?: Maybe<BriefingSeverity>;
  title?: Maybe<Scalars['String']['output']>;
  waitingOnParties?: Maybe<Array<Maybe<ResponsibleParty>>>;
  waitingOnRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DailyBriefingModel = {
  __typename?: 'DailyBriefingModel';
  actionItems?: Maybe<Array<Maybe<DailyBriefingActionItemModel>>>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type DailyBriefingRequestModelInput = {
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardItemModel = {
  __typename?: 'DashboardItemModel';
  chart?: Maybe<ChartModel>;
  layout?: Maybe<CellLayoutModel>;
};

export type DashboardItemModelInput = {
  chart?: InputMaybe<ChartModelInput>;
  layout?: InputMaybe<CellLayoutModelInput>;
};

export type DashboardModel = {
  __typename?: 'DashboardModel';
  creatorUid?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<DashboardItemModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  sharing?: Maybe<DashboardSharingModel>;
  uid: Scalars['String']['output'];
};

export type DashboardModelInput = {
  creatorUid?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<DashboardItemModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sharing?: InputMaybe<DashboardSharingModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum DashboardSection {
  Highlight = 'HIGHLIGHT',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type DashboardSharingModel = {
  __typename?: 'DashboardSharingModel';
  visibleToEveryone?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardSharingModelInput = {
  visibleToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardsModel = {
  __typename?: 'DashboardsModel';
  dashboards?: Maybe<Array<Maybe<DashboardModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DashboardsPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DataMappingFieldModel = {
  __typename?: 'DataMappingFieldModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<FieldKeyModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type DataMappingFieldModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<FieldKeyModel>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type DataMappingRuleModel = {
  __typename?: 'DataMappingRuleModel';
  id?: Maybe<Scalars['String']['output']>;
  input?: Maybe<DataMappingFieldModel>;
  output?: Maybe<DataMappingFieldModel>;
};

export type DataMappingRuleModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataMappingFieldModelInput>;
  output?: InputMaybe<DataMappingFieldModelInput>;
};

export type DataMappingTableModel = {
  __typename?: 'DataMappingTableModel';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<DataMappingRuleModel>>>;
};

export type DataMappingTableModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<DataMappingRuleModelInput>>>;
};

export type DataTableColumnConfigurationModel = {
  __typename?: 'DataTableColumnConfigurationModel';
  columnOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columnSizing?: Maybe<Scalars['Map_String_IntegerScalar']['output']>;
  hiddenColumns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key?: Maybe<Scalars['String']['output']>;
};

export type DataTableColumnConfigurationModelInput = {
  columnOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnSizing?: InputMaybe<Scalars['Map_String_IntegerScalar']['input']>;
  hiddenColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterModelInput = {
  equals?: InputMaybe<Scalars['LocalDate']['input']>;
  equalsRelative?: InputMaybe<RelativeLocalDateModelInput>;
  greaterThan?: InputMaybe<Scalars['LocalDate']['input']>;
  greaterThanOrEquals?: InputMaybe<Scalars['LocalDate']['input']>;
  greaterThanOrEqualsRelative?: InputMaybe<RelativeLocalDateModelInput>;
  greaterThanRelative?: InputMaybe<RelativeLocalDateModelInput>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  includesRelative?: InputMaybe<Array<InputMaybe<RelativeLocalDateModelInput>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['LocalDate']['input']>;
  lessThanOrEquals?: InputMaybe<Scalars['LocalDate']['input']>;
  lessThanOrEqualsRelative?: InputMaybe<RelativeLocalDateModelInput>;
  lessThanRelative?: InputMaybe<RelativeLocalDateModelInput>;
  notEquals?: InputMaybe<Scalars['LocalDate']['input']>;
  notEqualsRelative?: InputMaybe<RelativeLocalDateModelInput>;
  notIncludes?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  notIncludesRelative?: InputMaybe<Array<InputMaybe<RelativeLocalDateModelInput>>>;
};

export enum DateFormatModel {
  DayMonthYear = 'DAY_MONTH_YEAR',
  MonthDayYear = 'MONTH_DAY_YEAR',
  YearMonthDay = 'YEAR_MONTH_DAY'
}

export type DateRangeModel = {
  __typename?: 'DateRangeModel';
  from?: Maybe<Scalars['LocalDate']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['LocalDate']['output']>;
};

export type DateRangeModelInput = {
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export enum DateSeparatorModel {
  Dash = 'DASH',
  Dot = 'DOT',
  Slash = 'SLASH',
  Space = 'SPACE'
}

export type DateTimeFilterModelInput = {
  equals?: InputMaybe<Scalars['LocalDateTime']['input']>;
  equalsRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  greaterThan?: InputMaybe<Scalars['LocalDateTime']['input']>;
  greaterThanOrEquals?: InputMaybe<Scalars['LocalDateTime']['input']>;
  greaterThanOrEqualsRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  greaterThanRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['LocalDateTime']['input']>>>;
  includesRelative?: InputMaybe<Array<InputMaybe<RelativeLocalDateTimeModelInput>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['LocalDateTime']['input']>;
  lessThanOrEquals?: InputMaybe<Scalars['LocalDateTime']['input']>;
  lessThanOrEqualsRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  lessThanRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  notEquals?: InputMaybe<Scalars['LocalDateTime']['input']>;
  notEqualsRelative?: InputMaybe<RelativeLocalDateTimeModelInput>;
  notIncludes?: InputMaybe<Array<InputMaybe<Scalars['LocalDateTime']['input']>>>;
  notIncludesRelative?: InputMaybe<Array<InputMaybe<RelativeLocalDateTimeModelInput>>>;
};

export type DateTimeFormatConfigModel = {
  __typename?: 'DateTimeFormatConfigModel';
  format?: Maybe<DateFormatModel>;
  separator?: Maybe<DateSeparatorModel>;
  use24HrTime: Scalars['Boolean']['output'];
};

export type DateTimeFormatConfigModelInput = {
  format?: InputMaybe<DateFormatModel>;
  separator?: InputMaybe<DateSeparatorModel>;
  use24HrTime: Scalars['Boolean']['input'];
};

export type DateTimeFormatConfigUpdateModelInput = {
  format?: InputMaybe<DateFormatModel>;
  separator?: InputMaybe<DateSeparatorModel>;
  use24HrTime: Scalars['Boolean']['input'];
};

export enum DateTypeModel {
  IsEmpty = 'IS_EMPTY',
  IsInBetween = 'IS_IN_BETWEEN',
  IsInTheLast = 'IS_IN_THE_LAST',
  IsInTheNext = 'IS_IN_THE_NEXT',
  IsOn = 'IS_ON',
  IsWithinThis = 'IS_WITHIN_THIS'
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DaySpecifierModel {
  Day = 'DAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Weekday = 'WEEKDAY',
  WeekendingDay = 'WEEKENDING_DAY'
}

export type DayWorkingHoursEntry = {
  __typename?: 'DayWorkingHoursEntry';
  dayOfWeek?: Maybe<DayOfWeek>;
  hours: Scalars['Float']['output'];
};

export type DayWorkingHoursEntryInput = {
  dayOfWeek?: InputMaybe<DayOfWeek>;
  hours: Scalars['Float']['input'];
};

export type DebugPayloadModel = {
  __typename?: 'DebugPayloadModel';
  payload?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
};

export type DecisionExplanationModel = {
  __typename?: 'DecisionExplanationModel';
  decision?: Maybe<VerificationDecisionModel>;
  explanation?: Maybe<Scalars['String']['output']>;
};

export type DecisionFieldModel = {
  __typename?: 'DecisionFieldModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<FieldKeyModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type DecisionFieldModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<FieldKeyModel>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionModel = {
  __typename?: 'DecisionModel';
  decision?: Maybe<VerificationDecisionModel>;
  permissionAction?: Maybe<PermissionAction>;
  permissionIdentifier?: Maybe<Scalars['String']['output']>;
  resourceUid?: Maybe<Scalars['String']['output']>;
  subjectUid?: Maybe<Scalars['String']['output']>;
};

export type DecisionModelInput = {
  decision?: InputMaybe<VerificationDecisionModel>;
  permissionAction?: InputMaybe<PermissionAction>;
  permissionIdentifier?: InputMaybe<Scalars['String']['input']>;
  resourceUid?: InputMaybe<Scalars['String']['input']>;
  subjectUid?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionRuleModel = {
  __typename?: 'DecisionRuleModel';
  id?: Maybe<Scalars['String']['output']>;
  inputEntries?: Maybe<Array<Maybe<FieldConditionModel>>>;
  outputEntries?: Maybe<Array<Maybe<FieldAssignmentModel>>>;
};

export type DecisionRuleModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inputEntries?: InputMaybe<Array<InputMaybe<FieldConditionModelInput>>>;
  outputEntries?: InputMaybe<Array<InputMaybe<FieldAssignmentModelInput>>>;
};

export type DecisionTableDefinitionCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<DecisionTableDefinitionScopeModel>;
  type?: InputMaybe<DecisionTableDefinitionTypeModel>;
};

export type DecisionTableDefinitionDuplicateCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionTableDefinitionModel = {
  __typename?: 'DecisionTableDefinitionModel';
  comment?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  decisionTable?: Maybe<DecisionTableModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  restoredFrom?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<DecisionTableDefinitionScopeModel>;
  status?: Maybe<DecisionTableDefinitionStatusModel>;
  type?: Maybe<DecisionTableDefinitionTypeModel>;
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};


export type DecisionTableDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DecisionTableDefinitionQueryModelInput = {
  createdRange?: InputMaybe<DateRangeModelInput>;
  modifiedRange?: InputMaybe<DateRangeModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DecisionTableDefinitionStatusModel>>>;
  type?: InputMaybe<DecisionTableDefinitionTypeModel>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DecisionTableDefinitionReferenceModel = {
  __typename?: 'DecisionTableDefinitionReferenceModel';
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type DecisionTableDefinitionReferenceModelInput = {
  uid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type DecisionTableDefinitionRestoreModelInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

export type DecisionTableDefinitionRevisionModel = {
  __typename?: 'DecisionTableDefinitionRevisionModel';
  comment?: Maybe<Scalars['String']['output']>;
  decisionTableDefinitionUid?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  restoredFrom?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type DecisionTableDefinitionRevisionsModel = {
  __typename?: 'DecisionTableDefinitionRevisionsModel';
  items?: Maybe<Array<Maybe<DecisionTableDefinitionRevisionModel>>>;
};

export enum DecisionTableDefinitionScopeModel {
  Task = 'TASK'
}

export enum DecisionTableDefinitionStatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum DecisionTableDefinitionTypeModel {
  TimesheetRules = 'TIMESHEET_RULES'
}

export type DecisionTableDefinitionUpdateModelInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  decisionTable?: InputMaybe<DecisionTableModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionTableDefinitionsModel = {
  __typename?: 'DecisionTableDefinitionsModel';
  items?: Maybe<Array<Maybe<DecisionTableDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DecisionTableModel = {
  __typename?: 'DecisionTableModel';
  defaultRuleId?: Maybe<Scalars['String']['output']>;
  hitPolicy?: Maybe<HitPolicyModel>;
  id?: Maybe<Scalars['String']['output']>;
  inputs?: Maybe<Array<Maybe<DecisionFieldModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  outputs?: Maybe<Array<Maybe<DecisionFieldModel>>>;
  rules?: Maybe<Array<Maybe<DecisionRuleModel>>>;
};

export type DecisionTableModelInput = {
  defaultRuleId?: InputMaybe<Scalars['String']['input']>;
  hitPolicy?: InputMaybe<HitPolicyModel>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<Array<InputMaybe<DecisionFieldModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputs?: InputMaybe<Array<InputMaybe<DecisionFieldModelInput>>>;
  rules?: InputMaybe<Array<InputMaybe<DecisionRuleModelInput>>>;
};

export type DecisionsModel = {
  __typename?: 'DecisionsModel';
  decisions?: Maybe<Array<Maybe<DecisionModel>>>;
};

export type DeleteSupplierContactModelInput = {
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum DeliveredFieldDefinitionDataTypeModel {
  Enum = 'ENUM'
}

export type DeliveredFieldDefinitionModel = {
  __typename?: 'DeliveredFieldDefinitionModel';
  code?: Maybe<ConfigurableDeliveredFieldsModel>;
  dataType?: Maybe<DeliveredFieldDefinitionDataTypeModel>;
  parentEntityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<ValueModel>>>;
};

export enum DistributionGroupInstanceStatusModel {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  Stopped = 'STOPPED'
}

export enum DistributionGroupStatusModel {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Published = 'PUBLISHED'
}

export type DistributionRuleCreateModelInput = {
  previousTierOffset?: InputMaybe<PreviousTierOffsetRuleCreateModelInput>;
  referenceDateOffset?: InputMaybe<ReferenceDateOffsetRuleCreateModelInput>;
  type?: InputMaybe<DistributionRuleTypeModel>;
};

export type DistributionRuleInstanceModel = ImmediateDistributionRuleInstanceModel | PreviousTierOffsetDistributionRuleInstanceModel | ReferenceDateOffsetDistributionRuleInstanceModel;

export type DistributionRuleInstancePatchModelInput = {
  referenceDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  subType?: InputMaybe<DistributionRuleSubTypeModel>;
  timeOffset?: InputMaybe<RuleTimeOffsetInputModelInput>;
  type?: InputMaybe<DistributionRuleTypeModel>;
};

export type DistributionRuleModel = ImmediateDistributionRuleModel | PreviousTierOffsetDistributionRuleModel | ReferenceDateOffsetDistributionRuleModel;

export type DistributionRulePatchModelInput = {
  referenceDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  subType?: InputMaybe<DistributionRuleSubTypeModel>;
  timeOffset?: InputMaybe<RuleTimeOffsetInputModelInput>;
  type?: InputMaybe<DistributionRuleTypeModel>;
};

export enum DistributionRuleSubTypeModel {
  After = 'AFTER',
  Before = 'BEFORE'
}

export enum DistributionRuleTypeModel {
  Immediate = 'IMMEDIATE',
  PreviousTierOffset = 'PREVIOUS_TIER_OFFSET',
  ReferenceDateOffset = 'REFERENCE_DATE_OFFSET'
}

export enum DistributionTierInstanceStatusModel {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Inactive = 'INACTIVE',
  Queued = 'QUEUED'
}

export enum DuplicateWorkerMatchConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DuplicateWorkerMatchModel = {
  __typename?: 'DuplicateWorkerMatchModel';
  confidence?: Maybe<DuplicateWorkerMatchConfidence>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  matchedOn?: Maybe<Array<Maybe<DuplicateWorkerMatchReasonModel>>>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  score: Scalars['Float']['output'];
  uid: Scalars['String']['output'];
  worker?: Maybe<PersonModel>;
};


export type DuplicateWorkerMatchModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuplicateWorkerMatchReasonModel = {
  __typename?: 'DuplicateWorkerMatchReasonModel';
  firstNameSimilarity?: Maybe<Scalars['Float']['output']>;
  lastNameSimilarity?: Maybe<Scalars['Float']['output']>;
  sharedAcrossNWorkers?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DuplicateWorkerMatchReasonType>;
};

export enum DuplicateWorkerMatchReasonType {
  LastNameAndDob = 'LAST_NAME_AND_DOB',
  NameSimilarity = 'NAME_SIMILARITY',
  NationalId = 'NATIONAL_ID',
  PersonalEmail = 'PERSONAL_EMAIL',
  Phone = 'PHONE',
  PrimaryEmail = 'PRIMARY_EMAIL'
}

export type DuplicateWorkerSearchQueryModelInput = {
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalIds?: InputMaybe<Array<InputMaybe<NationalIdModelInput>>>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  preferredLastName?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateWorkersModel = {
  __typename?: 'DuplicateWorkersModel';
  duplicates?: Maybe<Array<Maybe<DuplicateWorkerMatchModel>>>;
};

export enum DynamicEntityTypeModel {
  Company = 'COMPANY',
  Supplier = 'SUPPLIER'
}

export type EligibilityRequirementCreateModelInput = {
  certification?: InputMaybe<CertificationCreateModelInput>;
};

export type EligibilityRequirementFilterModelInput = {
  assignable?: InputMaybe<BooleanFilterModelInput>;
  issuer?: InputMaybe<StringFilterModelInput>;
  name?: InputMaybe<StringFilterModelInput>;
  referenceId?: InputMaybe<StringFilterModelInput>;
  sourceName?: InputMaybe<StringFilterModelInput>;
  statuses?: InputMaybe<EntityStatusFilterModelInput>;
};

export type EligibilityRequirementModel = {
  jobProfileEligibilityRequirement?: Maybe<Array<Maybe<JobProfileEligibilityRequirementModel>>>;
  uid: Scalars['String']['output'];
};

export type EligibilityRequirementRootFilterModelInput = {
  or?: InputMaybe<Array<InputMaybe<EligibilityRequirementFilterModelInput>>>;
};

export type EligibilityRequirementSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<EligibilityRequirementSortTypeModel>;
};

export enum EligibilityRequirementSortTypeModel {
  Assignable = 'ASSIGNABLE',
  Created = 'CREATED',
  Issuer = 'ISSUER',
  Modified = 'MODIFIED',
  Name = 'NAME',
  ReferenceId = 'REFERENCE_ID',
  SourceName = 'SOURCE_NAME',
  Status = 'STATUS'
}

export type EligibilityRequirementsModel = {
  __typename?: 'EligibilityRequirementsModel';
  items?: Maybe<Array<Maybe<EligibilityRequirementModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmbeddableUrlModel = {
  __typename?: 'EmbeddableUrlModel';
  params?: Maybe<Scalars['Map_String_List_StringScalar']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type EmergencyContactModel = {
  __typename?: 'EmergencyContactModel';
  address?: Maybe<AddressModel>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<NameModel>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberModel>>>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  relationshipType?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type EmergencyContactModelInput = {
  address?: InputMaybe<AddressModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberModelInput>>>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type EngagementChangeSetQueryModelInput = {
  changeSetStatuses?: InputMaybe<Array<InputMaybe<ChangeSetStatusModel>>>;
  engagementUid?: InputMaybe<Scalars['String']['input']>;
  startEventTypes?: InputMaybe<Array<InputMaybe<StartEventTypeModel>>>;
};

export type EngagementConfigModel = {
  __typename?: 'EngagementConfigModel';
  allowBackdatedStartDates?: Maybe<Scalars['Boolean']['output']>;
  dateValidationTimezone?: Maybe<Scalars['String']['output']>;
  deletableEngagementStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endableEngagementStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  managingSources?: Maybe<Array<Maybe<EngagementManagingSourceModel>>>;
  mustMapToWorkdayEngagement?: Maybe<Scalars['Boolean']['output']>;
  offboardAutoTransitionContingentsOnly?: Maybe<Scalars['Boolean']['output']>;
  offboardClassificationReferenceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offboardLocationReferenceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offboardSchedulerCron?: Maybe<Scalars['String']['output']>;
  offboardSupplierReferenceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  onboardedEngagementDatesCanOverlap?: Maybe<Scalars['Boolean']['output']>;
  startEventIgnoredSourceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statusChangedIgnoredSourceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EngagementDateEffectiveRowValidationQueryModelInput = {
  index: Scalars['Int']['input'];
  urnToValueMap?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  urnToValuesMap?: InputMaybe<Scalars['Map_String_List_StringScalar']['input']>;
};

export type EngagementDateEffectiveValidationQueryModelInput = {
  values?: InputMaybe<Array<InputMaybe<EngagementDateEffectiveRowValidationQueryModelInput>>>;
};

export type EngagementDurationFilterModelInput = {
  numMonthsLowerBound?: InputMaybe<Scalars['Int']['input']>;
  numMonthsUpperBound?: InputMaybe<Scalars['Int']['input']>;
};

export type EngagementIdCompanyWorkerIdInput = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['String']['input']>;
};

export type EngagementIdPersonUidInput = {
  engagementId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type EngagementIdentifierInput = {
  engagementIdCompanyWorkerId?: InputMaybe<EngagementIdCompanyWorkerIdInput>;
  engagementIdPersonUid?: InputMaybe<EngagementIdPersonUidInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum EngagementLocationTypeModel {
  OnSite = 'ON_SITE',
  Remote = 'REMOTE'
}

export enum EngagementManagingSourceModel {
  Beeline = 'BEELINE',
  Ukg = 'UKG',
  Utmost = 'UTMOST',
  Workday = 'WORKDAY'
}

export type EngagementModel = {
  __typename?: 'EngagementModel';
  accountablePerson?: Maybe<PersonModel>;
  allowedProjectTasks?: Maybe<Array<Maybe<ProjectPlanTaskModel>>>;
  alternateExternalApprover?: Maybe<PersonModel>;
  anomalies?: Maybe<Array<Maybe<AnomalyModel>>>;
  appendixRequest?: Maybe<AppendixRequestModel>;
  badgeId?: Maybe<Scalars['String']['output']>;
  billRate?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<BudgetModel>;
  businessSite?: Maybe<LocationModel>;
  changeRequest?: Maybe<ChangeRequestModel>;
  clockInTimesEnabled?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  contract?: Maybe<ContractModel>;
  costCenterRevisionAtTime?: Maybe<CostCenterModel>;
  costCenters?: Maybe<CostCentersModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  deliveredFieldDefinitions?: Maybe<Scalars['Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directReportsCount?: Maybe<Scalars['Int']['output']>;
  directReportsCounts?: Maybe<ClassificationCountModel>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  engagementId?: Maybe<Scalars['String']['output']>;
  engagementSettings?: Maybe<EngagementSettingsModel>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  estimatedAdditionalCosts?: Maybe<Scalars['Float']['output']>;
  extensionDates?: Maybe<Array<Maybe<Scalars['LocalDate']['output']>>>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  fullTitle?: Maybe<Scalars['String']['output']>;
  hasOpenChangeSets: Scalars['Boolean']['output'];
  holidaySchedule?: Maybe<HolidayScheduleModel>;
  jobApplication?: Maybe<JobApplicationModel>;
  jobFamily?: Maybe<JobFamilyModel>;
  jobFamilyGroup?: Maybe<JobFamilyGroupModel>;
  jobProfile?: Maybe<JobProfileModel>;
  jobSummary?: Maybe<Scalars['String']['output']>;
  lastWorkdaySyncTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  location?: Maybe<LocationModel>;
  managingOrgs?: Maybe<Array<Maybe<OrgModel>>>;
  managingSources?: Maybe<Array<Maybe<EngagementManagingSourceModel>>>;
  migratedRatesItems?: Maybe<Array<Maybe<ComplexRateModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  msp?: Maybe<MspModel>;
  offboardOnEndDate?: Maybe<Scalars['Boolean']['output']>;
  orgRevisionAtTime?: Maybe<OrgModel>;
  originalStartDate?: Maybe<Scalars['LocalDate']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  personRevisionAtTime?: Maybe<PersonModel>;
  personUid?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  primaryExternalApprover?: Maybe<PersonModel>;
  primaryManager?: Maybe<EngagementModel>;
  primaryOrg?: Maybe<OrgModel>;
  primarySubordinates?: Maybe<Array<Maybe<EngagementModel>>>;
  priorSpend?: Maybe<PriorSpendModel>;
  programType?: Maybe<ProgramTypeModel>;
  project?: Maybe<ProjectModel>;
  projectPosition?: Maybe<ProjectPositionModel>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateCard?: Maybe<RateCardModel>;
  rateCurrency?: Maybe<Scalars['String']['output']>;
  ratePeriod?: Maybe<PayRatePeriodModel>;
  rateType?: Maybe<PayRateTypeModel>;
  rates?: Maybe<RatesModel>;
  ratesItems?: Maybe<Array<Maybe<ComplexRateModel>>>;
  remoteWorkAddress?: Maybe<AddressModel>;
  secondaryTerminationReason?: Maybe<Scalars['String']['output']>;
  secondaryTerminationReasonModel?: Maybe<TerminationReasonModel>;
  spend?: Maybe<EngagementSpendModel>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<EngagementStatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  supplierWorkerID?: Maybe<Scalars['String']['output']>;
  terminationReason?: Maybe<Scalars['String']['output']>;
  terminationReasonModel?: Maybe<TerminationReasonModel>;
  timesheetSubmissionEnabled?: Maybe<Scalars['Boolean']['output']>;
  timesheetView?: Maybe<TimesheetViewModel>;
  title?: Maybe<Scalars['String']['output']>;
  totalReportsCount?: Maybe<Scalars['Int']['output']>;
  totalReportsCounts?: Maybe<ClassificationCountModel>;
  uid: Scalars['String']['output'];
  workCalendar?: Maybe<WorkCalendarModel>;
  workCity?: Maybe<Scalars['String']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<EngagementWorkLocationModel>;
  workLocationType?: Maybe<EngagementWorkLocationTypeModel>;
  workPhones?: Maybe<Array<Maybe<PhoneNumberModel>>>;
  workProvince?: Maybe<Scalars['String']['output']>;
  workSchedule?: Maybe<WorkScheduleModel>;
  workdayPositionId?: Maybe<Scalars['String']['output']>;
  workdayStatus?: Maybe<EngagementStatusModel>;
  workerClassification?: Maybe<ClassificationModel>;
};


export type EngagementModelBudgetArgs = {
  skipBudgetResolution?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EngagementModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type EngagementModelCostCenterRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type EngagementModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EngagementModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EngagementModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EngagementModelOrgRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type EngagementModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EngagementModelPersonRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type EngagementModelPrimarySubordinatesArgs = {
  lastEvaluatedUid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementModelRatesArgs = {
  evaluateFormulas?: Scalars['Boolean']['input'];
};


export type EngagementModelRatesItemsArgs = {
  evaluateFormulas?: Scalars['Boolean']['input'];
};


export type EngagementModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type EngagementModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  allowedProjectTasks?: InputMaybe<Array<InputMaybe<ProjectPlanTaskModelInput>>>;
  alternateExternalApprover?: InputMaybe<PersonModelInput>;
  anomalies?: InputMaybe<Array<InputMaybe<AnomalyModelInput>>>;
  appendixRequest?: InputMaybe<AppendixRequestModelInput>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  billRate?: InputMaybe<Scalars['Float']['input']>;
  budget?: InputMaybe<BudgetModelInput>;
  businessSite?: InputMaybe<LocationModelInput>;
  changeRequest?: InputMaybe<ChangeRequestModelInput>;
  clockInTimesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<CompanyModelInput>;
  contract?: InputMaybe<ContractModelInput>;
  costCenters?: InputMaybe<CostCentersModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  deliveredFieldDefinitions?: InputMaybe<Scalars['DeliveredFieldDefinitionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directReportsCount?: InputMaybe<Scalars['Int']['input']>;
  directReportsCounts?: InputMaybe<ClassificationCountModelInput>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagementId?: InputMaybe<Scalars['String']['input']>;
  engagementSettings?: InputMaybe<EngagementSettingsModelInput>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  extensionDates?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  fullTitle?: InputMaybe<Scalars['String']['input']>;
  hasOpenChangeSets?: InputMaybe<Scalars['Boolean']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleModelInput>;
  jobApplication?: InputMaybe<JobApplicationModelInput>;
  jobFamily?: InputMaybe<JobFamilyModelInput>;
  jobFamilyGroup?: InputMaybe<JobFamilyGroupModelInput>;
  jobProfile?: InputMaybe<JobProfileModelInput>;
  jobSummary?: InputMaybe<Scalars['String']['input']>;
  lastWorkdaySyncTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  location?: InputMaybe<LocationModelInput>;
  managingOrgs?: InputMaybe<Array<InputMaybe<OrgModelInput>>>;
  managingSources?: InputMaybe<Array<InputMaybe<EngagementManagingSourceModel>>>;
  migratedRatesItems?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  msp?: InputMaybe<MspModelInput>;
  offboardOnEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  originalStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  person?: InputMaybe<PersonModelInput>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  primaryExternalApprover?: InputMaybe<PersonModelInput>;
  primaryManager?: InputMaybe<EngagementModelInput>;
  primaryOrg?: InputMaybe<OrgModelInput>;
  primarySubordinates?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  priorSpend?: InputMaybe<PriorSpendModelInput>;
  programType?: InputMaybe<ProgramTypeModel>;
  project?: InputMaybe<ProjectModelInput>;
  projectPosition?: InputMaybe<ProjectPositionModelInput>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateCard?: InputMaybe<RateCardModelInput>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  rates?: InputMaybe<RatesModelInput>;
  ratesItems?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  secondaryTerminationReason?: InputMaybe<Scalars['String']['input']>;
  secondaryTerminationReasonModel?: InputMaybe<TerminationReasonModelInput>;
  spend?: InputMaybe<EngagementSpendModelInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<EngagementStatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  supplierWorkerID?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  terminationReasonModel?: InputMaybe<TerminationReasonModelInput>;
  timesheetSubmissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetView?: InputMaybe<TimesheetViewModel>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalReportsCount?: InputMaybe<Scalars['Int']['input']>;
  totalReportsCounts?: InputMaybe<ClassificationCountModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workCalendar?: InputMaybe<WorkCalendarModelInput>;
  workCity?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<EngagementWorkLocationModelInput>;
  workLocationType?: InputMaybe<EngagementWorkLocationTypeModel>;
  workPhones?: InputMaybe<Array<InputMaybe<PhoneNumberModelInput>>>;
  workProvince?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleModelInput>;
  workdayPositionId?: InputMaybe<Scalars['String']['input']>;
  workdayStatus?: InputMaybe<EngagementStatusModel>;
  workerClassification?: InputMaybe<ClassificationModelInput>;
};

export type EngagementOpenChangesetsStatusModel = {
  __typename?: 'EngagementOpenChangesetsStatusModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  engagementId?: Maybe<Scalars['String']['output']>;
  hasOpenChangeSets: Scalars['Boolean']['output'];
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
};


export type EngagementOpenChangesetsStatusModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EngagementRevisionModel = RevisionModel & {
  __typename?: 'EngagementRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  engagement?: Maybe<EngagementModel>;
  indirectChangeReason?: Maybe<IndirectChangeReasonModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousEngagement?: Maybe<EngagementModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export enum EngagementScopeModel {
  All = 'ALL',
  Current = 'CURRENT',
  Primary = 'PRIMARY'
}

export type EngagementSettingsModel = {
  __typename?: 'EngagementSettingsModel';
  dateOfInvoice?: Maybe<Scalars['Int']['output']>;
  dayOfInvoice?: Maybe<DayOfWeek>;
  invoiceFrequency?: Maybe<InvoiceFrequencyModel>;
};

export type EngagementSettingsModelInput = {
  dateOfInvoice?: InputMaybe<Scalars['Int']['input']>;
  dayOfInvoice?: InputMaybe<DayOfWeek>;
  invoiceFrequency?: InputMaybe<InvoiceFrequencyModel>;
};

export type EngagementSpendItemModel = {
  __typename?: 'EngagementSpendItemModel';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<EngagementSpendStatusModel>;
  tax?: Maybe<Scalars['Float']['output']>;
};

export type EngagementSpendItemModelInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EngagementSpendStatusModel>;
  tax?: InputMaybe<Scalars['Float']['input']>;
};

export type EngagementSpendModel = {
  __typename?: 'EngagementSpendModel';
  items?: Maybe<Array<Maybe<EngagementSpendItemModel>>>;
};

export type EngagementSpendModelInput = {
  items?: InputMaybe<Array<InputMaybe<EngagementSpendItemModelInput>>>;
};

export enum EngagementSpendStatusModel {
  Approved = 'APPROVED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  Pending = 'PENDING',
  Total = 'TOTAL'
}

export enum EngagementStatusModel {
  Draft = 'DRAFT',
  Offboarded = 'OFFBOARDED',
  Offboarding = 'OFFBOARDING',
  Onboarded = 'ONBOARDED',
  Onboarding = 'ONBOARDING',
  PreHire = 'PRE_HIRE'
}

export type EngagementWorkLocationModel = {
  __typename?: 'EngagementWorkLocationModel';
  address?: Maybe<AddressModel>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EngagementWorkLocationTypeModel>;
};

export type EngagementWorkLocationModelInput = {
  address?: InputMaybe<AddressModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EngagementWorkLocationTypeModel>;
};

export enum EngagementWorkLocationTypeModel {
  OnSite = 'ON_SITE',
  Remote = 'REMOTE'
}

export type EngagementsDiagnosticsModel = {
  __typename?: 'EngagementsDiagnosticsModel';
  engagements?: Maybe<BaseEngagementDiagnosticsModel>;
  entityVersion?: Maybe<Scalars['Int']['output']>;
};

export type EngagementsModel = {
  __typename?: 'EngagementsModel';
  engagements?: Maybe<Array<Maybe<EngagementModel>>>;
};

export type EngagementsModelInput = {
  engagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
};

export type EngagementsQueryModel = {
  __typename?: 'EngagementsQueryModel';
  activeOnly?: Maybe<Scalars['Boolean']['output']>;
  classificationType?: Maybe<ClassificationTypeModel>;
  overlapsWithRange?: Maybe<DateRangeModel>;
  supplierUid?: Maybe<Scalars['String']['output']>;
  uids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EngagementsQueryModelInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  classificationType?: InputMaybe<ClassificationTypeModel>;
  overlapsWithRange?: InputMaybe<DateRangeModelInput>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EngagementsRevisionsDiagnosticsModel = {
  __typename?: 'EngagementsRevisionsDiagnosticsModel';
  engagements?: Maybe<BaseEngagementDiagnosticsModel>;
  rev?: Maybe<Scalars['Long']['output']>;
  revType?: Maybe<RevType>;
};

export type EntityFinancialCustomFieldDefinitionsQueryModelInput = {
  parentEntityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type EntityStatusFilterModelInput = {
  equals?: InputMaybe<EntityStatusModel>;
  includes?: InputMaybe<Array<InputMaybe<EntityStatusModel>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<EntityStatusModel>;
  notIncludes?: InputMaybe<Array<InputMaybe<EntityStatusModel>>>;
};

export enum EntityStatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type EnumMap_DayOfWeek_DoubleInput = {
  FRIDAY?: InputMaybe<Scalars['Float']['input']>;
  MONDAY?: InputMaybe<Scalars['Float']['input']>;
  SATURDAY?: InputMaybe<Scalars['Float']['input']>;
  SUNDAY?: InputMaybe<Scalars['Float']['input']>;
  THURSDAY?: InputMaybe<Scalars['Float']['input']>;
  TUESDAY?: InputMaybe<Scalars['Float']['input']>;
  WEDNESDAY?: InputMaybe<Scalars['Float']['input']>;
};

export enum EnumTypeModel {
  BatchExecutionStatus = 'BATCH_EXECUTION_STATUS',
  BlueprintBillingFrequency = 'BLUEPRINT_BILLING_FREQUENCY',
  BlueprintExecutionMode = 'BLUEPRINT_EXECUTION_MODE',
  BlueprintExecutionStatus = 'BLUEPRINT_EXECUTION_STATUS',
  ContractStatus = 'CONTRACT_STATUS',
  ContractType = 'CONTRACT_TYPE',
  CreatePermission = 'CREATE_PERMISSION',
  DayGrouping = 'DAY_GROUPING',
  DayOfWeek = 'DAY_OF_WEEK',
  EngagementManagingSource = 'ENGAGEMENT_MANAGING_SOURCE',
  EngagementStatus = 'ENGAGEMENT_STATUS',
  EngagementTimesheetView = 'ENGAGEMENT_TIMESHEET_VIEW',
  EngagementWorkLocationType = 'ENGAGEMENT_WORK_LOCATION_TYPE',
  EntityStatus = 'ENTITY_STATUS',
  ExpenseStatus = 'EXPENSE_STATUS',
  ExpenseType = 'EXPENSE_TYPE',
  HighestLevelOfEducation = 'HIGHEST_LEVEL_OF_EDUCATION',
  InterviewStatus = 'INTERVIEW_STATUS',
  InterviewType = 'INTERVIEW_TYPE',
  InvoiceFrequency = 'INVOICE_FREQUENCY',
  InvoiceStatus = 'INVOICE_STATUS',
  JobApplicationStatus = 'JOB_APPLICATION_STATUS',
  JobPostingBusinessReason = 'JOB_POSTING_BUSINESS_REASON',
  JobRequestStatus = 'JOB_REQUEST_STATUS',
  JobRequestSupplierInviteStatus = 'JOB_REQUEST_SUPPLIER_INVITE_STATUS',
  JobRequestType = 'JOB_REQUEST_TYPE',
  MilestoneStatus = 'MILESTONE_STATUS',
  PayRatePeriod = 'PAY_RATE_PERIOD',
  PayRateType = 'PAY_RATE_TYPE',
  ProjectStatus = 'PROJECT_STATUS',
  RatePeriod = 'RATE_PERIOD',
  RehireEligibility = 'REHIRE_ELIGIBILITY',
  SourcingType = 'SOURCING_TYPE',
  SowResponseStatus = 'SOW_RESPONSE_STATUS',
  TerminationReason = 'TERMINATION_REASON',
  TimesheetPayBillType = 'TIMESHEET_PAY_BILL_TYPE',
  TimesheetStatus = 'TIMESHEET_STATUS',
  UserRole = 'USER_ROLE',
  WorkerCertificationComplianceStatus = 'WORKER_CERTIFICATION_COMPLIANCE_STATUS',
  WorkerCertificationValidationStatus = 'WORKER_CERTIFICATION_VALIDATION_STATUS',
  WorkRequestStatus = 'WORK_REQUEST_STATUS',
  WorkRequestWorkLocationType = 'WORK_REQUEST_WORK_LOCATION_TYPE',
  YesNo = 'YES_NO'
}

export type ErrorEventDefinitionModel = {
  __typename?: 'ErrorEventDefinitionModel';
  errorCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ErrorEventDefinitionModelInput = {
  errorCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum EthnicityModel {
  AnotherRacialOrEthnicIdentity = 'ANOTHER_RACIAL_OR_ETHNIC_IDENTITY',
  BlackInclAfricanAmerican = 'BLACK_INCL_AFRICAN_AMERICAN',
  EastAsian = 'EAST_ASIAN',
  HispanicLatinoOrLatinx = 'HISPANIC_LATINO_OR_LATINX',
  MiddleEasternOrNorthAfrican = 'MIDDLE_EASTERN_OR_NORTH_AFRICAN',
  NativeAmericanOrAlaskaNative = 'NATIVE_AMERICAN_OR_ALASKA_NATIVE',
  Other = 'OTHER',
  PacificIslanderInclNativeHawaiian = 'PACIFIC_ISLANDER_INCL_NATIVE_HAWAIIAN',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  SouthAsian = 'SOUTH_ASIAN',
  WhiteOrCaucasian = 'WHITE_OR_CAUCASIAN'
}

export type EventDefinitionModel = FlowNodeModel & {
  __typename?: 'EventDefinitionModel';
  assignmentConfiguration?: Maybe<AssignmentConfigurationModel>;
  attachedTo?: Maybe<Scalars['String']['output']>;
  errorEventDefinitionModel?: Maybe<ErrorEventDefinitionModel>;
  eventType?: Maybe<ProcessDefinitionEventTypeModel>;
  fieldConditions?: Maybe<Array<Maybe<FieldConditionModel>>>;
  flowNodeType?: Maybe<FlowNodeTypeModel>;
  id?: Maybe<Scalars['String']['output']>;
  managingSourcesCondition?: Maybe<FieldConditionModel>;
  name?: Maybe<Scalars['String']['output']>;
  signalEventDefinitionModel?: Maybe<SignalEventDefinitionModel>;
  startEventCondition?: Maybe<LogicalConditionModel>;
  startEventType?: Maybe<StartEventTypeModel>;
  timerEventDefinitionModel?: Maybe<TimerEventDefinitionModel>;
};

export type EventDefinitionModelInput = {
  assignmentConfiguration?: InputMaybe<AssignmentConfigurationModelInput>;
  attachedTo?: InputMaybe<Scalars['String']['input']>;
  errorEventDefinitionModel?: InputMaybe<ErrorEventDefinitionModelInput>;
  eventType?: InputMaybe<ProcessDefinitionEventTypeModel>;
  fieldConditions?: InputMaybe<Array<InputMaybe<FieldConditionModelInput>>>;
  flowNodeType?: InputMaybe<FlowNodeTypeModel>;
  id?: InputMaybe<Scalars['String']['input']>;
  managingSourcesCondition?: InputMaybe<FieldConditionModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  signalEventDefinitionModel?: InputMaybe<SignalEventDefinitionModelInput>;
  startEventCondition?: InputMaybe<LogicalConditionModelInput>;
  startEventType?: InputMaybe<StartEventTypeModel>;
  timerEventDefinitionModel?: InputMaybe<TimerEventDefinitionModelInput>;
};

export type ExpenseAmountModel = {
  __typename?: 'ExpenseAmountModel';
  currency?: Maybe<CurrencyModel>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ExpenseAmountModelInput = {
  currency?: InputMaybe<CurrencyModelInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum ExpenseApprovalStatusModel {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ExpenseApprovalUpdateModelInput = {
  approverPersonUid?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  decision?: InputMaybe<ExpenseApprovalStatusModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseAttachmentModel = {
  __typename?: 'ExpenseAttachmentModel';
  filename?: Maybe<Scalars['String']['output']>;
  mediaUid?: Maybe<Scalars['String']['output']>;
};

export type ExpenseAttachmentModelInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  mediaUid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseCategoriesModel = {
  __typename?: 'ExpenseCategoriesModel';
  items?: Maybe<Array<Maybe<ExpenseCategoryModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExpenseCategoryCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  validCurrencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExpenseCategoryModel = {
  __typename?: 'ExpenseCategoryModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ExpenseCategoryStatusModel>;
  uid: Scalars['String']['output'];
  validCurrencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExpenseCategoryModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpenseCategoryModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ExpenseCategoryStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  validCurrencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExpenseCategoryQueryModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validCurrencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ExpenseCategoryStatusModel {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type ExpenseCategoryUpdateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ExpenseCategoryStatusModel>;
  validCurrencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExpenseCreateModelInput = {
  amount?: InputMaybe<ExpenseAmountModelInput>;
  costCenter?: InputMaybe<UidReferenceIdInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementIdentifierInput>;
  expenseCategory?: InputMaybe<UidReferenceIdInput>;
  financialFields?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  spentDate?: InputMaybe<Scalars['LocalDate']['input']>;
  supplier?: InputMaybe<UidReferenceIdInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpenseInvoiceModel = {
  __typename?: 'ExpenseInvoiceModel';
  consolidatedInvoiceId?: Maybe<Scalars['String']['output']>;
  consolidatedInvoiceUid?: Maybe<Scalars['String']['output']>;
  invoiceBlueprintExecutionUid?: Maybe<Scalars['String']['output']>;
  invoiceExecutionMode?: Maybe<InvoicingBlueprintExecutionModeModel>;
  /** @deprecated Use supplierInvoiceId */
  invoiceNumber?: Maybe<Scalars['Long']['output']>;
  /** @deprecated Use consolidatedInvoiceUid (V2) or supplierInvoiceUid (V1) */
  invoiceUid?: Maybe<Scalars['String']['output']>;
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
  supplierInvoiceUid?: Maybe<Scalars['String']['output']>;
};

export type ExpenseInvoiceModelInput = {
  consolidatedInvoiceId?: InputMaybe<Scalars['String']['input']>;
  consolidatedInvoiceUid?: InputMaybe<Scalars['String']['input']>;
  invoiceBlueprintExecutionUid?: InputMaybe<Scalars['String']['input']>;
  invoiceExecutionMode?: InputMaybe<InvoicingBlueprintExecutionModeModel>;
  invoiceNumber?: InputMaybe<Scalars['Long']['input']>;
  invoiceUid?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceUid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseModel = {
  __typename?: 'ExpenseModel';
  amount?: Maybe<ExpenseAmountModel>;
  approvalDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  approvals?: Maybe<Array<Maybe<ApprovalModel>>>;
  approver?: Maybe<PersonModel>;
  attachments?: Maybe<Array<Maybe<ExpenseAttachmentModel>>>;
  clientInvoice?: Maybe<ExpenseAmountModel>;
  costCenter?: Maybe<CostCenterModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creditExpense?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<EngagementModel>;
  engagementUid?: Maybe<Scalars['String']['output']>;
  expenseCategory?: Maybe<ExpenseCategoryModel>;
  expenseType?: Maybe<ExpenseTypeModel>;
  fee?: Maybe<ExpenseAmountModel>;
  financialObjects?: Maybe<Array<Maybe<FinancialObjectModel>>>;
  /** @deprecated Use invoices for full chronological history */
  invoice?: Maybe<ExpenseInvoiceModel>;
  invoices?: Maybe<Array<Maybe<ExpenseInvoiceModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  previousExpense?: Maybe<ExpenseModel>;
  /** @deprecated will be inside approvals elements */
  rejectReason?: Maybe<Scalars['String']['output']>;
  requiresActionReasons?: Maybe<Array<Maybe<RequiresActionReasonModel>>>;
  requiresActions?: Maybe<Scalars['Boolean']['output']>;
  semanticVersion?: Maybe<Scalars['String']['output']>;
  spentDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<ExpenseStatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierAmount?: Maybe<ExpenseAmountModel>;
  /** @deprecated Deprecated in favour of supplier.name. Will be removed after 2023.01.01 */
  supplierName?: Maybe<Scalars['String']['output']>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  /** @deprecated Deprecated in favour of supplier.uid. Will be removed after 2023.01.01 */
  supplierUid?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<ExpenseAmountModel>;
  uid: Scalars['String']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
  workerVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type ExpenseModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExpenseModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type ExpenseModelInput = {
  amount?: InputMaybe<ExpenseAmountModelInput>;
  approvalDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  approvals?: InputMaybe<Array<InputMaybe<ApprovalModelInput>>>;
  approver?: InputMaybe<PersonModelInput>;
  attachments?: InputMaybe<Array<InputMaybe<ExpenseAttachmentModelInput>>>;
  clientInvoice?: InputMaybe<ExpenseAmountModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creditExpense?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementModelInput>;
  engagementUid?: InputMaybe<Scalars['String']['input']>;
  expenseCategory?: InputMaybe<ExpenseCategoryModelInput>;
  expenseType?: InputMaybe<ExpenseTypeModel>;
  fee?: InputMaybe<ExpenseAmountModelInput>;
  financialObjects?: InputMaybe<Array<InputMaybe<FinancialObjectModelInput>>>;
  invoice?: InputMaybe<ExpenseInvoiceModelInput>;
  invoices?: InputMaybe<Array<InputMaybe<ExpenseInvoiceModelInput>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Long']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  person?: InputMaybe<PersonModelInput>;
  previousExpense?: InputMaybe<ExpenseModelInput>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  requiresActionReasons?: InputMaybe<Array<InputMaybe<RequiresActionReasonModelInput>>>;
  requiresActions?: InputMaybe<Scalars['Boolean']['input']>;
  semanticVersion?: InputMaybe<Scalars['String']['input']>;
  spentDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<ExpenseStatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  supplierAmount?: InputMaybe<ExpenseAmountModelInput>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<ExpenseAmountModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  workerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpensePageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<ExpenseSortModelInput>>>;
};

export type ExpensePatchModelInput = {
  amount?: InputMaybe<ExpenseAmountModelInput>;
  costCenter?: InputMaybe<UidReferenceIdInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementIdentifierInput>;
  expenseCategory?: InputMaybe<UidReferenceIdInput>;
  financialFields?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  merchant?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  spentDate?: InputMaybe<Scalars['LocalDate']['input']>;
  supplier?: InputMaybe<UidReferenceIdInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpenseQueryModelInput = {
  approvalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  approvalDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  dateWindow?: InputMaybe<RelativeDateRangeModelInput>;
  expenseTypes?: InputMaybe<Array<InputMaybe<ExpenseTypeModel>>>;
  lastUpdatedRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  modifiedSince?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyUnexported?: InputMaybe<Scalars['Boolean']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  requiresActions?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  semanticVersions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<ExpenseStatusModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExpenseSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<ExpenseSortTypeModel>;
};

export enum ExpenseSortTypeModel {
  LastUpdated = 'LAST_UPDATED',
  Name = 'NAME',
  Status = 'STATUS'
}

export enum ExpenseStatusModel {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ExpenseSubmittalConfigurationModel = {
  __typename?: 'ExpenseSubmittalConfigurationModel';
  supplierGeneralExpensesEnabled: Scalars['Boolean']['output'];
  supplierWorkerExpensesEnabled: Scalars['Boolean']['output'];
  workerExpensesEnabled: Scalars['Boolean']['output'];
};

export type ExpenseSubmittalConfigurationModelInput = {
  supplierGeneralExpensesEnabled: Scalars['Boolean']['input'];
  supplierWorkerExpensesEnabled: Scalars['Boolean']['input'];
  workerExpensesEnabled: Scalars['Boolean']['input'];
};

export enum ExpenseTypeModel {
  GeneralExpense = 'GENERAL_EXPENSE',
  WorkerExpense = 'WORKER_EXPENSE'
}

export type ExpensesModel = {
  __typename?: 'ExpensesModel';
  elements?: Maybe<Array<Maybe<ExpenseModel>>>;
  expenses?: Maybe<Array<Maybe<ExpenseModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceRangeModel = {
  __typename?: 'ExperienceRangeModel';
  maxYears?: Maybe<Scalars['Int']['output']>;
  minYears?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceRangeModelInput = {
  maxYears?: InputMaybe<Scalars['Int']['input']>;
  minYears?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportColumnConfigModelInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ExportResponseModel = {
  __typename?: 'ExportResponseModel';
  id?: Maybe<Scalars['Long']['output']>;
  notificationUid?: Maybe<Scalars['String']['output']>;
};

export enum ExternalApproverTypeModel {
  AlternateApprover = 'ALTERNATE_APPROVER',
  PrimaryApprover = 'PRIMARY_APPROVER'
}

export type FactorBillingVariableModel = {
  __typename?: 'FactorBillingVariableModel';
  code?: Maybe<Scalars['String']['output']>;
  feesType?: Maybe<FeesTypeModel>;
  name?: Maybe<Scalars['String']['output']>;
  payBillRateType?: Maybe<PayBillRateTypeModel>;
  rateType?: Maybe<RateTypeModel>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum FeesTypeModel {
  MspFee = 'MSP_FEE',
  Other = 'OTHER',
  VmsFee = 'VMS_FEE'
}

export type FieldAssignmentModel = {
  __typename?: 'FieldAssignmentModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<FieldKeyModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FieldAssignmentModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<FieldKeyModel>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FieldConditionModel = {
  __typename?: 'FieldConditionModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<FieldKeyModel>;
  operator?: Maybe<FieldConditionOperatorModel>;
  otherField?: Maybe<FieldReferenceModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FieldConditionModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<FieldKeyModel>;
  operator?: InputMaybe<FieldConditionOperatorModel>;
  otherField?: InputMaybe<FieldReferenceModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum FieldConditionOperatorModel {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  HasChanged = 'HAS_CHANGED',
  HasDecreased = 'HAS_DECREASED',
  HasIncreased = 'HAS_INCREASED',
  InRange = 'IN_RANGE',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
  Offset = 'OFFSET'
}

export type FieldConstraintDeclarationModel = {
  __typename?: 'FieldConstraintDeclarationModel';
  constrainedByFieldKey?: Maybe<FieldKeyModel>;
  entityType?: Maybe<FieldConstraintEntityTypeModel>;
  fieldKey?: Maybe<FieldKeyModel>;
  type?: Maybe<FieldConstraintTypeModel>;
};

export type FieldConstraintDeclarationsModel = {
  __typename?: 'FieldConstraintDeclarationsModel';
  items?: Maybe<Array<Maybe<FieldConstraintDeclarationModel>>>;
};

export type FieldConstraintDefinitionCreateModelInput = {
  constrainedByCustomFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  constrainedByCustomFieldReferenceId?: InputMaybe<Scalars['String']['input']>;
  constrainedByFieldKey?: InputMaybe<FieldKeyModel>;
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  customFieldReferenceId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<FieldConstraintEntityTypeModel>;
  fieldKey?: InputMaybe<FieldKeyModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FieldConstraintTypeModel>;
};

export type FieldConstraintDefinitionModel = {
  __typename?: 'FieldConstraintDefinitionModel';
  constrainedByCustomFieldDefinitionUid?: Maybe<Scalars['String']['output']>;
  constrainedByCustomFieldReferenceId?: Maybe<Scalars['String']['output']>;
  constrainedByFieldKey?: Maybe<FieldKeyModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customFieldDefinitionUid?: Maybe<Scalars['String']['output']>;
  customFieldReferenceId?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  entityType?: Maybe<FieldConstraintEntityTypeModel>;
  fieldKey?: Maybe<FieldKeyModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  relatedValueSet?: Maybe<Array<Maybe<FieldConstraintRelatedValueSetEntryModel>>>;
  status?: Maybe<StatusModel>;
  type?: Maybe<FieldConstraintTypeModel>;
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};


export type FieldConstraintDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldConstraintDefinitionUpdateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  relatedValueSet?: InputMaybe<Array<InputMaybe<FieldConstraintRelatedValueSetEntryModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type FieldConstraintDefinitionsModel = {
  __typename?: 'FieldConstraintDefinitionsModel';
  items?: Maybe<Array<Maybe<FieldConstraintDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FieldConstraintDefinitionsQueryModelInput = {
  entityTypes?: InputMaybe<Array<InputMaybe<FieldConstraintEntityTypeModel>>>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
  types?: InputMaybe<Array<InputMaybe<FieldConstraintTypeModel>>>;
};

export enum FieldConstraintEntityTypeModel {
  Contract = 'CONTRACT',
  Engagement = 'ENGAGEMENT',
  JobRequest = 'JOB_REQUEST',
  Milestone = 'MILESTONE',
  WorkRequest = 'WORK_REQUEST'
}

export type FieldConstraintModelInput = {
  customFieldReferenceId?: InputMaybe<Scalars['String']['input']>;
  fieldConstraintDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<FieldKeyModel>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FieldConstraintRelatedValueSetEntryModel = {
  __typename?: 'FieldConstraintRelatedValueSetEntryModel';
  constrainedByValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FieldConstraintRelatedValueSetEntryModelInput = {
  constrainedByValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FieldConstraintTypeModel {
  RelatedValueSet = 'RELATED_VALUE_SET'
}

export type FieldDefinitionModel = {
  __typename?: 'FieldDefinitionModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  enumType?: Maybe<EnumTypeModel>;
  key?: Maybe<FieldKeyModel>;
  label?: Maybe<Scalars['String']['output']>;
  multivalued?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<ObjectTypeModel>;
  parentKey?: Maybe<FieldKeyModel>;
  parentObjectType?: Maybe<ObjectTypeModel>;
  qualifiedLabel?: Maybe<Scalars['String']['output']>;
  qualifiedName?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FieldTypeModel>;
  urn?: Maybe<Scalars['String']['output']>;
};

export type FieldDefinitionsModel = {
  __typename?: 'FieldDefinitionsModel';
  fieldDefinitions?: Maybe<Array<Maybe<FieldDefinitionModel>>>;
};

export enum FieldKeyModel {
  BatchExecution = 'BATCH_EXECUTION',
  BatchExecutionBatchName = 'BATCH_EXECUTION_BATCH_NAME',
  BatchExecutionClientAmount = 'BATCH_EXECUTION_CLIENT_AMOUNT',
  BatchExecutionGrossAmount = 'BATCH_EXECUTION_GROSS_AMOUNT',
  BatchExecutionInvoiceBatchId = 'BATCH_EXECUTION_INVOICE_BATCH_ID',
  BatchExecutionInvoiceNumber = 'BATCH_EXECUTION_INVOICE_NUMBER',
  BatchExecutionLinkToInvoiceSummary = 'BATCH_EXECUTION_LINK_TO_INVOICE_SUMMARY',
  BatchExecutionStatus = 'BATCH_EXECUTION_STATUS',
  BatchExecutionSupplier = 'BATCH_EXECUTION_SUPPLIER',
  BatchExecutionSupplierAmount = 'BATCH_EXECUTION_SUPPLIER_AMOUNT',
  BlueprintExecution = 'BLUEPRINT_EXECUTION',
  BlueprintExecutionBillingEndDate = 'BLUEPRINT_EXECUTION_BILLING_END_DATE',
  BlueprintExecutionBillingFrequency = 'BLUEPRINT_EXECUTION_BILLING_FREQUENCY',
  BlueprintExecutionBlueprintName = 'BLUEPRINT_EXECUTION_BLUEPRINT_NAME',
  BlueprintExecutionButtonToInvoiceSummary = 'BLUEPRINT_EXECUTION_BUTTON_TO_INVOICE_SUMMARY',
  BlueprintExecutionClientAmount = 'BLUEPRINT_EXECUTION_CLIENT_AMOUNT',
  BlueprintExecutionGrossAmount = 'BLUEPRINT_EXECUTION_GROSS_AMOUNT',
  BlueprintExecutionInvoiceNumber = 'BLUEPRINT_EXECUTION_INVOICE_NUMBER',
  BlueprintExecutionLinkToExecutionSummary = 'BLUEPRINT_EXECUTION_LINK_TO_EXECUTION_SUMMARY',
  BlueprintExecutionLinkToInvoiceSummary = 'BLUEPRINT_EXECUTION_LINK_TO_INVOICE_SUMMARY',
  BlueprintExecutionMode = 'BLUEPRINT_EXECUTION_MODE',
  BlueprintExecutionRunDate = 'BLUEPRINT_EXECUTION_RUN_DATE',
  BlueprintExecutionStatus = 'BLUEPRINT_EXECUTION_STATUS',
  BlueprintExecutionSuppliers = 'BLUEPRINT_EXECUTION_SUPPLIERS',
  BlueprintExecutionSupplierAmount = 'BLUEPRINT_EXECUTION_SUPPLIER_AMOUNT',
  Classification = 'CLASSIFICATION',
  ClassificationReferenceId = 'CLASSIFICATION_REFERENCE_ID',
  ClassificationUid = 'CLASSIFICATION_UID',
  Contract = 'CONTRACT',
  ContractAccountablePerson = 'CONTRACT_ACCOUNTABLE_PERSON',
  ContractBudgetApprovedAmount = 'CONTRACT_BUDGET_APPROVED_AMOUNT',
  ContractBudgetOriginalAmount = 'CONTRACT_BUDGET_ORIGINAL_AMOUNT',
  ContractBusinessSite = 'CONTRACT_BUSINESS_SITE',
  ContractCompany = 'CONTRACT_COMPANY',
  ContractContractingParty = 'CONTRACT_CONTRACTING_PARTY',
  ContractCostCenter = 'CONTRACT_COST_CENTER',
  ContractCurrency = 'CONTRACT_CURRENCY',
  ContractCustomField = 'CONTRACT_CUSTOM_FIELD',
  ContractDescription = 'CONTRACT_DESCRIPTION',
  ContractDocuments = 'CONTRACT_DOCUMENTS',
  ContractEndDate = 'CONTRACT_END_DATE',
  ContractHolidaySchedule = 'CONTRACT_HOLIDAY_SCHEDULE',
  ContractId = 'CONTRACT_ID',
  ContractParentContract = 'CONTRACT_PARENT_CONTRACT',
  ContractPoNumber = 'CONTRACT_PO_NUMBER',
  ContractPrimaryDocument = 'CONTRACT_PRIMARY_DOCUMENT',
  ContractReferenceId = 'CONTRACT_REFERENCE_ID',
  ContractSourcingType = 'CONTRACT_SOURCING_TYPE',
  ContractStartDate = 'CONTRACT_START_DATE',
  ContractStatus = 'CONTRACT_STATUS',
  ContractSupervisoryOrg = 'CONTRACT_SUPERVISORY_ORG',
  ContractSupplier = 'CONTRACT_SUPPLIER',
  ContractTitle = 'CONTRACT_TITLE',
  ContractType = 'CONTRACT_TYPE',
  ContractWorkSchedule = 'CONTRACT_WORK_SCHEDULE',
  EligibilityRequirement = 'ELIGIBILITY_REQUIREMENT',
  EligibilityRequirementIssuer = 'ELIGIBILITY_REQUIREMENT_ISSUER',
  EligibilityRequirementName = 'ELIGIBILITY_REQUIREMENT_NAME',
  Engagement = 'ENGAGEMENT',
  EngagementAccountablePerson = 'ENGAGEMENT_ACCOUNTABLE_PERSON',
  EngagementAlternateExternalApprover = 'ENGAGEMENT_ALTERNATE_EXTERNAL_APPROVER',
  EngagementAlternateExternalApproverFirstName = 'ENGAGEMENT_ALTERNATE_EXTERNAL_APPROVER_FIRST_NAME',
  EngagementAlternateExternalApproverLastName = 'ENGAGEMENT_ALTERNATE_EXTERNAL_APPROVER_LAST_NAME',
  EngagementAlternateExternalApproverPreferredFirstName = 'ENGAGEMENT_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  EngagementAlternateExternalApproverPreferredLastName = 'ENGAGEMENT_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  EngagementBadgeId = 'ENGAGEMENT_BADGE_ID',
  EngagementBillRate = 'ENGAGEMENT_BILL_RATE',
  EngagementBudgetApprovedAmount = 'ENGAGEMENT_BUDGET_APPROVED_AMOUNT',
  EngagementBudgetOriginalAmount = 'ENGAGEMENT_BUDGET_ORIGINAL_AMOUNT',
  EngagementBusinessSite = 'ENGAGEMENT_BUSINESS_SITE',
  EngagementBusinessSiteCity = 'ENGAGEMENT_BUSINESS_SITE_CITY',
  EngagementBusinessSiteRegion = 'ENGAGEMENT_BUSINESS_SITE_REGION',
  EngagementClassification = 'ENGAGEMENT_CLASSIFICATION',
  EngagementClockInTimes = 'ENGAGEMENT_CLOCK_IN_TIMES',
  EngagementCompany = 'ENGAGEMENT_COMPANY',
  EngagementContract = 'ENGAGEMENT_CONTRACT',
  EngagementCostCenter = 'ENGAGEMENT_COST_CENTER',
  EngagementCostCenters = 'ENGAGEMENT_COST_CENTERS',
  EngagementCostCenterCode = 'ENGAGEMENT_COST_CENTER_CODE',
  EngagementCountry = 'ENGAGEMENT_COUNTRY',
  EngagementCountryStateCode = 'ENGAGEMENT_COUNTRY_STATE_CODE',
  EngagementCustomField = 'ENGAGEMENT_CUSTOM_FIELD',
  EngagementEndDate = 'ENGAGEMENT_END_DATE',
  EngagementEstimatedAdditionalCosts = 'ENGAGEMENT_ESTIMATED_ADDITIONAL_COSTS',
  EngagementFinancialField = 'ENGAGEMENT_FINANCIAL_FIELD',
  EngagementFinancialFields = 'ENGAGEMENT_FINANCIAL_FIELDS',
  EngagementFirstLevelManager = 'ENGAGEMENT_FIRST_LEVEL_MANAGER',
  EngagementHolidaySchedule = 'ENGAGEMENT_HOLIDAY_SCHEDULE',
  EngagementId = 'ENGAGEMENT_ID',
  EngagementJobApplication = 'ENGAGEMENT_JOB_APPLICATION',
  EngagementJobFamily = 'ENGAGEMENT_JOB_FAMILY',
  EngagementJobFamilyGroup = 'ENGAGEMENT_JOB_FAMILY_GROUP',
  EngagementJobProfile = 'ENGAGEMENT_JOB_PROFILE',
  EngagementJobRequest = 'ENGAGEMENT_JOB_REQUEST',
  EngagementJobSummary = 'ENGAGEMENT_JOB_SUMMARY',
  EngagementManager = 'ENGAGEMENT_MANAGER',
  EngagementManagerCompanyWorkerId = 'ENGAGEMENT_MANAGER_COMPANY_WORKER_ID',
  EngagementManagerCustomField = 'ENGAGEMENT_MANAGER_CUSTOM_FIELD',
  EngagementManagerPersonalEmail = 'ENGAGEMENT_MANAGER_PERSONAL_EMAIL',
  EngagementManagerWorkEmail = 'ENGAGEMENT_MANAGER_WORK_EMAIL',
  EngagementManagingSources = 'ENGAGEMENT_MANAGING_SOURCES',
  EngagementMsp = 'ENGAGEMENT_MSP',
  EngagementOriginalStartDate = 'ENGAGEMENT_ORIGINAL_START_DATE',
  EngagementPayRate = 'ENGAGEMENT_PAY_RATE',
  EngagementPoNumber = 'ENGAGEMENT_PO_NUMBER',
  EngagementPrimaryExternalApprover = 'ENGAGEMENT_PRIMARY_EXTERNAL_APPROVER',
  EngagementPrimaryExternalApproverFirstName = 'ENGAGEMENT_PRIMARY_EXTERNAL_APPROVER_FIRST_NAME',
  EngagementPrimaryExternalApproverLastName = 'ENGAGEMENT_PRIMARY_EXTERNAL_APPROVER_LAST_NAME',
  EngagementPrimaryExternalApproverPreferredFirstName = 'ENGAGEMENT_PRIMARY_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  EngagementPrimaryExternalApproverPreferredLastName = 'ENGAGEMENT_PRIMARY_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  EngagementPriorSpend = 'ENGAGEMENT_PRIOR_SPEND',
  EngagementProject = 'ENGAGEMENT_PROJECT',
  EngagementProjectCustomField = 'ENGAGEMENT_PROJECT_CUSTOM_FIELD',
  EngagementProjectPosition = 'ENGAGEMENT_PROJECT_POSITION',
  EngagementProjectPositionRate = 'ENGAGEMENT_PROJECT_POSITION_RATE',
  EngagementRate = 'ENGAGEMENT_RATE',
  EngagementRateAmount = 'ENGAGEMENT_RATE_AMOUNT',
  EngagementRateBaseRate = 'ENGAGEMENT_RATE_BASE_RATE',
  EngagementRateCard = 'ENGAGEMENT_RATE_CARD',
  EngagementRateCardRate = 'ENGAGEMENT_RATE_CARD_RATE',
  EngagementRateCurrency = 'ENGAGEMENT_RATE_CURRENCY',
  EngagementRateFrequency = 'ENGAGEMENT_RATE_FREQUENCY',
  EngagementRateMultiplier = 'ENGAGEMENT_RATE_MULTIPLIER',
  EngagementRemoteWorkAddress = 'ENGAGEMENT_REMOTE_WORK_ADDRESS',
  EngagementSecondaryTerminationReason = 'ENGAGEMENT_SECONDARY_TERMINATION_REASON',
  EngagementSecondLevelManager = 'ENGAGEMENT_SECOND_LEVEL_MANAGER',
  EngagementSettings = 'ENGAGEMENT_SETTINGS',
  EngagementSettingsDateOfInvoice = 'ENGAGEMENT_SETTINGS_DATE_OF_INVOICE',
  EngagementSettingsDayOfInvoice = 'ENGAGEMENT_SETTINGS_DAY_OF_INVOICE',
  EngagementSettingsInvoiceFrequency = 'ENGAGEMENT_SETTINGS_INVOICE_FREQUENCY',
  EngagementStartDate = 'ENGAGEMENT_START_DATE',
  EngagementStatus = 'ENGAGEMENT_STATUS',
  EngagementSupervisoryOrg = 'ENGAGEMENT_SUPERVISORY_ORG',
  EngagementSupplier = 'ENGAGEMENT_SUPPLIER',
  EngagementTerminationReason = 'ENGAGEMENT_TERMINATION_REASON',
  EngagementTimesheetSubmission = 'ENGAGEMENT_TIMESHEET_SUBMISSION',
  EngagementTimesheetView = 'ENGAGEMENT_TIMESHEET_VIEW',
  EngagementTitle = 'ENGAGEMENT_TITLE',
  EngagementUid = 'ENGAGEMENT_UID',
  EngagementWorkdayPositionId = 'ENGAGEMENT_WORKDAY_POSITION_ID',
  EngagementWorkerQualificationCount = 'ENGAGEMENT_WORKER_QUALIFICATION_COUNT',
  EngagementWorkEmail = 'ENGAGEMENT_WORK_EMAIL',
  EngagementWorkLocationType = 'ENGAGEMENT_WORK_LOCATION_TYPE',
  EngagementWorkPhone = 'ENGAGEMENT_WORK_PHONE',
  EngagementWorkPhones = 'ENGAGEMENT_WORK_PHONES',
  EngagementWorkRequest = 'ENGAGEMENT_WORK_REQUEST',
  EngagementWorkSchedule = 'ENGAGEMENT_WORK_SCHEDULE',
  Expense = 'EXPENSE',
  ExpenseAmount = 'EXPENSE_AMOUNT',
  ExpenseAmountCurrency = 'EXPENSE_AMOUNT_CURRENCY',
  ExpenseAmountValue = 'EXPENSE_AMOUNT_VALUE',
  ExpenseCategory = 'EXPENSE_CATEGORY',
  ExpenseDescription = 'EXPENSE_DESCRIPTION',
  ExpenseFee = 'EXPENSE_FEE',
  ExpenseFinancialCustomField = 'EXPENSE_FINANCIAL_CUSTOM_FIELD',
  ExpenseId = 'EXPENSE_ID',
  ExpenseRejectionReason = 'EXPENSE_REJECTION_REASON',
  ExpenseSpentDate = 'EXPENSE_SPENT_DATE',
  ExpenseStatus = 'EXPENSE_STATUS',
  ExpenseSupplierName = 'EXPENSE_SUPPLIER_NAME',
  ExpenseTax = 'EXPENSE_TAX',
  ExpenseType = 'EXPENSE_TYPE',
  ExpenseWorkerName = 'EXPENSE_WORKER_NAME',
  Interview = 'INTERVIEW',
  InterviewStatus = 'INTERVIEW_STATUS',
  InterviewType = 'INTERVIEW_TYPE',
  Invoice = 'INVOICE',
  InvoiceApproverComment = 'INVOICE_APPROVER_COMMENT',
  InvoiceExternalInvoiceId = 'INVOICE_EXTERNAL_INVOICE_ID',
  InvoiceStatus = 'INVOICE_STATUS',
  InvoiceSupplier = 'INVOICE_SUPPLIER',
  JobApplication = 'JOB_APPLICATION',
  JobApplicationAccountablePerson = 'JOB_APPLICATION_ACCOUNTABLE_PERSON',
  JobApplicationAlternateExternalApprover = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER',
  JobApplicationAlternateExternalApproverFirstName = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER_FIRST_NAME',
  JobApplicationAlternateExternalApproverLastName = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER_LAST_NAME',
  JobApplicationAlternateExternalApproverPreferredFirstName = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  JobApplicationAlternateExternalApproverPreferredLastName = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  JobApplicationApplicantEmail = 'JOB_APPLICATION_APPLICANT_EMAIL',
  JobApplicationBillComplexRate = 'JOB_APPLICATION_BILL_COMPLEX_RATE',
  JobApplicationBillRate = 'JOB_APPLICATION_BILL_RATE',
  JobApplicationBudgetApprovedAmount = 'JOB_APPLICATION_BUDGET_APPROVED_AMOUNT',
  JobApplicationBudgetOriginalAmount = 'JOB_APPLICATION_BUDGET_ORIGINAL_AMOUNT',
  JobApplicationBusinessSite = 'JOB_APPLICATION_BUSINESS_SITE',
  JobApplicationBusinessSiteCity = 'JOB_APPLICATION_BUSINESS_SITE_CITY',
  JobApplicationBusinessSiteRegion = 'JOB_APPLICATION_BUSINESS_SITE_REGION',
  JobApplicationClassification = 'JOB_APPLICATION_CLASSIFICATION',
  JobApplicationCompany = 'JOB_APPLICATION_COMPANY',
  JobApplicationCostCenter = 'JOB_APPLICATION_COST_CENTER',
  JobApplicationCostCenters = 'JOB_APPLICATION_COST_CENTERS',
  JobApplicationCustomField = 'JOB_APPLICATION_CUSTOM_FIELD',
  JobApplicationDateOfBirth = 'JOB_APPLICATION_DATE_OF_BIRTH',
  JobApplicationDuplicateWorkerSelected = 'JOB_APPLICATION_DUPLICATE_WORKER_SELECTED',
  JobApplicationEngagementEndDate = 'JOB_APPLICATION_ENGAGEMENT_END_DATE',
  JobApplicationEngagementStartDate = 'JOB_APPLICATION_ENGAGEMENT_START_DATE',
  JobApplicationFinancialField = 'JOB_APPLICATION_FINANCIAL_FIELD',
  JobApplicationFinancialFields = 'JOB_APPLICATION_FINANCIAL_FIELDS',
  JobApplicationFirstName = 'JOB_APPLICATION_FIRST_NAME',
  JobApplicationFirstSubmittedBillComplexRate = 'JOB_APPLICATION_FIRST_SUBMITTED_BILL_COMPLEX_RATE',
  JobApplicationFoundWorkerDuplicates = 'JOB_APPLICATION_FOUND_WORKER_DUPLICATES',
  JobApplicationGender = 'JOB_APPLICATION_GENDER',
  JobApplicationHolidaySchedule = 'JOB_APPLICATION_HOLIDAY_SCHEDULE',
  JobApplicationJobPostingBusinessReason = 'JOB_APPLICATION_JOB_POSTING_BUSINESS_REASON',
  JobApplicationJobProfile = 'JOB_APPLICATION_JOB_PROFILE',
  JobApplicationJobRequest = 'JOB_APPLICATION_JOB_REQUEST',
  JobApplicationLastName = 'JOB_APPLICATION_LAST_NAME',
  JobApplicationLink = 'JOB_APPLICATION_LINK',
  JobApplicationMiddleName = 'JOB_APPLICATION_MIDDLE_NAME',
  JobApplicationMsp = 'JOB_APPLICATION_MSP',
  JobApplicationPayComplexRate = 'JOB_APPLICATION_PAY_COMPLEX_RATE',
  JobApplicationPayRate = 'JOB_APPLICATION_PAY_RATE',
  JobApplicationPersonalEmail = 'JOB_APPLICATION_PERSONAL_EMAIL',
  JobApplicationPreferredEndDate = 'JOB_APPLICATION_PREFERRED_END_DATE',
  JobApplicationPreferredFirstName = 'JOB_APPLICATION_PREFERRED_FIRST_NAME',
  JobApplicationPreferredLastName = 'JOB_APPLICATION_PREFERRED_LAST_NAME',
  JobApplicationPreferredMiddleName = 'JOB_APPLICATION_PREFERRED_MIDDLE_NAME',
  JobApplicationPreferredStartDate = 'JOB_APPLICATION_PREFERRED_START_DATE',
  JobApplicationPrimaryExternalApprover = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER',
  JobApplicationPrimaryExternalApproverFirstName = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER_FIRST_NAME',
  JobApplicationPrimaryExternalApproverLastName = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER_LAST_NAME',
  JobApplicationPrimaryExternalApproverPreferredFirstName = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  JobApplicationPrimaryExternalApproverPreferredLastName = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  JobApplicationRateCard = 'JOB_APPLICATION_RATE_CARD',
  JobApplicationRateCardRate = 'JOB_APPLICATION_RATE_CARD_RATE',
  JobApplicationRateCurrency = 'JOB_APPLICATION_RATE_CURRENCY',
  JobApplicationRatePeriod = 'JOB_APPLICATION_RATE_PERIOD',
  JobApplicationRateType = 'JOB_APPLICATION_RATE_TYPE',
  JobApplicationRemoteWorkAddress = 'JOB_APPLICATION_REMOTE_WORK_ADDRESS',
  JobApplicationSourcingType = 'JOB_APPLICATION_SOURCING_TYPE',
  JobApplicationStage = 'JOB_APPLICATION_STAGE',
  JobApplicationStatus = 'JOB_APPLICATION_STATUS',
  JobApplicationSupervisoryOrg = 'JOB_APPLICATION_SUPERVISORY_ORG',
  JobApplicationSupplier = 'JOB_APPLICATION_SUPPLIER',
  JobApplicationWorkSchedule = 'JOB_APPLICATION_WORK_SCHEDULE',
  JobProfile = 'JOB_PROFILE',
  JobProfileCustomField = 'JOB_PROFILE_CUSTOM_FIELD',
  JobProfileName = 'JOB_PROFILE_NAME',
  JobRequest = 'JOB_REQUEST',
  JobRequestAccountablePerson = 'JOB_REQUEST_ACCOUNTABLE_PERSON',
  JobRequestAlternateExternalApprover = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER',
  JobRequestAlternateExternalApproverFirstName = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER_FIRST_NAME',
  JobRequestAlternateExternalApproverLastName = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER_LAST_NAME',
  JobRequestAlternateExternalApproverPreferredFirstName = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  JobRequestAlternateExternalApproverPreferredLastName = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  JobRequestBudgetApprovedAmount = 'JOB_REQUEST_BUDGET_APPROVED_AMOUNT',
  JobRequestBudgetOriginalAmount = 'JOB_REQUEST_BUDGET_ORIGINAL_AMOUNT',
  JobRequestBusinessReason = 'JOB_REQUEST_BUSINESS_REASON',
  JobRequestBusinessSite = 'JOB_REQUEST_BUSINESS_SITE',
  JobRequestCancelledComment = 'JOB_REQUEST_CANCELLED_COMMENT',
  JobRequestCancelledReason = 'JOB_REQUEST_CANCELLED_REASON',
  JobRequestCancelledReasonReferenceId = 'JOB_REQUEST_CANCELLED_REASON_REFERENCE_ID',
  JobRequestClassification = 'JOB_REQUEST_CLASSIFICATION',
  JobRequestCompany = 'JOB_REQUEST_COMPANY',
  JobRequestCostCenter = 'JOB_REQUEST_COST_CENTER',
  JobRequestCostCenters = 'JOB_REQUEST_COST_CENTERS',
  JobRequestCreator = 'JOB_REQUEST_CREATOR',
  JobRequestCurrency = 'JOB_REQUEST_CURRENCY',
  JobRequestCustomField = 'JOB_REQUEST_CUSTOM_FIELD',
  JobRequestEndDate = 'JOB_REQUEST_END_DATE',
  JobRequestEstimatedAdditionalCosts = 'JOB_REQUEST_ESTIMATED_ADDITIONAL_COSTS',
  JobRequestExpiryDate = 'JOB_REQUEST_EXPIRY_DATE',
  JobRequestExternalDescription = 'JOB_REQUEST_EXTERNAL_DESCRIPTION',
  JobRequestExternalTitle = 'JOB_REQUEST_EXTERNAL_TITLE',
  JobRequestFinancialField = 'JOB_REQUEST_FINANCIAL_FIELD',
  JobRequestFinancialFields = 'JOB_REQUEST_FINANCIAL_FIELDS',
  JobRequestHolidaySchedule = 'JOB_REQUEST_HOLIDAY_SCHEDULE',
  JobRequestId = 'JOB_REQUEST_ID',
  JobRequestJobFamily = 'JOB_REQUEST_JOB_FAMILY',
  JobRequestJobProfile = 'JOB_REQUEST_JOB_PROFILE',
  JobRequestJobSummary = 'JOB_REQUEST_JOB_SUMMARY',
  JobRequestLink = 'JOB_REQUEST_LINK',
  JobRequestMaximumPayRate = 'JOB_REQUEST_MAXIMUM_PAY_RATE',
  JobRequestMaximumRate = 'JOB_REQUEST_MAXIMUM_RATE',
  JobRequestMinimumPayRate = 'JOB_REQUEST_MINIMUM_PAY_RATE',
  JobRequestMinimumRate = 'JOB_REQUEST_MINIMUM_RATE',
  JobRequestMsp = 'JOB_REQUEST_MSP',
  JobRequestPrimaryExternalApprover = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER',
  JobRequestPrimaryExternalApproverFirstName = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER_FIRST_NAME',
  JobRequestPrimaryExternalApproverLastName = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER_LAST_NAME',
  JobRequestPrimaryExternalApproverPreferredFirstName = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER_PREFERRED_FIRST_NAME',
  JobRequestPrimaryExternalApproverPreferredLastName = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER_PREFERRED_LAST_NAME',
  JobRequestProjectedCost = 'JOB_REQUEST_PROJECTED_COST',
  JobRequestRateCurrency = 'JOB_REQUEST_RATE_CURRENCY',
  JobRequestRatePeriod = 'JOB_REQUEST_RATE_PERIOD',
  JobRequestRateType = 'JOB_REQUEST_RATE_TYPE',
  JobRequestRemoteWorkAddress = 'JOB_REQUEST_REMOTE_WORK_ADDRESS',
  JobRequestRequestedWorkers = 'JOB_REQUEST_REQUESTED_WORKERS',
  JobRequestSourcingType = 'JOB_REQUEST_SOURCING_TYPE',
  JobRequestStartDate = 'JOB_REQUEST_START_DATE',
  JobRequestStatus = 'JOB_REQUEST_STATUS',
  JobRequestSupervisoryOrg = 'JOB_REQUEST_SUPERVISORY_ORG',
  JobRequestSupplierInvite = 'JOB_REQUEST_SUPPLIER_INVITE',
  JobRequestSupplierInviteStatus = 'JOB_REQUEST_SUPPLIER_INVITE_STATUS',
  JobRequestTimesheetView = 'JOB_REQUEST_TIMESHEET_VIEW',
  JobRequestTotalBudgetApprovedAmount = 'JOB_REQUEST_TOTAL_BUDGET_APPROVED_AMOUNT',
  JobRequestTotalBudgetOriginalAmount = 'JOB_REQUEST_TOTAL_BUDGET_ORIGINAL_AMOUNT',
  JobRequestType = 'JOB_REQUEST_TYPE',
  JobRequestWorkingHoursPerWeek = 'JOB_REQUEST_WORKING_HOURS_PER_WEEK',
  JobRequestWorkSchedule = 'JOB_REQUEST_WORK_SCHEDULE',
  Milestone = 'MILESTONE',
  MilestoneAcceptanceCriteria = 'MILESTONE_ACCEPTANCE_CRITERIA',
  MilestoneAmount = 'MILESTONE_AMOUNT',
  MilestoneComment = 'MILESTONE_COMMENT',
  MilestoneCompletedDate = 'MILESTONE_COMPLETED_DATE',
  MilestoneContract = 'MILESTONE_CONTRACT',
  MilestoneCostCenter = 'MILESTONE_COST_CENTER',
  MilestoneCurrency = 'MILESTONE_CURRENCY',
  MilestoneCustomField = 'MILESTONE_CUSTOM_FIELD',
  MilestoneDeliveryLocation = 'MILESTONE_DELIVERY_LOCATION',
  MilestoneDescription = 'MILESTONE_DESCRIPTION',
  MilestoneDueDate = 'MILESTONE_DUE_DATE',
  MilestoneExternalInvoiceDate = 'MILESTONE_EXTERNAL_INVOICE_DATE',
  MilestoneExternalInvoiceId = 'MILESTONE_EXTERNAL_INVOICE_ID',
  MilestoneFinancialFields = 'MILESTONE_FINANCIAL_FIELDS',
  MilestoneId = 'MILESTONE_ID',
  MilestoneIsCorrected = 'MILESTONE_IS_CORRECTED',
  MilestoneIsCorrection = 'MILESTONE_IS_CORRECTION',
  MilestoneIsCredit = 'MILESTONE_IS_CREDIT',
  MilestoneName = 'MILESTONE_NAME',
  MilestoneSemanticVersion = 'MILESTONE_SEMANTIC_VERSION',
  MilestoneStatus = 'MILESTONE_STATUS',
  Msp = 'MSP',
  MspCustomField = 'MSP_CUSTOM_FIELD',
  MspName = 'MSP_NAME',
  Person = 'PERSON',
  PersonAddressCountryCode = 'PERSON_ADDRESS_COUNTRY_CODE',
  PersonAddressLine_1 = 'PERSON_ADDRESS_LINE_1',
  PersonAddressLine_2 = 'PERSON_ADDRESS_LINE_2',
  PersonAddressMunicipality = 'PERSON_ADDRESS_MUNICIPALITY',
  PersonAddressPostCode = 'PERSON_ADDRESS_POST_CODE',
  PersonAddressRegion = 'PERSON_ADDRESS_REGION',
  PersonAddressRegionCode = 'PERSON_ADDRESS_REGION_CODE',
  PersonAddressSubMunicipality = 'PERSON_ADDRESS_SUB_MUNICIPALITY',
  PersonAddressSubRegion = 'PERSON_ADDRESS_SUB_REGION',
  PersonApprovalLimits = 'PERSON_APPROVAL_LIMITS',
  PersonCitizenships = 'PERSON_CITIZENSHIPS',
  PersonCompanyWorkerId = 'PERSON_COMPANY_WORKER_ID',
  PersonCustomField = 'PERSON_CUSTOM_FIELD',
  PersonDateOfBirth = 'PERSON_DATE_OF_BIRTH',
  PersonDuplicateWorkerSelected = 'PERSON_DUPLICATE_WORKER_SELECTED',
  PersonEmail = 'PERSON_EMAIL',
  PersonEmergencyContactAddressCountryCode = 'PERSON_EMERGENCY_CONTACT_ADDRESS_COUNTRY_CODE',
  PersonEmergencyContactAddressLine_1 = 'PERSON_EMERGENCY_CONTACT_ADDRESS_LINE_1',
  PersonEmergencyContactAddressLine_2 = 'PERSON_EMERGENCY_CONTACT_ADDRESS_LINE_2',
  PersonEmergencyContactAddressMunicipality = 'PERSON_EMERGENCY_CONTACT_ADDRESS_MUNICIPALITY',
  PersonEmergencyContactAddressPostCode = 'PERSON_EMERGENCY_CONTACT_ADDRESS_POST_CODE',
  PersonEmergencyContactAddressRegion = 'PERSON_EMERGENCY_CONTACT_ADDRESS_REGION',
  PersonEmergencyContactAddressRegionCode = 'PERSON_EMERGENCY_CONTACT_ADDRESS_REGION_CODE',
  PersonEmergencyContactAddressSubMunicipality = 'PERSON_EMERGENCY_CONTACT_ADDRESS_SUB_MUNICIPALITY',
  PersonEmergencyContactAddressSubRegion = 'PERSON_EMERGENCY_CONTACT_ADDRESS_SUB_REGION',
  PersonEmergencyContactEmail = 'PERSON_EMERGENCY_CONTACT_EMAIL',
  PersonEmergencyContactFirstName = 'PERSON_EMERGENCY_CONTACT_FIRST_NAME',
  PersonEmergencyContactLastName = 'PERSON_EMERGENCY_CONTACT_LAST_NAME',
  PersonEmergencyContactMiddleName = 'PERSON_EMERGENCY_CONTACT_MIDDLE_NAME',
  PersonEmergencyContactPreferredFirstName = 'PERSON_EMERGENCY_CONTACT_PREFERRED_FIRST_NAME',
  PersonEmergencyContactPreferredLastName = 'PERSON_EMERGENCY_CONTACT_PREFERRED_LAST_NAME',
  PersonEmergencyContactPreferredMiddleName = 'PERSON_EMERGENCY_CONTACT_PREFERRED_MIDDLE_NAME',
  PersonEmergencyContactPrimary = 'PERSON_EMERGENCY_CONTACT_PRIMARY',
  PersonEmergencyContactRelationshipType = 'PERSON_EMERGENCY_CONTACT_RELATIONSHIP_TYPE',
  PersonFirstName = 'PERSON_FIRST_NAME',
  PersonFoundGlobalIdDuplicate = 'PERSON_FOUND_GLOBAL_ID_DUPLICATE',
  PersonFoundWorkerDuplicates = 'PERSON_FOUND_WORKER_DUPLICATES',
  PersonGender = 'PERSON_GENDER',
  PersonHighestLevelOfEducation = 'PERSON_HIGHEST_LEVEL_OF_EDUCATION',
  PersonLastName = 'PERSON_LAST_NAME',
  PersonMiddleName = 'PERSON_MIDDLE_NAME',
  PersonNationalIds = 'PERSON_NATIONAL_IDS',
  PersonPersonalEmail = 'PERSON_PERSONAL_EMAIL',
  PersonPhoneNumber = 'PERSON_PHONE_NUMBER',
  PersonPreferredFirstName = 'PERSON_PREFERRED_FIRST_NAME',
  PersonPreferredLastName = 'PERSON_PREFERRED_LAST_NAME',
  PersonPreferredMiddleName = 'PERSON_PREFERRED_MIDDLE_NAME',
  PersonPrimaryPerson = 'PERSON_PRIMARY_PERSON',
  PersonRehireEligibility = 'PERSON_REHIRE_ELIGIBILITY',
  PersonSecondaryPersons = 'PERSON_SECONDARY_PERSONS',
  PersonUid = 'PERSON_UID',
  PersonWorkdayApplicantId = 'PERSON_WORKDAY_APPLICANT_ID',
  PersonWorkdayWorkerId = 'PERSON_WORKDAY_WORKER_ID',
  PersonWorkerProfileUid = 'PERSON_WORKER_PROFILE_UID',
  Project = 'PROJECT',
  ProjectController = 'PROJECT_CONTROLLER',
  ProjectCustomer = 'PROJECT_CUSTOMER',
  ProjectCustomField = 'PROJECT_CUSTOM_FIELD',
  ProjectDescription = 'PROJECT_DESCRIPTION',
  ProjectManager = 'PROJECT_MANAGER',
  ProjectName = 'PROJECT_NAME',
  ProjectStatus = 'PROJECT_STATUS',
  SowResponse = 'SOW_RESPONSE',
  SowResponseAccountablePerson = 'SOW_RESPONSE_ACCOUNTABLE_PERSON',
  SowResponseCompany = 'SOW_RESPONSE_COMPANY',
  SowResponseContactEmail = 'SOW_RESPONSE_CONTACT_EMAIL',
  SowResponseCostCenter = 'SOW_RESPONSE_COST_CENTER',
  SowResponseCustomField = 'SOW_RESPONSE_CUSTOM_FIELD',
  SowResponseStatus = 'SOW_RESPONSE_STATUS',
  SowResponseSupplier = 'SOW_RESPONSE_SUPPLIER',
  SowResponseWorkPosting = 'SOW_RESPONSE_WORK_POSTING',
  Supplier = 'SUPPLIER',
  SupplierCustomField = 'SUPPLIER_CUSTOM_FIELD',
  SupplierMsp = 'SUPPLIER_MSP',
  SupplierName = 'SUPPLIER_NAME',
  SupplierPhone = 'SUPPLIER_PHONE',
  System = 'SYSTEM',
  SystemCronExpression = 'SYSTEM_CRON_EXPRESSION',
  SystemProcessDefinitionName = 'SYSTEM_PROCESS_DEFINITION_NAME',
  SystemProcessErrorMessage = 'SYSTEM_PROCESS_ERROR_MESSAGE',
  SystemProcessInitiator = 'SYSTEM_PROCESS_INITIATOR',
  SystemProcessInitiatorCreatePermissions = 'SYSTEM_PROCESS_INITIATOR_CREATE_PERMISSIONS',
  SystemProcessInitiatorOrg = 'SYSTEM_PROCESS_INITIATOR_ORG',
  SystemProcessInitiatorUserRole = 'SYSTEM_PROCESS_INITIATOR_USER_ROLE',
  SystemRecipeExecutionTranscript = 'SYSTEM_RECIPE_EXECUTION_TRANSCRIPT',
  Task = 'TASK',
  TaskApproved = 'TASK_APPROVED',
  TaskTimeoutDays = 'TASK_TIMEOUT_DAYS',
  Timesheet = 'TIMESHEET',
  TimesheetAllocation = 'TIMESHEET_ALLOCATION',
  TimesheetAllocationConsecutiveDays = 'TIMESHEET_ALLOCATION_CONSECUTIVE_DAYS',
  TimesheetAllocationDayGrouping = 'TIMESHEET_ALLOCATION_DAY_GROUPING',
  TimesheetAllocationLastWorkingDayAccumulation = 'TIMESHEET_ALLOCATION_LAST_WORKING_DAY_ACCUMULATION',
  TimesheetAllocationLocations = 'TIMESHEET_ALLOCATION_LOCATIONS',
  TimesheetAllocationRatePercentage = 'TIMESHEET_ALLOCATION_RATE_PERCENTAGE',
  TimesheetAllocationTimeCodes = 'TIMESHEET_ALLOCATION_TIME_CODES',
  TimesheetApprover = 'TIMESHEET_APPROVER',
  TimesheetEndDate = 'TIMESHEET_END_DATE',
  TimesheetNumber = 'TIMESHEET_NUMBER',
  TimesheetPayBillType = 'TIMESHEET_PAY_BILL_TYPE',
  TimesheetRejector = 'TIMESHEET_REJECTOR',
  TimesheetRejectorComment = 'TIMESHEET_REJECTOR_COMMENT',
  TimesheetStartDate = 'TIMESHEET_START_DATE',
  TimesheetStatus = 'TIMESHEET_STATUS',
  TimesheetSubmitter = 'TIMESHEET_SUBMITTER',
  TimesheetTotalHours = 'TIMESHEET_TOTAL_HOURS',
  TimesheetWorkedPercentage = 'TIMESHEET_WORKED_PERCENTAGE',
  WorkerCertification = 'WORKER_CERTIFICATION',
  WorkerCertificationCertificateNumber = 'WORKER_CERTIFICATION_CERTIFICATE_NUMBER',
  WorkerCertificationComplianceStatus = 'WORKER_CERTIFICATION_COMPLIANCE_STATUS',
  WorkerCertificationEffectiveEndDate = 'WORKER_CERTIFICATION_EFFECTIVE_END_DATE',
  WorkerCertificationEffectiveStartDate = 'WORKER_CERTIFICATION_EFFECTIVE_START_DATE',
  WorkerCertificationExaminationDate = 'WORKER_CERTIFICATION_EXAMINATION_DATE',
  WorkerCertificationExaminationScore = 'WORKER_CERTIFICATION_EXAMINATION_SCORE',
  WorkerCertificationExpirationDate = 'WORKER_CERTIFICATION_EXPIRATION_DATE',
  WorkerCertificationIssueDate = 'WORKER_CERTIFICATION_ISSUE_DATE',
  WorkerCertificationMedia = 'WORKER_CERTIFICATION_MEDIA',
  WorkerCertificationValidationBy = 'WORKER_CERTIFICATION_VALIDATION_BY',
  WorkerCertificationValidationComment = 'WORKER_CERTIFICATION_VALIDATION_COMMENT',
  WorkerCertificationValidationDateTime = 'WORKER_CERTIFICATION_VALIDATION_DATE_TIME',
  WorkerCertificationValidationRequestDateTime = 'WORKER_CERTIFICATION_VALIDATION_REQUEST_DATE_TIME',
  WorkerCertificationValidationStatus = 'WORKER_CERTIFICATION_VALIDATION_STATUS',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkerQualificationExpirationDate = 'WORKER_QUALIFICATION_EXPIRATION_DATE',
  WorkRequest = 'WORK_REQUEST',
  WorkRequestAccountablePerson = 'WORK_REQUEST_ACCOUNTABLE_PERSON',
  WorkRequestBusinessSite = 'WORK_REQUEST_BUSINESS_SITE',
  WorkRequestBusinessSiteCity = 'WORK_REQUEST_BUSINESS_SITE_CITY',
  WorkRequestBusinessSiteRegion = 'WORK_REQUEST_BUSINESS_SITE_REGION',
  WorkRequestCompany = 'WORK_REQUEST_COMPANY',
  WorkRequestCostCenter = 'WORK_REQUEST_COST_CENTER',
  WorkRequestCostCenters = 'WORK_REQUEST_COST_CENTERS',
  WorkRequestCreator = 'WORK_REQUEST_CREATOR',
  WorkRequestCustomField = 'WORK_REQUEST_CUSTOM_FIELD',
  WorkRequestDescription = 'WORK_REQUEST_DESCRIPTION',
  WorkRequestFinancialField = 'WORK_REQUEST_FINANCIAL_FIELD',
  WorkRequestFinancialFields = 'WORK_REQUEST_FINANCIAL_FIELDS',
  WorkRequestFirstLevelManager = 'WORK_REQUEST_FIRST_LEVEL_MANAGER',
  WorkRequestHighestScoringRecommendationOption = 'WORK_REQUEST_HIGHEST_SCORING_RECOMMENDATION_OPTION',
  WorkRequestHighestScoringRecommendationOptionDescription = 'WORK_REQUEST_HIGHEST_SCORING_RECOMMENDATION_OPTION_DESCRIPTION',
  WorkRequestHolidaySchedule = 'WORK_REQUEST_HOLIDAY_SCHEDULE',
  WorkRequestId = 'WORK_REQUEST_ID',
  WorkRequestLink = 'WORK_REQUEST_LINK',
  WorkRequestMsp = 'WORK_REQUEST_MSP',
  WorkRequestPoNumber = 'WORK_REQUEST_PO_NUMBER',
  WorkRequestReason = 'WORK_REQUEST_REASON',
  WorkRequestRecommendationOptionScoreField = 'WORK_REQUEST_RECOMMENDATION_OPTION_SCORE_FIELD',
  WorkRequestRemoteWorkAddress = 'WORK_REQUEST_REMOTE_WORK_ADDRESS',
  WorkRequestSecondLevelManager = 'WORK_REQUEST_SECOND_LEVEL_MANAGER',
  WorkRequestSelectedRecommendationOption = 'WORK_REQUEST_SELECTED_RECOMMENDATION_OPTION',
  WorkRequestSelectedRecommendationOptionDescription = 'WORK_REQUEST_SELECTED_RECOMMENDATION_OPTION_DESCRIPTION',
  WorkRequestStatus = 'WORK_REQUEST_STATUS',
  WorkRequestSupervisoryOrg = 'WORK_REQUEST_SUPERVISORY_ORG',
  WorkRequestTitle = 'WORK_REQUEST_TITLE',
  WorkRequestWorkLocationType = 'WORK_REQUEST_WORK_LOCATION_TYPE',
  WorkRequestWorkSchedule = 'WORK_REQUEST_WORK_SCHEDULE'
}

export type FieldMappingModel = {
  __typename?: 'FieldMappingModel';
  customFieldReferenceId?: Maybe<Scalars['String']['output']>;
  idpAttributeName?: Maybe<Scalars['String']['output']>;
  serviceProviderField?: Maybe<ServiceProviderFieldModel>;
};

export type FieldMappingModelInput = {
  customFieldReferenceId?: InputMaybe<Scalars['String']['input']>;
  idpAttributeName?: InputMaybe<Scalars['String']['input']>;
  serviceProviderField?: InputMaybe<ServiceProviderFieldModel>;
};

export type FieldMetadataModel = {
  __typename?: 'FieldMetadataModel';
  generated?: Maybe<Array<Maybe<CommonFieldDefinitionModel>>>;
  overrides?: Maybe<Array<Maybe<CommonFieldDefinitionModel>>>;
};

export enum FieldMetadataOperator {
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL'
}

export type FieldReferenceModel = {
  __typename?: 'FieldReferenceModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<FieldKeyModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type FieldReferenceModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<FieldKeyModel>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type FieldRule = {
  __typename?: 'FieldRule';
  condition?: Maybe<FieldRuleCondition>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  regex?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  values?: Maybe<Array<Maybe<CommonFieldDefinitionValueModel>>>;
};

export type FieldRuleCondition = {
  __typename?: 'FieldRuleCondition';
  field?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<FieldMetadataOperator>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum FieldType {
  CustomField = 'CUSTOM_FIELD',
  Delivered = 'DELIVERED',
  FinancialField = 'FINANCIAL_FIELD',
  Other = 'OTHER'
}

export enum FieldTypeModel {
  Boolean = 'BOOLEAN',
  Custom = 'CUSTOM',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Enum = 'ENUM',
  Financial = 'FINANCIAL',
  Integer = 'INTEGER',
  Object = 'OBJECT',
  Rate = 'RATE',
  RecommendationOptionScore = 'RECOMMENDATION_OPTION_SCORE',
  String = 'STRING',
  Text = 'TEXT',
  Time = 'TIME'
}

export enum FilterFieldTypeModel {
  CustomField = 'CUSTOM_FIELD',
  Delivered = 'DELIVERED',
  FinancialField = 'FINANCIAL_FIELD',
  Other = 'OTHER'
}

export type FinanceJournalExportJobModel = {
  __typename?: 'FinanceJournalExportJobModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  numTimesheets?: Maybe<Scalars['Int']['output']>;
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type FinanceJournalExportJobsModel = {
  __typename?: 'FinanceJournalExportJobsModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<FinanceJournalExportJobModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FinanceJournalScheduleCreateModelInput = {
  repeatInterval?: InputMaybe<FinanceJournalScheduleRepeatModel>;
  startDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

export type FinanceJournalScheduleModel = {
  __typename?: 'FinanceJournalScheduleModel';
  createdDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  lastTriggered?: Maybe<Scalars['OffsetDateTime']['output']>;
  nextRun?: Maybe<Scalars['OffsetDateTime']['output']>;
  repeatInterval?: Maybe<FinanceJournalScheduleRepeatModel>;
  startDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};

export type FinanceJournalSchedulePatchModelInput = {
  repeatInterval?: InputMaybe<FinanceJournalScheduleRepeatModel>;
  startDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum FinanceJournalScheduleRepeatModel {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export type FinanceJournalSchedulesModel = {
  __typename?: 'FinanceJournalSchedulesModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<FinanceJournalScheduleModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FinancialCustomFieldDefinitionCreateModelInput = {
  dataType?: InputMaybe<FinancialCustomFieldDefinitionDataTypeModel>;
  financialFieldDefinition?: InputMaybe<FinancialFieldDefinitionModelInput>;
  helperText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
};

export enum FinancialCustomFieldDefinitionDataTypeModel {
  Object = 'OBJECT',
  String = 'STRING'
}

export type FinancialCustomFieldDefinitionUpdateModelInput = {
  financialFieldDefinition?: InputMaybe<FinancialFieldDefinitionModelInput>;
  helperText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialCustomFieldDefinitionsQueryModelInput = {
  parentEntityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  parentEntityTypes?: InputMaybe<Array<InputMaybe<CustomFieldDefinitionEntityTypeModel>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type FinancialCustomObjectCreateModelInput = {
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
};

export type FinancialCustomObjectCreateOrUpdateModelInput = {
  customFieldDefinitionReferenceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
};

export type FinancialCustomObjectStatusUpdateModelInput = {
  status?: InputMaybe<UpdatableStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialCustomObjectUpdateModelInput = {
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdatableStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialCustomObjectsModel = {
  __typename?: 'FinancialCustomObjectsModel';
  elements?: Maybe<Array<Maybe<CustomObjectModel>>>;
  items?: Maybe<Array<Maybe<CustomObjectModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FinancialCustomObjectsQueryModelInput = {
  customFieldDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type FinancialFieldDefinitionModel = {
  __typename?: 'FinancialFieldDefinitionModel';
  hideFromTimesheetAndExpenseViews?: Maybe<Scalars['Boolean']['output']>;
  requiredOnGeneralExpense: Scalars['Boolean']['output'];
  requiredOnTimesheet: Scalars['Boolean']['output'];
  requiredOnWorkerExpense: Scalars['Boolean']['output'];
};

export type FinancialFieldDefinitionModelInput = {
  hideFromTimesheetAndExpenseViews?: InputMaybe<Scalars['Boolean']['input']>;
  requiredOnGeneralExpense: Scalars['Boolean']['input'];
  requiredOnTimesheet: Scalars['Boolean']['input'];
  requiredOnWorkerExpense: Scalars['Boolean']['input'];
};

export type FinancialFieldUnavailableModel = {
  __typename?: 'FinancialFieldUnavailableModel';
  assignedValueLabel?: Maybe<Scalars['String']['output']>;
  assignedValueUid?: Maybe<Scalars['String']['output']>;
  availableValues?: Maybe<Array<Maybe<AvailableValueModel>>>;
  definitionName?: Maybe<Scalars['String']['output']>;
  definitionUid?: Maybe<Scalars['String']['output']>;
};

export type FinancialFieldUnavailableModelInput = {
  assignedValueLabel?: InputMaybe<Scalars['String']['input']>;
  assignedValueUid?: InputMaybe<Scalars['String']['input']>;
  availableValues?: InputMaybe<Array<InputMaybe<AvailableValueModelInput>>>;
  definitionName?: InputMaybe<Scalars['String']['input']>;
  definitionUid?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialObjectDefinitionModel = {
  __typename?: 'FinancialObjectDefinitionModel';
  externalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EntityStatusModel>;
  uid: Scalars['String']['output'];
};

export type FinancialObjectDefinitionModelInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialObjectModel = {
  __typename?: 'FinancialObjectModel';
  financialObject?: Maybe<FinancialObjectValueModel>;
  financialObjectDefinition?: Maybe<FinancialObjectDefinitionModel>;
  permissions?: Maybe<Scalars['ActionPermissionsModelScalar']['output']>;
};

export type FinancialObjectModelInput = {
  financialObject?: InputMaybe<FinancialObjectValueModelInput>;
  financialObjectDefinition?: InputMaybe<FinancialObjectDefinitionModelInput>;
  permissions?: InputMaybe<Scalars['ActionPermissionsModelScalar']['input']>;
};

export type FinancialObjectValueModel = {
  __typename?: 'FinancialObjectValueModel';
  label?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FinancialObjectValueModelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlatFileConfigModel = {
  __typename?: 'FlatFileConfigModel';
  customer?: Maybe<FlatFileCustomerConfigModel>;
  licenseKey?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  useOnPrem?: Maybe<Scalars['Boolean']['output']>;
};

export type FlatFileCustomerConfigModel = {
  __typename?: 'FlatFileCustomerConfigModel';
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
};

export type FlatFilePlatformConfigModel = {
  __typename?: 'FlatFilePlatformConfigModel';
  apiUrl?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  publishableKey?: Maybe<Scalars['String']['output']>;
  spacesUrl?: Maybe<Scalars['String']['output']>;
  useOnPrem: Scalars['Boolean']['output'];
};

export type FlowNodeModel = {
  flowNodeType?: Maybe<FlowNodeTypeModel>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FlowNodePropertyDefinitionModel = {
  __typename?: 'FlowNodePropertyDefinitionModel';
  defaultValue?: Maybe<Scalars['String']['output']>;
  dependsOnProperty?: Maybe<FlowNodePropertyDependsOnPropertyModel>;
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<FlowNodePropertyKeyModel>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FlowNodePropertyTypeModel>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FlowNodePropertyDefinitionModelInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  dependsOnProperty?: InputMaybe<FlowNodePropertyDependsOnPropertyModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<FlowNodePropertyKeyModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FlowNodePropertyTypeModel>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FlowNodePropertyDependsOnPropertyModel = {
  __typename?: 'FlowNodePropertyDependsOnPropertyModel';
  key?: Maybe<FlowNodePropertyKeyModel>;
  withValueIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FlowNodePropertyDependsOnPropertyModelInput = {
  key?: InputMaybe<FlowNodePropertyKeyModel>;
  withValueIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum FlowNodePropertyKeyModel {
  Assignee = 'ASSIGNEE',
  Body = 'BODY',
  CaptureEffectiveDate = 'CAPTURE_EFFECTIVE_DATE',
  CorrelationMessageName = 'CORRELATION_MESSAGE_NAME',
  CrossEngagementTimesheetRule = 'CROSS_ENGAGEMENT_TIMESHEET_RULE',
  DisplayScore = 'DISPLAY_SCORE',
  DisplayZeroScoreOptions = 'DISPLAY_ZERO_SCORE_OPTIONS',
  DuplicateCheckByContractStartDate = 'DUPLICATE_CHECK_BY_CONTRACT_START_DATE',
  DuplicateCheckByCountryOfBirth = 'DUPLICATE_CHECK_BY_COUNTRY_OF_BIRTH',
  DuplicateCheckByDateOfBirth = 'DUPLICATE_CHECK_BY_DATE_OF_BIRTH',
  DuplicateCheckByEmail = 'DUPLICATE_CHECK_BY_EMAIL',
  DuplicateCheckByFirstName = 'DUPLICATE_CHECK_BY_FIRST_NAME',
  DuplicateCheckByJobProfileReferenceId = 'DUPLICATE_CHECK_BY_JOB_PROFILE_REFERENCE_ID',
  DuplicateCheckByLastName = 'DUPLICATE_CHECK_BY_LAST_NAME',
  DuplicateCheckByManagerReferenceId = 'DUPLICATE_CHECK_BY_MANAGER_REFERENCE_ID',
  DuplicateCheckByPhoneNumber = 'DUPLICATE_CHECK_BY_PHONE_NUMBER',
  DuplicateCheckByPreferredFirstName = 'DUPLICATE_CHECK_BY_PREFERRED_FIRST_NAME',
  DuplicateCheckBySsn = 'DUPLICATE_CHECK_BY_SSN',
  DuplicateCheckBySsnFieldCode = 'DUPLICATE_CHECK_BY_SSN_FIELD_CODE',
  DuplicateCheckBySupervisoryOrgReferenceId = 'DUPLICATE_CHECK_BY_SUPERVISORY_ORG_REFERENCE_ID',
  DuplicateCheckBySupplierReferenceId = 'DUPLICATE_CHECK_BY_SUPPLIER_REFERENCE_ID',
  DuplicateCheckFindStrategy = 'DUPLICATE_CHECK_FIND_STRATEGY',
  DuplicateCheckReportUrl = 'DUPLICATE_CHECK_REPORT_URL',
  ExternalIntegrationCategory = 'EXTERNAL_INTEGRATION_CATEGORY',
  ExternalIntegrationInstanceId = 'EXTERNAL_INTEGRATION_INSTANCE_ID',
  IntegrationClientUid = 'INTEGRATION_CLIENT_UID',
  MaximumJobRequestCount = 'MAXIMUM_JOB_REQUEST_COUNT',
  MinimumJobRequestCount = 'MINIMUM_JOB_REQUEST_COUNT',
  NewEngagementStatus = 'NEW_ENGAGEMENT_STATUS',
  NotificationChannel = 'NOTIFICATION_CHANNEL',
  NotificationContractRecipient = 'NOTIFICATION_CONTRACT_RECIPIENT',
  NotificationEngagementRecipient = 'NOTIFICATION_ENGAGEMENT_RECIPIENT',
  NotificationFinancialObjectRecipient = 'NOTIFICATION_FINANCIAL_OBJECT_RECIPIENT',
  NotificationInvoiceRecipient = 'NOTIFICATION_INVOICE_RECIPIENT',
  NotificationJobApplicationRecipient = 'NOTIFICATION_JOB_APPLICATION_RECIPIENT',
  NotificationJobRequestRecipient = 'NOTIFICATION_JOB_REQUEST_RECIPIENT',
  NotificationMilestoneRecipient = 'NOTIFICATION_MILESTONE_RECIPIENT',
  NotificationSupplierRecipient = 'NOTIFICATION_SUPPLIER_RECIPIENT',
  NotificationSystemRecipient = 'NOTIFICATION_SYSTEM_RECIPIENT',
  NotificationWorkerQualificationRecipient = 'NOTIFICATION_WORKER_QUALIFICATION_RECIPIENT',
  NotificationWorkRequestRecipient = 'NOTIFICATION_WORK_REQUEST_RECIPIENT',
  PreferredEmailType = 'PREFERRED_EMAIL_TYPE',
  RecipeEndDateFromDuration = 'RECIPE_END_DATE_FROM_DURATION',
  RecipeEndDateToDuration = 'RECIPE_END_DATE_TO_DURATION',
  RecipeExecutionDate = 'RECIPE_EXECUTION_DATE',
  RecipeExecutionDatetime = 'RECIPE_EXECUTION_DATETIME',
  RecipeModifiedSinceDuration = 'RECIPE_MODIFIED_SINCE_DURATION',
  RecipeModifiedToDuration = 'RECIPE_MODIFIED_TO_DURATION',
  RecipeS3BucketPrefix = 'RECIPE_S3_BUCKET_PREFIX',
  RecipeStartDateFromDuration = 'RECIPE_START_DATE_FROM_DURATION',
  RecipeStartDateToDuration = 'RECIPE_START_DATE_TO_DURATION',
  RecipeUid = 'RECIPE_UID',
  RecommendationDefinitionUid = 'RECOMMENDATION_DEFINITION_UID',
  SecondarySmartformuid = 'SECONDARY_SMARTFORMUID',
  SecondarySmartformVersion = 'SECONDARY_SMARTFORM_VERSION',
  Sender = 'SENDER',
  SequenceGeneratorUid = 'SEQUENCE_GENERATOR_UID',
  SequenceNumber = 'SEQUENCE_NUMBER',
  SetNewEngagementAsPrimary = 'SET_NEW_ENGAGEMENT_AS_PRIMARY',
  Smartformuid = 'SMARTFORMUID',
  SmartformEngagementAssignee = 'SMARTFORM_ENGAGEMENT_ASSIGNEE',
  SmartformJobApplicationAssignee = 'SMARTFORM_JOB_APPLICATION_ASSIGNEE',
  SmartformVersion = 'SMARTFORM_VERSION',
  SmartFormSubmitButtonText = 'SMART_FORM_SUBMIT_BUTTON_TEXT',
  Subject = 'SUBJECT',
  TaskDescription = 'TASK_DESCRIPTION',
  WarningMessage = 'WARNING_MESSAGE',
  WebhookAuthentication = 'WEBHOOK_AUTHENTICATION',
  WorkatoServiceTaskIcon = 'WORKATO_SERVICE_TASK_ICON',
  WorkatoServiceTaskWebhookUrl = 'WORKATO_SERVICE_TASK_WEBHOOK_URL',
  WorkdaySequenceGeneratorId = 'WORKDAY_SEQUENCE_GENERATOR_ID',
  WorkdayServiceTaskApplicantCountryCode = 'WORKDAY_SERVICE_TASK_APPLICANT_COUNTRY_CODE',
  WorkdayServiceTaskChangeHomeContactInformationFieldSelection = 'WORKDAY_SERVICE_TASK_CHANGE_HOME_CONTACT_INFORMATION_FIELD_SELECTION',
  WorkdayServiceTaskChangeJobReasonReferenceId = 'WORKDAY_SERVICE_TASK_CHANGE_JOB_REASON_REFERENCE_ID',
  WorkdayServiceTaskChangePersonalInformationIncludeDateOfBirth = 'WORKDAY_SERVICE_TASK_CHANGE_PERSONAL_INFORMATION_INCLUDE_DATE_OF_BIRTH',
  WorkdayServiceTaskChangePersonalInformationIncludeGender = 'WORKDAY_SERVICE_TASK_CHANGE_PERSONAL_INFORMATION_INCLUDE_GENDER',
  WorkdayServiceTaskChangeWorkContactFieldSelection = 'WORKDAY_SERVICE_TASK_CHANGE_WORK_CONTACT_FIELD_SELECTION',
  WorkdayServiceTaskClosePosition = 'WORKDAY_SERVICE_TASK_CLOSE_POSITION',
  WorkdayServiceTaskContractWorkerIncludeWorkerId = 'WORKDAY_SERVICE_TASK_CONTRACT_WORKER_INCLUDE_WORKER_ID',
  WorkdayServiceTaskContractWorkerReasonReferenceId = 'WORKDAY_SERVICE_TASK_CONTRACT_WORKER_REASON_REFERENCE_ID',
  WorkdayServiceTaskCustomDataTemplate = 'WORKDAY_SERVICE_TASK_CUSTOM_DATA_TEMPLATE',
  WorkdayServiceTaskCustomIdTypeReferenceId = 'WORKDAY_SERVICE_TASK_CUSTOM_ID_TYPE_REFERENCE_ID',
  WorkdayServiceTaskCustomIdValue = 'WORKDAY_SERVICE_TASK_CUSTOM_ID_VALUE',
  WorkdayServiceTaskCustomOrganizationAssignmentCustomField_1 = 'WORKDAY_SERVICE_TASK_CUSTOM_ORGANIZATION_ASSIGNMENT_CUSTOM_FIELD_1',
  WorkdayServiceTaskCustomOrganizationAssignmentCustomField_2 = 'WORKDAY_SERVICE_TASK_CUSTOM_ORGANIZATION_ASSIGNMENT_CUSTOM_FIELD_2',
  WorkdayServiceTaskCustomOrganizationReferenceId = 'WORKDAY_SERVICE_TASK_CUSTOM_ORGANIZATION_REFERENCE_ID',
  WorkdayServiceTaskDuplicateCheckContractStartDateParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_CONTRACT_START_DATE_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckCountryOfBirthParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_COUNTRY_OF_BIRTH_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckDateOfBirthParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_DATE_OF_BIRTH_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckEmailParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_EMAIL_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckFirstNameParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_FIRST_NAME_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckJobProfileReferenceIdParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_JOB_PROFILE_REFERENCE_ID_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckLastNameParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_LAST_NAME_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckManagerReferenceIdParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_MANAGER_REFERENCE_ID_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckPhoneNumberParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_PHONE_NUMBER_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckPreferredFirstNameParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_PREFERRED_FIRST_NAME_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckReportUrl = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_REPORT_URL',
  WorkdayServiceTaskDuplicateCheckSsnParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_SSN_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckSupervisoryOrgReferenceIdParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_SUPERVISORY_ORG_REFERENCE_ID_PARAM_NAME',
  WorkdayServiceTaskDuplicateCheckSupplierReferenceIdParamName = 'WORKDAY_SERVICE_TASK_DUPLICATE_CHECK_SUPPLIER_REFERENCE_ID_PARAM_NAME',
  WorkdayServiceTaskFundReferenceId = 'WORKDAY_SERVICE_TASK_FUND_REFERENCE_ID',
  WorkdayServiceTaskHeadCountOptionReferenceId = 'WORKDAY_SERVICE_TASK_HEAD_COUNT_OPTION_REFERENCE_ID',
  WorkdayServiceTaskJobRecruitingInstructionReferenceId = 'WORKDAY_SERVICE_TASK_JOB_RECRUITING_INSTRUCTION_REFERENCE_ID',
  WorkdayServiceTaskJobRequisitionReasonReferenceId = 'WORKDAY_SERVICE_TASK_JOB_REQUISITION_REASON_REFERENCE_ID',
  WorkdayServiceTaskLogging = 'WORKDAY_SERVICE_TASK_LOGGING',
  WorkdayServiceTaskMaintainContactInformationFieldSelection = 'WORKDAY_SERVICE_TASK_MAINTAIN_CONTACT_INFORMATION_FIELD_SELECTION',
  WorkdayServiceTaskOperation = 'WORKDAY_SERVICE_TASK_OPERATION',
  WorkdayServiceTaskPhoneDeviceTypeReferenceId = 'WORKDAY_SERVICE_TASK_PHONE_DEVICE_TYPE_REFERENCE_ID',
  WorkdayServiceTaskPositionRequestReasonReferenceId = 'WORKDAY_SERVICE_TASK_POSITION_REQUEST_REASON_REFERENCE_ID',
  WorkdayServiceTaskPositionTimeTypeReferenceId = 'WORKDAY_SERVICE_TASK_POSITION_TIME_TYPE_REFERENCE_ID',
  WorkdayServiceTaskPositionWorkerTypeReferenceId = 'WORKDAY_SERVICE_TASK_POSITION_WORKER_TYPE_REFERENCE_ID',
  WorkdayServiceTaskPutApplicantFieldSelection = 'WORKDAY_SERVICE_TASK_PUT_APPLICANT_FIELD_SELECTION',
  WorkdayServiceTaskPutApplicantIncludeRecruitingPositions = 'WORKDAY_SERVICE_TASK_PUT_APPLICANT_INCLUDE_RECRUITING_POSITIONS',
  WorkdayServiceTaskSequenceGeneratorReferenceId = 'WORKDAY_SERVICE_TASK_SEQUENCE_GENERATOR_REFERENCE_ID',
  WorkdayServiceTaskWorkdayServiceTaskId = 'WORKDAY_SERVICE_TASK_WORKDAY_SERVICE_TASK_ID',
  WorkdayServiceTaskWorkerTypeReferenceId = 'WORKDAY_SERVICE_TASK_WORKER_TYPE_REFERENCE_ID',
  WorkdayServiceTaskWorkShiftReferenceId = 'WORKDAY_SERVICE_TASK_WORK_SHIFT_REFERENCE_ID',
  WorkdayTimeCodeReferenceId = 'WORKDAY_TIME_CODE_REFERENCE_ID',
  WorkerChangedNotificationUrl = 'WORKER_CHANGED_NOTIFICATION_URL'
}

export type FlowNodePropertyModel = {
  __typename?: 'FlowNodePropertyModel';
  key?: Maybe<FlowNodePropertyKeyModel>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FlowNodePropertyModelInput = {
  key?: InputMaybe<FlowNodePropertyKeyModel>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FlowNodePropertyTypeModel {
  Enum = 'ENUM',
  Integer = 'INTEGER',
  String = 'STRING'
}

export enum FlowNodeTypeModel {
  Event = 'EVENT',
  Gateway = 'GATEWAY',
  SubProcess = 'SUB_PROCESS',
  Task = 'TASK'
}

export type FormulaRateModel = {
  __typename?: 'FormulaRateModel';
  baseRateCode?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

export type FormulaRateModelInput = {
  baseRateCode?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
};

export enum FrequencyModel {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type GatewayDefinitionModel = FlowNodeModel & {
  __typename?: 'GatewayDefinitionModel';
  defaultSequenceFlowId?: Maybe<Scalars['String']['output']>;
  flowNodeType?: Maybe<FlowNodeTypeModel>;
  gatewayType?: Maybe<ProcessDefinitionGatewayTypeModel>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GatewayDefinitionModelInput = {
  defaultSequenceFlowId?: InputMaybe<Scalars['String']['input']>;
  flowNodeType?: InputMaybe<FlowNodeTypeModel>;
  gatewayType?: InputMaybe<ProcessDefinitionGatewayTypeModel>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GatewayModel = {
  __typename?: 'GatewayModel';
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  flowNodeId?: Maybe<Scalars['String']['output']>;
  gatewayType?: Maybe<ProcessDefinitionGatewayTypeModel>;
  name?: Maybe<Scalars['String']['output']>;
  parentActivityName?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type GatewayModelInput = {
  endTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  flowNodeId?: InputMaybe<Scalars['String']['input']>;
  gatewayType?: InputMaybe<ProcessDefinitionGatewayTypeModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentActivityName?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

export type GenderCreateModelInput = {
  assignable: Scalars['Boolean']['input'];
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type GenderModel = {
  __typename?: 'GenderModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onExportMapTo?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type GenderModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenderModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type GenderPatchModelInput = {
  assignable: Scalars['Boolean']['input'];
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type GendersModel = {
  __typename?: 'GendersModel';
  items?: Maybe<Array<Maybe<GenderModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetDecisionModel = {
  __typename?: 'GetDecisionModel';
  decision?: Maybe<GetDecisionModelDecision>;
  requestedPermission?: Maybe<GetDecisionModelRequestedPermission>;
};

export type GetDecisionModelDecision = {
  __typename?: 'GetDecisionModelDecision';
  always: Scalars['Boolean']['output'];
  by?: Maybe<GetDecisionModelDecisionBy>;
  determinate: Scalars['Boolean']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
};

export type GetDecisionModelDecisionBy = {
  __typename?: 'GetDecisionModelDecisionBy';
  policy?: Maybe<GetDecisionModelDecisionByPolicy>;
};

export type GetDecisionModelDecisionByPolicy = {
  __typename?: 'GetDecisionModelDecisionByPolicy';
  refId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type GetDecisionModelRequestedPermission = {
  __typename?: 'GetDecisionModelRequestedPermission';
  action?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<GetDecisionModelRequestedPermissionResource>;
};

export type GetDecisionModelRequestedPermissionResource = {
  __typename?: 'GetDecisionModelRequestedPermissionResource';
  uid: Scalars['String']['output'];
};

export type GlobalIdFormulaCreateModelInput = {
  fields?: InputMaybe<Array<InputMaybe<GlobalIdFormulaFieldModelInput>>>;
  formulaType?: InputMaybe<GlobalIdFormulaTypeModel>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalIdFormulaFieldModel = {
  __typename?: 'GlobalIdFormulaFieldModel';
  qualifier?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
};

export type GlobalIdFormulaFieldModelInput = {
  qualifier?: InputMaybe<Scalars['String']['input']>;
  urn?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalIdFormulaModel = {
  __typename?: 'GlobalIdFormulaModel';
  fields?: Maybe<Array<Maybe<GlobalIdFormulaFieldModel>>>;
  formulaType?: Maybe<GlobalIdFormulaTypeModel>;
  locationUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runState?: Maybe<GlobalIdGenerationStateModel>;
  separator?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export enum GlobalIdFormulaTypeModel {
  Default = 'DEFAULT',
  DefaultDraft = 'DEFAULT_DRAFT',
  Exception = 'EXCEPTION',
  ExceptionDraft = 'EXCEPTION_DRAFT'
}

export type GlobalIdFormulaUpdateModelInput = {
  fields?: InputMaybe<Array<InputMaybe<GlobalIdFormulaFieldModelInput>>>;
  formulaType?: InputMaybe<GlobalIdFormulaTypeModel>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalIdGenerationStateModel = {
  __typename?: 'GlobalIdGenerationStateModel';
  collisions?: Maybe<Scalars['Map_String_Set_StringScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<GlobalIdRunStatusModel>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GlobalIdPreviewModelInput = {
  fields?: InputMaybe<Array<InputMaybe<GlobalIdFormulaFieldModelInput>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
};

export enum GlobalIdRunStatusModel {
  Canceled = 'CANCELED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Queued = 'QUEUED',
  Success = 'SUCCESS'
}

export type GroupedTimerMetricModel = {
  __typename?: 'GroupedTimerMetricModel';
  avg?: Maybe<Scalars['Float']['output']>;
  dateFrom?: Maybe<Scalars['LocalDate']['output']>;
  dateTo?: Maybe<Scalars['LocalDate']['output']>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
};


export type GroupedTimerMetricModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export enum GwgGenderModel {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER'
}

export type GwgMediaModel = {
  __typename?: 'GwgMediaModel';
  contentType?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  timeUntilExpirationInSeconds?: Maybe<Scalars['Long']['output']>;
  type?: Maybe<GwgMediaTypeModel>;
  uid: Scalars['String']['output'];
};

export type GwgMediaModelInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  signedUrl?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  timeUntilExpirationInSeconds?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<GwgMediaTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type GwgMediaModelResponse = {
  __typename?: 'GwgMediaModelResponse';
  items?: Maybe<Array<Maybe<GwgMediaModel>>>;
};

export type GwgMediaModelResponseInput = {
  items?: InputMaybe<Array<InputMaybe<GwgMediaModelInput>>>;
};

export enum GwgMediaTypeModel {
  Certificate = 'CERTIFICATE',
  EnterpriseLogo = 'ENTERPRISE_LOGO',
  OtherWorkerDocument = 'OTHER_WORKER_DOCUMENT',
  ProfilePicture = 'PROFILE_PICTURE',
  Resume = 'RESUME',
  TimesheetAttachment = 'TIMESHEET_ATTACHMENT',
  Unknown = 'UNKNOWN',
  WorkerSkillAttachment = 'WORKER_SKILL_ATTACHMENT'
}

export enum HighestLevelOfEducationModel {
  Bachelor = 'BACHELOR',
  Doctor = 'DOCTOR',
  HighSchoolDegree = 'HIGH_SCHOOL_DEGREE',
  Master = 'MASTER',
  Unknown = 'UNKNOWN'
}

export type HiringManagerDetailsModel = {
  __typename?: 'HiringManagerDetailsModel';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

export type HiringManagerDetailsModelInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export enum HitPolicyModel {
  First = 'FIRST',
  Unique = 'UNIQUE'
}

export type HolidayEntry = {
  __typename?: 'HolidayEntry';
  date?: Maybe<Scalars['LocalDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HolidayEntryInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HolidayScheduleCreationModelInput = {
  active: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HolidayScheduleImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type HolidayScheduleModel = {
  __typename?: 'HolidayScheduleModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['Map_LocalDate_StringScalar']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
};


export type HolidayScheduleModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HolidayScheduleModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type HolidayScheduleUpdateModelInput = {
  active: Scalars['Boolean']['input'];
  configuration?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HolidaySchedulesModel = {
  __typename?: 'HolidaySchedulesModel';
  items?: Maybe<Array<Maybe<HolidayScheduleModel>>>;
};

export type HomePageItemModel = {
  __typename?: 'HomePageItemModel';
  chart?: Maybe<ChartModel>;
  index?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use index and section instead */
  layout?: Maybe<CellLayoutModel>;
  section?: Maybe<DashboardSection>;
  widgetOptions?: Maybe<WidgetOptionsModel>;
  widgetType?: Maybe<WidgetTypeModel>;
};

export type HomePageItemModelInput = {
  chart?: InputMaybe<ChartModelInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  layout?: InputMaybe<CellLayoutModelInput>;
  section?: InputMaybe<DashboardSection>;
  widgetOptions?: InputMaybe<WidgetOptionsModelInput>;
  widgetType?: InputMaybe<WidgetTypeModel>;
};

export type ImmediateDistributionRuleInstanceModel = {
  __typename?: 'ImmediateDistributionRuleInstanceModel';
  uid: Scalars['String']['output'];
};

export type ImmediateDistributionRuleModel = {
  __typename?: 'ImmediateDistributionRuleModel';
  uid: Scalars['String']['output'];
};

export type ImportColumnModel = {
  __typename?: 'ImportColumnModel';
  label?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<ImportColumnValueInfoModel>>>;
};

export type ImportColumnValueInfoModel = {
  __typename?: 'ImportColumnValueInfoModel';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportColumnsModel = {
  __typename?: 'ImportColumnsModel';
  columns?: Maybe<Array<Maybe<ImportColumnModel>>>;
};

export enum ImportEntityTypeModel {
  BusinessSite = 'BUSINESS_SITE',
  Classification = 'CLASSIFICATION',
  Company = 'COMPANY',
  Contract = 'CONTRACT',
  CostCenter = 'COST_CENTER',
  CustomObject = 'CUSTOM_OBJECT',
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobFamily = 'JOB_FAMILY',
  JobFamilyGroup = 'JOB_FAMILY_GROUP',
  JobProfile = 'JOB_PROFILE',
  Milestone = 'MILESTONE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
  SpendApprovalLimit = 'SPEND_APPROVAL_LIMIT',
  Supplier = 'SUPPLIER',
  Timesheet = 'TIMESHEET',
  User = 'USER',
  Worker = 'WORKER',
  WorkerQualification = 'WORKER_QUALIFICATION'
}

export type ImportErrorModel = {
  __typename?: 'ImportErrorModel';
  columnName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recordNumber?: Maybe<Scalars['Long']['output']>;
  severity?: Maybe<ImportErrorSeverityTypeModel>;
};

export enum ImportErrorSeverityTypeModel {
  Fatal = 'FATAL',
  Warning = 'WARNING'
}

export type ImportJobCommandResultModel = {
  __typename?: 'ImportJobCommandResultModel';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportLogModel = {
  __typename?: 'ImportLogModel';
  comment?: Maybe<Scalars['String']['output']>;
  errorsFilename?: Maybe<Scalars['String']['output']>;
  failedRecordsFilename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  initiatorType?: Maybe<InitiatorTypeModel>;
  integrationClient?: Maybe<IntegrationClientModel>;
  jobId?: Maybe<Scalars['Long']['output']>;
  progress?: Maybe<ImportLogsProgressModel>;
  status?: Maybe<ImportStatusModel>;
  uid: Scalars['String']['output'];
  uploadDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  uploadedBy?: Maybe<PersonModel>;
  uploadedFilename?: Maybe<Scalars['String']['output']>;
};

export type ImportLogQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ImportLogsModel = {
  __typename?: 'ImportLogsModel';
  items?: Maybe<Array<Maybe<ImportLogModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ImportLogsProgressModel = {
  __typename?: 'ImportLogsProgressModel';
  numberOfRecordsFailed?: Maybe<Scalars['Long']['output']>;
  numberOfRecordsProcessed?: Maybe<Scalars['Long']['output']>;
  numberOfRecordsTotal?: Maybe<Scalars['Long']['output']>;
};

export type ImportStatisticsModel = {
  __typename?: 'ImportStatisticsModel';
  createInvoicesCount?: Maybe<Scalars['Int']['output']>;
  createPaymentsCount?: Maybe<Scalars['Int']['output']>;
  createPeopleCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Job profiles no longer automatically imported. Remove field after 2020.09 */
  createRolesCount?: Maybe<Scalars['Int']['output']>;
  createSuppliersCount?: Maybe<Scalars['Int']['output']>;
  csvFormatValid?: Maybe<Scalars['Boolean']['output']>;
  deactivatePeopleCount?: Maybe<Scalars['Int']['output']>;
  duplicateRecordsCount?: Maybe<Scalars['Int']['output']>;
  failedRecordsCount?: Maybe<Scalars['Int']['output']>;
  mergePaymentsCount?: Maybe<Scalars['Int']['output']>;
  mergePeopleCount?: Maybe<Scalars['Int']['output']>;
  mergeSuppliersCount?: Maybe<Scalars['Int']['output']>;
  missingIdentifiableInformationPeopleCount?: Maybe<Scalars['Int']['output']>;
  processedRecordsCount?: Maybe<Scalars['Int']['output']>;
  recordsWithIssues?: Maybe<Array<Maybe<RecordErrorModel>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export enum ImportStatusModel {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Queued = 'QUEUED'
}

export type ImportSystemActivityDetailsModel = SystemActivityDetailsModel & {
  __typename?: 'ImportSystemActivityDetailsModel';
  archivedFilename?: Maybe<Scalars['String']['output']>;
  detail1?: Maybe<Scalars['String']['output']>;
  detail2?: Maybe<Scalars['String']['output']>;
  detailedType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ImportErrorModel>>>;
  failedCount: Scalars['Int']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  processedCount: Scalars['Int']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SystemActivityTypeModel>;
};

export type InactiveUsersCountQueryModelInput = {
  affectedUserRoles?: InputMaybe<Array<InputMaybe<UserRoleModel>>>;
};

export enum IndirectChangeEntityTypeModel {
  BudgetRecalculation = 'BUDGET_RECALCULATION',
  HolidaySchedule = 'HOLIDAY_SCHEDULE',
  RateCard = 'RATE_CARD',
  WorkPosting = 'WORK_POSTING',
  WorkSchedule = 'WORK_SCHEDULE'
}

export type IndirectChangeReasonModel = {
  __typename?: 'IndirectChangeReasonModel';
  entityType?: Maybe<IndirectChangeEntityTypeModel>;
  entityUid?: Maybe<Scalars['String']['output']>;
};

export enum InitiatorTypeModel {
  IntegrationClient = 'INTEGRATION_CLIENT',
  User = 'USER'
}

export type IntegrationClientModel = {
  __typename?: 'IntegrationClientModel';
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactInfoModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  permissionsConfiguration?: Maybe<IntegrationClientPermissionsConfigurationModel>;
  secretExpiresAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  userUid?: Maybe<Scalars['String']['output']>;
};


export type IntegrationClientModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationClientModelInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactInfoModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  permissionsConfiguration?: InputMaybe<IntegrationClientPermissionsConfigurationModelInput>;
  secretExpiresAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  userUid?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationClientPermissionsConfigurationModel = {
  __typename?: 'IntegrationClientPermissionsConfigurationModel';
  timesheets?: Maybe<IntegrationClientTimesheetPermissionsConfigurationModel>;
};

export type IntegrationClientPermissionsConfigurationModelInput = {
  timesheets?: InputMaybe<IntegrationClientTimesheetPermissionsConfigurationModelInput>;
};

export type IntegrationClientPermissionsConfigurationUpdateModelInput = {
  timesheets?: InputMaybe<IntegrationClientTimesheetPermissionsConfigurationUpdateModelInput>;
};

export type IntegrationClientTimesheetPermissionsConfigurationModel = {
  __typename?: 'IntegrationClientTimesheetPermissionsConfigurationModel';
  canRead: Scalars['Boolean']['output'];
  canReadAmount: Scalars['Boolean']['output'];
  canUpdateAllocations: Scalars['Boolean']['output'];
  canUpdateStatus: Scalars['Boolean']['output'];
};

export type IntegrationClientTimesheetPermissionsConfigurationModelInput = {
  canRead: Scalars['Boolean']['input'];
  canReadAmount: Scalars['Boolean']['input'];
  canUpdateAllocations: Scalars['Boolean']['input'];
  canUpdateStatus: Scalars['Boolean']['input'];
};

export type IntegrationClientTimesheetPermissionsConfigurationUpdateModelInput = {
  canRead: Scalars['Boolean']['input'];
  canReadAmount: Scalars['Boolean']['input'];
  canUpdateAllocations: Scalars['Boolean']['input'];
  canUpdateStatus: Scalars['Boolean']['input'];
};

export type IntegrationClientsModel = {
  __typename?: 'IntegrationClientsModel';
  integrationClients?: Maybe<Array<Maybe<IntegrationClientModel>>>;
};

export type InvoiceApprovalModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  decision?: InputMaybe<InvoiceApprovalStatusModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceApprovalStatusModel {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type InvoiceAttachmentModel = {
  __typename?: 'InvoiceAttachmentModel';
  contentType?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Long']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  mediaUid?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAttachmentModelInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Long']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mediaUid?: InputMaybe<Scalars['String']['input']>;
  signedUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceCreateLineItemModelInput = {
  lineType?: InputMaybe<InvoiceLineItemTypeModel>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceCreateModelInput = {
  billToAddress?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  lineItems?: InputMaybe<Array<InputMaybe<InvoiceCreateLineItemModelInput>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceFrequencyModel {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type InvoiceLineItemModel = {
  __typename?: 'InvoiceLineItemModel';
  adjustmentAmount?: Maybe<Scalars['String']['output']>;
  adjustmentId?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<ExpenseModel>;
  fees?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['String']['output']>;
  timesheet?: Maybe<TimesheetModel>;
  total?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InvoiceLineItemTypeModel>;
};

export type InvoiceLineItemModelInput = {
  adjustmentAmount?: InputMaybe<Scalars['String']['input']>;
  adjustmentId?: InputMaybe<Scalars['String']['input']>;
  expense?: InputMaybe<ExpenseModelInput>;
  fees?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<Scalars['String']['input']>;
  taxPercentage?: InputMaybe<Scalars['String']['input']>;
  timesheet?: InputMaybe<TimesheetModelInput>;
  total?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InvoiceLineItemTypeModel>;
};

export enum InvoiceLineItemTypeModel {
  Expense = 'EXPENSE',
  Timesheet = 'TIMESHEET'
}

export enum InvoiceMappingModel {
  Amount = 'AMOUNT',
  Fees = 'FEES',
  Tax = 'TAX'
}

export type InvoiceModel = {
  __typename?: 'InvoiceModel';
  amount?: Maybe<Scalars['Float']['output']>;
  approvedDate?: Maybe<Scalars['LocalDate']['output']>;
  approver?: Maybe<PersonModel>;
  approverComment?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<InvoiceAttachmentModel>>>;
  billToAddress?: Maybe<AddressModel>;
  blueprintExecutionUid?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Maybe<CompanyModel>>>;
  costCenters?: Maybe<Array<Maybe<CostCenterModel>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  currency?: Maybe<CurrencyModel>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['LocalDate']['output']>;
  invoiceTotals?: Maybe<InvoiceTotalsModel>;
  lineItems?: Maybe<Array<Maybe<InvoiceLineItemModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  paymentTerms?: Maybe<InvoicePaymentTermsModel>;
  payments?: Maybe<Array<Maybe<PaymentModel>>>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  previousInvoiceUid?: Maybe<Scalars['String']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InvoiceStatusModel>;
  supplier?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
};


export type InvoiceModelAttachmentsArgs = {
  downloadLinkExpiration?: InputMaybe<Scalars['Duration']['input']>;
};


export type InvoiceModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approvedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  approver?: InputMaybe<PersonModelInput>;
  approverComment?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<InvoiceAttachmentModelInput>>>;
  billToAddress?: InputMaybe<AddressModelInput>;
  blueprintExecutionUid?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<CompanyModelInput>>>;
  costCenters?: InputMaybe<Array<InputMaybe<CostCenterModelInput>>>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  currency?: InputMaybe<CurrencyModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  invoiceTotals?: InputMaybe<InvoiceTotalsModelInput>;
  lineItems?: InputMaybe<Array<InputMaybe<InvoiceLineItemModelInput>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Long']['input']>;
  paymentTerms?: InputMaybe<InvoicePaymentTermsModel>;
  payments?: InputMaybe<Array<InputMaybe<PaymentModelInput>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  previousInvoiceUid?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicePageModelInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Long']['input'];
  sort?: InputMaybe<Array<InputMaybe<InvoiceSortModelInput>>>;
};

export enum InvoicePaymentTermsModel {
  Net_15 = 'NET_15',
  Net_30 = 'NET_30',
  Net_45 = 'NET_45',
  Net_60 = 'NET_60',
  Net_90 = 'NET_90'
}

export type InvoiceQueryModelInput = {
  invoiceNumber?: InputMaybe<Scalars['Long']['input']>;
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<InvoiceSortTypeModel>;
};

export enum InvoiceSortTypeModel {
  LastUpdated = 'LAST_UPDATED',
  Number = 'NUMBER'
}

export enum InvoiceStatusModel {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type InvoiceTotalsModel = {
  __typename?: 'InvoiceTotalsModel';
  clientAmount?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  supplierAmount?: Maybe<Scalars['String']['output']>;
  totalFees?: Maybe<Scalars['String']['output']>;
  totalTax?: Maybe<Scalars['String']['output']>;
};

export type InvoiceTotalsModelInput = {
  clientAmount?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['String']['input']>;
  supplierAmount?: InputMaybe<Scalars['String']['input']>;
  totalFees?: InputMaybe<Scalars['String']['input']>;
  totalTax?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceUpdateModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicesModel = {
  __typename?: 'InvoicesModel';
  items?: Maybe<Array<Maybe<InvoiceModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Long']['output'];
};

export type InvoicesPageModel = {
  __typename?: 'InvoicesPageModel';
  elements?: Maybe<Array<Maybe<InvoiceModel>>>;
  invoices?: Maybe<Array<Maybe<InvoiceModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoicingAvailableColumnDefinitionModel = {
  __typename?: 'InvoicingAvailableColumnDefinitionModel';
  customField?: Maybe<Scalars['Boolean']['output']>;
  customInvoiceIdEligible?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  fieldType?: Maybe<FieldType>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type InvoicingAvailableColumnDefinitionModelInput = {
  customInvoiceIdEligible?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  entities?: InputMaybe<Array<InputMaybe<OcExportEntityModel>>>;
  fieldType?: InputMaybe<FieldType>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingAvailableColumnsResponseModel = {
  __typename?: 'InvoicingAvailableColumnsResponseModel';
  columns?: Maybe<Array<Maybe<InvoicingAvailableColumnDefinitionModel>>>;
};

export type InvoicingBatchDefinitionModel = {
  __typename?: 'InvoicingBatchDefinitionModel';
  batchNamePrefix?: Maybe<Scalars['String']['output']>;
  blueprintDefinitionUid?: Maybe<Scalars['String']['output']>;
  blueprintDefinitionVersion: Scalars['Int']['output'];
  dynamicEntityType?: Maybe<DynamicEntityTypeModel>;
  filters?: Maybe<InvoicingBatchFiltersConfigurationModel>;
  name?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<BatchScopeModel>;
  uid: Scalars['String']['output'];
};

export type InvoicingBatchDefinitionMutateModelInput = {
  batchNamePrefix?: InputMaybe<Scalars['String']['input']>;
  dynamicEntityType?: InputMaybe<DynamicEntityTypeModel>;
  filters?: InputMaybe<InvoicingBatchFiltersConfigurationModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<BatchScopeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBatchDefinitionsModel = {
  __typename?: 'InvoicingBatchDefinitionsModel';
  items?: Maybe<Array<Maybe<InvoicingBatchDefinitionModel>>>;
  totalCount: Scalars['Long']['output'];
};

export type InvoicingBatchExecutionModel = {
  __typename?: 'InvoicingBatchExecutionModel';
  batchDefinitionUid?: Maybe<Scalars['String']['output']>;
  batchName?: Maybe<Scalars['String']['output']>;
  blueprintExecutionUid?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  dataTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errorPayload?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  reportDownloadLink?: Maybe<Scalars['String']['output']>;
  rerunCount?: Maybe<Scalars['Long']['output']>;
  resultPayload?: Maybe<InvoicingBatchExecutionResultModel>;
  startedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<InvoicingExecutionStatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
  supplierReportDownloadLink?: Maybe<Scalars['String']['output']>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
};


export type InvoicingBatchExecutionModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type InvoicingBatchExecutionResultModel = {
  __typename?: 'InvoicingBatchExecutionResultModel';
  exportActualCount?: Maybe<Scalars['Long']['output']>;
  exportExecutionId?: Maybe<Scalars['Long']['output']>;
  exportRecordCount?: Maybe<Scalars['Long']['output']>;
  processedExpenses: Scalars['Int']['output'];
  processedMilestones: Scalars['Int']['output'];
  processedTimesheets: Scalars['Int']['output'];
  skippedZeroAmountTimesheets: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type InvoicingBatchExecutionsModel = {
  __typename?: 'InvoicingBatchExecutionsModel';
  items?: Maybe<Array<Maybe<InvoicingBatchExecutionModel>>>;
  totalCount: Scalars['Long']['output'];
};

export type InvoicingBatchFilterValueModel = {
  __typename?: 'InvoicingBatchFilterValueModel';
  displayValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvoicingBatchFilterValueModelInput = {
  displayValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBatchFiltersConfigurationModel = {
  __typename?: 'InvoicingBatchFiltersConfigurationModel';
  companies?: Maybe<Array<Maybe<InvoicingBatchFilterValueModel>>>;
  dataTypes?: Maybe<Array<Maybe<InvoicingBatchFilterValueModel>>>;
  locations?: Maybe<Array<Maybe<InvoicingBatchFilterValueModel>>>;
  organizations?: Maybe<Array<Maybe<InvoicingBatchOrgFilterValueModel>>>;
  supplier?: Maybe<InvoicingBatchSupplierFilterValueModel>;
};

export type InvoicingBatchFiltersConfigurationModelInput = {
  companies?: InputMaybe<Array<InputMaybe<InvoicingBatchFilterValueModelInput>>>;
  dataTypes?: InputMaybe<Array<InputMaybe<InvoicingBatchFilterValueModelInput>>>;
  locations?: InputMaybe<Array<InputMaybe<InvoicingBatchFilterValueModelInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<InvoicingBatchOrgFilterValueModelInput>>>;
  supplier?: InputMaybe<InvoicingBatchSupplierFilterValueModelInput>;
};

export type InvoicingBatchOrgFilterValueModel = {
  __typename?: 'InvoicingBatchOrgFilterValueModel';
  displayValue?: Maybe<Scalars['String']['output']>;
  includeSubOrg?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvoicingBatchOrgFilterValueModelInput = {
  displayValue?: InputMaybe<Scalars['String']['input']>;
  includeSubOrg?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBatchSupplierFilterValueModel = {
  __typename?: 'InvoicingBatchSupplierFilterValueModel';
  displayValue?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<MediaModel>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvoicingBatchSupplierFilterValueModelInput = {
  displayValue?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<MediaModelInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBillingPeriodEndDateModel = {
  __typename?: 'InvoicingBillingPeriodEndDateModel';
  frequency?: Maybe<FrequencyModel>;
  monthlyConfiguration?: Maybe<MonthlyConfigurationModel>;
  weeklyConfiguration?: Maybe<WeeklyConfigurationModel>;
};

export type InvoicingBillingPeriodEndDateModelInput = {
  frequency?: InputMaybe<FrequencyModel>;
  monthlyConfiguration?: InputMaybe<MonthlyConfigurationModelInput>;
  weeklyConfiguration?: InputMaybe<WeeklyConfigurationModelInput>;
};

export type InvoicingBlueprintDefinitionCreateModelInput = {
  batches?: InputMaybe<Array<InputMaybe<InvoicingBatchDefinitionMutateModelInput>>>;
  billingPeriodEndDate?: InputMaybe<InvoicingBillingPeriodEndDateModelInput>;
  columnConfiguration?: InputMaybe<InvoicingColumnConfigurationModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalRunDate?: InputMaybe<InvoicingFinalRunDateModelInput>;
  includeZeroAmounts?: InputMaybe<Scalars['Boolean']['input']>;
  isPreliminaryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputOptions?: InputMaybe<InvoicingOutputOptionsModelInput>;
  preliminaryRunDate?: InputMaybe<InvoicingPreliminaryRunDateModelInput>;
  scheduleStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduleZoneId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBlueprintDefinitionModel = {
  __typename?: 'InvoicingBlueprintDefinitionModel';
  batches?: Maybe<InvoicingBatchDefinitionsModel>;
  billingPeriodEndDate?: Maybe<InvoicingBillingPeriodEndDateModel>;
  columnConfiguration?: Maybe<InvoicingColumnConfigurationModel>;
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  finalRunDate?: Maybe<InvoicingFinalRunDateModel>;
  includeZeroAmounts?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  outputOptions?: Maybe<InvoicingOutputOptionsModel>;
  preliminaryRun?: Maybe<Scalars['Boolean']['output']>;
  preliminaryRunDate?: Maybe<InvoicingPreliminaryRunDateModel>;
  scheduleStartDate?: Maybe<Scalars['LocalDate']['output']>;
  scheduleZoneId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InvoicingBlueprintDefinitionStatusModel>;
  uid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  versions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type InvoicingBlueprintDefinitionPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Long']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<InvoicingBlueprintDefinitionSortModelInput>>>;
};

export type InvoicingBlueprintDefinitionPatchModelInput = {
  batches?: InputMaybe<Array<InputMaybe<InvoicingBatchDefinitionMutateModelInput>>>;
  billingPeriodEndDate?: InputMaybe<InvoicingBillingPeriodEndDateModelInput>;
  columnConfiguration?: InputMaybe<InvoicingColumnConfigurationModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalRunDate?: InputMaybe<InvoicingFinalRunDateModelInput>;
  includeZeroAmounts?: InputMaybe<Scalars['Boolean']['input']>;
  isPreliminaryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputOptions?: InputMaybe<InvoicingOutputOptionsModelInput>;
  preliminaryRunDate?: InputMaybe<InvoicingPreliminaryRunDateModelInput>;
  scheduleStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduleZoneId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBlueprintDefinitionQueryModelInput = {
  companyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizations?: InputMaybe<Array<InputMaybe<InvoicingOrganizationFilterInput>>>;
  scheduleFrequency?: InputMaybe<FrequencyModel>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<InvoicingBlueprintDefinitionStatusModel>>>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InvoicingBlueprintDefinitionSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<InvoicingBlueprintDefinitionSortTypeModel>;
};

export enum InvoicingBlueprintDefinitionSortTypeModel {
  CreatedAt = 'CREATED_AT'
}

export enum InvoicingBlueprintDefinitionStatusModel {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type InvoicingBlueprintDefinitionSubmitModelInput = {
  isActive: Scalars['Boolean']['input'];
};

export type InvoicingBlueprintDefinitionsModel = {
  __typename?: 'InvoicingBlueprintDefinitionsModel';
  elements?: Maybe<Array<Maybe<InvoicingBlueprintDefinitionModel>>>;
  items?: Maybe<Array<Maybe<InvoicingBlueprintDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum InvoicingBlueprintExecutionModeModel {
  Final = 'FINAL',
  Preliminary = 'PRELIMINARY'
}

export type InvoicingBlueprintExecutionModel = {
  __typename?: 'InvoicingBlueprintExecutionModel';
  batchExecutions?: Maybe<InvoicingBatchExecutionsModel>;
  billingPeriodEndDate?: Maybe<Scalars['LocalDate']['output']>;
  blueprintDefinitionUid?: Maybe<Scalars['String']['output']>;
  blueprintDefinitionVersion: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  errorPayload?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  executionMode?: Maybe<InvoicingBlueprintExecutionModeModel>;
  executionTriggerType?: Maybe<InvoicingBlueprintExecutionTriggerTypeModel>;
  maxRerunCount?: Maybe<Scalars['Long']['output']>;
  modifiedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  reportDownloadLink?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['String']['output']>;
  resultPayload?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  startedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<InvoicingExecutionStatusModel>;
  uid: Scalars['String']['output'];
};

export type InvoicingBlueprintExecutionPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Long']['input']>;
};

export type InvoicingBlueprintExecutionQueryModelInput = {
  blueprintDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  blueprintDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoicingExecutionStatusModel>>>;
};

export enum InvoicingBlueprintExecutionTriggerTypeModel {
  AdHoc = 'AD_HOC',
  Scheduled = 'SCHEDULED'
}

export type InvoicingBlueprintExecutionsModel = {
  __typename?: 'InvoicingBlueprintExecutionsModel';
  elements?: Maybe<Array<Maybe<InvoicingBlueprintExecutionModel>>>;
  items?: Maybe<Array<Maybe<InvoicingBlueprintExecutionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoicingColumnConfigurationModel = {
  __typename?: 'InvoicingColumnConfigurationModel';
  availableColumns?: Maybe<Array<Maybe<InvoicingAvailableColumnDefinitionModel>>>;
  customInvoiceIdColumns?: Maybe<Array<Maybe<InvoicingColumnDefinitionModel>>>;
  /** @deprecated Use 'selectedColumns' instead */
  definitions?: Maybe<Array<Maybe<InvoicingColumnDefinitionModel>>>;
  selectedColumns?: Maybe<Array<Maybe<InvoicingColumnDefinitionModel>>>;
  supplierColumnConfiguration?: Maybe<Array<Maybe<InvoicingColumnDefinitionModel>>>;
};

export type InvoicingColumnConfigurationModelInput = {
  availableColumns?: InputMaybe<Array<InputMaybe<InvoicingAvailableColumnDefinitionModelInput>>>;
  customInvoiceIdColumns?: InputMaybe<Array<InputMaybe<InvoicingColumnDefinitionModelInput>>>;
  definitions?: InputMaybe<Array<InputMaybe<InvoicingColumnDefinitionModelInput>>>;
  selectedColumns?: InputMaybe<Array<InputMaybe<InvoicingColumnDefinitionModelInput>>>;
  supplierColumnConfiguration?: InputMaybe<Array<InputMaybe<InvoicingColumnDefinitionModelInput>>>;
};

export type InvoicingColumnDefinitionModel = {
  __typename?: 'InvoicingColumnDefinitionModel';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type InvoicingColumnDefinitionModelInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingEngagementModel = {
  __typename?: 'InvoicingEngagementModel';
  engagementUid?: Maybe<Scalars['String']['output']>;
};

export type InvoicingEngagementsModel = {
  __typename?: 'InvoicingEngagementsModel';
  items?: Maybe<Array<Maybe<InvoicingEngagementModel>>>;
  totalCount: Scalars['Long']['output'];
};

export type InvoicingExecuteBlueprintRequestModelInput = {
  billingPeriodEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  executionMode?: InputMaybe<InvoicingBlueprintExecutionModeModel>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvoicingExecutionStatusModel {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type InvoicingFinalRunDateModel = {
  __typename?: 'InvoicingFinalRunDateModel';
  daysAfterBillingPeriod?: Maybe<Scalars['Int']['output']>;
  daysAfterPreliminaryRun?: Maybe<Scalars['Int']['output']>;
  preferredTime?: Maybe<Scalars['LocalTime']['output']>;
};

export type InvoicingFinalRunDateModelInput = {
  daysAfterBillingPeriod?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPreliminaryRun?: InputMaybe<Scalars['Int']['input']>;
  preferredTime?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type InvoicingModel = {
  __typename?: 'InvoicingModel';
  billFrequency?: Maybe<Scalars['String']['output']>;
  billingPeriodEndDate?: Maybe<Scalars['LocalDate']['output']>;
  customInvoiceId?: Maybe<Scalars['String']['output']>;
  customInvoiceIdCalculation?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['LocalDate']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceLineItemId?: Maybe<Scalars['String']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<Scalars['String']['output']>;
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
  supplierInvoiceName?: Maybe<Scalars['String']['output']>;
};

export type InvoicingOrganizationFilterInput = {
  includeSubOrg: Scalars['Boolean']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingOutputOptionsModel = {
  __typename?: 'InvoicingOutputOptionsModel';
  sftpDirectoryUid?: Maybe<Scalars['String']['output']>;
  sftpTransfer: Scalars['Boolean']['output'];
  transactionFileFormat?: Maybe<TransactionFileFormatModel>;
};

export type InvoicingOutputOptionsModelInput = {
  sftpDirectoryUid?: InputMaybe<Scalars['String']['input']>;
  sftpTransfer: Scalars['Boolean']['input'];
  transactionFileFormat?: InputMaybe<TransactionFileFormatModel>;
};

export type InvoicingPreliminaryRunDateModel = {
  __typename?: 'InvoicingPreliminaryRunDateModel';
  daysAfterBillingPeriod?: Maybe<Scalars['Int']['output']>;
  preferredTime?: Maybe<Scalars['LocalTime']['output']>;
};

export type InvoicingPreliminaryRunDateModelInput = {
  daysAfterBillingPeriod?: InputMaybe<Scalars['Int']['input']>;
  preferredTime?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type InvoicingSupplierModel = {
  __typename?: 'InvoicingSupplierModel';
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type InvoicingSuppliersModel = {
  __typename?: 'InvoicingSuppliersModel';
  items?: Maybe<Array<Maybe<InvoicingSupplierModel>>>;
  totalCount: Scalars['Long']['output'];
};

export type JobApplicationCandidateSkillModel = {
  __typename?: 'JobApplicationCandidateSkillModel';
  label?: Maybe<Scalars['String']['output']>;
  skillUid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type JobApplicationCandidateSkillModelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  skillUid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationCreateModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressModelInput>;
  alternateExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  billRate?: InputMaybe<Scalars['Float']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  dateOfBirth?: InputMaybe<UserDateAttributeModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  genderModel?: InputMaybe<GenderModelInput>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  jobPostingBusinessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  nationalId?: InputMaybe<JobApplicationNationalIdInputModelInput>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  preferredEndDate?: InputMaybe<UserDateAttributeModelInput>;
  preferredStartDate?: InputMaybe<UserDateAttributeModelInput>;
  primaryExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  stageUid?: InputMaybe<Scalars['String']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
  workerProfileUid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationModel = {
  __typename?: 'JobApplicationModel';
  accountablePerson?: Maybe<PersonModel>;
  address?: Maybe<AddressModel>;
  alternateExternalApprover?: Maybe<PersonModel>;
  billRate?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<BudgetModel>;
  businessSite?: Maybe<LocationModel>;
  classification?: Maybe<ClassificationModel>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  companyWorkerId?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<CostCenterModel>;
  costCenters?: Maybe<CostCentersModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  dateOfBirth?: Maybe<UserDateAttributeModel>;
  deliveredFieldDefinitions?: Maybe<Scalars['Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar']['output']>;
  documents?: Maybe<GwgMediaModelResponse>;
  duplicateWorker?: Maybe<PersonModel>;
  email?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<EngagementModel>;
  engagementEndDate?: Maybe<UserDateAttributeModel>;
  engagementStartDate?: Maybe<UserDateAttributeModel>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  firstSubmittedBillRate?: Maybe<Scalars['Float']['output']>;
  firstSubmittedRateCurrency?: Maybe<Scalars['String']['output']>;
  firstSubmittedRatePeriod?: Maybe<PayRatePeriodModel>;
  /** @deprecated Deprecated in favour of genderModel */
  gender?: Maybe<Scalars['String']['output']>;
  genderModel?: Maybe<GenderModel>;
  hasDuplicateWorkerCheckCompleted?: Maybe<Scalars['Boolean']['output']>;
  holidaySchedule?: Maybe<HolidayScheduleModel>;
  jobPostingBusinessReason?: Maybe<JobPostingBusinessReasonModel>;
  jobProfile?: Maybe<JobProfileModel>;
  jobRequest?: Maybe<WorkPostingModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  msp?: Maybe<MspModel>;
  name?: Maybe<NameModel>;
  nationalId?: Maybe<JobApplicationNationalIdModel>;
  nationalIdMasked?: Maybe<JobApplicationNationalIdModel>;
  number?: Maybe<Scalars['Long']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumberModel>;
  preferredEndDate?: Maybe<UserDateAttributeModel>;
  preferredStartDate?: Maybe<UserDateAttributeModel>;
  primaryExternalApprover?: Maybe<PersonModel>;
  rateCard?: Maybe<RateCardModel>;
  rateCurrency?: Maybe<Scalars['String']['output']>;
  rateMarkup?: Maybe<Scalars['Float']['output']>;
  ratePeriod?: Maybe<PayRatePeriodModel>;
  rateType?: Maybe<PayRateTypeModel>;
  rejectedBy?: Maybe<PersonModel>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  rejectionDate?: Maybe<Scalars['LocalDate']['output']>;
  rejectionReason?: Maybe<BusinessEventReasonModel>;
  remoteWorkAddress?: Maybe<AddressModel>;
  shortlisted?: Maybe<Scalars['Boolean']['output']>;
  skills?: Maybe<Array<Maybe<JobApplicationCandidateSkillModel>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourcingType?: Maybe<SourcingTypeModel>;
  stage?: Maybe<JobApplicationStageModel>;
  stagesTimeInfo?: Maybe<Array<Maybe<JobApplicationStageTimeInfoModel>>>;
  status?: Maybe<JobApplicationStatusModel>;
  supervisoryOrg?: Maybe<OrgModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  timeToHireDays?: Maybe<Scalars['Int']['output']>;
  timeToStartDays?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  workSchedule?: Maybe<WorkScheduleModel>;
  workdayApplicantId?: Maybe<Scalars['String']['output']>;
  workdayWorkerId?: Maybe<Scalars['String']['output']>;
  workerDuplicates?: Maybe<Array<Maybe<WorkerDuplicateModel>>>;
  workerProfileUid?: Maybe<Scalars['String']['output']>;
};


export type JobApplicationModelBudgetArgs = {
  skipBudgetResolution?: InputMaybe<Scalars['Boolean']['input']>;
};


export type JobApplicationModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type JobApplicationModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobApplicationModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobApplicationModelDocumentsArgs = {
  downloadLinkExpiration?: InputMaybe<Scalars['Duration']['input']>;
};


export type JobApplicationModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobApplicationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type JobApplicationModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type JobApplicationModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  address?: InputMaybe<AddressModelInput>;
  alternateExternalApprover?: InputMaybe<PersonModelInput>;
  billRate?: InputMaybe<Scalars['Float']['input']>;
  budget?: InputMaybe<BudgetModelInput>;
  businessSite?: InputMaybe<LocationModelInput>;
  classification?: InputMaybe<ClassificationModelInput>;
  company?: InputMaybe<CompanyModelInput>;
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  costCenters?: InputMaybe<CostCentersModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  dateOfBirth?: InputMaybe<UserDateAttributeModelInput>;
  deliveredFieldDefinitions?: InputMaybe<Scalars['DeliveredFieldDefinitionsModelScalar']['input']>;
  documents?: InputMaybe<GwgMediaModelResponseInput>;
  duplicateWorker?: InputMaybe<PersonModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementModelInput>;
  engagementEndDate?: InputMaybe<UserDateAttributeModelInput>;
  engagementStartDate?: InputMaybe<UserDateAttributeModelInput>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  firstSubmittedBillRate?: InputMaybe<Scalars['Float']['input']>;
  firstSubmittedRateCurrency?: InputMaybe<Scalars['String']['input']>;
  firstSubmittedRatePeriod?: InputMaybe<PayRatePeriodModel>;
  gender?: InputMaybe<Scalars['String']['input']>;
  genderModel?: InputMaybe<GenderModelInput>;
  hasDuplicateWorkerCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleModelInput>;
  jobPostingBusinessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  jobProfile?: InputMaybe<JobProfileModelInput>;
  jobRequest?: InputMaybe<WorkPostingModelInput>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  msp?: InputMaybe<MspModelInput>;
  name?: InputMaybe<NameModelInput>;
  nationalId?: InputMaybe<JobApplicationNationalIdModelInput>;
  nationalIdMasked?: InputMaybe<JobApplicationNationalIdModelInput>;
  number?: InputMaybe<Scalars['Long']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  person?: InputMaybe<PersonModelInput>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  preferredEndDate?: InputMaybe<UserDateAttributeModelInput>;
  preferredStartDate?: InputMaybe<UserDateAttributeModelInput>;
  primaryExternalApprover?: InputMaybe<PersonModelInput>;
  rateCard?: InputMaybe<RateCardModelInput>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  rateMarkup?: InputMaybe<Scalars['Float']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  rejectedBy?: InputMaybe<PersonModelInput>;
  rejectionComment?: InputMaybe<Scalars['String']['input']>;
  rejectionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  rejectionReason?: InputMaybe<BusinessEventReasonModelInput>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  shortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<InputMaybe<JobApplicationCandidateSkillModelInput>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  stage?: InputMaybe<JobApplicationStageModelInput>;
  stagesTimeInfo?: InputMaybe<Array<InputMaybe<JobApplicationStageTimeInfoModelInput>>>;
  status?: InputMaybe<JobApplicationStatusModel>;
  supervisoryOrg?: InputMaybe<OrgModelInput>;
  supplier?: InputMaybe<SupplierModelInput>;
  timeToHireDays?: InputMaybe<Scalars['Int']['input']>;
  timeToStartDays?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleModelInput>;
  workdayApplicantId?: InputMaybe<Scalars['String']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
  workerDuplicates?: InputMaybe<Array<InputMaybe<WorkerDuplicateModelInput>>>;
  workerProfileUid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationNationalIdInputModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationNationalIdModel = {
  __typename?: 'JobApplicationNationalIdModel';
  type?: Maybe<NationalIdTypeModel>;
  validUntil?: Maybe<Scalars['LocalDate']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationNationalIdModelInput = {
  type?: InputMaybe<NationalIdTypeModelInput>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationOrgQueryModelInput = {
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationPatchModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressModelInput>;
  alternateExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  billRate?: InputMaybe<Scalars['Float']['input']>;
  businessSiteUid?: InputMaybe<Scalars['String']['input']>;
  classificationUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUids?: InputMaybe<CostCenterUidsModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  dateOfBirth?: InputMaybe<UserDateAttributeModelInput>;
  duplicateWorkerUid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  engagementEndDate?: InputMaybe<UserDateAttributeModelInput>;
  engagementStartDate?: InputMaybe<UserDateAttributeModelInput>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  genderModel?: InputMaybe<GenderModelInput>;
  hasDuplicateWorkerCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  jobPostingBusinessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  jobProfileUid?: InputMaybe<Scalars['String']['input']>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  nationalId?: InputMaybe<JobApplicationNationalIdInputModelInput>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  preferredEndDate?: InputMaybe<UserDateAttributeModelInput>;
  preferredStartDate?: InputMaybe<UserDateAttributeModelInput>;
  primaryExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  shortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  stageUid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobApplicationStatusModel>;
  supervisoryOrgUid?: InputMaybe<Scalars['String']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
  workdayApplicantId?: InputMaybe<Scalars['String']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationQueryModelInput = {
  businessSiteUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  createdDateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  customFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  dob?: InputMaybe<Scalars['LocalDate']['input']>;
  financialFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<JobApplicationSortModelInput>>>;
  stageUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<JobApplicationStatusModel>>>;
  supervisoryOrgFilters?: InputMaybe<Array<InputMaybe<JobApplicationOrgQueryModelInput>>>;
  supervisoryOrgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JobApplicationRevisionModel = RevisionModel & {
  __typename?: 'JobApplicationRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  indirectChangeReason?: Maybe<IndirectChangeReasonModel>;
  jobApplication?: Maybe<JobApplicationModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousJobApplication?: Maybe<JobApplicationModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type JobApplicationSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<JobApplicationSortTypeModel>;
};

export enum JobApplicationSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  LastModified = 'LAST_MODIFIED',
  Status = 'STATUS'
}

export type JobApplicationStageCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationStageModel = {
  __typename?: 'JobApplicationStageModel';
  name?: Maybe<Scalars['String']['output']>;
  processOnly?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};

export type JobApplicationStageModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  processOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationStagePatchModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  processOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationStageTimeInfoModel = {
  __typename?: 'JobApplicationStageTimeInfoModel';
  daysToStage?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<JobApplicationStageModel>;
};

export type JobApplicationStageTimeInfoModelInput = {
  daysToStage?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<JobApplicationStageModelInput>;
};

export type JobApplicationStagesModel = {
  __typename?: 'JobApplicationStagesModel';
  items?: Maybe<Array<Maybe<JobApplicationStageModel>>>;
};

export enum JobApplicationStatusModel {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
  Rescinded = 'RESCINDED',
  SupplierDraft = 'SUPPLIER_DRAFT'
}

export type JobApplicationWorkerDuplicateSelectedModelInput = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
};

export type JobApplicationWorkerDuplicatesModelInput = {
  uid?: InputMaybe<Scalars['String']['input']>;
  workerDuplicates?: InputMaybe<Array<InputMaybe<WorkerDuplicateModelInput>>>;
};

export type JobApplicationsModel = {
  __typename?: 'JobApplicationsModel';
  elements?: Maybe<Array<Maybe<JobApplicationModel>>>;
  /** @deprecated Deprecated as part of page model unification */
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobApplicationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JobClassificationModel = {
  __typename?: 'JobClassificationModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type JobClassificationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobClassificationModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamiliesModel = {
  __typename?: 'JobFamiliesModel';
  elements?: Maybe<Array<Maybe<JobFamilyModel>>>;
  items?: Maybe<Array<Maybe<JobFamilyModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JobFamilyCreateModelInput = {
  jobFamilyGroupReference?: InputMaybe<JobFamilyGroupImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupModel = {
  __typename?: 'JobFamilyGroupModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  summary?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type JobFamilyGroupModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobFamilyGroupModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupQueryModelInput = {
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupUpdateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyGroupsModel = {
  __typename?: 'JobFamilyGroupsModel';
  elements?: Maybe<Array<Maybe<JobFamilyGroupModel>>>;
  items?: Maybe<Array<Maybe<JobFamilyGroupModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JobFamilyImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyModel = {
  __typename?: 'JobFamilyModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  jobFamilyGroup?: Maybe<JobFamilyGroupModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  summary?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type JobFamilyModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobFamilyModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  jobFamilyGroup?: InputMaybe<JobFamilyGroupModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyPatchModelInput = {
  jobFamilyGroupReference?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type JobFamilyQueryModelInput = {
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  jobFamilyGroupUid?: InputMaybe<Scalars['String']['input']>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JobFamilyUpdateModelInput = {
  jobFamilyGroupReference?: InputMaybe<JobFamilyGroupImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobPostingApplicationSmartFormModel = {
  __typename?: 'JobPostingApplicationSmartFormModel';
  classificationUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jobProfileUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  smartFormUid?: Maybe<Scalars['String']['output']>;
};

export type JobPostingApplicationSmartFormModelInput = {
  classificationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobProfileUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smartFormUid?: InputMaybe<Scalars['String']['input']>;
};

export enum JobPostingBusinessReasonModel {
  Backfill = 'BACKFILL',
  MaternityLeave = 'MATERNITY_LEAVE',
  NewHeadcount = 'NEW_HEADCOUNT',
  Replacement = 'REPLACEMENT',
  ShortTermAbsence = 'SHORT_TERM_ABSENCE'
}

export type JobPostingSummaryModel = {
  __typename?: 'JobPostingSummaryModel';
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedDate?: Maybe<Scalars['LocalDate']['output']>;
  candidatesOffered?: Maybe<Scalars['Int']['output']>;
  candidatesShortlisted?: Maybe<Scalars['Int']['output']>;
  filled?: Maybe<Scalars['Int']['output']>;
  interviewsScheduled?: Maybe<Scalars['Int']['output']>;
  rejectedCandidates?: Maybe<Scalars['Int']['output']>;
  suppliersResponded?: Maybe<Scalars['Int']['output']>;
  timeToHire?: Maybe<Scalars['Float']['output']>;
  timeToInterview?: Maybe<Scalars['Float']['output']>;
  timeToOffer?: Maybe<Scalars['Float']['output']>;
  timeToShortList?: Maybe<Scalars['Float']['output']>;
  timeToStart?: Maybe<Scalars['Float']['output']>;
  totalCandidates?: Maybe<Scalars['Int']['output']>;
};

export type JobPostingSummaryModelInput = {
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  approvedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  candidatesOffered?: InputMaybe<Scalars['Int']['input']>;
  candidatesShortlisted?: InputMaybe<Scalars['Int']['input']>;
  filled?: InputMaybe<Scalars['Int']['input']>;
  interviewsScheduled?: InputMaybe<Scalars['Int']['input']>;
  rejectedCandidates?: InputMaybe<Scalars['Int']['input']>;
  suppliersResponded?: InputMaybe<Scalars['Int']['input']>;
  timeToHire?: InputMaybe<Scalars['Float']['input']>;
  timeToInterview?: InputMaybe<Scalars['Float']['input']>;
  timeToOffer?: InputMaybe<Scalars['Float']['input']>;
  timeToShortList?: InputMaybe<Scalars['Float']['input']>;
  timeToStart?: InputMaybe<Scalars['Float']['input']>;
  totalCandidates?: InputMaybe<Scalars['Int']['input']>;
};

export type JobProfileCertificationModel = {
  __typename?: 'JobProfileCertificationModel';
  certification?: Maybe<CertificationModel>;
  jobProfile?: Maybe<JobProfileModel>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type JobProfileCertificationModelInput = {
  certification?: InputMaybe<CertificationModelInput>;
  jobProfile?: InputMaybe<JobProfileModelInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProfileCreateModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  classifications?: InputMaybe<Array<InputMaybe<ClassificationImportableReferenceModelInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryModelInput>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  jobFamily?: InputMaybe<JobFamilyImportableReferenceModelInput>;
  jobFamilyGroup?: InputMaybe<JobFamilyGroupModelInput>;
  mappedExportJobProfile?: InputMaybe<JobProfileImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobProfileStatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobProfileEligibilityRequirementModel = {
  __typename?: 'JobProfileEligibilityRequirementModel';
  eligibilityRequirement?: Maybe<EligibilityRequirementModel>;
  jobProfile?: Maybe<JobProfileModel>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type JobProfileImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobProfileModel = {
  __typename?: 'JobProfileModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  classifications?: Maybe<Array<Maybe<ClassificationModel>>>;
  code?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Array<Maybe<CountryModel>>>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  eligibilityRequirements?: Maybe<Array<Maybe<JobProfileEligibilityRequirementModel>>>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalTitle?: Maybe<Scalars['String']['output']>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  /** @deprecated Use eligibilityRequirements instead */
  jobCertifications?: Maybe<Array<Maybe<JobProfileCertificationModel>>>;
  jobClassifications?: Maybe<Array<Maybe<JobClassificationModel>>>;
  jobFamily?: Maybe<JobFamilyModel>;
  jobFamilyGroup?: Maybe<JobFamilyGroupModel>;
  mappedExportJobProfile?: Maybe<JobProfileModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<JobProfileStatusModel>;
  summary?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type JobProfileModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobProfileModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobProfileModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type JobProfileModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProfileModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  classifications?: InputMaybe<Array<InputMaybe<ClassificationModelInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryModelInput>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  jobCertifications?: InputMaybe<Array<InputMaybe<JobProfileCertificationModelInput>>>;
  jobClassifications?: InputMaybe<Array<InputMaybe<JobClassificationModelInput>>>;
  jobFamily?: InputMaybe<JobFamilyModelInput>;
  jobFamilyGroup?: InputMaybe<JobFamilyGroupModelInput>;
  mappedExportJobProfile?: InputMaybe<JobProfileModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobProfileStatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobProfileQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  classificationAssignable?: InputMaybe<Scalars['Boolean']['input']>;
  classificationUid?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  forceClassificationRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  forceJobFamilyRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  jobFamilyGroupUid?: InputMaybe<Scalars['String']['input']>;
  jobFamilyUid?: InputMaybe<Scalars['String']['input']>;
  locationFilter?: InputMaybe<LocationFilterCriteriaInput>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<JobProfileStatusModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum JobProfileStatusModel {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type JobProfileUpdateModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  classifications?: InputMaybe<Array<InputMaybe<ClassificationImportableReferenceModelInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryModelInput>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  jobFamily?: InputMaybe<JobFamilyImportableReferenceModelInput>;
  jobFamilyGroup?: InputMaybe<JobFamilyGroupModelInput>;
  mappedExportJobProfile?: InputMaybe<JobProfileImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobProfileStatusModel>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type JobProfilesModel = {
  __typename?: 'JobProfilesModel';
  elements?: Maybe<Array<Maybe<JobProfileModel>>>;
  jobProfiles?: Maybe<Array<Maybe<JobProfileModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JoinersAndLeaversChartModel = {
  __typename?: 'JoinersAndLeaversChartModel';
  data?: Maybe<Array<Maybe<JoinersAndLeaversModel>>>;
  range?: Maybe<DateRangeModel>;
};

export type JoinersAndLeaversModel = {
  __typename?: 'JoinersAndLeaversModel';
  date?: Maybe<Scalars['LocalDate']['output']>;
  joiners: Scalars['Int']['output'];
  leavers: Scalars['Int']['output'];
};

export type LabelVariableModel = {
  __typename?: 'LabelVariableModel';
  allowedInTaskName?: Maybe<Scalars['Boolean']['output']>;
  fieldKey?: Maybe<FieldKeyModel>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LabelVariableModelInput = {
  allowedInTaskName?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<FieldKeyModel>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LabelVariablesModel = {
  __typename?: 'LabelVariablesModel';
  entityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  variables?: Maybe<Array<Maybe<LabelVariableModel>>>;
};

export type LabelVariablesModelInput = {
  entityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
  variables?: InputMaybe<Array<InputMaybe<LabelVariableModelInput>>>;
};

export enum LineItem {
  Expense = 'EXPENSE',
  Milestone = 'MILESTONE',
  Timesheet = 'TIMESHEET'
}

export type LocationCreateModelInput = {
  address?: InputMaybe<AddressModelInput>;
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LocationImportableReferenceModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
  workdayLocationHierarchyReferences?: InputMaybe<Array<InputMaybe<LocationHierarchyReferenceModelInput>>>;
};

export type LocationFilterCriteriaInput = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profilesWithNoLocationWhenNoCountriesMatch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationHierarchyReferenceModel = {
  __typename?: 'LocationHierarchyReferenceModel';
  referenceId?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
};

export type LocationHierarchyReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
};

export type LocationImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type LocationModel = {
  __typename?: 'LocationModel';
  address?: Maybe<AddressModel>;
  assignable?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<Maybe<LocationModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  /** @deprecated Deprecated in favour of reference_id and WID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favour of reference_id and WID */
  externalIds?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<LocationModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  roleAssignments?: Maybe<Array<Maybe<RoleAssignmentsModel>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LocationTypeModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
  workdayLocationHierarchyReferences?: Maybe<Array<Maybe<LocationHierarchyReferenceModel>>>;
};


export type LocationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationModelInput = {
  address?: InputMaybe<AddressModelInput>;
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LocationModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  roleAssignments?: InputMaybe<Array<InputMaybe<RoleAssignmentsModelInput>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
  workdayLocationHierarchyReferences?: InputMaybe<Array<InputMaybe<LocationHierarchyReferenceModelInput>>>;
};

export type LocationPatchModelInput = {
  address?: InputMaybe<AddressModelInput>;
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LocationImportableReferenceModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
  workdayLocationHierarchyReferences?: InputMaybe<Array<InputMaybe<LocationHierarchyReferenceModelInput>>>;
};

export type LocationQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<LocationTypeModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationRoleAssignmentsModel = {
  __typename?: 'LocationRoleAssignmentsModel';
  assignees?: Maybe<Array<Maybe<PersonModel>>>;
  location?: Maybe<LocationModel>;
};

export type LocationRoleAssignmentsModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  location?: InputMaybe<LocationModelInput>;
};

export type LocationSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<LocationSortTypeModel>;
};

export enum LocationSortTypeModel {
  Assignable = 'ASSIGNABLE',
  Name = 'NAME',
  ReferenceId = 'REFERENCE_ID'
}

export enum LocationTypeModel {
  BusinessSite = 'BUSINESS_SITE',
  LocationHierarchy = 'LOCATION_HIERARCHY',
  Unknown = 'UNKNOWN'
}

export type LocationsFilterModelInput = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasGeolocation?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocation?: InputMaybe<Scalars['Boolean']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationsModel = {
  __typename?: 'LocationsModel';
  elements?: Maybe<Array<Maybe<LocationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  locations?: Maybe<Array<Maybe<LocationModel>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LogicalConditionModel = {
  __typename?: 'LogicalConditionModel';
  fieldCondition?: Maybe<FieldConditionModel>;
  logicalConditions?: Maybe<Array<Maybe<LogicalConditionModel>>>;
  negate?: Maybe<Scalars['Boolean']['output']>;
  operator?: Maybe<LogicalConditionOperatorModel>;
};

export type LogicalConditionModelInput = {
  fieldCondition?: InputMaybe<FieldConditionModelInput>;
  logicalConditions?: InputMaybe<Array<InputMaybe<LogicalConditionModelInput>>>;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<LogicalConditionOperatorModel>;
};

export enum LogicalConditionOperatorModel {
  And = 'AND',
  Or = 'OR'
}

export type ManagedSftpServerModel = {
  __typename?: 'ManagedSftpServerModel';
  host?: Maybe<Scalars['URI']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ManagerImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MediaDownloadInfoModel = {
  __typename?: 'MediaDownloadInfoModel';
  contentType?: Maybe<Scalars['String']['output']>;
  downloadLink?: Maybe<Scalars['URI']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  uid: Scalars['String']['output'];
};

export type MediaModel = {
  __typename?: 'MediaModel';
  alternates?: Maybe<Array<Maybe<MediaModel>>>;
  contentType?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  type?: Maybe<MediaTypeModel>;
  uid: Scalars['String']['output'];
};

export type MediaModelInput = {
  alternates?: InputMaybe<Array<InputMaybe<MediaModelInput>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  signedUrl?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<MediaTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum MediaTypeModel {
  AlternateImage = 'ALTERNATE_IMAGE',
  BackgroundCheckDocument = 'BACKGROUND_CHECK_DOCUMENT',
  ContractAttachment = 'CONTRACT_ATTACHMENT',
  CsvExport = 'CSV_EXPORT',
  CsvTemplate = 'CSV_TEMPLATE',
  DecisionTableCsv = 'DECISION_TABLE_CSV',
  EncryptionKey = 'ENCRYPTION_KEY',
  EnterpriseLogo = 'ENTERPRISE_LOGO',
  ImportSheet = 'IMPORT_SHEET',
  ImportSheetErrors = 'IMPORT_SHEET_ERRORS',
  ImportSheetXml = 'IMPORT_SHEET_XML',
  IntegrationExecutionLogs = 'INTEGRATION_EXECUTION_LOGS',
  IntegrationStepResults = 'INTEGRATION_STEP_RESULTS',
  JsonlExport = 'JSONL_EXPORT',
  MilestoneAttachment = 'MILESTONE_ATTACHMENT',
  OrgLogo = 'ORG_LOGO',
  OtherWorkerDocument = 'OTHER_WORKER_DOCUMENT',
  PptExport = 'PPT_EXPORT',
  PptTemplate = 'PPT_TEMPLATE',
  ProcessDefinitionThumbnail = 'PROCESS_DEFINITION_THUMBNAIL',
  ProfilePicture = 'PROFILE_PICTURE',
  RecipeTranscriptXml = 'RECIPE_TRANSCRIPT_XML',
  RecipeXml = 'RECIPE_XML',
  RecipeXslt = 'RECIPE_XSLT',
  RecommendationOptionImage = 'RECOMMENDATION_OPTION_IMAGE',
  Resume = 'RESUME',
  SoapRequest = 'SOAP_REQUEST',
  SoapResponse = 'SOAP_RESPONSE',
  SupplierLogo = 'SUPPLIER_LOGO',
  Unknown = 'UNKNOWN',
  WorkatoWebhookTranscript = 'WORKATO_WEBHOOK_TRANSCRIPT',
  WorkdayServiceTaskRequest = 'WORKDAY_SERVICE_TASK_REQUEST',
  WorkdayServiceTaskResponse = 'WORKDAY_SERVICE_TASK_RESPONSE',
  WorkerQualificationAttachment = 'WORKER_QUALIFICATION_ATTACHMENT'
}

export type MilestoneAttachmentCreateModelInput = {
  mediaUid?: InputMaybe<Scalars['String']['input']>;
};

export type MilestoneAttachmentModel = {
  __typename?: 'MilestoneAttachmentModel';
  id: Scalars['Long']['output'];
  media?: Maybe<MediaModel>;
};

export type MilestoneAttachmentModelInput = {
  id: Scalars['Long']['input'];
  media?: InputMaybe<MediaModelInput>;
};

export type MilestoneAttachmentsPatchModelInput = {
  add?: InputMaybe<Array<InputMaybe<MilestoneAttachmentCreateModelInput>>>;
  remove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MilestoneCreateModelInput = {
  acceptanceCriteria?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<MilestoneAttachmentCreateModelInput>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  costCenter?: InputMaybe<CostCenterImportableReferenceModelInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  deliveryLocation?: InputMaybe<LocationImportableReferenceModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type MilestoneModel = {
  __typename?: 'MilestoneModel';
  acceptanceCriteria?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['BigDecimal']['output']>;
  approvedDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  approver?: Maybe<PersonModel>;
  attachments?: Maybe<Array<Maybe<MilestoneAttachmentModel>>>;
  comment?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['LocalDate']['output']>;
  contract?: Maybe<ContractModel>;
  correctable?: Maybe<Scalars['Boolean']['output']>;
  corrected?: Maybe<Scalars['Boolean']['output']>;
  costCenter?: Maybe<CostCenterModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creditMilestone?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  deliveryLocation?: Maybe<LocationModel>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  externalInvoiceDate?: Maybe<Scalars['LocalDate']['output']>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  id?: Maybe<Scalars['Long']['output']>;
  minorNumber?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  previousMilestone?: Maybe<MilestoneModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  semanticVersion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MilestoneStatusModel>;
  submitter?: Maybe<PersonModel>;
  uid: Scalars['String']['output'];
  versions?: Maybe<Array<Maybe<MilestoneModel>>>;
};


export type MilestoneModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MilestoneModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MilestoneModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MilestoneModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MilestoneModelInput = {
  acceptanceCriteria?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  approvedDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  approver?: InputMaybe<PersonModelInput>;
  attachments?: InputMaybe<Array<InputMaybe<MilestoneAttachmentModelInput>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  contract?: InputMaybe<ContractModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  deliveryLocation?: InputMaybe<LocationModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MilestoneStatusModel>;
  submitter?: InputMaybe<PersonModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MilestonePatchModelInput = {
  acceptanceCriteria?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  attachments?: InputMaybe<MilestoneAttachmentsPatchModelInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  costCenter?: InputMaybe<CostCenterImportableReferenceModelInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  deliveryLocation?: InputMaybe<LocationImportableReferenceModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum MilestoneStatusModel {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export enum MilestoneStatusUpdateModel {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type MilestonesModel = {
  __typename?: 'MilestonesModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<MilestoneModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MilestonesModelInput = {
  endOfResults?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<MilestoneModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type MilestonesQueryModelInput = {
  includeSuperseded?: InputMaybe<Scalars['Boolean']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum MilitaryAffiliationModel {
  ActiveMilitaryMember = 'ACTIVE_MILITARY_MEMBER',
  None = 'NONE',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  SpouseOfActiveOrReserve = 'SPOUSE_OF_ACTIVE_OR_RESERVE',
  SpouseOfVeteran = 'SPOUSE_OF_VETERAN',
  VeteranOrNoLongerServing = 'VETERAN_OR_NO_LONGER_SERVING'
}

export type MonthlyConfigurationModel = {
  __typename?: 'MonthlyConfigurationModel';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  daySpecifier?: Maybe<DaySpecifierModel>;
  interval: Scalars['Int']['output'];
  ordinal?: Maybe<OrdinalModel>;
};

export type MonthlyConfigurationModelInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  daySpecifier?: InputMaybe<DaySpecifierModel>;
  interval: Scalars['Int']['input'];
  ordinal?: InputMaybe<OrdinalModel>;
};

export type MspCreateModelInput = {
  contactAddress?: InputMaybe<AddressModelInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<NameModelInput>;
  contactPhoneNumber?: InputMaybe<PhoneNumberModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MspImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MspModel = {
  __typename?: 'MspModel';
  contactDetails?: Maybe<ContactInfoModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};


export type MspModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MspModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MspModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MspModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MspModelInput = {
  contactDetails?: InputMaybe<ContactInfoModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MspPatchModelInput = {
  contactAddress?: InputMaybe<AddressModelInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<NameModelInput>;
  contactPhoneNumber?: InputMaybe<PhoneNumberModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type MspQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MspSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<MspSortTypeModel>;
};

export enum MspSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  LastModified = 'LAST_MODIFIED',
  Name = 'NAME',
  Status = 'STATUS'
}

export enum MspUserRoleUpdateModel {
  MspAdmin = 'MSP_ADMIN',
  MspUser = 'MSP_USER'
}

export type MspsModel = {
  __typename?: 'MspsModel';
  items?: Maybe<Array<Maybe<MspModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAnalyticsDashboard: AnalyticsDashboardModel;
  activateBlueprintDefinition: InvoicingBlueprintDefinitionModel;
  activateBusinessEventReason?: Maybe<BusinessEventReasonModel>;
  activateDecisionTableDefinition: DecisionTableDefinitionModel;
  activateFieldConstraintDefinition?: Maybe<FieldConstraintDefinitionModel>;
  activateGender: GenderModel;
  activateJobApplicationStage: JobApplicationStageModel;
  activateMsp: MspModel;
  activatePeople: PeopleModel;
  activateSeniority: SeniorityModel;
  activateTaskDefinition?: Maybe<Scalars['Boolean']['output']>;
  activateTerminationReason: TerminationReasonModel;
  addComment: CommentModel;
  addContractDocuments: Array<Maybe<ContractDocumentModel>>;
  addJobApplicationSmartForm: WorkPostingModel;
  addMilestoneAttachments: Array<Maybe<MilestoneAttachmentModel>>;
  addPersonToSupervisoryOrg?: Maybe<Scalars['Boolean']['output']>;
  addSupplierGroupInstanceToWorkPosting?: Maybe<SupplierGroupInstanceModel>;
  addViewToHistory?: Maybe<Scalars['Boolean']['output']>;
  approveExpense: ExpenseModel;
  approveInvoice?: Maybe<InvoiceModel>;
  approveTimesheet: TimesheetModel;
  assignCostCenterRoles: RoleAssignmentsModel;
  assignCountryRoles: RoleAssignmentsModel;
  assignLocationRoles: RoleAssignmentsModel;
  assignOrgRoles: RoleAssignmentsModel;
  attachJobApplicationDocument: GwgMediaModel;
  bulkInvoiceMarkAsPaid: Array<Maybe<InvoiceModel>>;
  cancelExport: OcExportModel;
  cancelImportJob?: Maybe<ImportJobCommandResultModel>;
  clearSupplier: EngagementModel;
  commitEngagementRetroactiveChange: RetroactiveChangeModel;
  correctMilestone: MilestoneModel;
  correlateReceiveTask: TaskModel;
  createAnalyticsDashboard: AnalyticsDashboardModel;
  createBlueprintDefinition: InvoicingBlueprintDefinitionModel;
  createBusinessEventReason?: Maybe<BusinessEventReasonModel>;
  createCertification: CertificationModel;
  createClassification: ClassificationModel;
  createCompany: CompanyModel;
  createConfigurableAnomalyDefinition: AnomalyDefinitionModel;
  createContract: ContractModel;
  createCostCenter?: Maybe<CostCenterModel>;
  createCsvTemplate: CsvTemplateModel;
  createCustomFieldDefinition: CustomFieldDefinitionModel;
  createCustomFieldDefinitionGroup: CustomFieldDefinitionGroupModel;
  createCustomObject: CustomObjectModel;
  createCustomObjectDefinition: CustomObjectDefinitionModel;
  createCustomTimeSeriesEvent: CustomTimeSeriesEventModel;
  createDashboard: DashboardModel;
  createDecisionTableDefinition: DecisionTableDefinitionModel;
  createEligibilityRequirement: EligibilityRequirementModel;
  createEngagement: EngagementModel;
  createExpense: ExpenseModel;
  createExpenseCategory: ExpenseCategoryModel;
  createFieldConstraintDefinition: FieldConstraintDefinitionModel;
  createFinancialCustomFieldDefinition: CustomFieldDefinitionModel;
  createFinancialCustomObject: CustomObjectModel;
  createGender: GenderModel;
  createGlobalIdFormula: GlobalIdFormulaModel;
  createHolidaySchedule: HolidayScheduleModel;
  createIntegrationClient: IntegrationClientModel;
  createInvoice: InvoiceModel;
  createJobApplication: JobApplicationModel;
  createJobApplicationFromPerson: JobApplicationModel;
  createJobApplicationStage: JobApplicationStageModel;
  createJobFamily: JobFamilyModel;
  createJobFamilyGroup: JobFamilyGroupModel;
  createJobProfile: JobProfileModel;
  createJournalConfig?: Maybe<FinanceJournalScheduleModel>;
  createLocation?: Maybe<LocationModel>;
  createMilestone: MilestoneModel;
  createMsp: MspModel;
  createOrUpdateCustomObjects: CustomObjectsModel;
  createOrUpdateFinancialCustomObjects: FinancialCustomObjectsModel;
  createOrg: OrgModel;
  createPayment: PaymentModel;
  createPerson: PersonModel;
  createPolicyRule: PolicyRuleModel;
  createProcess: ProcessModel;
  createProcessDefinition?: Maybe<ProcessDefinitionModel>;
  createProject: ProjectModel;
  createProjectCustomer: ProjectCustomerModel;
  createProjectPlan: ProjectPlanModel;
  createProjectPosition: ProjectPositionModel;
  createProjectPositionTaskMapping: ProjectPositionTaskMappingModel;
  createProjectRole: ProjectRoleModel;
  createQuickReport: QuickReportModel;
  createRate: RateBillingVariableModel;
  createRateCard: RateCardModel;
  createRecipe: RecipeModel;
  createRecommendationDefinition: RecommendationDefinitionModel;
  createReportConfiguration: ReportConfigurationResponseModel;
  createReportConfigurations: ReportConfigurationListModel;
  createRole: RoleModel;
  createSchedule: ReportScheduleModel;
  createSeniority: SeniorityModel;
  createSequenceGenerator: SequenceGeneratorModel;
  createSftpDirectory: SftpDirectoryModel;
  createSftpSshKey: SftpSshKeyModel;
  createSmartFormDefinition: SmartFormDefinitionModel;
  createSowResponse: SowResponseModel;
  createSupplier: SupplierModel;
  createSupplierContact?: Maybe<SupplierContactModel>;
  createSupplierGroup: SupplierGroupModel;
  createSupplierTier: SupplierTierModel;
  createTag: TagModel;
  createTagInstance: TagInstanceModel;
  createTask: TaskModel;
  createTaskDelegation: TaskDelegationModel;
  createTenantAdminUser: UserModel;
  createTerminationReason: TerminationReasonModel;
  createTimeCode: TimeCodeModel;
  createTimesheet: TimesheetModel;
  createUpdateQuickReports: QuickReportsModel;
  createUser: UserModel;
  createWorkCalendar: WorkCalendarModel;
  createWorkPosting: WorkPostingModel;
  createWorkRequest: WorkRequestModel;
  createWorkSchedule: WorkScheduleModel;
  createWorkerQualification: WorkerQualificationModel;
  deactivateAnalyticsDashboard: AnalyticsDashboardModel;
  deactivateBlueprintDefinition: InvoicingBlueprintDefinitionModel;
  deactivateBusinessEventReason?: Maybe<BusinessEventReasonModel>;
  deactivateDecisionTableDefinition: DecisionTableDefinitionModel;
  deactivateFieldConstraintDefinition?: Maybe<FieldConstraintDefinitionModel>;
  deactivateGender: GenderModel;
  deactivateJobApplicationStage: JobApplicationStageModel;
  deactivateMsp: MspModel;
  deactivatePerson?: Maybe<Scalars['Boolean']['output']>;
  deactivateSeniority: SeniorityModel;
  deactivateTaskDefinition?: Maybe<Scalars['Boolean']['output']>;
  deactivateTaskDelegation?: Maybe<Scalars['Boolean']['output']>;
  deactivateTerminationReason: TerminationReasonModel;
  deleteAnalyticsDashboard: AnalyticsDashboardModel;
  deleteAnomalyDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteBlueprintDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteBusinessEventReason?: Maybe<Scalars['Boolean']['output']>;
  deleteClassification?: Maybe<Scalars['Boolean']['output']>;
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  deleteCompany?: Maybe<Scalars['Boolean']['output']>;
  deleteContract?: Maybe<Scalars['Boolean']['output']>;
  deleteCostCenter?: Maybe<Scalars['Boolean']['output']>;
  deleteCsvTemplate: CsvTemplateModel;
  deleteCustomFieldDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteCustomObject?: Maybe<Scalars['Boolean']['output']>;
  deleteCustomObjectDefinition: CustomObjectDefinitionModel;
  deleteDashboard?: Maybe<Scalars['Boolean']['output']>;
  deleteDecisionTableDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteEngagement?: Maybe<Scalars['Boolean']['output']>;
  deleteExpenseCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteFieldConstraintDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteFinancialCustomFieldDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteGender: GenderModel;
  deleteGlobalIdFormula?: Maybe<Scalars['Boolean']['output']>;
  deleteHolidaySchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteIntegrationClient?: Maybe<Scalars['Boolean']['output']>;
  deleteJobApplication: JobApplicationModel;
  deleteJobApplicationStage: JobApplicationStageModel;
  deleteJobApplications?: Maybe<Scalars['Boolean']['output']>;
  deleteJobFamily: JobFamilyModel;
  deleteJobFamilyGroup: JobFamilyGroupModel;
  deleteJobProfile?: Maybe<Scalars['Boolean']['output']>;
  deleteJournalConfig?: Maybe<FinanceJournalScheduleModel>;
  deleteLocation?: Maybe<Scalars['Boolean']['output']>;
  deleteMilestone?: Maybe<Scalars['Boolean']['output']>;
  deleteMsp?: Maybe<Scalars['Boolean']['output']>;
  deleteNotification: NotificationModel;
  deleteOrg?: Maybe<Scalars['Boolean']['output']>;
  deleteOrgMembership?: Maybe<Scalars['Boolean']['output']>;
  deletePayment?: Maybe<Scalars['Boolean']['output']>;
  deletePeople?: Maybe<Scalars['Boolean']['output']>;
  deletePerson?: Maybe<Scalars['Boolean']['output']>;
  deleteProcess?: Maybe<Scalars['Boolean']['output']>;
  deleteProcessDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectCustomer?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectPlan?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectPosition?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectPositionTaskMapping?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectRole?: Maybe<Scalars['Boolean']['output']>;
  deleteRate?: Maybe<Scalars['Boolean']['output']>;
  deleteRateCard: RateCardModel;
  deleteRecipe?: Maybe<Scalars['Boolean']['output']>;
  deleteRecommendationDefinition: RecommendationDefinitionModel;
  deleteReportConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  deleteSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteSeniority: SeniorityModel;
  deleteSftpDirectory?: Maybe<Scalars['Boolean']['output']>;
  deleteSftpSshKey?: Maybe<Scalars['Boolean']['output']>;
  deleteSmartFormDefinition: SmartFormDefinitionModel;
  deleteSmartFormDefinitionsByType: SmartFormDefinitionsModel;
  deleteSowResponse: SowResponseModel;
  deleteSupplier?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierContact?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierTier?: Maybe<Scalars['Boolean']['output']>;
  deleteTag: TagModel;
  deleteTagInstance: TagInstanceModel;
  deleteTask?: Maybe<Scalars['Boolean']['output']>;
  deleteTaskDelegation?: Maybe<Scalars['Boolean']['output']>;
  deleteTerminationReason: TerminationReasonModel;
  deleteTimeCode?: Maybe<Scalars['Boolean']['output']>;
  deleteTimesheet?: Maybe<Scalars['Boolean']['output']>;
  deleteUsers: Array<Maybe<Scalars['String']['output']>>;
  deleteWorkCalendar?: Maybe<Scalars['Boolean']['output']>;
  deleteWorkPosting: WorkPostingModel;
  deleteWorkPostingSupplierGroupInstance?: Maybe<Scalars['Boolean']['output']>;
  deleteWorkRequest: WorkRequestModel;
  deleteWorkSchedule?: Maybe<Scalars['Boolean']['output']>;
  deployProcessDefinition: ProcessDefinitionModel;
  discardProcessDefinitionUpdates?: Maybe<Scalars['Boolean']['output']>;
  duplicateDecisionTableDefinition: DecisionTableDefinitionModel;
  duplicatePolicyRules: PolicyRulesModel;
  duplicateProcessDefinition?: Maybe<ProcessDefinitionModel>;
  executeBlueprint: InvoicingBlueprintExecutionModel;
  export: ExportResponseModel;
  generateAttachedMediaDownloadToken: Scalars['String']['output'];
  generateAuditReport: NotificationModel;
  generateException?: Maybe<Scalars['Boolean']['output']>;
  generateRecipeMediaDownloadToken: Scalars['String']['output'];
  generateTaskAttachedMediaDownloadToken: Scalars['String']['output'];
  generateTaskExternalLink?: Maybe<Scalars['String']['output']>;
  globalIdResetRunState: Array<Maybe<GlobalIdFormulaModel>>;
  globalIdStartDryRun: Array<Maybe<GlobalIdFormulaModel>>;
  incrementSequenceGenerator: SequenceGeneratorModel;
  invalidateSftpSshKey: SftpSshKeyModel;
  invitePeopleToEnterpriseApplication: UsersModel;
  invitePeopleToWorkerApplication?: Maybe<Scalars['Boolean']['output']>;
  inviteSupplier?: Maybe<Scalars['Boolean']['output']>;
  inviteSuppliers: SuppliersModel;
  markTimesheetsAsExported: Array<Maybe<Scalars['String']['output']>>;
  mergeCostCenters: CostCentersModel;
  patchAnalyticsDashboard: AnalyticsDashboardModel;
  patchApprovalLimits: PersonApprovalLimitsModel;
  patchBlueprintDefinition: InvoicingBlueprintDefinitionModel;
  patchChangeSet?: Maybe<ChangeSetModel>;
  patchContract: ContractModel;
  patchCostCenter?: Maybe<CostCenterModel>;
  patchEngagement: EngagementModel;
  patchEngagements: EngagementsModel;
  patchExpense: ExpenseModel;
  patchGender: GenderModel;
  patchJobApplication: JobApplicationModel;
  patchJobApplicationStage: JobApplicationStageModel;
  patchJobApplicationWorkerDuplicates: JobApplicationModel;
  patchJobFamily: JobFamilyModel;
  patchJournalConfig: FinanceJournalScheduleModel;
  patchMilestone: MilestoneModel;
  patchMsp: MspModel;
  patchOrg: OrgModel;
  patchPerson?: Maybe<PersonModel>;
  patchProject: ProjectModel;
  patchQuickReport?: Maybe<QuickReportModel>;
  patchRate: RateBillingVariableModel;
  patchRateCard: RateCardModel;
  patchRecipe: RecipeModel;
  patchSeniority: SeniorityModel;
  patchSowResponse: SowResponseModel;
  patchSupplier: SupplierModel;
  patchSupplierContact?: Maybe<SupplierContactModel>;
  patchSupplierGroup: SupplierGroupModel;
  patchSupplierTier: SupplierTierModel;
  patchTerminationReason: TerminationReasonModel;
  patchTimesheet: TimesheetModel;
  patchUserPreferences: UserPreferencesModel;
  patchWorkCalendar: WorkCalendarModel;
  patchWorkPosting: WorkPostingModel;
  patchWorkPostingSupplierGroupInstance?: Maybe<SupplierGroupInstanceModel>;
  patchWorkPostingSupplierTierInstance?: Maybe<SupplierTierInstanceModel>;
  patchWorkRequest: WorkRequestModel;
  patchWorkerQualification: WorkerQualificationModel;
  patchWorkerQualificationByPersonUidAndEligibilityRequirementUid: WorkerQualificationModel;
  pauseImportJob?: Maybe<ImportJobCommandResultModel>;
  pingNotification: NotificationModel;
  reactivateTaskDelegation?: Maybe<Scalars['Boolean']['output']>;
  readAllNotifications: NotificationsModel;
  readNotifications: NotificationsModel;
  referenceIdExists?: Maybe<Scalars['Boolean']['output']>;
  rejectChangeSet: ChangeSetModel;
  rejectJobApplications?: Maybe<Scalars['Boolean']['output']>;
  rejectRemainingJobApplications?: Maybe<Scalars['Boolean']['output']>;
  removeContractDocuments: Array<Maybe<ContractDocumentModel>>;
  removeMilestoneAttachments: Array<Maybe<MilestoneAttachmentModel>>;
  requestAuditReportDownloadToken: Scalars['String']['output'];
  requestCustomDocumentDownloadToken: Scalars['String']['output'];
  requestSystemActivityDownloadToken: Scalars['String']['output'];
  rescindJobApplications?: Maybe<Scalars['Boolean']['output']>;
  rescindWorkdayData?: Maybe<Scalars['Boolean']['output']>;
  resetFeature: TenantFeatureModel;
  resetIntegrationClient: IntegrationClientModel;
  resetOverridesToInitialState?: Maybe<Scalars['Boolean']['output']>;
  resolveTask: TaskModel;
  restoreDecisionTableDefinition: DecisionTableDefinitionModel;
  restoreProcessDefinition?: Maybe<ProcessDefinitionModel>;
  resumeImportJob?: Maybe<ImportJobCommandResultModel>;
  retryBlueprint: InvoicingBlueprintExecutionModel;
  retryExport: OcExportModel;
  retryProcess: ProcessModel;
  revertProcessToTask?: Maybe<Scalars['Boolean']['output']>;
  scheduleSync: NotificationModel;
  scheduleSyncFromUkg: NotificationModel;
  scheduleWorkdayTimeallocationImport?: Maybe<Scalars['Boolean']['output']>;
  selectJobApplicationDuplicateWorker: JobApplicationModel;
  selectPersonDuplicateWorker: PersonModel;
  sendSms: BulkSmsSendReportModel;
  setFieldMetadataOverrides: FieldMetadataModel;
  /** @deprecated use patchUserPreferences */
  setFocusOrg?: Maybe<Scalars['Boolean']['output']>;
  setLinkedPeople: PeopleModel;
  setPeopleAsGeneralUser: UsersModel;
  setPeopleAsMspUser: UsersModel;
  setPeopleAsSupportUser: UsersModel;
  setPeopleAsTenantAdminUser: UsersModel;
  setPersonAsGeneralUser: UserModel;
  setPersonAsMspUser: UserModel;
  setPersonAsSupportUser: UserModel;
  setPersonAsTenantAdminUser: UserModel;
  setPrimaryEngagement?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use setUserStatuses instead, to be removed when FE is updated */
  setTenantAdminUserStatuses: UsersModel;
  setUserStatuses: UsersModel;
  signalProcess?: Maybe<Scalars['Boolean']['output']>;
  signalTasks: SignalTasksResultModel;
  startWorkPostingSupplierDistribution?: Maybe<Scalars['Boolean']['output']>;
  submitBlueprintDefinition: InvoicingBlueprintDefinitionModel;
  /** @deprecated Being replaced with supplierCreateJobApplications and supplierSubmitJobApplications */
  submitJobApplications: JobApplicationsModel;
  supplierCreateJobApplications: JobApplicationsModel;
  supplierSubmitJobApplications: JobApplicationsModel;
  terminateProcess?: Maybe<Scalars['Boolean']['output']>;
  touchPerson?: Maybe<Scalars['OffsetDateTime']['output']>;
  uninviteSupplier?: Maybe<Scalars['Boolean']['output']>;
  updateAnomalyDefinition: AnomalyDefinitionModel;
  updateBusinessEventReason?: Maybe<BusinessEventReasonModel>;
  updateClassification: ClassificationModel;
  updateComment: CommentModel;
  updateCompany: CompanyModel;
  updateCustomFieldDefinition: CustomFieldDefinitionModel;
  updateCustomObject: CustomObjectModel;
  updateCustomObjectActiveStatus: CustomObjectModel;
  updateCustomTimeSeriesEvent: CustomTimeSeriesEventModel;
  updateDashboard: DashboardModel;
  updateDecisionTableDefinition: DecisionTableDefinitionModel;
  updateExpenseCategory: ExpenseCategoryModel;
  updateFeature: TenantFeatureModel;
  updateFeatureEnabled: TenantFeatureModel;
  updateFieldConstraintDefinition?: Maybe<FieldConstraintDefinitionModel>;
  updateFinancialCustomFieldDefinition: CustomFieldDefinitionModel;
  updateFinancialCustomObject: CustomObjectModel;
  updateFinancialCustomObjectStatus: CustomObjectModel;
  updateGlobalIdFormula: GlobalIdFormulaModel;
  updateHolidaySchedule: HolidayScheduleModel;
  updateIntegrationClient: IntegrationClientModel;
  updateIntegrationClientPermissions: IntegrationClientPermissionsConfigurationModel;
  updateInvoice: InvoiceModel;
  updateJobFamily: JobFamilyModel;
  updateJobFamilyGroup: JobFamilyGroupModel;
  updateJobProfile: JobProfileModel;
  updateLocation?: Maybe<LocationModel>;
  updateMilestoneStatus: MilestoneModel;
  updateMspUsersRoles: UsersModel;
  updateNotification: NotificationModel;
  updateNotificationHubSetting: NotificationHubSettingModel;
  updateNotificationHubSettings: Array<Maybe<NotificationHubSettingModel>>;
  updatePayment: PaymentModel;
  /** @deprecated use collection API instead */
  updatePolicyRule: PolicyRuleModel;
  updatePolicyRules: PolicyRulesModel;
  updateProcess: ProcessModel;
  updateProcessDefinition?: Maybe<ProcessDefinitionModel>;
  updateProcessDefinitionStatus?: Maybe<ProcessDefinitionModel>;
  updateProject: ProjectModel;
  updateProjectCustomer: ProjectCustomerModel;
  updateProjectPlan: ProjectPlanModel;
  updateProjectPosition: ProjectPositionModel;
  updateProjectPositionTaskMapping: ProjectPositionTaskMappingModel;
  updateProjectRole: ProjectRoleModel;
  updateRecommendationDefinition: RecommendationDefinitionModel;
  updateReportConfiguration: ReportConfigurationResponseModel;
  updateRole: RoleModel;
  updateRoleAssignments: RoleAssignmentsUpdateResultModel;
  updateSchedule: ReportScheduleModel;
  updateSelectedRecommendationOption: WorkRequestModel;
  updateSmartFormDefinition: SmartFormDefinitionModel;
  updateTag: TagModel;
  updateTask?: Maybe<TaskModel>;
  updateTenantDateTimeFormatConfig: DateTimeFormatConfigModel;
  updateTenantDuplicateSearchConfig: TenantDuplicateSearchConfigurationModel;
  updateTenantPermissions: TenantPermissionsConfigurationModel;
  updateTenantProcessSweeperConfig: ProcessSweeperConfigModel;
  updateTenantSpendConfig: SpendConfigModel;
  updateTenantSsoConfig: SsoConfigModel;
  updateTenantTaskDelegationConfig: TaskDelegationConfigModel;
  updateTenantUsersConfig: TenantUsersConfigurationModel;
  updateTenantWorkerConfig: TenantWorkerConfigurationModel;
  updateTimeCode: TimeCodeModel;
  updateTimesheetSettings?: Maybe<TimesheetSettingsModel>;
  updateUser: UserModel;
  updateWidgetSetting: WidgetSettingModel;
  updateWorkSchedule: WorkScheduleModel;
  updateWorkdaySecrets: WorkdaySecretsModel;
};


export type MutationActivateAnalyticsDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateBlueprintDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateBusinessEventReasonArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type MutationActivateDecisionTableDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateFieldConstraintDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type MutationActivateGenderArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateJobApplicationStageArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateMspArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivatePeopleArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  people?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
};


export type MutationActivateSeniorityArgs = {
  uid: Scalars['String']['input'];
};


export type MutationActivateTaskDefinitionArgs = {
  taskDefinitionId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationActivateTerminationReasonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationAddCommentArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationAddContractDocumentsArgs = {
  contractUid: Scalars['String']['input'];
  documents: Array<InputMaybe<ContractDocumentCreateModelInput>>;
};


export type MutationAddJobApplicationSmartFormArgs = {
  jobApplicationSmartForm: JobPostingApplicationSmartFormModelInput;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddMilestoneAttachmentsArgs = {
  attachments: Array<InputMaybe<MilestoneAttachmentCreateModelInput>>;
  milestoneUid: Scalars['String']['input'];
};


export type MutationAddPersonToSupervisoryOrgArgs = {
  engagement?: InputMaybe<EngagementModelInput>;
  org?: InputMaybe<OrgModelInput>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddSupplierGroupInstanceToWorkPostingArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  supplierGroupUid: Scalars['String']['input'];
  workPostingUid: Scalars['String']['input'];
};


export type MutationAddViewToHistoryArgs = {
  recentlyViewedPersonUid: Scalars['String']['input'];
};


export type MutationApproveExpenseArgs = {
  expense?: InputMaybe<ExpenseApprovalUpdateModelInput>;
};


export type MutationApproveInvoiceArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: InvoiceApprovalModelInput;
};


export type MutationApproveTimesheetArgs = {
  timesheet?: InputMaybe<TimesheetApprovalModelInput>;
};


export type MutationAssignCostCenterRolesArgs = {
  assignees: Array<InputMaybe<PersonModelInput>>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  role?: InputMaybe<RoleModelInput>;
};


export type MutationAssignCountryRolesArgs = {
  assignees: Array<InputMaybe<PersonModelInput>>;
  country?: InputMaybe<CountryModelInput>;
  role?: InputMaybe<RoleModelInput>;
};


export type MutationAssignLocationRolesArgs = {
  assignees: Array<InputMaybe<PersonModelInput>>;
  location?: InputMaybe<LocationModelInput>;
  role?: InputMaybe<RoleModelInput>;
};


export type MutationAssignOrgRolesArgs = {
  assignees: Array<InputMaybe<PersonModelInput>>;
  org?: InputMaybe<OrgModelInput>;
  role?: InputMaybe<RoleModelInput>;
};


export type MutationAttachJobApplicationDocumentArgs = {
  jobApplicationUid: Scalars['String']['input'];
  mediaUid: Scalars['String']['input'];
};


export type MutationBulkInvoiceMarkAsPaidArgs = {
  invoicesAndSupplier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCancelExportArgs = {
  executionId: Scalars['String']['input'];
};


export type MutationCancelImportJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationClearSupplierArgs = {
  engagement?: InputMaybe<EngagementModelInput>;
};


export type MutationCommitEngagementRetroactiveChangeArgs = {
  engagementRetroactiveChange: EngagementModelInput;
  retroactiveChangeSpec: RetroactiveChangeCreateOrUpdateModelInput;
};


export type MutationCorrectMilestoneArgs = {
  milestone: MilestonePatchModelInput;
};


export type MutationCorrelateReceiveTaskArgs = {
  correlationMessageName: Scalars['String']['input'];
  processUid: Scalars['String']['input'];
  taskTranscript: TaskTranscriptUpdateModelInput;
};


export type MutationCreateAnalyticsDashboardArgs = {
  model?: InputMaybe<AnalyticsDashboardCreateModelInput>;
};


export type MutationCreateBlueprintDefinitionArgs = {
  create: InvoicingBlueprintDefinitionCreateModelInput;
};


export type MutationCreateBusinessEventReasonArgs = {
  create: BusinessEventReasonCreateModelInput;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type MutationCreateCertificationArgs = {
  certification: CertificationCreateModelInput;
};


export type MutationCreateClassificationArgs = {
  classification: ClassificationModelInput;
};


export type MutationCreateCompanyArgs = {
  model: CompanyCreationModelInput;
};


export type MutationCreateConfigurableAnomalyDefinitionArgs = {
  anomalyDefinition?: InputMaybe<AnomalyDefinitionCreateModelInput>;
};


export type MutationCreateContractArgs = {
  contract: ContractCreateModelInput;
};


export type MutationCreateCostCenterArgs = {
  costCenterNameWithCode?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: CostCenterCreateModelInput;
};


export type MutationCreateCsvTemplateArgs = {
  csvTemplate: CsvTemplateCreateModelInput;
};


export type MutationCreateCustomFieldDefinitionArgs = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
};


export type MutationCreateCustomFieldDefinitionGroupArgs = {
  customFieldDefinitionGroup?: InputMaybe<CustomFieldDefinitionGroupModelInput>;
};


export type MutationCreateCustomObjectArgs = {
  model: CustomObjectCreationModelInput;
};


export type MutationCreateCustomObjectDefinitionArgs = {
  customObjectDefinition?: InputMaybe<CustomObjectDefinitionCreationModelInput>;
};


export type MutationCreateCustomTimeSeriesEventArgs = {
  customFieldDefinitionUid: Scalars['String']['input'];
  targetEntityUid?: InputMaybe<Scalars['String']['input']>;
  timeSeriesEvent?: InputMaybe<CustomTimeSeriesEventModelInput>;
};


export type MutationCreateDashboardArgs = {
  dashboard?: InputMaybe<DashboardModelInput>;
};


export type MutationCreateDecisionTableDefinitionArgs = {
  create?: InputMaybe<DecisionTableDefinitionCreateModelInput>;
};


export type MutationCreateEligibilityRequirementArgs = {
  input: EligibilityRequirementCreateModelInput;
};


export type MutationCreateEngagementArgs = {
  engagement?: InputMaybe<EngagementModelInput>;
};


export type MutationCreateExpenseArgs = {
  expense?: InputMaybe<ExpenseCreateModelInput>;
};


export type MutationCreateExpenseCategoryArgs = {
  expenseCategory?: InputMaybe<ExpenseCategoryCreateModelInput>;
};


export type MutationCreateFieldConstraintDefinitionArgs = {
  create?: InputMaybe<FieldConstraintDefinitionCreateModelInput>;
};


export type MutationCreateFinancialCustomFieldDefinitionArgs = {
  model: FinancialCustomFieldDefinitionCreateModelInput;
};


export type MutationCreateFinancialCustomObjectArgs = {
  model: FinancialCustomObjectCreateModelInput;
};


export type MutationCreateGenderArgs = {
  model: GenderCreateModelInput;
};


export type MutationCreateGlobalIdFormulaArgs = {
  model: GlobalIdFormulaCreateModelInput;
};


export type MutationCreateHolidayScheduleArgs = {
  holidaySchedule?: InputMaybe<HolidayScheduleCreationModelInput>;
};


export type MutationCreateIntegrationClientArgs = {
  integrationClient?: InputMaybe<IntegrationClientModelInput>;
};


export type MutationCreateInvoiceArgs = {
  model: InvoiceCreateModelInput;
};


export type MutationCreateJobApplicationArgs = {
  create: JobApplicationCreateModelInput;
};


export type MutationCreateJobApplicationFromPersonArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  personUid: Scalars['String']['input'];
};


export type MutationCreateJobApplicationStageArgs = {
  model?: InputMaybe<JobApplicationStageCreateModelInput>;
};


export type MutationCreateJobFamilyArgs = {
  mutation?: InputMaybe<JobFamilyCreateModelInput>;
};


export type MutationCreateJobFamilyGroupArgs = {
  mutation?: InputMaybe<JobFamilyGroupCreateModelInput>;
};


export type MutationCreateJobProfileArgs = {
  jobProfile?: InputMaybe<JobProfileCreateModelInput>;
};


export type MutationCreateJournalConfigArgs = {
  model: FinanceJournalScheduleCreateModelInput;
};


export type MutationCreateLocationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  location: LocationCreateModelInput;
};


export type MutationCreateMilestoneArgs = {
  milestone: MilestoneCreateModelInput;
  parentUid: Scalars['String']['input'];
};


export type MutationCreateMspArgs = {
  create?: InputMaybe<MspCreateModelInput>;
};


export type MutationCreateOrUpdateCustomObjectsArgs = {
  model: Array<InputMaybe<CustomObjectCreateOrUpdateModelInput>>;
};


export type MutationCreateOrUpdateFinancialCustomObjectsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: Array<InputMaybe<FinancialCustomObjectCreateOrUpdateModelInput>>;
};


export type MutationCreateOrgArgs = {
  org?: InputMaybe<OrgCreateModelInput>;
};


export type MutationCreatePaymentArgs = {
  payment?: InputMaybe<PaymentModelInput>;
};


export type MutationCreatePersonArgs = {
  person?: InputMaybe<PersonModelInput>;
};


export type MutationCreatePolicyRuleArgs = {
  policyRule?: InputMaybe<PolicyRuleModelInput>;
};


export type MutationCreateProcessArgs = {
  process?: InputMaybe<ProcessModelInput>;
};


export type MutationCreateProcessDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  processDefinition?: InputMaybe<ProcessDefinitionModelInput>;
};


export type MutationCreateProjectArgs = {
  model: ProjectCreateModelInput;
};


export type MutationCreateProjectCustomerArgs = {
  model: ProjectCustomerCreateModelInput;
};


export type MutationCreateProjectPlanArgs = {
  model: ProjectPlanCreateModelInput;
};


export type MutationCreateProjectPositionArgs = {
  model: ProjectPositionCreateModelInput;
};


export type MutationCreateProjectPositionTaskMappingArgs = {
  model: ProjectPositionTaskMappingCreateModelInput;
};


export type MutationCreateProjectRoleArgs = {
  model: ProjectRoleCreateModelInput;
};


export type MutationCreateQuickReportArgs = {
  quickReportCreate?: InputMaybe<QuickReportCreateModelInput>;
};


export type MutationCreateRateArgs = {
  rate?: InputMaybe<RateBillingVariableCreateModelInput>;
};


export type MutationCreateRateCardArgs = {
  rateCard: RateCardCreateModelInput;
};


export type MutationCreateRecipeArgs = {
  recipe: RecipeCreateModelInput;
};


export type MutationCreateRecommendationDefinitionArgs = {
  mutation: RecommendationDefinitionMutationModelInput;
};


export type MutationCreateReportConfigurationArgs = {
  model: ReportConfigurationCreateModelInput;
};


export type MutationCreateReportConfigurationsArgs = {
  model: ReportConfigurationsCreateModelInput;
};


export type MutationCreateRoleArgs = {
  role: RoleModelInput;
};


export type MutationCreateScheduleArgs = {
  model: ReportScheduleCreateModelInput;
};


export type MutationCreateSeniorityArgs = {
  model: SeniorityCreateModelInput;
};


export type MutationCreateSequenceGeneratorArgs = {
  input?: InputMaybe<SequenceGeneratorCreateModelInput>;
};


export type MutationCreateSftpDirectoryArgs = {
  sftpDirectory: SftpDirectoryCreateModelInput;
};


export type MutationCreateSftpSshKeyArgs = {
  sshPublicKey: CreateSftpSshKeyModelInput;
};


export type MutationCreateSmartFormDefinitionArgs = {
  model: SmartFormDefinitionCreationModelInput;
};


export type MutationCreateSowResponseArgs = {
  create?: InputMaybe<SowResponseCreateModelInput>;
};


export type MutationCreateSupplierArgs = {
  supplier?: InputMaybe<SupplierModelInput>;
};


export type MutationCreateSupplierContactArgs = {
  createSupplierContact?: InputMaybe<CreateSupplierContactModelInput>;
};


export type MutationCreateSupplierGroupArgs = {
  supplierGroup?: InputMaybe<SupplierGroupCreateModelInput>;
};


export type MutationCreateSupplierTierArgs = {
  supplierGroupUid: Scalars['String']['input'];
  supplierTier?: InputMaybe<SupplierTierCreateModelInput>;
};


export type MutationCreateTagArgs = {
  tag?: InputMaybe<TagCreateModelInput>;
};


export type MutationCreateTagInstanceArgs = {
  tagInstance?: InputMaybe<TagInstanceCreateModelInput>;
};


export type MutationCreateTaskArgs = {
  task?: InputMaybe<TaskModelInput>;
};


export type MutationCreateTaskDelegationArgs = {
  model: TaskDelegationCreateModelInput;
};


export type MutationCreateTenantAdminUserArgs = {
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  user: TenantAdminCreateModelInput;
};


export type MutationCreateTerminationReasonArgs = {
  model?: InputMaybe<TerminationReasonCreateModelInput>;
};


export type MutationCreateTimeCodeArgs = {
  timeCode?: InputMaybe<TimeCodeCreationModelInput>;
};


export type MutationCreateTimesheetArgs = {
  timesheet?: InputMaybe<TimesheetCreationModelInput>;
};


export type MutationCreateUpdateQuickReportsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  quickReportsCreateUpdate?: InputMaybe<QuickReportsCreateUpdateModelInput>;
};


export type MutationCreateUserArgs = {
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UserCreateModelInput>;
};


export type MutationCreateWorkCalendarArgs = {
  workCalendar?: InputMaybe<WorkCalendarCreateModelInput>;
};


export type MutationCreateWorkPostingArgs = {
  create?: InputMaybe<WorkPostingCreateModelInput>;
  workRequestUid: Scalars['String']['input'];
};


export type MutationCreateWorkRequestArgs = {
  create?: InputMaybe<WorkRequestCreateModelInput>;
};


export type MutationCreateWorkScheduleArgs = {
  workSchedule?: InputMaybe<WorkScheduleCreationModelInput>;
};


export type MutationCreateWorkerQualificationArgs = {
  workerQualification?: InputMaybe<WorkerQualificationCreateModelInput>;
};


export type MutationDeactivateAnalyticsDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateBlueprintDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateBusinessEventReasonArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type MutationDeactivateDecisionTableDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateFieldConstraintDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type MutationDeactivateGenderArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateJobApplicationStageArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateMspArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivatePersonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateSeniorityArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateTaskDefinitionArgs = {
  taskDefinitionId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationDeactivateTaskDelegationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeactivateTerminationReasonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteAnalyticsDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteAnomalyDefinitionArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteBlueprintDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteBusinessEventReasonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteClassificationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  commentUid: Scalars['String']['input'];
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCompanyArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteContractArgs = {
  contractUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCostCenterArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteCsvTemplateArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteCustomFieldDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteCustomObjectArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteCustomObjectDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteDecisionTableDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteEngagementArgs = {
  personUid: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteExpenseCategoryArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteFieldConstraintDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteFinancialCustomFieldDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteGenderArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteGlobalIdFormulaArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteHolidayScheduleArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteIntegrationClientArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJobApplicationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJobApplicationStageArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJobApplicationsArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteJobFamilyArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJobFamilyGroupArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJobProfileArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteJournalConfigArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteMilestoneArgs = {
  milestoneUid: Scalars['String']['input'];
};


export type MutationDeleteMspArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteNotificationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteOrgArgs = {
  newParentOrgUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOrgMembershipArgs = {
  engagement: EngagementModelInput;
};


export type MutationDeletePaymentArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeletePeopleArgs = {
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeletePersonArgs = {
  purge?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteProcessArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProcessDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectCustomerArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectPlanArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectPositionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectPositionTaskMappingArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteProjectRoleArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteRateArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteRateCardArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteRecipeArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationDeleteRecommendationDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteReportConfigurationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationDeleteScheduleArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSeniorityArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSftpDirectoryArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSftpSshKeyArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSmartFormDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSmartFormDefinitionsByTypeArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  type: SmartFormDefinitionTypeModel;
};


export type MutationDeleteSowResponseArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSupplierArgs = {
  deleteSubSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
  deleteWorkers?: InputMaybe<Scalars['Boolean']['input']>;
  subSuppliersNewParentSupplierUid?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
  workersNewSupplierUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSupplierContactArgs = {
  deleteSupplierContact?: InputMaybe<DeleteSupplierContactModelInput>;
};


export type MutationDeleteSupplierGroupArgs = {
  supplierGroupUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSupplierTierArgs = {
  supplierTierUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTagArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTagInstanceArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTaskArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTaskDelegationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTerminationReasonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTimeCodeArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteTimesheetArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteUsersArgs = {
  userUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteWorkCalendarArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteWorkPostingArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteWorkPostingSupplierGroupInstanceArgs = {
  supplierGroupInstanceUid: Scalars['String']['input'];
  workPostingUid: Scalars['String']['input'];
};


export type MutationDeleteWorkRequestArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteWorkScheduleArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeployProcessDefinitionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationDiscardProcessDefinitionUpdatesArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDuplicateDecisionTableDefinitionArgs = {
  duplicate?: InputMaybe<DecisionTableDefinitionDuplicateCreateModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationDuplicatePolicyRulesArgs = {
  duplicates: Array<InputMaybe<PolicyRuleDuplicateModelInput>>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type MutationDuplicateProcessDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  name: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationExecuteBlueprintArgs = {
  request: InvoicingExecuteBlueprintRequestModelInput;
  uid: Scalars['String']['input'];
};


export type MutationExportArgs = {
  request?: InputMaybe<OcExportCreateModelInput>;
};


export type MutationGenerateAttachedMediaDownloadTokenArgs = {
  uid: Scalars['String']['input'];
};


export type MutationGenerateAuditReportArgs = {
  dateRange?: InputMaybe<DateRangeModelInput>;
  entity: AuditReportTargetEntityModel;
  modifiedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedEntity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationGenerateExceptionArgs = {
  message: Scalars['String']['input'];
};


export type MutationGenerateRecipeMediaDownloadTokenArgs = {
  uid: Scalars['String']['input'];
};


export type MutationGenerateTaskAttachedMediaDownloadTokenArgs = {
  uid: Scalars['String']['input'];
};


export type MutationGenerateTaskExternalLinkArgs = {
  uid: Scalars['String']['input'];
};


export type MutationIncrementSequenceGeneratorArgs = {
  uid: Scalars['String']['input'];
};


export type MutationInvalidateSftpSshKeyArgs = {
  uid: Scalars['String']['input'];
};


export type MutationInvitePeopleToEnterpriseApplicationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationInvitePeopleToWorkerApplicationArgs = {
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationInviteSupplierArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  supplierUid: Scalars['String']['input'];
};


export type MutationInviteSuppliersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationMarkTimesheetsAsExportedArgs = {
  lastExportedDate: Scalars['OffsetDateTime']['input'];
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationMergeCostCentersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: CostCentersMergeModelInput;
};


export type MutationPatchAnalyticsDashboardArgs = {
  model?: InputMaybe<AnalyticsDashboardPatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchApprovalLimitsArgs = {
  approvalLimits: Array<InputMaybe<ApprovalLimitModelInput>>;
  personUid: Scalars['String']['input'];
};


export type MutationPatchBlueprintDefinitionArgs = {
  patch: InvoicingBlueprintDefinitionPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchChangeSetArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: ChangeSetPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchContractArgs = {
  contract: ContractPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchCostCenterArgs = {
  costCenter?: InputMaybe<CostCenterPatchModelInput>;
  costCenterNameWithCode?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type MutationPatchEngagementArgs = {
  engagement?: InputMaybe<EngagementModelInput>;
};


export type MutationPatchEngagementsArgs = {
  engagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type MutationPatchExpenseArgs = {
  expense?: InputMaybe<ExpensePatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchGenderArgs = {
  model: GenderPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchJobApplicationArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  patch: JobApplicationPatchModelInput;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchJobApplicationStageArgs = {
  model?: InputMaybe<JobApplicationStagePatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchJobApplicationWorkerDuplicatesArgs = {
  patch?: InputMaybe<JobApplicationWorkerDuplicatesModelInput>;
};


export type MutationPatchJobFamilyArgs = {
  jobFamily?: InputMaybe<JobFamilyPatchModelInput>;
  jobFamilyUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchJournalConfigArgs = {
  model: FinanceJournalSchedulePatchModelInput;
};


export type MutationPatchMilestoneArgs = {
  milestone: MilestonePatchModelInput;
  milestoneUid: Scalars['String']['input'];
};


export type MutationPatchMspArgs = {
  patch?: InputMaybe<MspPatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchOrgArgs = {
  org?: InputMaybe<OrgUpdateModelInput>;
};


export type MutationPatchPersonArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  person?: InputMaybe<PersonModelInput>;
  taskUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchProjectArgs = {
  model: ProjectPatchModelInput;
};


export type MutationPatchQuickReportArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  quickReportPatch?: InputMaybe<QuickReportPatchModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchRateArgs = {
  rate?: InputMaybe<RateBillingVariablePatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchRateCardArgs = {
  rateCard: RateCardPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchRecipeArgs = {
  recipe: RecipePatchModelInput;
};


export type MutationPatchSeniorityArgs = {
  model: SeniorityPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchSowResponseArgs = {
  patch?: InputMaybe<SowResponsePatchModelInput>;
};


export type MutationPatchSupplierArgs = {
  patch: SupplierPatchModelInput;
};


export type MutationPatchSupplierContactArgs = {
  patchSupplierContact?: InputMaybe<PatchSupplierContactModelInput>;
};


export type MutationPatchSupplierGroupArgs = {
  supplierGroup?: InputMaybe<SupplierGroupPatchModelInput>;
  supplierGroupUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchSupplierTierArgs = {
  supplierTier?: InputMaybe<SupplierTierPatchModelInput>;
  supplierTierUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchTerminationReasonArgs = {
  model?: InputMaybe<TerminationReasonPatchModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationPatchTimesheetArgs = {
  timesheet?: InputMaybe<TimesheetPatchModelInput>;
};


export type MutationPatchUserPreferencesArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
  userPreferences?: InputMaybe<UserPreferencesModelInput>;
};


export type MutationPatchWorkCalendarArgs = {
  uid: Scalars['String']['input'];
  workCalendar?: InputMaybe<WorkCalendarPatchModelInput>;
};


export type MutationPatchWorkPostingArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  patch: WorkPostingPatchModelInput;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPatchWorkPostingSupplierGroupInstanceArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  supplierGroupInstance?: InputMaybe<SupplierGroupInstancePatchModelInput>;
  supplierGroupInstanceUid: Scalars['String']['input'];
  workPostingUid: Scalars['String']['input'];
};


export type MutationPatchWorkPostingSupplierTierInstanceArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  supplierTierInstance?: InputMaybe<SupplierTierInstancePatchModelInput>;
  supplierTierInstanceUid: Scalars['String']['input'];
  workPostingUid: Scalars['String']['input'];
};


export type MutationPatchWorkRequestArgs = {
  patch: WorkRequestPatchModelInput;
};


export type MutationPatchWorkerQualificationArgs = {
  patch: WorkerQualificationPatchModelInput;
  uid: Scalars['String']['input'];
};


export type MutationPatchWorkerQualificationByPersonUidAndEligibilityRequirementUidArgs = {
  eligibilityRequirementUid: Scalars['String']['input'];
  patch: WorkerQualificationPatchModelInput;
  personUid: Scalars['String']['input'];
};


export type MutationPauseImportJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationReactivateTaskDelegationArgs = {
  uid: Scalars['String']['input'];
};


export type MutationReadAllNotificationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type MutationReadNotificationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  notifications?: InputMaybe<NotificationsModelInput>;
};


export type MutationReferenceIdExistsArgs = {
  referenceEntityType: ReferenceEntityTypeModel;
  referenceId: Scalars['String']['input'];
};


export type MutationRejectChangeSetArgs = {
  uid: Scalars['String']['input'];
};


export type MutationRejectJobApplicationsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRejectRemainingJobApplicationsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveContractDocumentsArgs = {
  contractUid?: InputMaybe<Scalars['String']['input']>;
  mediaUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRemoveMilestoneAttachmentsArgs = {
  mediaUids: Array<InputMaybe<Scalars['String']['input']>>;
  milestoneUid: Scalars['String']['input'];
};


export type MutationRequestAuditReportDownloadTokenArgs = {
  reportUid: Scalars['String']['input'];
};


export type MutationRequestCustomDocumentDownloadTokenArgs = {
  input: CustomDocumentsInputModelInput;
};


export type MutationRequestSystemActivityDownloadTokenArgs = {
  mediaUid?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationRescindJobApplicationsArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRescindWorkdayDataArgs = {
  uid: Scalars['String']['input'];
};


export type MutationResetFeatureArgs = {
  key: Scalars['String']['input'];
};


export type MutationResetIntegrationClientArgs = {
  secretExpiresAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationResolveTaskArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<TaskModelInput>;
};


export type MutationRestoreDecisionTableDefinitionArgs = {
  restore?: InputMaybe<DecisionTableDefinitionRestoreModelInput>;
};


export type MutationRestoreProcessDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationResumeImportJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationRetryBlueprintArgs = {
  uid: Scalars['String']['input'];
};


export type MutationRetryExportArgs = {
  executionId: Scalars['String']['input'];
};


export type MutationRetryProcessArgs = {
  uid: Scalars['String']['input'];
};


export type MutationRevertProcessToTaskArgs = {
  taskUid: Scalars['String']['input'];
};


export type MutationScheduleSyncArgs = {
  deltaImportMinusHours?: InputMaybe<Scalars['Int']['input']>;
  syncType: WorkdaySyncTypeModel;
};


export type MutationScheduleSyncFromUkgArgs = {
  syncType: UkgSyncTypePatchModel;
};


export type MutationScheduleWorkdayTimeallocationImportArgs = {
  periodCount?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectJobApplicationDuplicateWorkerArgs = {
  model: JobApplicationWorkerDuplicateSelectedModelInput;
};


export type MutationSelectPersonDuplicateWorkerArgs = {
  model: PersonWorkerDuplicateSelectedModelInput;
};


export type MutationSendSmsArgs = {
  message: Scalars['String']['input'];
  targetPersonUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetFieldMetadataOverridesArgs = {
  overrides: Scalars['String']['input'];
};


export type MutationSetFocusOrgArgs = {
  focusOrgUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetLinkedPeopleArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  primaryPerson?: InputMaybe<PersonModelInput>;
};


export type MutationSetPeopleAsGeneralUserArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetPeopleAsMspUserArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  mspUid: Scalars['String']['input'];
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetPeopleAsSupportUserArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetPeopleAsTenantAdminUserArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetPersonAsGeneralUserArgs = {
  personUid: Scalars['String']['input'];
};


export type MutationSetPersonAsMspUserArgs = {
  mspUid: Scalars['String']['input'];
  personUid: Scalars['String']['input'];
};


export type MutationSetPersonAsSupportUserArgs = {
  personUid: Scalars['String']['input'];
};


export type MutationSetPersonAsTenantAdminUserArgs = {
  personUid: Scalars['String']['input'];
};


export type MutationSetPrimaryEngagementArgs = {
  personUid: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetTenantAdminUserStatusesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: UserStatusChangeModel;
};


export type MutationSetUserStatusesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: UserStatusChangeModel;
};


export type MutationSignalProcessArgs = {
  signal: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationSignalTasksArgs = {
  signalType: Scalars['String']['input'];
  taskUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationStartWorkPostingSupplierDistributionArgs = {
  supplierGroupInstanceUid: Scalars['String']['input'];
  workPostingUid: Scalars['String']['input'];
};


export type MutationSubmitBlueprintDefinitionArgs = {
  submit: InvoicingBlueprintDefinitionSubmitModelInput;
  uid: Scalars['String']['input'];
};


export type MutationSubmitJobApplicationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  submitJobApplicationsPatchModel: SubmitJobApplicationsPatchModelInput;
};


export type MutationSupplierCreateJobApplicationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  jobApplications?: InputMaybe<SupplierCreateJobApplicationsModelInput>;
};


export type MutationSupplierSubmitJobApplicationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  jobApplications?: InputMaybe<SupplierSubmitJobApplicationsModelInput>;
};


export type MutationTerminateProcessArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationTouchPersonArgs = {
  uid: Scalars['String']['input'];
};


export type MutationUninviteSupplierArgs = {
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  supplierUid: Scalars['String']['input'];
};


export type MutationUpdateAnomalyDefinitionArgs = {
  anomalyDefinition?: InputMaybe<AnomalyDefinitionUpdateModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateBusinessEventReasonArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
  update: BusinessEventReasonUpdateModelInput;
};


export type MutationUpdateClassificationArgs = {
  classification?: InputMaybe<ClassificationModelInput>;
};


export type MutationUpdateCommentArgs = {
  commentUid: Scalars['String']['input'];
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationUpdateCompanyArgs = {
  model: CompanyUpdateModelInput;
};


export type MutationUpdateCustomFieldDefinitionArgs = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
};


export type MutationUpdateCustomObjectArgs = {
  model: CustomObjectUpdateModelInput;
};


export type MutationUpdateCustomObjectActiveStatusArgs = {
  model: CustomObjectActiveStatusModelInput;
};


export type MutationUpdateCustomTimeSeriesEventArgs = {
  timeSeriesEvent?: InputMaybe<CustomTimeSeriesEventModelInput>;
};


export type MutationUpdateDashboardArgs = {
  dashboard?: InputMaybe<DashboardModelInput>;
};


export type MutationUpdateDecisionTableDefinitionArgs = {
  update?: InputMaybe<DecisionTableDefinitionUpdateModelInput>;
};


export type MutationUpdateExpenseCategoryArgs = {
  expenseCategory?: InputMaybe<ExpenseCategoryUpdateModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateFeatureArgs = {
  feature?: InputMaybe<TenantFeatureModelInput>;
  key: Scalars['String']['input'];
};


export type MutationUpdateFeatureEnabledArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  path: Scalars['String']['input'];
};


export type MutationUpdateFieldConstraintDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  update?: InputMaybe<FieldConstraintDefinitionUpdateModelInput>;
};


export type MutationUpdateFinancialCustomFieldDefinitionArgs = {
  model: FinancialCustomFieldDefinitionUpdateModelInput;
};


export type MutationUpdateFinancialCustomObjectArgs = {
  model: FinancialCustomObjectUpdateModelInput;
};


export type MutationUpdateFinancialCustomObjectStatusArgs = {
  model: FinancialCustomObjectStatusUpdateModelInput;
};


export type MutationUpdateGlobalIdFormulaArgs = {
  model: GlobalIdFormulaUpdateModelInput;
  uid: Scalars['String']['input'];
};


export type MutationUpdateHolidayScheduleArgs = {
  holidaySchedule?: InputMaybe<HolidayScheduleUpdateModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateIntegrationClientArgs = {
  integrationClient?: InputMaybe<IntegrationClientModelInput>;
};


export type MutationUpdateIntegrationClientPermissionsArgs = {
  permissions: IntegrationClientPermissionsConfigurationUpdateModelInput;
  uid: Scalars['String']['input'];
};


export type MutationUpdateInvoiceArgs = {
  model: InvoiceUpdateModelInput;
};


export type MutationUpdateJobFamilyArgs = {
  patch?: InputMaybe<JobFamilyUpdateModelInput>;
};


export type MutationUpdateJobFamilyGroupArgs = {
  patch?: InputMaybe<JobFamilyGroupUpdateModelInput>;
};


export type MutationUpdateJobProfileArgs = {
  jobProfile?: InputMaybe<JobProfileUpdateModelInput>;
};


export type MutationUpdateLocationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  location: LocationPatchModelInput;
};


export type MutationUpdateMilestoneStatusArgs = {
  milestoneUid: Scalars['String']['input'];
  status: MilestoneStatusUpdateModel;
};


export type MutationUpdateMspUsersRolesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  personUids: Array<InputMaybe<Scalars['String']['input']>>;
  role: MspUserRoleUpdateModel;
};


export type MutationUpdateNotificationArgs = {
  notification?: InputMaybe<NotificationModelInput>;
};


export type MutationUpdateNotificationHubSettingArgs = {
  model: NotificationHubSettingUpdateModelInput;
};


export type MutationUpdateNotificationHubSettingsArgs = {
  models: Array<InputMaybe<NotificationHubSettingUpdateModelInput>>;
};


export type MutationUpdatePaymentArgs = {
  payment?: InputMaybe<PaymentModelInput>;
};


export type MutationUpdatePolicyRuleArgs = {
  policyRule?: InputMaybe<PolicyRuleModelInput>;
};


export type MutationUpdatePolicyRulesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  policyRules?: InputMaybe<Array<InputMaybe<PolicyRuleModelInput>>>;
};


export type MutationUpdateProcessArgs = {
  process?: InputMaybe<ProcessPatchModelInput>;
};


export type MutationUpdateProcessDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  processDefinition?: InputMaybe<ProcessDefinitionModelInput>;
};


export type MutationUpdateProcessDefinitionStatusArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  processDefinitionStatus?: InputMaybe<ProcessDefinitionStatusModel>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateProjectArgs = {
  model: ProjectUpdateModelInput;
};


export type MutationUpdateProjectCustomerArgs = {
  model: ProjectCustomerUpdateModelInput;
};


export type MutationUpdateProjectPlanArgs = {
  model: ProjectPlanUpdateModelInput;
};


export type MutationUpdateProjectPositionArgs = {
  model: ProjectPositionUpdateModelInput;
};


export type MutationUpdateProjectPositionTaskMappingArgs = {
  model: ProjectPositionTaskMappingUpdateModelInput;
};


export type MutationUpdateProjectRoleArgs = {
  model: ProjectRoleUpdateModelInput;
};


export type MutationUpdateRecommendationDefinitionArgs = {
  mutation: RecommendationDefinitionMutationModelInput;
  uid: Scalars['String']['input'];
};


export type MutationUpdateReportConfigurationArgs = {
  model: ReportConfigurationUpdateModelInput;
  uid: Scalars['String']['input'];
};


export type MutationUpdateRoleArgs = {
  role?: InputMaybe<RoleModelInput>;
};


export type MutationUpdateRoleAssignmentsArgs = {
  model: Array<InputMaybe<RoleAssignmentWithReferencesModelInput>>;
};


export type MutationUpdateScheduleArgs = {
  model: ReportScheduleUpdateModelInput;
};


export type MutationUpdateSelectedRecommendationOptionArgs = {
  selection: RecommendationOptionModelInput;
  uid: Scalars['String']['input'];
};


export type MutationUpdateSmartFormDefinitionArgs = {
  model: SmartFormDefinitionUpdateModelInput;
};


export type MutationUpdateTagArgs = {
  tag: TagUpdateModelInput;
};


export type MutationUpdateTaskArgs = {
  task?: InputMaybe<TaskModelInput>;
};


export type MutationUpdateTenantDateTimeFormatConfigArgs = {
  dateTimeFormatConfig: DateTimeFormatConfigUpdateModelInput;
};


export type MutationUpdateTenantDuplicateSearchConfigArgs = {
  duplicateSearchConfig: TenantDuplicateSearchConfigurationUpdateModelInput;
};


export type MutationUpdateTenantPermissionsArgs = {
  permissions: TenantPermissionsConfigurationUpdateModelInput;
};


export type MutationUpdateTenantProcessSweeperConfigArgs = {
  processSweeperConfig: ProcessSweeperConfigUpdateModelInput;
};


export type MutationUpdateTenantSpendConfigArgs = {
  spendConfig: SpendConfigUpdateModelInput;
};


export type MutationUpdateTenantSsoConfigArgs = {
  ssoConfig: SsoConfigUpdateModelInput;
};


export type MutationUpdateTenantTaskDelegationConfigArgs = {
  taskDelegationConfig: TaskDelegationConfigUpdateModelInput;
};


export type MutationUpdateTenantUsersConfigArgs = {
  usersConfig: TenantUsersConfigurationUpdateModelInput;
};


export type MutationUpdateTenantWorkerConfigArgs = {
  workerConfig: TenantWorkerConfigurationUpdateModelInput;
};


export type MutationUpdateTimeCodeArgs = {
  TimeCode?: InputMaybe<TimeCodeUpdateModelInput>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateTimesheetSettingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  model: TimesheetSettingsUpdateModelInput;
};


export type MutationUpdateUserArgs = {
  user?: InputMaybe<UserUpdateModelInput>;
};


export type MutationUpdateWidgetSettingArgs = {
  model: WidgetSettingUpdateModelInput;
};


export type MutationUpdateWorkScheduleArgs = {
  uid: Scalars['String']['input'];
  workSchedule?: InputMaybe<WorkScheduleUpdateModelInput>;
};


export type MutationUpdateWorkdaySecretsArgs = {
  secrets?: InputMaybe<WorkdaySecretsUpdateModelInput>;
};

export type MyAnalyticsDashboardModel = {
  __typename?: 'MyAnalyticsDashboardModel';
  dashboardId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  embeddableUrl?: Maybe<EmbeddableUrlModel>;
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  /** @deprecated replaced with embeddableUrl. Will be removed */
  url?: Maybe<Scalars['String']['output']>;
};

export type MyAnalyticsDashboardsModel = {
  __typename?: 'MyAnalyticsDashboardsModel';
  items?: Maybe<Array<Maybe<MyAnalyticsDashboardModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NameDetailsModel = {
  __typename?: 'NameDetailsModel';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  secondaryLastName?: Maybe<Scalars['String']['output']>;
};

export type NameDetailsModelInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  secondaryLastName?: InputMaybe<Scalars['String']['input']>;
};

export type NameModel = {
  __typename?: 'NameModel';
  first?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
  middle?: Maybe<Scalars['String']['output']>;
  preferredFirst?: Maybe<Scalars['String']['output']>;
  preferredLast?: Maybe<Scalars['String']['output']>;
  preferredMiddle?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type NameModelInput = {
  first?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  preferredFirst?: InputMaybe<Scalars['String']['input']>;
  preferredLast?: InputMaybe<Scalars['String']['input']>;
  preferredMiddle?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type NationalIdMaskedModel = {
  __typename?: 'NationalIdMaskedModel';
  country?: Maybe<CountryModel>;
  nationalIdType?: Maybe<NationalIdTypeModel>;
  nationalIdValue?: Maybe<Scalars['String']['output']>;
  personUid?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  uid: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['LocalDate']['output']>;
};

export type NationalIdMaskedModelInput = {
  country?: InputMaybe<CountryModelInput>;
  nationalIdType?: InputMaybe<NationalIdTypeModelInput>;
  nationalIdValue?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type NationalIdModel = {
  __typename?: 'NationalIdModel';
  country?: Maybe<CountryModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  nationalIdType?: Maybe<NationalIdTypeModel>;
  nationalIdValue?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  personUid?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['LocalDate']['output']>;
};


export type NationalIdModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NationalIdModelInput = {
  country?: InputMaybe<CountryModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  nationalIdType?: InputMaybe<NationalIdTypeModelInput>;
  nationalIdValue?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type NationalIdTypeModel = {
  __typename?: 'NationalIdTypeModel';
  code?: Maybe<Scalars['String']['output']>;
  hasValidUntilDate?: Maybe<Scalars['Boolean']['output']>;
  masks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type NationalIdTypeModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  hasValidUntilDate?: InputMaybe<Scalars['Boolean']['input']>;
  masks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NationalIdTypesModel = {
  __typename?: 'NationalIdTypesModel';
  items?: Maybe<Array<Maybe<NationalIdTypeModel>>>;
};

export type NotificationChannelConfigurationModel = {
  __typename?: 'NotificationChannelConfigurationModel';
  channel?: Maybe<NotificationChannelModel>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationChannelConfigurationModelInput = {
  channel?: InputMaybe<NotificationChannelModel>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationChannelModel {
  All = 'ALL',
  Email = 'EMAIL',
  Inapp = 'INAPP',
  None = 'NONE',
  Sms = 'SMS',
  Teams = 'TEAMS'
}

export enum NotificationEntityTypeModel {
  Engagements = 'ENGAGEMENTS',
  Expenses = 'EXPENSES',
  Invoices = 'INVOICES',
  People = 'PEOPLE',
  PolicyRules = 'POLICY_RULES',
  Roles = 'ROLES',
  RoleAssignments = 'ROLE_ASSIGNMENTS',
  Suppliers = 'SUPPLIERS',
  Timesheets = 'TIMESHEETS',
  Users = 'USERS',
  WorkerEngagements = 'WORKER_ENGAGEMENTS',
  WorkPostings = 'WORK_POSTINGS',
  WorkRequests = 'WORK_REQUESTS'
}

export type NotificationHubSettingModel = {
  __typename?: 'NotificationHubSettingModel';
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<NotificationHubSettingNameModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  roleAssignments?: Maybe<Array<Maybe<RoleAssignmentsModel>>>;
  stringValue?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationHubSettingTypeModel>;
  uid: Scalars['String']['output'];
};


export type NotificationHubSettingModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationHubSettingNameModel {
  EmailEnabled = 'EMAIL_ENABLED',
  EmailRedirectAddresses = 'EMAIL_REDIRECT_ADDRESSES',
  EmailRedirectEnabled = 'EMAIL_REDIRECT_ENABLED',
  EmailSendNewUser = 'EMAIL_SEND_NEW_USER',
  EmailSendPasswordReset = 'EMAIL_SEND_PASSWORD_RESET',
  TeamsEnabled = 'TEAMS_ENABLED',
  TeamsTenantId = 'TEAMS_TENANT_ID'
}

export enum NotificationHubSettingTypeModel {
  Boolean = 'BOOLEAN',
  String = 'STRING'
}

export type NotificationHubSettingUpdateModelInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationHubSettingsModel = {
  __typename?: 'NotificationHubSettingsModel';
  items?: Maybe<Array<Maybe<NotificationHubSettingModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationHubSettingsSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<NotificationHubSettingsSortTypeModel>;
};

export enum NotificationHubSettingsSortTypeModel {
  Name = 'NAME'
}

export type NotificationMetadataEntryModel = {
  __typename?: 'NotificationMetadataEntryModel';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NotificationModel = {
  __typename?: 'NotificationModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<Maybe<NotificationMetadataEntryModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  resourceLocation?: Maybe<Scalars['String']['output']>;
  resourceUid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NotificationStatusModel>;
  statusModified?: Maybe<Scalars['OffsetDateTime']['output']>;
  type?: Maybe<NotificationTypeModel>;
  uid: Scalars['String']['output'];
};

export type NotificationModelInput = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationQueryModelInput = {
  created?: InputMaybe<TimestampRangeModelInput>;
  entityTypes?: InputMaybe<Array<InputMaybe<NotificationEntityTypeModel>>>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<TimestampRangeModelInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<NotificationStatusModel>>>;
  types?: InputMaybe<Array<InputMaybe<NotificationTypeModel>>>;
};

export type NotificationSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<NotificationSortTypeModel>;
};

export enum NotificationSortTypeModel {
  CreatedTime = 'CREATED_TIME',
  ErrorMessage = 'ERROR_MESSAGE',
  LastModifiedTime = 'LAST_MODIFIED_TIME',
  Read = 'READ',
  Status = 'STATUS',
  Type = 'TYPE'
}

export enum NotificationStatusModel {
  Cancelled = 'CANCELLED',
  FinishedError = 'FINISHED_ERROR',
  FinishedSuccess = 'FINISHED_SUCCESS',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export enum NotificationTypeModel {
  AuditReport = 'AUDIT_REPORT',
  CsvExport = 'CSV_EXPORT',
  ExcelExport = 'EXCEL_EXPORT',
  GlobalIdRun = 'GLOBAL_ID_RUN',
  Import = 'IMPORT',
  ImportSheetUploaded = 'IMPORT_SHEET_UPLOADED',
  ImportUci = 'IMPORT_UCI',
  PersonEventImport = 'PERSON_EVENT_IMPORT',
  Ping = 'PING',
  PowerpointExport = 'POWERPOINT_EXPORT',
  SupplierProfileUpdate = 'SUPPLIER_PROFILE_UPDATE',
  SupplierRelationshipChange = 'SUPPLIER_RELATIONSHIP_CHANGE',
  TaskAssigned = 'TASK_ASSIGNED',
  TaskDeleted = 'TASK_DELETED',
  TaskNudge = 'TASK_NUDGE',
  TaskOverdue = 'TASK_OVERDUE',
  TaskPoke = 'TASK_POKE',
  TaskResolved = 'TASK_RESOLVED',
  TaskTerminated = 'TASK_TERMINATED',
  TaskUnassigned = 'TASK_UNASSIGNED',
  UcTransform = 'UC_TRANSFORM',
  UkgImport = 'UKG_IMPORT',
  UserImport = 'USER_IMPORT',
  WorkdayDiffExport = 'WORKDAY_DIFF_EXPORT',
  WorkdayImport = 'WORKDAY_IMPORT',
  WorkdayOrgTreeSync = 'WORKDAY_ORG_TREE_SYNC',
  WorkdayTimeAllocationImport = 'WORKDAY_TIME_ALLOCATION_IMPORT',
  WorkflowNotification = 'WORKFLOW_NOTIFICATION'
}

export type NotificationsModel = {
  __typename?: 'NotificationsModel';
  limit?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Array<Maybe<NotificationModel>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationsModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationModelInput>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberRangeModelInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export enum ObjectTypeModel {
  Address = 'ADDRESS',
  ApprovalLimit = 'APPROVAL_LIMIT',
  BatchExecution = 'BATCH_EXECUTION',
  BlueprintExecution = 'BLUEPRINT_EXECUTION',
  BusinessSite = 'BUSINESS_SITE',
  BusinessSiteCity = 'BUSINESS_SITE_CITY',
  BusinessSiteRegion = 'BUSINESS_SITE_REGION',
  Citizenship = 'CITIZENSHIP',
  Classification = 'CLASSIFICATION',
  Company = 'COMPANY',
  Contract = 'CONTRACT',
  CostCenter = 'COST_CENTER',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  CustomObject = 'CUSTOM_OBJECT',
  DateOfInvoice = 'DATE_OF_INVOICE',
  DayOfInvoice = 'DAY_OF_INVOICE',
  EligibilityRequirement = 'ELIGIBILITY_REQUIREMENT',
  Engagement = 'ENGAGEMENT',
  EngagementBudget = 'ENGAGEMENT_BUDGET',
  EngagementSettings = 'ENGAGEMENT_SETTINGS',
  Expense = 'EXPENSE',
  ExpenseCategory = 'EXPENSE_CATEGORY',
  Gender = 'GENDER',
  HolidaySchedule = 'HOLIDAY_SCHEDULE',
  Interview = 'INTERVIEW',
  Invoice = 'INVOICE',
  InvoiceFrequency = 'INVOICE_FREQUENCY',
  JobApplication = 'JOB_APPLICATION',
  JobApplicationBudget = 'JOB_APPLICATION_BUDGET',
  JobApplicationStage = 'JOB_APPLICATION_STAGE',
  JobFamily = 'JOB_FAMILY',
  JobFamilyGroup = 'JOB_FAMILY_GROUP',
  JobProfile = 'JOB_PROFILE',
  JobRequest = 'JOB_REQUEST',
  JobRequestBudget = 'JOB_REQUEST_BUDGET',
  JobRequestSupplierInvite = 'JOB_REQUEST_SUPPLIER_INVITE',
  Manager = 'MANAGER',
  Milestone = 'MILESTONE',
  Msp = 'MSP',
  NationalId = 'NATIONAL_ID',
  Org = 'ORG',
  Person = 'PERSON',
  PriorSpend = 'PRIOR_SPEND',
  Project = 'PROJECT',
  ProjectCustomer = 'PROJECT_CUSTOMER',
  ProjectPosition = 'PROJECT_POSITION',
  Rate = 'RATE',
  RateCard = 'RATE_CARD',
  RecommendationOption = 'RECOMMENDATION_OPTION',
  SowResponse = 'SOW_RESPONSE',
  Supplier = 'SUPPLIER',
  System = 'SYSTEM',
  Task = 'TASK',
  TerminationReason = 'TERMINATION_REASON',
  Timesheet = 'TIMESHEET',
  TimesheetAllocation = 'TIMESHEET_ALLOCATION',
  TimesheetAllocationLocations = 'TIMESHEET_ALLOCATION_LOCATIONS',
  TimeCode = 'TIME_CODE',
  WorkerCertification = 'WORKER_CERTIFICATION',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkRequest = 'WORK_REQUEST',
  WorkSchedule = 'WORK_SCHEDULE'
}

export type OcCsvExportQueryModelInput = {
  contracts?: InputMaybe<ContractsQueryModelInput>;
  costCenters?: InputMaybe<CostCenterQueryModelInput>;
  customObjects?: InputMaybe<CustomObjectQueryModelInput>;
  engagements?: InputMaybe<EngagementsQueryModelInput>;
  expenses?: InputMaybe<ExpenseQueryModelInput>;
  invoices?: InputMaybe<AllInvoicesQueryModelInput>;
  jobApplications?: InputMaybe<JobApplicationQueryModelInput>;
  jobFamilies?: InputMaybe<JobFamilyQueryModelInput>;
  jobFamilyGroups?: InputMaybe<JobFamilyGroupQueryModelInput>;
  jobProfiles?: InputMaybe<JobProfileQueryModelInput>;
  locations?: InputMaybe<LocationQueryModelInput>;
  organizations?: InputMaybe<OrgsQueryModelInput>;
  people?: InputMaybe<PeopleQueryModelInput>;
  rateCards?: InputMaybe<RateCardQueryModelInput>;
  suppliers?: InputMaybe<SuppliersQueryModelInput>;
  timesheets?: InputMaybe<TimesheetQueryModelInput>;
  users?: InputMaybe<UserQueryModelInput>;
  workPostings?: InputMaybe<WorkPostingQueryModelInput>;
  workRequests?: InputMaybe<WorkRequestsQueryModelInput>;
  workerEngagements?: InputMaybe<WorkerEngagementsQueryModelInput>;
};

export type OcExportCreateModelInput = {
  columns?: InputMaybe<Array<InputMaybe<ExportColumnConfigModelInput>>>;
  csvExportQueryModel?: InputMaybe<OcCsvExportQueryModelInput>;
  exportEntity?: InputMaybe<OcExportEntityModel>;
  format?: InputMaybe<OcExportTypeModel>;
  query?: InputMaybe<Scalars['String']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<OcReportSourceTypeModel>;
  targetSftpDirectoryUid?: InputMaybe<Scalars['String']['input']>;
  templateReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export enum OcExportEntityModel {
  BusinessSites = 'BUSINESS_SITES',
  Contracts = 'CONTRACTS',
  CostCenters = 'COST_CENTERS',
  CustomObjects = 'CUSTOM_OBJECTS',
  EligibilityRequirements = 'ELIGIBILITY_REQUIREMENTS',
  Engagements = 'ENGAGEMENTS',
  Expenses = 'EXPENSES',
  HeadcountReport = 'HEADCOUNT_REPORT',
  Invoices = 'INVOICES',
  JobApplications = 'JOB_APPLICATIONS',
  JobFamilies = 'JOB_FAMILIES',
  JobFamilyGroups = 'JOB_FAMILY_GROUPS',
  JobProfiles = 'JOB_PROFILES',
  Milestones = 'MILESTONES',
  Organizations = 'ORGANIZATIONS',
  People = 'PEOPLE',
  PolicyRules = 'POLICY_RULES',
  RateCards = 'RATE_CARDS',
  Roles = 'ROLES',
  RoleAssignments = 'ROLE_ASSIGNMENTS',
  Suppliers = 'SUPPLIERS',
  Timesheets = 'TIMESHEETS',
  Users = 'USERS',
  WorkerEngagements = 'WORKER_ENGAGEMENTS',
  WorkerQualifications = 'WORKER_QUALIFICATIONS',
  WorkPostings = 'WORK_POSTINGS',
  WorkRequests = 'WORK_REQUESTS'
}

export type OcExportFilterModel = {
  __typename?: 'OcExportFilterModel';
  engagements?: Maybe<EngagementsQueryModel>;
};

export type OcExportModel = {
  __typename?: 'OcExportModel';
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  executionId: Scalars['Long']['output'];
  /** @deprecated Deprecated in favour of requestedFrom */
  exportEntity?: Maybe<OcExportEntityModel>;
  exportType?: Maybe<OcExportTypeModel>;
  failureReason?: Maybe<Scalars['String']['output']>;
  filenames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filter?: Maybe<OcExportFilterModel>;
  initialTotalCount?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationUid?: Maybe<Scalars['String']['output']>;
  ownerUid?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<Maybe<OcExportPropertiesModel>>>;
  /** @deprecated Deprecated in favour of name */
  quickViewName?: Maybe<Scalars['String']['output']>;
  requestedFrom?: Maybe<Scalars['String']['output']>;
  requestedTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  resourceLocation?: Maybe<Scalars['String']['output']>;
  resourceUid?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<OcReportSourceTypeModel>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<OcExportStatusModel>;
  targetSftpDirectory?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Long']['output']>;
};

export type OcExportPageModel = {
  __typename?: 'OcExportPageModel';
  content?: Maybe<Array<Maybe<OcExportModel>>>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Long']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum OcExportPropertiesKey {
  TimesheetExportEmptyAllocation = 'TIMESHEET_EXPORT_EMPTY_ALLOCATION'
}

export type OcExportPropertiesModel = {
  __typename?: 'OcExportPropertiesModel';
  propertyName?: Maybe<OcExportPropertiesKey>;
  value: Scalars['Boolean']['output'];
};

export type OcExportQueryModelInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  notificationUid?: InputMaybe<Scalars['String']['input']>;
  requestedFrom?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OcExportSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<OcExportSortTypeModel>;
};

export enum OcExportSortTypeModel {
  CreateTime = 'CREATE_TIME'
}

export enum OcExportStatusModel {
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Queued = 'QUEUED'
}

export enum OcExportTypeModel {
  Csv = 'CSV',
  Excel = 'EXCEL',
  GoogleSheet = 'GOOGLE_SHEET'
}

export enum OcReportSourceTypeModel {
  CustomReport = 'CUSTOM_REPORT',
  Hub = 'HUB',
  MyReport = 'MY_REPORT',
  StandardReport = 'STANDARD_REPORT'
}

export enum OrdinalModel {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type OrgCreateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  costCentre?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  defaultRootOrg?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameStrategy?: InputMaybe<OrgDisplayNameStrategyTypeModel>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  location?: InputMaybe<LocationImportableReferenceModelInput>;
  logo?: InputMaybe<MediaModelInput>;
  manager?: InputMaybe<ManagerImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLevels?: InputMaybe<Array<InputMaybe<OrgLevelModelInput>>>;
  parentOrg?: InputMaybe<OrgImportableReferenceModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryAncestorOrgs?: InputMaybe<Array<InputMaybe<OrgImportableReferenceModelInput>>>;
  primarySubOrgs?: InputMaybe<Array<InputMaybe<OrgImportableReferenceModelInput>>>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrgTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  updatable?: InputMaybe<Scalars['Boolean']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export enum OrgDisplayNameStrategyTypeModel {
  ManagerName = 'MANAGER_NAME',
  OrgName = 'ORG_NAME',
  OrgNameAndManagerName = 'ORG_NAME_AND_MANAGER_NAME'
}

export type OrgFilterModelInput = {
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type OrgImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type OrgLevelFilterModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrgLevelModel = {
  __typename?: 'OrgLevelModel';
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<OrgModel>;
};

export type OrgLevelModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<OrgModelInput>;
};

export enum OrgManagingSourceModel {
  Beeline = 'BEELINE',
  Ukg = 'UKG',
  Utmost = 'UTMOST',
  Workday = 'WORKDAY'
}

export type OrgMembersPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgMembersQueryModelInput = {
  lastEvaluatedUid?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OrgMembershipDiagnosticsModel = {
  __typename?: 'OrgMembershipDiagnosticsModel';
  entityVersion?: Maybe<Scalars['Int']['output']>;
  orgMembershipModel?: Maybe<BaseOrgMembershipDiagnosticsModel>;
};

export type OrgMembershipRevisionModel = RevisionModel & {
  __typename?: 'OrgMembershipRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  memberEngagementUid?: Maybe<Scalars['String']['output']>;
  org?: Maybe<OrgModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousOrg?: Maybe<OrgModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type OrgMembershipRevisionsDiagnosticsModel = {
  __typename?: 'OrgMembershipRevisionsDiagnosticsModel';
  orgMembershipModel?: Maybe<BaseOrgMembershipDiagnosticsModel>;
  rev?: Maybe<Scalars['Long']['output']>;
  revType?: Maybe<RevType>;
};

export type OrgModel = {
  __typename?: 'OrgModel';
  aggregateEmployeePrimaryWorkerCount: Scalars['Int']['output'];
  aggregateEmployeeWorkerCount: Scalars['Int']['output'];
  aggregateNonEmployeePrimaryWorkerCount: Scalars['Int']['output'];
  aggregateNonEmployeeWorkerCount: Scalars['Int']['output'];
  aggregatePrimaryWorkerCount: Scalars['Int']['output'];
  aggregatePrimaryWorkerCounts?: Maybe<ClassificationCountModel>;
  aggregateWorkerCount: Scalars['Int']['output'];
  aggregateWorkerCounts?: Maybe<ClassificationCountModel>;
  amountOfSubOrgs: Scalars['Int']['output'];
  /** @deprecated Deprecated in favour of reference_code (Currently relied on by Studio) */
  code?: Maybe<Scalars['String']['output']>;
  /** @deprecated to be removed */
  costCentre?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  defaultRootOrg?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayNameStrategy?: Maybe<OrgDisplayNameStrategyTypeModel>;
  employeePrimaryWorkerCount: Scalars['Int']['output'];
  employeeWorkerCount: Scalars['Int']['output'];
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  /** @deprecated Deprecated in favour of reference_id and WID (Currently relied on by Studio) */
  externalIds?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  location?: Maybe<LocationModel>;
  logo?: Maybe<MediaModel>;
  manager?: Maybe<EngagementModel>;
  managingSources?: Maybe<Array<Maybe<OrgManagingSourceModel>>>;
  members?: Maybe<Array<Maybe<EngagementModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  nonEmployeePrimaryWorkerCount: Scalars['Int']['output'];
  nonEmployeeWorkerCount: Scalars['Int']['output'];
  orgLevels?: Maybe<Array<Maybe<OrgLevelModel>>>;
  orgManagerEngagementRevisionAtTime?: Maybe<EngagementModel>;
  parentOrg?: Maybe<OrgModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  primaryAncestorOrgs?: Maybe<Array<Maybe<OrgModel>>>;
  primarySubOrgs?: Maybe<Array<Maybe<OrgModel>>>;
  primaryWorkerCount: Scalars['Int']['output'];
  primaryWorkerCounts?: Maybe<ClassificationCountModel>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  roleAssignments?: Maybe<Array<Maybe<RoleAssignmentsModel>>>;
  sourceName?: Maybe<Scalars['String']['output']>;
  /** @deprecated can be removed on next prod deploy. all FE usages have been removed. */
  type?: Maybe<OrgTypeModel>;
  uid: Scalars['String']['output'];
  /** @deprecated to be removed from FE, use a datasource flag + ABAC to control */
  updatable?: Maybe<Scalars['Boolean']['output']>;
  wid?: Maybe<Scalars['String']['output']>;
  /** @deprecated to be removed from FE, check permissions / source name instead */
  workdayOrg?: Maybe<Scalars['Boolean']['output']>;
  workerCount: Scalars['Int']['output'];
  workerCounts?: Maybe<ClassificationCountModel>;
};


export type OrgModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrgModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrgModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrgModelMembersArgs = {
  page?: InputMaybe<OrgMembersPageModelInput>;
  q?: InputMaybe<OrgMembersQueryModelInput>;
};


export type OrgModelOrgLevelsArgs = {
  orgLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrgModelOrgManagerEngagementRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type OrgModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgModelInput = {
  aggregatePrimaryWorkerCounts?: InputMaybe<ClassificationCountModelInput>;
  aggregateWorkerCounts?: InputMaybe<ClassificationCountModelInput>;
  amountOfSubOrgs?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  costCentre?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  defaultRootOrg?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameStrategy?: InputMaybe<OrgDisplayNameStrategyTypeModel>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  location?: InputMaybe<LocationModelInput>;
  logo?: InputMaybe<MediaModelInput>;
  manager?: InputMaybe<EngagementModelInput>;
  managingSources?: InputMaybe<Array<InputMaybe<OrgManagingSourceModel>>>;
  members?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLevels?: InputMaybe<Array<InputMaybe<OrgLevelModelInput>>>;
  parentOrg?: InputMaybe<OrgModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryAncestorOrgs?: InputMaybe<Array<InputMaybe<OrgModelInput>>>;
  primarySubOrgs?: InputMaybe<Array<InputMaybe<OrgModelInput>>>;
  primaryWorkerCounts?: InputMaybe<ClassificationCountModelInput>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  roleAssignments?: InputMaybe<Array<InputMaybe<RoleAssignmentsModelInput>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrgTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  updatable?: InputMaybe<Scalars['Boolean']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
  workdayOrg?: InputMaybe<Scalars['Boolean']['input']>;
  workerCount?: InputMaybe<Scalars['Int']['input']>;
  workerCounts?: InputMaybe<ClassificationCountModelInput>;
};

export enum OrgRelationshipModel {
  AllReports = 'ALL_REPORTS',
  DirectReports = 'DIRECT_REPORTS'
}

export type OrgRoleAssignmentsModel = {
  __typename?: 'OrgRoleAssignmentsModel';
  assignees?: Maybe<Array<Maybe<PersonModel>>>;
  org?: Maybe<OrgModel>;
};

export type OrgRoleAssignmentsModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  org?: InputMaybe<OrgModelInput>;
};

export type OrgSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<OrgSortTypeModel>;
};

export enum OrgSortTypeModel {
  Name = 'NAME',
  ReferenceCode = 'REFERENCE_CODE',
  ReferenceId = 'REFERENCE_ID'
}

export type OrgSuggestionModel = SuggestionModel & {
  __typename?: 'OrgSuggestionModel';
  name?: Maybe<Scalars['String']['output']>;
  orgUid?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export enum OrgTypeModel {
  Supervisory = 'SUPERVISORY'
}

export type OrgUpdateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  costCentre?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  defaultRootOrg?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameStrategy?: InputMaybe<OrgDisplayNameStrategyTypeModel>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  externalIds?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  location?: InputMaybe<LocationImportableReferenceModelInput>;
  logo?: InputMaybe<MediaModelInput>;
  manager?: InputMaybe<ManagerImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLevels?: InputMaybe<Array<InputMaybe<OrgLevelModelInput>>>;
  parentOrg?: InputMaybe<OrgImportableReferenceModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryAncestorOrgs?: InputMaybe<Array<InputMaybe<OrgImportableReferenceModelInput>>>;
  primarySubOrgs?: InputMaybe<Array<InputMaybe<OrgImportableReferenceModelInput>>>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrgTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  updatable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgsModel = {
  __typename?: 'OrgsModel';
  aggregateAnomalyCount?: Maybe<Scalars['Int']['output']>;
  aggregateAnomalyScore?: Maybe<Scalars['Int']['output']>;
  aggregatePrimaryAnomalyCount?: Maybe<Scalars['Int']['output']>;
  aggregatePrimaryAnomalyScore?: Maybe<Scalars['Int']['output']>;
  elements?: Maybe<Array<Maybe<OrgModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  orgs?: Maybe<Array<Maybe<OrgModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrgsQueryModelInput = {
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldFilter?: InputMaybe<CustomFieldFilterModelInput>;
  fieldUrn?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<InputMaybe<OrgLevelFilterModelInput>>>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managerCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managersUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managingSources?: InputMaybe<Array<InputMaybe<OrgManagingSourceModel>>>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum OriginServiceEnum {
  OcUi = 'OC_UI',
  UcApi = 'UC_API',
  UcImporter = 'UC_IMPORTER',
  UkgConnector = 'UKG_CONNECTOR',
  UkgImporter = 'UKG_IMPORTER',
  Wdsync = 'WDSYNC'
}

export enum OwnershipTypeModel {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type PageInfoModel = {
  __typename?: 'PageInfoModel';
  endCursor?: Maybe<Scalars['String']['output']>;
  first?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageModelInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type Pair_String_StringInput = {
  first?: InputMaybe<Scalars['String']['input']>;
  second?: InputMaybe<Scalars['String']['input']>;
};

export type PatchSupplierContactModelInput = {
  businessSiteUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum PayBillRateTypeModel {
  BillRate = 'BILL_RATE',
  PayRate = 'PAY_RATE'
}

export enum PayRatePeriodModel {
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  OnInvoice = 'ON_INVOICE',
  Weekly = 'WEEKLY'
}

export enum PayRateTypeModel {
  Sow = 'SOW',
  Time = 'TIME',
  TimeAndMaterials = 'TIME_AND_MATERIALS'
}

export enum PaymentCurrencyModel {
  Cad = 'CAD',
  Cny = 'CNY',
  Eur = 'EUR',
  Inr = 'INR',
  Jpy = 'JPY',
  Mxn = 'MXN',
  Usd = 'USD'
}

export enum PaymentMethodModel {
  AchDirectDeposit = 'ACH_DIRECT_DEPOSIT',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD',
  Wire = 'WIRE'
}

export type PaymentModel = {
  __typename?: 'PaymentModel';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<PaymentCurrencyModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoiceUid?: Maybe<Scalars['String']['output']>;
  method?: Maybe<PaymentMethodModel>;
  orgResponsible?: Maybe<OrgModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
};


export type PaymentModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PaymentModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type PaymentModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<PaymentCurrencyModel>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  invoiceUid?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<PaymentMethodModel>;
  orgResponsible?: InputMaybe<OrgModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  supplier?: InputMaybe<SupplierModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<PaymentSortTypeModel>;
};

export enum PaymentSortTypeModel {
  Amount = 'AMOUNT',
  Currency = 'CURRENCY',
  Date = 'DATE',
  InvoiceNumber = 'INVOICE_NUMBER',
  Method = 'METHOD'
}

export type PaymentsModel = {
  __typename?: 'PaymentsModel';
  elements?: Maybe<Array<Maybe<PaymentModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Array<Maybe<PaymentModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentsModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  payments?: InputMaybe<Array<InputMaybe<PaymentModelInput>>>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentsQueryModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountRange?: InputMaybe<NumberRangeModelInput>;
  currency?: InputMaybe<PaymentCurrencyModel>;
  dateRange?: InputMaybe<DateRangeModelInput>;
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumberSearch?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<PaymentMethodModel>;
  orgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgUidsMatch?: InputMaybe<CollectionFilterModel>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suppliersMatch?: InputMaybe<CollectionFilterModel>;
};

export type PeopleModel = {
  __typename?: 'PeopleModel';
  elements?: Maybe<Array<Maybe<PersonModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfoModel>;
  people?: Maybe<Array<Maybe<PersonModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PeoplePageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<PersonSortModelInput>>>;
};

export type PeopleQueryModelInput = {
  anyEngagementEndRange?: InputMaybe<DateRangeModelInput>;
  anyEngagementStartRange?: InputMaybe<DateRangeModelInput>;
  citizenshipCountryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationType?: InputMaybe<ClassificationTypeModel>;
  classificationTypes?: InputMaybe<Array<InputMaybe<ClassificationTypeModel>>>;
  classificationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationsUidsMatch?: InputMaybe<CollectionFilterModel>;
  combinedEngagementStatus?: InputMaybe<CombinedEngagementStatusModel>;
  companyReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyWorkerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contractStatusChange?: InputMaybe<ContractStatusChangeFilterModelInput>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentEngagementEndRange?: InputMaybe<DateRangeModelInput>;
  currentEngagementStartRange?: InputMaybe<DateRangeModelInput>;
  currentEngagementsCountFilter?: InputMaybe<CountFilterModelInput>;
  customFieldFilter?: InputMaybe<CustomFieldFilterModelInput>;
  customFieldsFilterMatch?: InputMaybe<CollectionFilterModel>;
  dateOfBirthRange?: InputMaybe<DateRangeModelInput>;
  dateOfBirthRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  engagementDurations?: InputMaybe<Array<InputMaybe<EngagementDurationFilterModelInput>>>;
  engagementEndDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  engagementPoNumber?: InputMaybe<Scalars['String']['input']>;
  engagementScope?: InputMaybe<EngagementScopeModel>;
  engagementStartDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  engagementStatuses?: InputMaybe<Array<InputMaybe<EngagementStatusModel>>>;
  filterableCustomFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  genderReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasMultipleEngagements?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecondaries?: InputMaybe<Scalars['Boolean']['input']>;
  highestLevelOfEducation?: InputMaybe<HighestLevelOfEducationModel>;
  ignoreTimesheetChangesInModifiedRange?: InputMaybe<Scalars['Boolean']['input']>;
  isManagedByUtmost?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkdayUser?: InputMaybe<Scalars['Boolean']['input']>;
  jobProfileUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobProfileUidsMatch?: InputMaybe<CollectionFilterModel>;
  locations?: InputMaybe<LocationsFilterModelInput>;
  manager?: InputMaybe<Scalars['Boolean']['input']>;
  managingSources?: InputMaybe<Array<InputMaybe<EngagementManagingSourceModel>>>;
  modifiedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mspsMatch?: InputMaybe<CollectionFilterModel>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  nationalIdType?: InputMaybe<Scalars['String']['input']>;
  nationalIdValue?: InputMaybe<Scalars['String']['input']>;
  onlyPrimaryEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  orgFilters?: InputMaybe<Array<InputMaybe<OrgFilterModelInput>>>;
  orgLevelFilters?: InputMaybe<Array<InputMaybe<WorkerOrgLevelFilterModelInput>>>;
  orgRelationship?: InputMaybe<OrgRelationshipModel>;
  orgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgUidsMatch?: InputMaybe<CollectionFilterModel>;
  organizationReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousEngagementsCountFilter?: InputMaybe<CountFilterModelInput>;
  primaryWorkLocationType?: InputMaybe<EngagementLocationTypeModel>;
  processDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  relativeToDate?: InputMaybe<Scalars['LocalDate']['input']>;
  remoteLocations?: InputMaybe<RemoteLocationsFilterModelInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  showChildren?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Boolean']['input']>;
  sourceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suppliersMatch?: InputMaybe<CollectionFilterModel>;
  userActivityUid?: InputMaybe<Scalars['String']['input']>;
  utmostChangedRecords?: InputMaybe<Scalars['Boolean']['input']>;
  workdayUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PermissionAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Import = 'IMPORT',
  Read = 'READ',
  Update = 'UPDATE'
}

export enum PermissionName {
  AggregateSubSupplierCount = 'AGGREGATE_SUB_SUPPLIER_COUNT',
  AllTasks = 'ALL_TASKS',
  AnalyticsDashboard = 'ANALYTICS_DASHBOARD',
  AnomalyDefinition = 'ANOMALY_DEFINITION',
  AuditReport = 'AUDIT_REPORT',
  BillingRate = 'BILLING_RATE',
  BillingRateValue = 'BILLING_RATE_VALUE',
  BusinessEvent = 'BUSINESS_EVENT',
  BusinessEventReason = 'BUSINESS_EVENT_REASON',
  ChangeSet = 'CHANGE_SET',
  Chart = 'CHART',
  Classification = 'CLASSIFICATION',
  Company = 'COMPANY',
  ComplianceDefinition = 'COMPLIANCE_DEFINITION',
  ComplianceDefinitionDescription = 'COMPLIANCE_DEFINITION_DESCRIPTION',
  ComplianceDefinitionExpression = 'COMPLIANCE_DEFINITION_EXPRESSION',
  ComplianceDefinitionName = 'COMPLIANCE_DEFINITION_NAME',
  ComplianceDefinitionSeverity = 'COMPLIANCE_DEFINITION_SEVERITY',
  ComplianceDefinitionStatus = 'COMPLIANCE_DEFINITION_STATUS',
  ComplianceInstance = 'COMPLIANCE_INSTANCE',
  ComplianceInstanceDetectedTime = 'COMPLIANCE_INSTANCE_DETECTED_TIME',
  ComplianceInstanceSeverity = 'COMPLIANCE_INSTANCE_SEVERITY',
  Contract = 'CONTRACT',
  ContractAccountablePerson = 'CONTRACT_ACCOUNTABLE_PERSON',
  ContractBusinessSite = 'CONTRACT_BUSINESS_SITE',
  ContractCompany = 'CONTRACT_COMPANY',
  ContractContractingParty = 'CONTRACT_CONTRACTING_PARTY',
  ContractCostCenter = 'CONTRACT_COST_CENTER',
  ContractCurrency = 'CONTRACT_CURRENCY',
  ContractDescription = 'CONTRACT_DESCRIPTION',
  ContractDocuments = 'CONTRACT_DOCUMENTS',
  ContractEndDate = 'CONTRACT_END_DATE',
  ContractEngagements = 'CONTRACT_ENGAGEMENTS',
  ContractHolidaySchedule = 'CONTRACT_HOLIDAY_SCHEDULE',
  ContractMilestones = 'CONTRACT_MILESTONES',
  ContractParent = 'CONTRACT_PARENT',
  ContractPoNumber = 'CONTRACT_PO_NUMBER',
  ContractPrimaryDocument = 'CONTRACT_PRIMARY_DOCUMENT',
  ContractReferenceId = 'CONTRACT_REFERENCE_ID',
  ContractSourcingType = 'CONTRACT_SOURCING_TYPE',
  ContractSpend = 'CONTRACT_SPEND',
  ContractStartDate = 'CONTRACT_START_DATE',
  ContractSupervisoryOrg = 'CONTRACT_SUPERVISORY_ORG',
  ContractTitle = 'CONTRACT_TITLE',
  ContractTotalBudget = 'CONTRACT_TOTAL_BUDGET',
  ContractType = 'CONTRACT_TYPE',
  ContractWorkSchedule = 'CONTRACT_WORK_SCHEDULE',
  CostCenter = 'COST_CENTER',
  CsvTemplate = 'CSV_TEMPLATE',
  CustomFieldDefinition = 'CUSTOM_FIELD_DEFINITION',
  CustomFieldDefinitionExport = 'CUSTOM_FIELD_DEFINITION_EXPORT',
  CustomFieldDefinitionGroup = 'CUSTOM_FIELD_DEFINITION_GROUP',
  CustomFieldDefinitionImport = 'CUSTOM_FIELD_DEFINITION_IMPORT',
  DailyBriefing = 'DAILY_BRIEFING',
  Dashboards = 'DASHBOARDS',
  DashboardAnomaliesByLocation = 'DASHBOARD_ANOMALIES_BY_LOCATION',
  DashboardClassificationByLocation = 'DASHBOARD_CLASSIFICATION_BY_LOCATION',
  DashboardDiversityByLocation = 'DASHBOARD_DIVERSITY_BY_LOCATION',
  DataExtract = 'DATA_EXTRACT',
  DecisionTableDefinition = 'DECISION_TABLE_DEFINITION',
  Diagnostics = 'DIAGNOSTICS',
  EligibilityRequirement = 'ELIGIBILITY_REQUIREMENT',
  Engagement = 'ENGAGEMENT',
  EngagementAccountablePerson = 'ENGAGEMENT_ACCOUNTABLE_PERSON',
  EngagementBadgeId = 'ENGAGEMENT_BADGE_ID',
  EngagementBudget = 'ENGAGEMENT_BUDGET',
  EngagementBusinessSite = 'ENGAGEMENT_BUSINESS_SITE',
  EngagementClassification = 'ENGAGEMENT_CLASSIFICATION',
  EngagementClockInTimes = 'ENGAGEMENT_CLOCK_IN_TIMES',
  EngagementCompany = 'ENGAGEMENT_COMPANY',
  EngagementContract = 'ENGAGEMENT_CONTRACT',
  EngagementCostCenters = 'ENGAGEMENT_COST_CENTERS',
  EngagementDates = 'ENGAGEMENT_DATES',
  EngagementDescription = 'ENGAGEMENT_DESCRIPTION',
  EngagementEndDate = 'ENGAGEMENT_END_DATE',
  EngagementEstimatedAdditionalCosts = 'ENGAGEMENT_ESTIMATED_ADDITIONAL_COSTS',
  EngagementExtensionDates = 'ENGAGEMENT_EXTENSION_DATES',
  EngagementHolidaySchedule = 'ENGAGEMENT_HOLIDAY_SCHEDULE',
  EngagementId = 'ENGAGEMENT_ID',
  EngagementJobApplication = 'ENGAGEMENT_JOB_APPLICATION',
  EngagementJobFamily = 'ENGAGEMENT_JOB_FAMILY',
  EngagementJobFamilyGroup = 'ENGAGEMENT_JOB_FAMILY_GROUP',
  EngagementJobProfile = 'ENGAGEMENT_JOB_PROFILE',
  EngagementJobSummary = 'ENGAGEMENT_JOB_SUMMARY',
  EngagementLastWorkdaySyncTime = 'ENGAGEMENT_LAST_WORKDAY_SYNC_TIME',
  EngagementLocation = 'ENGAGEMENT_LOCATION',
  EngagementMsp = 'ENGAGEMENT_MSP',
  EngagementOffboardOnEndDate = 'ENGAGEMENT_OFFBOARD_ON_END_DATE',
  EngagementOrgMembership = 'ENGAGEMENT_ORG_MEMBERSHIP',
  EngagementOriginalStartDate = 'ENGAGEMENT_ORIGINAL_START_DATE',
  EngagementPoNumber = 'ENGAGEMENT_PO_NUMBER',
  EngagementPrimaryManager = 'ENGAGEMENT_PRIMARY_MANAGER',
  EngagementPriorSpend = 'ENGAGEMENT_PRIOR_SPEND',
  EngagementProgramType = 'ENGAGEMENT_PROGRAM_TYPE',
  EngagementProject = 'ENGAGEMENT_PROJECT',
  EngagementProjectPosition = 'ENGAGEMENT_PROJECT_POSITION',
  EngagementRate = 'ENGAGEMENT_RATE',
  EngagementRemoteWorkAddress = 'ENGAGEMENT_REMOTE_WORK_ADDRESS',
  EngagementSettings = 'ENGAGEMENT_SETTINGS',
  EngagementSpend = 'ENGAGEMENT_SPEND',
  EngagementStartDate = 'ENGAGEMENT_START_DATE',
  EngagementStatus = 'ENGAGEMENT_STATUS',
  EngagementSupplier = 'ENGAGEMENT_SUPPLIER',
  EngagementTerminationReason = 'ENGAGEMENT_TERMINATION_REASON',
  EngagementTimesheetSubmission = 'ENGAGEMENT_TIMESHEET_SUBMISSION',
  EngagementTimesheetView = 'ENGAGEMENT_TIMESHEET_VIEW',
  EngagementTitle = 'ENGAGEMENT_TITLE',
  EngagementWorkdayPositionId = 'ENGAGEMENT_WORKDAY_POSITION_ID',
  EngagementWorkCalendar = 'ENGAGEMENT_WORK_CALENDAR',
  EngagementWorkCity = 'ENGAGEMENT_WORK_CITY',
  EngagementWorkEmail = 'ENGAGEMENT_WORK_EMAIL',
  EngagementWorkLocationType = 'ENGAGEMENT_WORK_LOCATION_TYPE',
  EngagementWorkPhones = 'ENGAGEMENT_WORK_PHONES',
  EngagementWorkProvince = 'ENGAGEMENT_WORK_PROVINCE',
  EngagementWorkSchedule = 'ENGAGEMENT_WORK_SCHEDULE',
  Expense = 'EXPENSE',
  ExpenseAmount = 'EXPENSE_AMOUNT',
  ExpenseAttachments = 'EXPENSE_ATTACHMENTS',
  ExpenseCategory = 'EXPENSE_CATEGORY',
  ExpenseCategoryConfig = 'EXPENSE_CATEGORY_CONFIG',
  ExpenseSpentDate = 'EXPENSE_SPENT_DATE',
  ExpenseStatus = 'EXPENSE_STATUS',
  ExpenseSupplier = 'EXPENSE_SUPPLIER',
  Features = 'FEATURES',
  FieldConstraintDefinition = 'FIELD_CONSTRAINT_DEFINITION',
  FieldMetadataEditing = 'FIELD_METADATA_EDITING',
  Filter = 'FILTER',
  FinanceJournal = 'FINANCE_JOURNAL',
  FinanceSnapshotReport = 'FINANCE_SNAPSHOT_REPORT',
  GlobalIdFormula = 'GLOBAL_ID_FORMULA',
  HolidaySchedule = 'HOLIDAY_SCHEDULE',
  ImportExportConfiguration = 'IMPORT_EXPORT_CONFIGURATION',
  IntegrationClient = 'INTEGRATION_CLIENT',
  IntegrationClientPermissionsConfiguration = 'INTEGRATION_CLIENT_PERMISSIONS_CONFIGURATION',
  Invoice = 'INVOICE',
  InvoiceStatus = 'INVOICE_STATUS',
  InvoicingBlueprintDefinition = 'INVOICING_BLUEPRINT_DEFINITION',
  JobApplication = 'JOB_APPLICATION',
  JobApplicationAccountablePerson = 'JOB_APPLICATION_ACCOUNTABLE_PERSON',
  JobApplicationAddress = 'JOB_APPLICATION_ADDRESS',
  JobApplicationAlternateExternalApprover = 'JOB_APPLICATION_ALTERNATE_EXTERNAL_APPROVER',
  JobApplicationBudget = 'JOB_APPLICATION_BUDGET',
  JobApplicationBusinessSite = 'JOB_APPLICATION_BUSINESS_SITE',
  JobApplicationClassification = 'JOB_APPLICATION_CLASSIFICATION',
  JobApplicationCompany = 'JOB_APPLICATION_COMPANY',
  JobApplicationCompanyWorkerId = 'JOB_APPLICATION_COMPANY_WORKER_ID',
  JobApplicationCostCenter = 'JOB_APPLICATION_COST_CENTER',
  JobApplicationDateOfBirth = 'JOB_APPLICATION_DATE_OF_BIRTH',
  JobApplicationDuplicateWorker = 'JOB_APPLICATION_DUPLICATE_WORKER',
  JobApplicationDuplicateWorkerCheckCompleted = 'JOB_APPLICATION_DUPLICATE_WORKER_CHECK_COMPLETED',
  JobApplicationEmail = 'JOB_APPLICATION_EMAIL',
  JobApplicationEngagement = 'JOB_APPLICATION_ENGAGEMENT',
  JobApplicationEngagementEndDate = 'JOB_APPLICATION_ENGAGEMENT_END_DATE',
  JobApplicationEngagementStartDate = 'JOB_APPLICATION_ENGAGEMENT_START_DATE',
  JobApplicationGender = 'JOB_APPLICATION_GENDER',
  JobApplicationHolidaySchedule = 'JOB_APPLICATION_HOLIDAY_SCHEDULE',
  JobApplicationJobPostingBusinessReason = 'JOB_APPLICATION_JOB_POSTING_BUSINESS_REASON',
  JobApplicationJobProfile = 'JOB_APPLICATION_JOB_PROFILE',
  JobApplicationJobRequest = 'JOB_APPLICATION_JOB_REQUEST',
  JobApplicationMsp = 'JOB_APPLICATION_MSP',
  JobApplicationName = 'JOB_APPLICATION_NAME',
  JobApplicationNationalId = 'JOB_APPLICATION_NATIONAL_ID',
  JobApplicationNationalIdMasked = 'JOB_APPLICATION_NATIONAL_ID_MASKED',
  JobApplicationPerson = 'JOB_APPLICATION_PERSON',
  JobApplicationPersonalEmail = 'JOB_APPLICATION_PERSONAL_EMAIL',
  JobApplicationPhoneNumber = 'JOB_APPLICATION_PHONE_NUMBER',
  JobApplicationPreferredEndDate = 'JOB_APPLICATION_PREFERRED_END_DATE',
  JobApplicationPreferredStartDate = 'JOB_APPLICATION_PREFERRED_START_DATE',
  JobApplicationPrimaryExternalApprover = 'JOB_APPLICATION_PRIMARY_EXTERNAL_APPROVER',
  JobApplicationRate = 'JOB_APPLICATION_RATE',
  JobApplicationRejectedBy = 'JOB_APPLICATION_REJECTED_BY',
  JobApplicationRejectionComment = 'JOB_APPLICATION_REJECTION_COMMENT',
  JobApplicationRejectionDate = 'JOB_APPLICATION_REJECTION_DATE',
  JobApplicationRejectionReason = 'JOB_APPLICATION_REJECTION_REASON',
  JobApplicationRemoteWorkAddress = 'JOB_APPLICATION_REMOTE_WORK_ADDRESS',
  JobApplicationShortlist = 'JOB_APPLICATION_SHORTLIST',
  JobApplicationSourcingType = 'JOB_APPLICATION_SOURCING_TYPE',
  JobApplicationStage = 'JOB_APPLICATION_STAGE',
  JobApplicationSupervisoryOrg = 'JOB_APPLICATION_SUPERVISORY_ORG',
  JobApplicationSupplier = 'JOB_APPLICATION_SUPPLIER',
  JobApplicationTimeToHireDays = 'JOB_APPLICATION_TIME_TO_HIRE_DAYS',
  JobApplicationTimeToStartDays = 'JOB_APPLICATION_TIME_TO_START_DAYS',
  JobApplicationWorkdayApplicantId = 'JOB_APPLICATION_WORKDAY_APPLICANT_ID',
  JobApplicationWorkdayWorkerId = 'JOB_APPLICATION_WORKDAY_WORKER_ID',
  JobApplicationWorkerDuplicates = 'JOB_APPLICATION_WORKER_DUPLICATES',
  JobApplicationWorkSchedule = 'JOB_APPLICATION_WORK_SCHEDULE',
  JobClassification = 'JOB_CLASSIFICATION',
  JobFamily = 'JOB_FAMILY',
  JobFamilyGroup = 'JOB_FAMILY_GROUP',
  JobProfile = 'JOB_PROFILE',
  JobProfileAssignable = 'JOB_PROFILE_ASSIGNABLE',
  JobProfileCertifications = 'JOB_PROFILE_CERTIFICATIONS',
  JobProfileClassifications = 'JOB_PROFILE_CLASSIFICATIONS',
  JobProfileCode = 'JOB_PROFILE_CODE',
  JobProfileCountry = 'JOB_PROFILE_COUNTRY',
  JobProfileDescription = 'JOB_PROFILE_DESCRIPTION',
  JobProfileEligibilityRequirements = 'JOB_PROFILE_ELIGIBILITY_REQUIREMENTS',
  JobProfileJobClassifications = 'JOB_PROFILE_JOB_CLASSIFICATIONS',
  JobProfileJobFamily = 'JOB_PROFILE_JOB_FAMILY',
  JobProfileJobFamilyGroup = 'JOB_PROFILE_JOB_FAMILY_GROUP',
  JobProfileMappedExportJobProfile = 'JOB_PROFILE_MAPPED_EXPORT_JOB_PROFILE',
  JobProfileName = 'JOB_PROFILE_NAME',
  JobProfileStatus = 'JOB_PROFILE_STATUS',
  JobProfileSummary = 'JOB_PROFILE_SUMMARY',
  JobRequest = 'JOB_REQUEST',
  JobRequestAccountablePerson = 'JOB_REQUEST_ACCOUNTABLE_PERSON',
  JobRequestAlternateExternalApprover = 'JOB_REQUEST_ALTERNATE_EXTERNAL_APPROVER',
  JobRequestBudget = 'JOB_REQUEST_BUDGET',
  JobRequestBusinessReason = 'JOB_REQUEST_BUSINESS_REASON',
  JobRequestBusinessSite = 'JOB_REQUEST_BUSINESS_SITE',
  JobRequestCancellationComment = 'JOB_REQUEST_CANCELLATION_COMMENT',
  JobRequestCancellationReason = 'JOB_REQUEST_CANCELLATION_REASON',
  JobRequestCancelledBy = 'JOB_REQUEST_CANCELLED_BY',
  JobRequestCancelledDate = 'JOB_REQUEST_CANCELLED_DATE',
  JobRequestClassification = 'JOB_REQUEST_CLASSIFICATION',
  JobRequestComments = 'JOB_REQUEST_COMMENTS',
  JobRequestCompany = 'JOB_REQUEST_COMPANY',
  JobRequestCostCenter = 'JOB_REQUEST_COST_CENTER',
  JobRequestCurrencyCode = 'JOB_REQUEST_CURRENCY_CODE',
  JobRequestDates = 'JOB_REQUEST_DATES',
  JobRequestEstimatedAdditionalCosts = 'JOB_REQUEST_ESTIMATED_ADDITIONAL_COSTS',
  JobRequestExternalDescription = 'JOB_REQUEST_EXTERNAL_DESCRIPTION',
  JobRequestExternalTitle = 'JOB_REQUEST_EXTERNAL_TITLE',
  JobRequestHiringManager = 'JOB_REQUEST_HIRING_MANAGER',
  JobRequestHolidaySchedule = 'JOB_REQUEST_HOLIDAY_SCHEDULE',
  JobRequestJobApplicationSmartForm = 'JOB_REQUEST_JOB_APPLICATION_SMART_FORM',
  JobRequestJobFamily = 'JOB_REQUEST_JOB_FAMILY',
  JobRequestJobProfile = 'JOB_REQUEST_JOB_PROFILE',
  JobRequestJobSummary = 'JOB_REQUEST_JOB_SUMMARY',
  JobRequestMaximumBillRate = 'JOB_REQUEST_MAXIMUM_BILL_RATE',
  JobRequestMaximumPayRate = 'JOB_REQUEST_MAXIMUM_PAY_RATE',
  JobRequestMinimumBillRate = 'JOB_REQUEST_MINIMUM_BILL_RATE',
  JobRequestMinimumPayRate = 'JOB_REQUEST_MINIMUM_PAY_RATE',
  JobRequestMsp = 'JOB_REQUEST_MSP',
  JobRequestPayRate = 'JOB_REQUEST_PAY_RATE',
  JobRequestPrimaryExternalApprover = 'JOB_REQUEST_PRIMARY_EXTERNAL_APPROVER',
  JobRequestProjectedCost = 'JOB_REQUEST_PROJECTED_COST',
  JobRequestRate = 'JOB_REQUEST_RATE',
  JobRequestRateCurrency = 'JOB_REQUEST_RATE_CURRENCY',
  JobRequestRatePeriod = 'JOB_REQUEST_RATE_PERIOD',
  JobRequestRateType = 'JOB_REQUEST_RATE_TYPE',
  JobRequestRemoteWorkAddress = 'JOB_REQUEST_REMOTE_WORK_ADDRESS',
  JobRequestRequestedWorkers = 'JOB_REQUEST_REQUESTED_WORKERS',
  JobRequestSeniority = 'JOB_REQUEST_SENIORITY',
  JobRequestSourcingType = 'JOB_REQUEST_SOURCING_TYPE',
  JobRequestSummary = 'JOB_REQUEST_SUMMARY',
  JobRequestSupervisoryOrg = 'JOB_REQUEST_SUPERVISORY_ORG',
  JobRequestSuppliers = 'JOB_REQUEST_SUPPLIERS',
  JobRequestSupplierGroupInstance = 'JOB_REQUEST_SUPPLIER_GROUP_INSTANCE',
  JobRequestTimesheetView = 'JOB_REQUEST_TIMESHEET_VIEW',
  JobRequestWorkingHoursPerWeek = 'JOB_REQUEST_WORKING_HOURS_PER_WEEK',
  JobRequestWorkRequest = 'JOB_REQUEST_WORK_REQUEST',
  JobRequestWorkSchedule = 'JOB_REQUEST_WORK_SCHEDULE',
  Location = 'LOCATION',
  LocationAssignable = 'LOCATION_ASSIGNABLE',
  Milestone = 'MILESTONE',
  MilestoneAcceptanceCriteria = 'MILESTONE_ACCEPTANCE_CRITERIA',
  MilestoneAmount = 'MILESTONE_AMOUNT',
  MilestoneApprovedDateTime = 'MILESTONE_APPROVED_DATE_TIME',
  MilestoneApprover = 'MILESTONE_APPROVER',
  MilestoneAttachments = 'MILESTONE_ATTACHMENTS',
  MilestoneComment = 'MILESTONE_COMMENT',
  MilestoneCompletedDate = 'MILESTONE_COMPLETED_DATE',
  MilestoneContract = 'MILESTONE_CONTRACT',
  MilestoneCostCenter = 'MILESTONE_COST_CENTER',
  MilestoneCurrency = 'MILESTONE_CURRENCY',
  MilestoneDeliveryLocation = 'MILESTONE_DELIVERY_LOCATION',
  MilestoneDescription = 'MILESTONE_DESCRIPTION',
  MilestoneDueDate = 'MILESTONE_DUE_DATE',
  MilestoneExternalInvoiceDate = 'MILESTONE_EXTERNAL_INVOICE_DATE',
  MilestoneExternalInvoiceId = 'MILESTONE_EXTERNAL_INVOICE_ID',
  MilestoneName = 'MILESTONE_NAME',
  MilestoneSubmitter = 'MILESTONE_SUBMITTER',
  MonitoringImportLogs = 'MONITORING_IMPORT_LOGS',
  MonitoringUserActivities = 'MONITORING_USER_ACTIVITIES',
  MonitoringWorkdayTimeAllocationImport = 'MONITORING_WORKDAY_TIME_ALLOCATION_IMPORT',
  Msp = 'MSP',
  MspContact = 'MSP_CONTACT',
  NotificationHubSettings = 'NOTIFICATION_HUB_SETTINGS',
  Org = 'ORG',
  OrgLocation = 'ORG_LOCATION',
  OrgManager = 'ORG_MANAGER',
  OrgMembers = 'ORG_MEMBERS',
  OrgName = 'ORG_NAME',
  OrgParent = 'ORG_PARENT',
  ParentSupplier = 'PARENT_SUPPLIER',
  Payment = 'PAYMENT',
  Person = 'PERSON',
  PersonAddress = 'PERSON_ADDRESS',
  PersonApprovalLimits = 'PERSON_APPROVAL_LIMITS',
  PersonCitizenship = 'PERSON_CITIZENSHIP',
  PersonCompanyWorkerId = 'PERSON_COMPANY_WORKER_ID',
  PersonCountryOfBirth = 'PERSON_COUNTRY_OF_BIRTH',
  PersonDateOfBirth = 'PERSON_DATE_OF_BIRTH',
  PersonDemographics = 'PERSON_DEMOGRAPHICS',
  PersonEmail = 'PERSON_EMAIL',
  PersonEmergencyContact = 'PERSON_EMERGENCY_CONTACT',
  PersonGender = 'PERSON_GENDER',
  PersonGlobalId = 'PERSON_GLOBAL_ID',
  PersonHighestLevelOfEducation = 'PERSON_HIGHEST_LEVEL_OF_EDUCATION',
  PersonInviteWorker = 'PERSON_INVITE_WORKER',
  PersonLinkedPersons = 'PERSON_LINKED_PERSONS',
  PersonModified = 'PERSON_MODIFIED',
  PersonName = 'PERSON_NAME',
  PersonNationalId = 'PERSON_NATIONAL_ID',
  PersonNationalIdMasked = 'PERSON_NATIONAL_ID_MASKED',
  PersonOrgMembership = 'PERSON_ORG_MEMBERSHIP',
  PersonPersonalEmail = 'PERSON_PERSONAL_EMAIL',
  PersonPhoneNumber = 'PERSON_PHONE_NUMBER',
  PersonPrimaryManager = 'PERSON_PRIMARY_MANAGER',
  PersonProfilePhoto = 'PERSON_PROFILE_PHOTO',
  PersonRehireEligibility = 'PERSON_REHIRE_ELIGIBILITY',
  PersonRescindWorkdayData = 'PERSON_RESCIND_WORKDAY_DATA',
  PersonSetPrimaryEngagement = 'PERSON_SET_PRIMARY_ENGAGEMENT',
  PersonTenure = 'PERSON_TENURE',
  PersonTitle = 'PERSON_TITLE',
  PersonUserStatus = 'PERSON_USER_STATUS',
  PersonWorkdayApplicantId = 'PERSON_WORKDAY_APPLICANT_ID',
  PersonWorkdayWorkerId = 'PERSON_WORKDAY_WORKER_ID',
  PersonWorkerDuplicates = 'PERSON_WORKER_DUPLICATES',
  PolicyRule = 'POLICY_RULE',
  Process = 'PROCESS',
  ProcessDefinition = 'PROCESS_DEFINITION',
  Project = 'PROJECT',
  ProjectCustomer = 'PROJECT_CUSTOMER',
  ProjectPlan = 'PROJECT_PLAN',
  ProjectPosition = 'PROJECT_POSITION',
  ProjectPositionTaskMapping = 'PROJECT_POSITION_TASK_MAPPING',
  ProjectRole = 'PROJECT_ROLE',
  ProxyUser = 'PROXY_USER',
  RateCard = 'RATE_CARD',
  Recipe = 'RECIPE',
  RecommendationDefinition = 'RECOMMENDATION_DEFINITION',
  ReferenceData = 'REFERENCE_DATA',
  RetroactiveChange = 'RETROACTIVE_CHANGE',
  Role = 'ROLE',
  RoleAssignment = 'ROLE_ASSIGNMENT',
  Root = 'ROOT',
  Seniority = 'SENIORITY',
  SequenceGenerator = 'SEQUENCE_GENERATOR',
  SettingsAnomalies = 'SETTINGS_ANOMALIES',
  SettingsClassification = 'SETTINGS_CLASSIFICATION',
  SettingsClientIds = 'SETTINGS_CLIENT_IDS',
  SettingsComplianceAndRisks = 'SETTINGS_COMPLIANCE_AND_RISKS',
  SettingsConfiguration = 'SETTINGS_CONFIGURATION',
  SettingsConnectResources = 'SETTINGS_CONNECT_RESOURCES',
  SettingsCustomFields = 'SETTINGS_CUSTOM_FIELDS',
  SettingsEngagements = 'SETTINGS_ENGAGEMENTS',
  SettingsEnterprise = 'SETTINGS_ENTERPRISE',
  SettingsFinancialFields = 'SETTINGS_FINANCIAL_FIELDS',
  SettingsIntegrations = 'SETTINGS_INTEGRATIONS',
  SettingsLocation = 'SETTINGS_LOCATION',
  SettingsPermissions = 'SETTINGS_PERMISSIONS',
  SettingsSftp = 'SETTINGS_SFTP',
  SettingsSmartForms = 'SETTINGS_SMART_FORMS',
  SettingsSourcing = 'SETTINGS_SOURCING',
  SettingsSpend = 'SETTINGS_SPEND',
  SettingsSso = 'SETTINGS_SSO',
  SettingsSystemActivities = 'SETTINGS_SYSTEM_ACTIVITIES',
  SettingsUser = 'SETTINGS_USER',
  Sftp = 'SFTP',
  SftpDirectory = 'SFTP_DIRECTORY',
  SftpUser = 'SFTP_USER',
  SmartFormDefinition = 'SMART_FORM_DEFINITION',
  SmartFormDefinitionExport = 'SMART_FORM_DEFINITION_EXPORT',
  SmartFormDefinitionImport = 'SMART_FORM_DEFINITION_IMPORT',
  SowResponse = 'SOW_RESPONSE',
  SowResponseAccountablePerson = 'SOW_RESPONSE_ACCOUNTABLE_PERSON',
  SowResponseCompany = 'SOW_RESPONSE_COMPANY',
  SowResponseContact = 'SOW_RESPONSE_CONTACT',
  SowResponseCostCenter = 'SOW_RESPONSE_COST_CENTER',
  SowResponseSupplier = 'SOW_RESPONSE_SUPPLIER',
  SshKey = 'SSH_KEY',
  SubSuppliers = 'SUB_SUPPLIERS',
  Supplier = 'SUPPLIER',
  SupplierAggregateActiveWorkerCount = 'SUPPLIER_AGGREGATE_ACTIVE_WORKER_COUNT',
  SupplierAggregateInactiveWorkerCount = 'SUPPLIER_AGGREGATE_INACTIVE_WORKER_COUNT',
  SupplierAppUsers = 'SUPPLIER_APP_USERS',
  SupplierBoxUploadEmail = 'SUPPLIER_BOX_UPLOAD_EMAIL',
  SupplierContacts = 'SUPPLIER_CONTACTS',
  SupplierDescription = 'SUPPLIER_DESCRIPTION',
  SupplierGeneralContact = 'SUPPLIER_GENERAL_CONTACT',
  SupplierGroup = 'SUPPLIER_GROUP',
  SupplierGroupBusinessSites = 'SUPPLIER_GROUP_BUSINESS_SITES',
  SupplierGroupClassifications = 'SUPPLIER_GROUP_CLASSIFICATIONS',
  SupplierGroupDescription = 'SUPPLIER_GROUP_DESCRIPTION',
  SupplierGroupInstance = 'SUPPLIER_GROUP_INSTANCE',
  SupplierGroupInstanceBusinessSites = 'SUPPLIER_GROUP_INSTANCE_BUSINESS_SITES',
  SupplierGroupInstanceClassifications = 'SUPPLIER_GROUP_INSTANCE_CLASSIFICATIONS',
  SupplierGroupInstanceDescription = 'SUPPLIER_GROUP_INSTANCE_DESCRIPTION',
  SupplierGroupInstanceJobFamilyGroups = 'SUPPLIER_GROUP_INSTANCE_JOB_FAMILY_GROUPS',
  SupplierGroupInstanceName = 'SUPPLIER_GROUP_INSTANCE_NAME',
  SupplierGroupInstanceReferenceId = 'SUPPLIER_GROUP_INSTANCE_REFERENCE_ID',
  SupplierGroupInstanceStatus = 'SUPPLIER_GROUP_INSTANCE_STATUS',
  SupplierGroupInstanceTiers = 'SUPPLIER_GROUP_INSTANCE_TIERS',
  SupplierGroupJobFamilyGroups = 'SUPPLIER_GROUP_JOB_FAMILY_GROUPS',
  SupplierGroupName = 'SUPPLIER_GROUP_NAME',
  SupplierGroupReferenceId = 'SUPPLIER_GROUP_REFERENCE_ID',
  SupplierGroupStatus = 'SUPPLIER_GROUP_STATUS',
  SupplierGroupTiers = 'SUPPLIER_GROUP_TIERS',
  SupplierId = 'SUPPLIER_ID',
  SupplierInsuranceInfo = 'SUPPLIER_INSURANCE_INFO',
  SupplierInvitationStatus = 'SUPPLIER_INVITATION_STATUS',
  SupplierLegalInfo = 'SUPPLIER_LEGAL_INFO',
  SupplierLogo = 'SUPPLIER_LOGO',
  SupplierMetadata = 'SUPPLIER_METADATA',
  SupplierMsp = 'SUPPLIER_MSP',
  SupplierName = 'SUPPLIER_NAME',
  SupplierPayments = 'SUPPLIER_PAYMENTS',
  SupplierPaymentTerms = 'SUPPLIER_PAYMENT_TERMS',
  SupplierSpendSummary = 'SUPPLIER_SPEND_SUMMARY',
  SupplierStatus = 'SUPPLIER_STATUS',
  SupplierTaxInfo = 'SUPPLIER_TAX_INFO',
  SupplierTier = 'SUPPLIER_TIER',
  SupplierTierInstance = 'SUPPLIER_TIER_INSTANCE',
  SupplierTierInstanceOrder = 'SUPPLIER_TIER_INSTANCE_ORDER',
  SupplierTierInstanceRule = 'SUPPLIER_TIER_INSTANCE_RULE',
  SupplierTierInstanceStatus = 'SUPPLIER_TIER_INSTANCE_STATUS',
  SupplierTierInstanceSuppliers = 'SUPPLIER_TIER_INSTANCE_SUPPLIERS',
  SupplierTierOrder = 'SUPPLIER_TIER_ORDER',
  SupplierTierRule = 'SUPPLIER_TIER_RULE',
  SupplierTierSuppliers = 'SUPPLIER_TIER_SUPPLIERS',
  SupplierType = 'SUPPLIER_TYPE',
  SupplierWebsite = 'SUPPLIER_WEBSITE',
  SystemActivity = 'SYSTEM_ACTIVITY',
  Tag = 'TAG',
  TaskDelegation = 'TASK_DELEGATION',
  TenantConfig = 'TENANT_CONFIG',
  TenantSecrets = 'TENANT_SECRETS',
  TerminateProcess = 'TERMINATE_PROCESS',
  TerminationReason = 'TERMINATION_REASON',
  Timesheet = 'TIMESHEET',
  TimesheetAmount = 'TIMESHEET_AMOUNT',
  TimesheetHours = 'TIMESHEET_HOURS',
  TimesheetRule = 'TIMESHEET_RULE',
  TimesheetSettings = 'TIMESHEET_SETTINGS',
  TimesheetStatus = 'TIMESHEET_STATUS',
  TimesheetTimeAllocations = 'TIMESHEET_TIME_ALLOCATIONS',
  TimeCode = 'TIME_CODE',
  UcTransformOutput = 'UC_TRANSFORM_OUTPUT',
  UkgImport = 'UKG_IMPORT',
  User = 'USER',
  UserLastLogin = 'USER_LAST_LOGIN',
  UserMsp = 'USER_MSP',
  Widgets = 'WIDGETS',
  WidgetActiveWorkersChart = 'WIDGET_ACTIVE_WORKERS_CHART',
  WidgetContingentWorkersClassificationPie = 'WIDGET_CONTINGENT_WORKERS_CLASSIFICATION_PIE',
  WidgetContingentWorkersLocationMap = 'WIDGET_CONTINGENT_WORKERS_LOCATION_MAP',
  WidgetHeadcount = 'WIDGET_HEADCOUNT',
  WidgetJoinersAndLeavers = 'WIDGET_JOINERS_AND_LEAVERS',
  WidgetMyOrganizationChart = 'WIDGET_MY_ORGANIZATION_CHART',
  WidgetMyTasksList = 'WIDGET_MY_TASKS_LIST',
  WidgetProgramAlerts = 'WIDGET_PROGRAM_ALERTS',
  WidgetQuickActions = 'WIDGET_QUICK_ACTIONS',
  WidgetRecentExports = 'WIDGET_RECENT_EXPORTS',
  WidgetSettings = 'WIDGET_SETTINGS',
  WidgetSuppliers = 'WIDGET_SUPPLIERS',
  WidgetTimeToFillCount = 'WIDGET_TIME_TO_FILL_COUNT',
  WidgetViewHistory = 'WIDGET_VIEW_HISTORY',
  WorkdayDiff = 'WORKDAY_DIFF',
  WorkdayImport = 'WORKDAY_IMPORT',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkCalendar = 'WORK_CALENDAR',
  WorkRequest = 'WORK_REQUEST',
  WorkRequestAccountablePerson = 'WORK_REQUEST_ACCOUNTABLE_PERSON',
  WorkRequestApprovedDate = 'WORK_REQUEST_APPROVED_DATE',
  WorkRequestApprover = 'WORK_REQUEST_APPROVER',
  WorkRequestBusinessSite = 'WORK_REQUEST_BUSINESS_SITE',
  WorkRequestCompany = 'WORK_REQUEST_COMPANY',
  WorkRequestCost = 'WORK_REQUEST_COST',
  WorkRequestCostCenter = 'WORK_REQUEST_COST_CENTER',
  WorkRequestDescription = 'WORK_REQUEST_DESCRIPTION',
  WorkRequestHolidaySchedule = 'WORK_REQUEST_HOLIDAY_SCHEDULE',
  WorkRequestMsp = 'WORK_REQUEST_MSP',
  WorkRequestPoNumber = 'WORK_REQUEST_PO_NUMBER',
  WorkRequestReason = 'WORK_REQUEST_REASON',
  WorkRequestRemoteWorkAddress = 'WORK_REQUEST_REMOTE_WORK_ADDRESS',
  WorkRequestSupervisoryOrg = 'WORK_REQUEST_SUPERVISORY_ORG',
  WorkRequestTitle = 'WORK_REQUEST_TITLE',
  WorkRequestTotalBudget = 'WORK_REQUEST_TOTAL_BUDGET',
  WorkRequestWorkLocationType = 'WORK_REQUEST_WORK_LOCATION_TYPE',
  WorkRequestWorkSchedule = 'WORK_REQUEST_WORK_SCHEDULE',
  WorkSchedule = 'WORK_SCHEDULE',
  WorkScheduleConfiguration = 'WORK_SCHEDULE_CONFIGURATION'
}

export type PermissionNameModel = {
  __typename?: 'PermissionNameModel';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<PermissionName>;
  path?: Maybe<Scalars['String']['output']>;
};

export enum PermissionRelationship {
  AccountablePersonOf = 'ACCOUNTABLE_PERSON_OF',
  Creator = 'CREATOR',
  InOrgWith = 'IN_ORG_WITH',
  ManagerOf = 'MANAGER_OF',
  MspFor = 'MSP_FOR',
  PrimaryManagerOf = 'PRIMARY_MANAGER_OF',
  ProjectController = 'PROJECT_CONTROLLER',
  ProjectManager = 'PROJECT_MANAGER',
  Self = 'SELF',
  SupplierFor = 'SUPPLIER_FOR',
  TaskAssigneeFor = 'TASK_ASSIGNEE_FOR'
}

export type PersonApprovalLimitsModel = {
  __typename?: 'PersonApprovalLimitsModel';
  approvalLimits?: Maybe<Array<Maybe<ApprovalLimitModel>>>;
};

export type PersonDemographicsModel = {
  __typename?: 'PersonDemographicsModel';
  disability?: Maybe<PersonDisabilityModel>;
  ethnicities?: Maybe<Array<Maybe<EthnicityModel>>>;
  gender?: Maybe<GwgGenderModel>;
  militaryAffiliation?: Maybe<MilitaryAffiliationModel>;
  nationality?: Maybe<CountryModel>;
  sexualOrientation?: Maybe<SexualOrientationModel>;
  transgenderStatus?: Maybe<TransgenderStatusModel>;
};

export type PersonDemographicsModelInput = {
  disability?: InputMaybe<PersonDisabilityModel>;
  ethnicities?: InputMaybe<Array<InputMaybe<EthnicityModel>>>;
  gender?: InputMaybe<GwgGenderModel>;
  militaryAffiliation?: InputMaybe<MilitaryAffiliationModel>;
  nationality?: InputMaybe<CountryModelInput>;
  sexualOrientation?: InputMaybe<SexualOrientationModel>;
  transgenderStatus?: InputMaybe<TransgenderStatusModel>;
};

export type PersonDiagnosticsModel = {
  __typename?: 'PersonDiagnosticsModel';
  companyWorkerId?: Maybe<Scalars['Long']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  entityVersion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryEngagementUid?: Maybe<Scalars['String']['output']>;
  primaryPersonUid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  workdayApplicantId?: Maybe<Scalars['String']['output']>;
  workdaySyncStatus?: Maybe<Scalars['String']['output']>;
  workdayUserUid?: Maybe<Scalars['String']['output']>;
  workdayUsername?: Maybe<Scalars['String']['output']>;
  workerProfileUid?: Maybe<Scalars['String']['output']>;
};

export enum PersonDisabilityModel {
  No = 'NO',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  Yes = 'YES'
}

export type PersonFacetsDiagnosticsModel = {
  __typename?: 'PersonFacetsDiagnosticsModel';
  entityVersion?: Maybe<Scalars['Int']['output']>;
  personFacetModel?: Maybe<BasePersonFacetDiagnosticsModel>;
};

export type PersonFacetsRevisionsDiagnosticsModel = {
  __typename?: 'PersonFacetsRevisionsDiagnosticsModel';
  personFacetModel?: Maybe<BasePersonFacetDiagnosticsModel>;
  rev?: Maybe<Scalars['Long']['output']>;
  revType?: Maybe<RevType>;
};

export type PersonImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type PersonModel = {
  __typename?: 'PersonModel';
  address?: Maybe<AddressModel>;
  approvalLimits?: Maybe<Array<Maybe<ApprovalLimitModel>>>;
  citizenships?: Maybe<Array<Maybe<CitizenshipModel>>>;
  closedEngagements?: Maybe<Array<Maybe<EngagementModel>>>;
  companyWorkerId?: Maybe<UserStringAttributeModel>;
  contingentType?: Maybe<ContingentTypeModel>;
  contractUid?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<CountryModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  currentEngagements?: Maybe<Array<Maybe<EngagementModel>>>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  dateOfBirth?: Maybe<UserDateAttributeModel>;
  deliveredFieldDefinitions?: Maybe<Scalars['Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar']['output']>;
  /** @deprecated Replaced with engagement.directReportsCount */
  directReportsCount?: Maybe<Scalars['Int']['output']>;
  draftEngagements?: Maybe<Array<Maybe<EngagementModel>>>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyContactDetails?: Maybe<EmergencyContactModel>;
  engagements?: Maybe<Array<Maybe<EngagementModel>>>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  formerContingent?: Maybe<Scalars['Boolean']['output']>;
  formerEmployee?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use personName instead */
  fullName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favour of genderModel */
  gender?: Maybe<Scalars['String']['output']>;
  genderModel?: Maybe<GenderModel>;
  globalId?: Maybe<Scalars['String']['output']>;
  globalIdDuplicatePersonUid?: Maybe<Scalars['String']['output']>;
  hasAtLeastOneActiveEngagement?: Maybe<Scalars['Boolean']['output']>;
  hasProfilePhoto?: Maybe<Scalars['Boolean']['output']>;
  highestLevelOfEducation?: Maybe<HighestLevelOfEducationModel>;
  hiringManagerId?: Maybe<UserStringAttributeModel>;
  lastLogin?: Maybe<UserDateTimeAttributeModel>;
  legacyCompany?: Maybe<UserStringAttributeModel>;
  /** @deprecated Replaced with engagement.managingOrgs */
  managingOrgs?: Maybe<Array<Maybe<OrgModel>>>;
  managingSources?: Maybe<Array<Maybe<EngagementManagingSourceModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<NameModel>;
  nationalIds?: Maybe<Array<Maybe<NationalIdModel>>>;
  nationalIdsMasked?: Maybe<Array<Maybe<NationalIdMaskedModel>>>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  personName?: Maybe<PersonNameModel>;
  personStatus?: Maybe<PersonStatusModel>;
  personUid?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumberModel>;
  primaryEngagement?: Maybe<EngagementModel>;
  /** @deprecated Replaced with engagement.primaryManager */
  primaryManager?: Maybe<PersonModel>;
  /** @deprecated Replaced with engagement.primaryOrg */
  primaryOrg?: Maybe<OrgModel>;
  primaryPerson?: Maybe<PersonModel>;
  /** @deprecated Replaced with engagement.primarySubordinates */
  primarySubordinates?: Maybe<Array<Maybe<PersonModel>>>;
  profilePhoto?: Maybe<MediaModel>;
  rehireEligibility?: Maybe<Scalars['String']['output']>;
  secondaryPersonModels?: Maybe<Array<Maybe<SecondaryPersonModel>>>;
  skills?: Maybe<Array<Maybe<SkillModel>>>;
  /** @deprecated FE has no need to know this - check permissions instead */
  sources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated use user.status instead */
  status?: Maybe<UserStatusModel>;
  talentAppDemographics?: Maybe<PersonDemographicsModel>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenureDuration?: Maybe<TenureDurationModel>;
  tenureStartDate?: Maybe<Scalars['LocalDate']['output']>;
  /** @deprecated Replaced with engagement.title */
  title?: Maybe<UserStringAttributeModel>;
  /** @deprecated Replaced with engagement.totalReportsCount */
  totalReportsCount?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user?: Maybe<UserModel>;
  userRole?: Maybe<UserRoleModel>;
  userUid?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<EngagementWorkLocationModel>;
  workdayApplicantId?: Maybe<Scalars['String']['output']>;
  /** @deprecated FE has no need to know this - check permissions instead */
  workdayUser?: Maybe<Scalars['Boolean']['output']>;
  workdayWorkerId?: Maybe<Scalars['String']['output']>;
  workerDuplicates?: Maybe<Array<Maybe<WorkerDuplicateModel>>>;
  /** @deprecated Replaced with engagement.location */
  workerLocation?: Maybe<LocationModel>;
  workerProfileUid?: Maybe<Scalars['String']['output']>;
};


export type PersonModelCurrentEngagementsArgs = {
  q?: InputMaybe<EngagementsQueryModelInput>;
};


export type PersonModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PersonModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PersonModelDraftEngagementsArgs = {
  q?: InputMaybe<EngagementsQueryModelInput>;
};


export type PersonModelEngagementsArgs = {
  q?: InputMaybe<EngagementsQueryModelInput>;
};


export type PersonModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PersonModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonModelPrimarySubordinatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonModelInput = {
  address?: InputMaybe<AddressModelInput>;
  approvalLimits?: InputMaybe<Array<InputMaybe<ApprovalLimitModelInput>>>;
  citizenships?: InputMaybe<Array<InputMaybe<CitizenshipModelInput>>>;
  closedEngagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  companyWorkerId?: InputMaybe<UserStringAttributeModelInput>;
  contingentType?: InputMaybe<ContingentTypeModel>;
  contractUid?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<CountryModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  currentEngagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  dateOfBirth?: InputMaybe<UserDateAttributeModelInput>;
  deliveredFieldDefinitions?: InputMaybe<Scalars['DeliveredFieldDefinitionsModelScalar']['input']>;
  directReportsCount?: InputMaybe<Scalars['Int']['input']>;
  draftEngagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactDetails?: InputMaybe<EmergencyContactModelInput>;
  engagements?: InputMaybe<Array<InputMaybe<EngagementModelInput>>>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  formerContingent?: InputMaybe<Scalars['Boolean']['input']>;
  formerEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  genderModel?: InputMaybe<GenderModelInput>;
  globalId?: InputMaybe<Scalars['String']['input']>;
  globalIdDuplicatePersonUid?: InputMaybe<Scalars['String']['input']>;
  hasAtLeastOneActiveEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  highestLevelOfEducation?: InputMaybe<HighestLevelOfEducationModel>;
  hiringManagerId?: InputMaybe<UserStringAttributeModelInput>;
  lastLogin?: InputMaybe<UserDateTimeAttributeModelInput>;
  legacyCompany?: InputMaybe<UserStringAttributeModelInput>;
  managingOrgs?: InputMaybe<Array<InputMaybe<OrgModelInput>>>;
  managingSources?: InputMaybe<Array<InputMaybe<EngagementManagingSourceModel>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<NameModelInput>;
  nationalIds?: InputMaybe<Array<InputMaybe<NationalIdModelInput>>>;
  nationalIdsMasked?: InputMaybe<Array<InputMaybe<NationalIdMaskedModelInput>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  personName?: InputMaybe<PersonNameModelInput>;
  personStatus?: InputMaybe<PersonStatusModel>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  primaryEngagement?: InputMaybe<EngagementModelInput>;
  primaryManager?: InputMaybe<PersonModelInput>;
  primaryOrg?: InputMaybe<OrgModelInput>;
  primaryPerson?: InputMaybe<PersonModelInput>;
  primarySubordinates?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  profilePhoto?: InputMaybe<MediaModelInput>;
  rehireEligibility?: InputMaybe<Scalars['String']['input']>;
  secondaryPersonModels?: InputMaybe<Array<InputMaybe<SecondaryPersonModelInput>>>;
  skills?: InputMaybe<Array<InputMaybe<SkillModelInput>>>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<UserStatusModel>;
  talentAppDemographics?: InputMaybe<PersonDemographicsModelInput>;
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  tenureDuration?: InputMaybe<TenureDurationModelInput>;
  tenureStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  title?: InputMaybe<UserStringAttributeModelInput>;
  totalReportsCount?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserModelInput>;
  userRole?: InputMaybe<UserRoleModel>;
  userUid?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<EngagementWorkLocationModelInput>;
  workdayApplicantId?: InputMaybe<Scalars['String']['input']>;
  workdayUser?: InputMaybe<Scalars['Boolean']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
  workerDuplicates?: InputMaybe<Array<InputMaybe<WorkerDuplicateModelInput>>>;
  workerLocation?: InputMaybe<LocationModelInput>;
  workerProfileUid?: InputMaybe<Scalars['String']['input']>;
};

export type PersonNameModel = {
  __typename?: 'PersonNameModel';
  fullName?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<NameDetailsModel>;
  preferredName?: Maybe<NameDetailsModel>;
};

export type PersonNameModelInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<NameDetailsModelInput>;
  preferredName?: InputMaybe<NameDetailsModelInput>;
};

export type PersonRevisionModel = RevisionModel & {
  __typename?: 'PersonRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  person?: Maybe<PersonModel>;
  previousPerson?: Maybe<PersonModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type PersonSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<PersonSortTypeModel>;
};

export enum PersonSortTypeModel {
  Company = 'COMPANY',
  ContractEnding = 'CONTRACT_ENDING',
  ContractStarted = 'CONTRACT_STARTED',
  CostCenter = 'COST_CENTER',
  CurrentEngagementsCount = 'CURRENT_ENGAGEMENTS_COUNT',
  JobProfile = 'JOB_PROFILE',
  LastLogin = 'LAST_LOGIN',
  LastModifiedTime = 'LAST_MODIFIED_TIME',
  Location = 'LOCATION',
  Name = 'NAME',
  Org = 'ORG',
  PreviousEngagementsCount = 'PREVIOUS_ENGAGEMENTS_COUNT',
  Supplier = 'SUPPLIER',
  TenureDuration = 'TENURE_DURATION',
  TenureStartDate = 'TENURE_START_DATE',
  UnclaimedProfile = 'UNCLAIMED_PROFILE',
  UserRole = 'USER_ROLE',
  WorkerId = 'WORKER_ID',
  WorkerType = 'WORKER_TYPE'
}

export enum PersonStatusModel {
  Active = 'ACTIVE',
  ActiveHidden = 'ACTIVE_HIDDEN',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Secondary = 'SECONDARY'
}

export type PersonSuggestionModel = SuggestionModel & {
  __typename?: 'PersonSuggestionModel';
  companyWorkerId?: Maybe<Scalars['String']['output']>;
  engagementUid?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  managingOrgUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  personUid?: Maybe<Scalars['String']['output']>;
  primaryOrgName?: Maybe<Scalars['String']['output']>;
  primaryOrgUid?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type PersonWorkerDuplicateSelectedModelInput = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumberModel = {
  __typename?: 'PhoneNumberModel';
  areaCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  deliveredFieldDefinitions?: Maybe<Scalars['Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  e164Number?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  extension?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Only one device type is supported now */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberModelInput = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  deliveredFieldDefinitions?: InputMaybe<Scalars['DeliveredFieldDefinitionsModelScalar']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  e164Number?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum PolicyGroupCategoryModel {
  Administration = 'ADMINISTRATION',
  AllTasks = 'ALL_TASKS',
  BusinessEvent = 'BUSINESS_EVENT',
  BusinessEventReason = 'BUSINESS_EVENT_REASON',
  ComplianceDefinition = 'COMPLIANCE_DEFINITION',
  ComplianceInstance = 'COMPLIANCE_INSTANCE',
  Contract = 'CONTRACT',
  Dashboards = 'DASHBOARDS',
  DataExtract = 'DATA_EXTRACT',
  DecisionTableDefinition = 'DECISION_TABLE_DEFINITION',
  EligibilityRequirement = 'ELIGIBILITY_REQUIREMENT',
  Engagement = 'ENGAGEMENT',
  Expense = 'EXPENSE',
  FieldConstraintDefinition = 'FIELD_CONSTRAINT_DEFINITION',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobPosting = 'JOB_POSTING',
  Milestone = 'MILESTONE',
  Msp = 'MSP',
  NotificationHubSettings = 'NOTIFICATION_HUB_SETTINGS',
  Payment = 'PAYMENT',
  ProcessDefinition = 'PROCESS_DEFINITION',
  ProcessInstance = 'PROCESS_INSTANCE',
  Project = 'PROJECT',
  Recipe = 'RECIPE',
  ReferenceData = 'REFERENCE_DATA',
  Sftp = 'SFTP',
  Sow = 'SOW',
  Supplier = 'SUPPLIER',
  SupplierGroup = 'SUPPLIER_GROUP',
  SupplierGroupInstance = 'SUPPLIER_GROUP_INSTANCE',
  Tag = 'TAG',
  TaskDelegation = 'TASK_DELEGATION',
  Timesheet = 'TIMESHEET',
  TimesheetRule = 'TIMESHEET_RULE',
  User = 'USER',
  Widgets = 'WIDGETS',
  WidgetSettings = 'WIDGET_SETTINGS',
  Worker = 'WORKER',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkRequest = 'WORK_REQUEST'
}

export type PolicyGroupModel = {
  __typename?: 'PolicyGroupModel';
  category?: Maybe<PolicyGroupCategoryModel>;
  relationships?: Maybe<Array<Maybe<AllowedRelationshipModel>>>;
  resources?: Maybe<Array<Maybe<ResourceMetadataModel>>>;
};

export type PolicyGroupModelInput = {
  category?: InputMaybe<PolicyGroupCategoryModel>;
  relationships?: InputMaybe<Array<InputMaybe<AllowedRelationshipModel>>>;
  resources?: InputMaybe<Array<InputMaybe<ResourceMetadataModelInput>>>;
};

export type PolicyGroupsModel = {
  __typename?: 'PolicyGroupsModel';
  groups?: Maybe<Array<Maybe<PolicyGroupModel>>>;
};

export type PolicyRuleDuplicateModelInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyRuleExclusionModel = {
  __typename?: 'PolicyRuleExclusionModel';
  resource?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PolicyRuleExclusionTypeModel>;
};

export type PolicyRuleExclusionModelInput = {
  resource?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PolicyRuleExclusionTypeModel>;
};

export enum PolicyRuleExclusionTypeModel {
  Subtree = 'SUBTREE'
}

export enum PolicyRuleKindModel {
  Deny = 'DENY',
  Standard = 'STANDARD'
}

export type PolicyRuleModel = {
  __typename?: 'PolicyRuleModel';
  actions?: Maybe<Array<Maybe<PermissionAction>>>;
  actorClassificationUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actorIsManager?: Maybe<Scalars['Boolean']['output']>;
  actorLocationUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actorOrgRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actorOrgUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actorRelationships?: Maybe<Array<Maybe<PermissionRelationship>>>;
  actorUserRoles?: Maybe<Array<Maybe<UserRoleModel>>>;
  actorUserUid?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exclusions?: Maybe<Array<Maybe<PolicyRuleExclusionModel>>>;
  groups?: Maybe<Array<Maybe<PolicyGroupModel>>>;
  invalidCondition?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  permissionNames?: Maybe<Array<Maybe<PermissionName>>>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  resourceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleRelationships?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<PolicyRuleStatusModel>;
  systemKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type PolicyRuleModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PolicyRuleModelInput = {
  actions?: InputMaybe<Array<InputMaybe<PermissionAction>>>;
  actorClassificationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actorIsManager?: InputMaybe<Scalars['Boolean']['input']>;
  actorLocationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actorOrgRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actorOrgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actorRelationships?: InputMaybe<Array<InputMaybe<PermissionRelationship>>>;
  actorUserRoles?: InputMaybe<Array<InputMaybe<UserRoleModel>>>;
  actorUserUid?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exclusions?: InputMaybe<Array<InputMaybe<PolicyRuleExclusionModelInput>>>;
  groups?: InputMaybe<Array<InputMaybe<PolicyGroupModelInput>>>;
  invalidCondition?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifier?: InputMaybe<PersonModelInput>;
  permissionNames?: InputMaybe<Array<InputMaybe<PermissionName>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleRelationships?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PolicyRuleStatusModel>;
  systemKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum PolicyRuleStatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Locked = 'LOCKED'
}

export type PolicyRulesModel = {
  __typename?: 'PolicyRulesModel';
  rules?: Maybe<Array<Maybe<PolicyRuleModel>>>;
};

export enum PreferredEmailType {
  Primary = 'PRIMARY',
  Work = 'WORK'
}

export type PreviousTierOffsetDistributionRuleInstanceModel = {
  __typename?: 'PreviousTierOffsetDistributionRuleInstanceModel';
  timeOffset?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type PreviousTierOffsetDistributionRuleModel = {
  __typename?: 'PreviousTierOffsetDistributionRuleModel';
  timeOffset?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type PreviousTierOffsetRuleCreateModelInput = {
  timeOffset?: InputMaybe<RuleTimeOffsetInputModelInput>;
};

export type PriorSpendModel = {
  __typename?: 'PriorSpendModel';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type PriorSpendModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessCreatorCountModel = {
  __typename?: 'ProcessCreatorCountModel';
  creator?: Maybe<PersonModel>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProcessDefinitionCategoryModel {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Offboarding = 'OFFBOARDING',
  Onboarding = 'ONBOARDING',
  System = 'SYSTEM',
  Timesheet = 'TIMESHEET'
}

export type ProcessDefinitionConfigModel = {
  __typename?: 'ProcessDefinitionConfigModel';
  categories?: Maybe<Array<Maybe<ProcessDefinitionCategoryModel>>>;
  gatewayTypes?: Maybe<Array<Maybe<ProcessDefinitionGatewayTypeModel>>>;
  startEventTypeConfigs?: Maybe<Array<Maybe<StartEventTypeConfigModel>>>;
  startEventTypes?: Maybe<Array<Maybe<StartEventTypeModel>>>;
  subProcessTypeConfigs?: Maybe<Array<Maybe<SubProcessTypeConfigModel>>>;
  targetEntityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  taskDefinitionTemplates?: Maybe<Array<Maybe<TaskDefinitionTemplateModel>>>;
  taskInputFieldKeys?: Maybe<Array<Maybe<TaskInputFieldKeyModel>>>;
  taskUpdateFieldKeys?: Maybe<Array<Maybe<TaskUpdateFieldKeyModel>>>;
};

export type ProcessDefinitionCountModel = {
  __typename?: 'ProcessDefinitionCountModel';
  name?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export enum ProcessDefinitionEntityTypeModel {
  Contract = 'CONTRACT',
  Engagement = 'ENGAGEMENT',
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobProfile = 'JOB_PROFILE',
  JobRequest = 'JOB_REQUEST',
  Milestone = 'MILESTONE',
  Supplier = 'SUPPLIER',
  System = 'SYSTEM',
  Timesheet = 'TIMESHEET',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkRequest = 'WORK_REQUEST'
}

export enum ProcessDefinitionEventTypeModel {
  BoundaryEvent = 'BOUNDARY_EVENT',
  EndEvent = 'END_EVENT',
  IntermediateCatchEvent = 'INTERMEDIATE_CATCH_EVENT',
  StartEvent = 'START_EVENT'
}

export enum ProcessDefinitionGatewayTypeModel {
  ExclusiveGateway = 'EXCLUSIVE_GATEWAY',
  InclusiveGateway = 'INCLUSIVE_GATEWAY',
  ParallelGateway = 'PARALLEL_GATEWAY'
}

export type ProcessDefinitionModel = {
  __typename?: 'ProcessDefinitionModel';
  category?: Maybe<ProcessDefinitionCategoryModel>;
  comment?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  deployer?: Maybe<PersonModel>;
  description?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  eventDefinitions?: Maybe<Array<Maybe<EventDefinitionModel>>>;
  gatewayDefinitions?: Maybe<Array<Maybe<GatewayDefinitionModel>>>;
  hideForTaskDelegationByUser?: Maybe<Scalars['Boolean']['output']>;
  lastDeployed?: Maybe<Scalars['OffsetDateTime']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ProcessDefinitionReportModel>;
  restoredFrom?: Maybe<Scalars['Int']['output']>;
  sequenceFlows?: Maybe<Array<Maybe<SequenceFlowModel>>>;
  shapes?: Maybe<Array<Maybe<BpmnShapeModel>>>;
  status?: Maybe<ProcessDefinitionStatusModel>;
  subProcessDefinitions?: Maybe<Array<Maybe<SubProcessDefinitionModel>>>;
  targetEntityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  taskDefinitions?: Maybe<Array<Maybe<TaskDefinitionModel>>>;
  thumbnail?: Maybe<MediaModel>;
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};


export type ProcessDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessDefinitionModelInput = {
  category?: InputMaybe<ProcessDefinitionCategoryModel>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  deployer?: InputMaybe<PersonModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  eventDefinitions?: InputMaybe<Array<InputMaybe<EventDefinitionModelInput>>>;
  gatewayDefinitions?: InputMaybe<Array<InputMaybe<GatewayDefinitionModelInput>>>;
  hideForTaskDelegationByUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastDeployed?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifier?: InputMaybe<PersonModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ProcessDefinitionReportModelInput>;
  restoredFrom?: InputMaybe<Scalars['Int']['input']>;
  sequenceFlows?: InputMaybe<Array<InputMaybe<SequenceFlowModelInput>>>;
  shapes?: InputMaybe<Array<InputMaybe<BpmnShapeModelInput>>>;
  status?: InputMaybe<ProcessDefinitionStatusModel>;
  subProcessDefinitions?: InputMaybe<Array<InputMaybe<SubProcessDefinitionModelInput>>>;
  targetEntityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
  taskDefinitions?: InputMaybe<Array<InputMaybe<TaskDefinitionModelInput>>>;
  thumbnail?: InputMaybe<MediaModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessDefinitionRefModel = {
  __typename?: 'ProcessDefinitionRefModel';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type ProcessDefinitionRefModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessDefinitionReportModel = {
  __typename?: 'ProcessDefinitionReportModel';
  processStatusCounts?: Maybe<Array<Maybe<ProcessStatusCountModel>>>;
  totalProcessCount?: Maybe<Scalars['Int']['output']>;
};

export type ProcessDefinitionReportModelInput = {
  processStatusCounts?: InputMaybe<Array<InputMaybe<ProcessStatusCountModelInput>>>;
  totalProcessCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessDefinitionRevisionModel = {
  __typename?: 'ProcessDefinitionRevisionModel';
  comment?: Maybe<Scalars['String']['output']>;
  deployed?: Maybe<Scalars['OffsetDateTime']['output']>;
  deployer?: Maybe<PersonModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  processDefinitionUid?: Maybe<Scalars['String']['output']>;
  restoredFrom?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ProcessDefinitionRevisionsModel = {
  __typename?: 'ProcessDefinitionRevisionsModel';
  processDefinitionRevisions?: Maybe<Array<Maybe<ProcessDefinitionRevisionModel>>>;
};

export enum ProcessDefinitionStatusModel {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ProcessDefinitionTaskTypeModel {
  BusinessRuleTask = 'BUSINESS_RULE_TASK',
  ReceiveTask = 'RECEIVE_TASK',
  SendTask = 'SEND_TASK',
  ServiceTask = 'SERVICE_TASK',
  UserTask = 'USER_TASK'
}

export type ProcessDefinitionsModel = {
  __typename?: 'ProcessDefinitionsModel';
  processDefinitions?: Maybe<Array<Maybe<ProcessDefinitionModel>>>;
};

export type ProcessDefinitionsQueryModelInput = {
  excludeDnus?: InputMaybe<Scalars['Boolean']['input']>;
  excludeHiddenForTaskDelegationByUserIfNotTenantAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  processDefinitionStatus?: InputMaybe<ProcessDefinitionStatusModel>;
  startEventTypes?: InputMaybe<Array<InputMaybe<StartEventTypeModel>>>;
  targetContractUid?: InputMaybe<Scalars['String']['input']>;
  targetEngagementUid?: InputMaybe<Scalars['String']['input']>;
  targetEntityTypes?: InputMaybe<Array<InputMaybe<ProcessDefinitionEntityTypeModel>>>;
  targetJobApplicationUid?: InputMaybe<Scalars['String']['input']>;
  targetJobPostingUid?: InputMaybe<Scalars['String']['input']>;
  targetMilestoneUid?: InputMaybe<Scalars['String']['input']>;
  targetWorkRequestUid?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessEventModel = {
  __typename?: 'ProcessEventModel';
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  errorEventDefinition?: Maybe<ErrorEventDefinitionModel>;
  eventType?: Maybe<ProcessDefinitionEventTypeModel>;
  flowNodeId?: Maybe<Scalars['String']['output']>;
  initiator?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  parentActivityName?: Maybe<Scalars['String']['output']>;
  signalEventDefinition?: Maybe<SignalEventDefinitionModel>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  timerEventDefinition?: Maybe<TimerEventDefinitionModel>;
};

export type ProcessEventModelInput = {
  endTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  errorEventDefinition?: InputMaybe<ErrorEventDefinitionModelInput>;
  eventType?: InputMaybe<ProcessDefinitionEventTypeModel>;
  flowNodeId?: InputMaybe<Scalars['String']['input']>;
  initiator?: InputMaybe<PersonModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentActivityName?: InputMaybe<Scalars['String']['input']>;
  signalEventDefinition?: InputMaybe<SignalEventDefinitionModelInput>;
  startTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  timerEventDefinition?: InputMaybe<TimerEventDefinitionModelInput>;
};

export type ProcessLinkModel = {
  __typename?: 'ProcessLinkModel';
  source?: Maybe<ProcessModel>;
  target?: Maybe<ProcessModel>;
  type?: Maybe<ProcessLinkTypeModel>;
};

export type ProcessLinkModelInput = {
  source?: InputMaybe<ProcessModelInput>;
  target?: InputMaybe<ProcessModelInput>;
  type?: InputMaybe<ProcessLinkTypeModel>;
};

export enum ProcessLinkTypeModel {
  Retry = 'RETRY'
}

export type ProcessModel = {
  __typename?: 'ProcessModel';
  attachedMedia?: Maybe<Array<Maybe<MediaModel>>>;
  category?: Maybe<ProcessDefinitionCategoryModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  currentTasks?: Maybe<Array<Maybe<TaskModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  duplicatedPerson?: Maybe<PersonModel>;
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  events?: Maybe<Array<Maybe<ProcessEventModel>>>;
  gateways?: Maybe<Array<Maybe<GatewayModel>>>;
  links?: Maybe<Array<Maybe<ProcessLinkModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  processDefinition?: Maybe<ProcessDefinitionModel>;
  processDefinitionRef?: Maybe<ProcessDefinitionRefModel>;
  processErrorMessage?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<ProcessStatusModel>;
  targetChangeSet?: Maybe<ChangeSetModel>;
  targetContract?: Maybe<ContractModel>;
  targetEngagement?: Maybe<EngagementModel>;
  targetEntityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  targetExpense?: Maybe<ExpenseModel>;
  targetInvoice?: Maybe<InvoiceModel>;
  targetJobApplication?: Maybe<JobApplicationModel>;
  targetJobRequest?: Maybe<WorkPostingModel>;
  targetMilestone?: Maybe<MilestoneModel>;
  targetPerson?: Maybe<PersonModel>;
  targetSowResponse?: Maybe<SowResponseModel>;
  targetSupplier?: Maybe<SupplierModel>;
  targetTimesheet?: Maybe<TimesheetModel>;
  targetWorkRequest?: Maybe<WorkRequestModel>;
  tasks?: Maybe<Array<Maybe<TaskModel>>>;
  terminationReason?: Maybe<Scalars['String']['output']>;
  terminator?: Maybe<PersonModel>;
  uid: Scalars['String']['output'];
};


export type ProcessModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessModelInput = {
  attachedMedia?: InputMaybe<Array<InputMaybe<MediaModelInput>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  currentTasks?: InputMaybe<Array<InputMaybe<TaskModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  duplicatedPerson?: InputMaybe<PersonModelInput>;
  endTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  events?: InputMaybe<Array<InputMaybe<ProcessEventModelInput>>>;
  gateways?: InputMaybe<Array<InputMaybe<GatewayModelInput>>>;
  links?: InputMaybe<Array<InputMaybe<ProcessLinkModelInput>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  processDefinition?: InputMaybe<ProcessDefinitionModelInput>;
  processDefinitionRef?: InputMaybe<ProcessDefinitionRefModelInput>;
  processErrorMessage?: InputMaybe<Scalars['String']['input']>;
  retryable?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  status?: InputMaybe<ProcessStatusModel>;
  targetChangeSet?: InputMaybe<ChangeSetModelInput>;
  targetContract?: InputMaybe<ContractModelInput>;
  targetEngagement?: InputMaybe<EngagementModelInput>;
  targetEntityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
  targetExpense?: InputMaybe<ExpenseModelInput>;
  targetInvoice?: InputMaybe<InvoiceModelInput>;
  targetJobApplication?: InputMaybe<JobApplicationModelInput>;
  targetJobRequest?: InputMaybe<WorkPostingModelInput>;
  targetMilestone?: InputMaybe<MilestoneModelInput>;
  targetPerson?: InputMaybe<PersonModelInput>;
  targetSowResponse?: InputMaybe<SowResponseModelInput>;
  targetSupplier?: InputMaybe<SupplierModelInput>;
  targetTimesheet?: InputMaybe<TimesheetModelInput>;
  targetWorkRequest?: InputMaybe<WorkRequestModelInput>;
  tasks?: InputMaybe<Array<InputMaybe<TaskModelInput>>>;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  terminator?: InputMaybe<PersonModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessPatchModelInput = {
  duplicatedPerson?: InputMaybe<PersonModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<ProcessSortTypeModel>;
};

export enum ProcessSortTypeModel {
  CompletedDate = 'COMPLETED_DATE',
  StartDate = 'START_DATE'
}

export type ProcessStatusCountModel = {
  __typename?: 'ProcessStatusCountModel';
  count?: Maybe<Scalars['Int']['output']>;
  processStatus?: Maybe<ProcessStatusModel>;
};

export type ProcessStatusCountModelInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  processStatus?: InputMaybe<ProcessStatusModel>;
};

export enum ProcessStatusModel {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Deleted = 'DELETED'
}

export type ProcessSweeperConfigModel = {
  __typename?: 'ProcessSweeperConfigModel';
  activeProcessBatchSize: Scalars['Int']['output'];
  activeProcessExpirationDays: Scalars['Long']['output'];
  activeProcessExpirationEnabled: Scalars['Boolean']['output'];
};

export type ProcessSweeperConfigUpdateModelInput = {
  activeProcessBatchSize: Scalars['Int']['input'];
  activeProcessExpirationDays: Scalars['Long']['input'];
  activeProcessExpirationEnabled: Scalars['Boolean']['input'];
};

export type ProcessesModel = {
  __typename?: 'ProcessesModel';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  processes?: Maybe<Array<Maybe<ProcessModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProcessesPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<ProcessSortModelInput>>>;
};

export type ProcessesQueryModelInput = {
  completedRange?: InputMaybe<DateRangeModelInput>;
  creatorUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  processDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processStatus?: InputMaybe<ProcessStatusModel>;
  processStatuses?: InputMaybe<Array<InputMaybe<ProcessStatusModel>>>;
  startedRange?: InputMaybe<DateRangeModelInput>;
  targetBatchExecutionUid?: InputMaybe<Scalars['String']['input']>;
  targetBlueprintExecutionUid?: InputMaybe<Scalars['String']['input']>;
  targetContractUid?: InputMaybe<Scalars['String']['input']>;
  targetEngagementUid?: InputMaybe<Scalars['String']['input']>;
  targetEntityTypes?: InputMaybe<Array<InputMaybe<ProcessDefinitionEntityTypeModel>>>;
  targetExpenseUid?: InputMaybe<Scalars['String']['input']>;
  targetJobApplicationUid?: InputMaybe<Scalars['String']['input']>;
  targetJobRequestUid?: InputMaybe<Scalars['String']['input']>;
  targetMilestoneUid?: InputMaybe<Scalars['String']['input']>;
  targetPersonUid?: InputMaybe<Scalars['String']['input']>;
  targetTimesheetUid?: InputMaybe<Scalars['String']['input']>;
  targetWorkRequestUid?: InputMaybe<Scalars['String']['input']>;
};

export enum ProgramTypeModel {
  Contingent = 'CONTINGENT',
  Contract = 'CONTRACT',
  ResourceTracking = 'RESOURCE_TRACKING'
}

export type ProjectCreateModelInput = {
  controllerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  customerUid?: InputMaybe<ProjectCustomerImportableReferenceModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  managerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCustomerCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCustomerImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCustomerModel = {
  __typename?: 'ProjectCustomerModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type ProjectCustomerModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectCustomerModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCustomerQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectCustomerUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCustomersModel = {
  __typename?: 'ProjectCustomersModel';
  items?: Maybe<Array<Maybe<ProjectCustomerModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectModel = {
  __typename?: 'ProjectModel';
  controller?: Maybe<PersonModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  customer?: Maybe<ProjectCustomerModel>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  manager?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  plans?: Maybe<Array<Maybe<ProjectPlanModel>>>;
  positions?: Maybe<Array<Maybe<ProjectPositionModel>>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  timeCodeUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uid: Scalars['String']['output'];
};


export type ProjectModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectModelInput = {
  controller?: InputMaybe<PersonModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  customer?: InputMaybe<ProjectCustomerModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<PersonModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Long']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  plans?: InputMaybe<Array<InputMaybe<ProjectPlanModelInput>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPatchModelInput = {
  controllerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  customerUid?: InputMaybe<ProjectCustomerImportableReferenceModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  managerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  planPhases?: InputMaybe<Array<InputMaybe<ProjectPlanCreatePhaseModelInput>>>;
  projectUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanCreatePhaseModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  planTasks?: InputMaybe<Array<InputMaybe<ProjectPlanCreateTaskModelInput>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectPlanCreateTaskModelInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectPlanModel = {
  __typename?: 'ProjectPlanModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  phases?: Maybe<Array<Maybe<ProjectPlanPhaseModel>>>;
  project?: Maybe<ProjectModel>;
  /** @deprecated Replace with project model */
  projectUid?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};


export type ProjectPlanModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectPlanModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  phases?: InputMaybe<Array<InputMaybe<ProjectPlanPhaseModelInput>>>;
  project?: InputMaybe<ProjectModelInput>;
  projectUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanPhaseModel = {
  __typename?: 'ProjectPlanPhaseModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  planUid?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  tasks?: Maybe<Array<Maybe<ProjectPlanTaskModel>>>;
  timeCodeUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uid: Scalars['String']['output'];
};


export type ProjectPlanPhaseModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectPlanPhaseModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  planUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  tasks?: InputMaybe<Array<InputMaybe<ProjectPlanTaskModelInput>>>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanQueryModelInput = {
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  projectReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type ProjectPlanTaskModel = {
  __typename?: 'ProjectPlanTaskModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  planPhaseUid?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<StatusModel>;
  timeCodeUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uid: Scalars['String']['output'];
};


export type ProjectPlanTaskModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectPlanTaskModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  planPhaseUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanTaskQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type ProjectPlanTasksModel = {
  __typename?: 'ProjectPlanTasksModel';
  items?: Maybe<Array<Maybe<ProjectPlanTaskModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectPlanUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  planPhases?: InputMaybe<Array<InputMaybe<ProjectPlanUpdatePhaseModelInput>>>;
  projectUid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPlanUpdatePhaseModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  planTasks?: InputMaybe<Array<InputMaybe<ProjectPlanUpdateTaskModelInput>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectPlanUpdateTaskModelInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectPlansModel = {
  __typename?: 'ProjectPlansModel';
  items?: Maybe<Array<Maybe<ProjectPlanModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectPositionCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  projectReference?: InputMaybe<ProjectImportableReferenceModelInput>;
  projectRoleReference?: InputMaybe<ProjectRoleImportableReferenceModelInput>;
  rates?: InputMaybe<RatesModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionModel = {
  __typename?: 'ProjectPositionModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  projectPlanTasks?: Maybe<Array<Maybe<ProjectPlanTaskModel>>>;
  projectRole?: Maybe<ProjectRoleModel>;
  projectRoleUid?: Maybe<Scalars['String']['output']>;
  projectUid?: Maybe<Scalars['String']['output']>;
  rates?: Maybe<RatesModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  uid: Scalars['String']['output'];
};


export type ProjectPositionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectPositionModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  projectRole?: InputMaybe<ProjectRoleModelInput>;
  projectRoleUid?: InputMaybe<Scalars['String']['input']>;
  projectUid?: InputMaybe<Scalars['String']['input']>;
  rates?: InputMaybe<RatesModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionQueryModelInput = {
  projectReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionTaskMappingCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  projectPlanTaskUid?: InputMaybe<Scalars['String']['input']>;
  projectPositionUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionTaskMappingModel = {
  __typename?: 'ProjectPositionTaskMappingModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  projectPlanTaskUid?: Maybe<Scalars['String']['output']>;
  projectPositionUid?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type ProjectPositionTaskMappingModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectPositionTaskMappingQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionTaskMappingUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  projectPlanTaskUid?: InputMaybe<Scalars['String']['input']>;
  projectPositionUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionTaskMappingsModel = {
  __typename?: 'ProjectPositionTaskMappingsModel';
  items?: Maybe<Array<Maybe<ProjectPositionTaskMappingModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectPositionUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  projectReference?: InputMaybe<ProjectImportableReferenceModelInput>;
  projectRoleReference?: InputMaybe<ProjectRoleImportableReferenceModelInput>;
  rates?: InputMaybe<RatesModelInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectPositionsModel = {
  __typename?: 'ProjectPositionsModel';
  items?: Maybe<Array<Maybe<ProjectPositionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectQueryModelInput = {
  customerUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type ProjectRevisionModel = RevisionModel & {
  __typename?: 'ProjectRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousProject?: Maybe<ProjectModel>;
  project?: Maybe<ProjectModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type ProjectRoleCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectRoleImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectRoleModel = {
  __typename?: 'ProjectRoleModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};


export type ProjectRoleModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectRoleModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectRoleQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type ProjectRoleUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectRolesModel = {
  __typename?: 'ProjectRolesModel';
  items?: Maybe<Array<Maybe<ProjectRoleModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<ProjectSortTypeModel>;
};

export enum ProjectSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  Customer = 'CUSTOMER',
  Description = 'DESCRIPTION',
  Id = 'ID',
  LastModified = 'LAST_MODIFIED',
  Name = 'NAME',
  Number = 'NUMBER',
  ReferenceId = 'REFERENCE_ID',
  Status = 'STATUS'
}

export type ProjectUpdateModelInput = {
  controllerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  customerUid?: InputMaybe<ProjectCustomerImportableReferenceModelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  managerUid?: InputMaybe<PersonImportableReferenceModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<StatusModel>;
  timeCodeUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectsModel = {
  __typename?: 'ProjectsModel';
  items?: Maybe<Array<Maybe<ProjectModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activeWorkers: ActiveWorkersChartModel;
  allCustomObjects: CustomObjectsModel;
  allFinancialCustomObjects: FinancialCustomObjectsModel;
  allInvoices: InvoicesPageModel;
  allowedProjectTasksForTimesheet: ProjectPlanTasksModel;
  analyticsCloudDashboards: AnalyticsCloudDashboardsModel;
  analyticsDashboard: AnalyticsDashboardModel;
  analyticsDashboards: AnalyticsDashboardsModel;
  anomalies: AnomalyPageModel;
  anomaliesTotalCount: AnomaliesTotalCountModel;
  auditReports: AuditReportMetadataModels;
  availableSignals: SignalsModel;
  baseUser: UserModel;
  batchExecutionDownloadLink: MediaDownloadInfoModel;
  batchExecutionSupplierDownloadLink: MediaDownloadInfoModel;
  billingConfiguration: BillingConfigurationModel;
  blueprintAvailableColumns: InvoicingAvailableColumnsResponseModel;
  blueprintDefinition: InvoicingBlueprintDefinitionModel;
  blueprintDefinitions: InvoicingBlueprintDefinitionsModel;
  blueprintExecutions: InvoicingBlueprintExecutionsModel;
  blueprintInvoice: BlueprintInvoiceModel;
  blueprintInvoices: BlueprintInvoicesModel;
  businessEventReason?: Maybe<BusinessEventReasonModel>;
  businessEventReasons?: Maybe<BusinessEventReasonsModel>;
  businessEvents?: Maybe<BusinessEventsModel>;
  businessSiteCities: BusinessSiteCitiesModel;
  businessSiteRegions: BusinessSiteRegionsModel;
  calculateBudget: BudgetAmountModel;
  candidateGlobalSuppliers: SuppliersModel;
  candidateManagers: Array<Maybe<EngagementModel>>;
  candidateParentOrgs: OrgsModel;
  candidateParentSuppliers?: Maybe<SuppliersModel>;
  certification?: Maybe<CertificationModel>;
  certifications: CertificationsModel;
  changeSet: ChangeSetModel;
  classification: ClassificationModel;
  classifications: ClassificationsModel;
  classificationsForConnect: ClassificationsModel;
  companies: CompaniesModel;
  company: CompanyModel;
  complianceAndRiskDefinitions: AnomalyDefinitionsModel;
  connectRevisions?: Maybe<RevisionsModel>;
  contract?: Maybe<ContractModel>;
  contractRevisions: Array<Maybe<ContractRevisionModel>>;
  contractWithDescendants: Array<Maybe<ContractModel>>;
  contracts: ContractsModel;
  costCenterByUid: CostCenterModel;
  costCenterRevisionAtTime?: Maybe<CostCenterModel>;
  costCenters: CostCentersModel;
  costCentersRevisionsAtTime: Array<Maybe<CostCenterModel>>;
  costs: SpendModel;
  costsByBatchExecution: SpendModel;
  csvTemplate: CsvTemplateModel;
  csvTemplates: CsvTemplatesModel;
  currencies: CurrenciesModel;
  customFieldDefinition: CustomFieldDefinitionModel;
  customFieldDefinitionById?: Maybe<CustomFieldDefinitionModel>;
  customFieldDefinitionGroup: CustomFieldDefinitionGroupModel;
  customFieldDefinitionGroups: CustomFieldDefinitionGroupsModel;
  customFieldDefinitions: CustomFieldDefinitionsModel;
  customObject: CustomObjectModel;
  customObjectDefinition: CustomObjectDefinitionModel;
  customObjectDefinitions: CustomObjectDefinitionsModel;
  customObjects: CustomObjectsModel;
  dailyBriefing: DailyBriefingModel;
  dashboard: DashboardModel;
  dashboards: DashboardsModel;
  debugDumpOrgTreeField: DebugPayloadModel;
  decisionRules: DecisionRuleModel;
  decisionTableDefinition: DecisionTableDefinitionModel;
  decisionTableDefinitionRevisions: DecisionTableDefinitionRevisionsModel;
  decisionTableDefinitions: DecisionTableDefinitionsModel;
  decisionTableReferences: ReferencesModel;
  decisions: DecisionsModel;
  deleteAuditReport?: Maybe<Scalars['Boolean']['output']>;
  deliveredFieldDefinition: DeliveredFieldDefinitionModel;
  eligibilityRequirement?: Maybe<EligibilityRequirementModel>;
  eligibilityRequirements: EligibilityRequirementsModel;
  enabledInactiveUsersCount: UserCountModel;
  engagement: EngagementModel;
  engagementBillingConfiguration: BillingConfigurationModel;
  engagementChangeSets: ChangeSetsModel;
  engagementDiag: Array<Maybe<EngagementsDiagnosticsModel>>;
  engagementRevDiag: Array<Maybe<EngagementsRevisionsDiagnosticsModel>>;
  engagementRevisionAtTime?: Maybe<EngagementModel>;
  engagements: EngagementsModel;
  engagementsOpenChangeSetStatus: Array<Maybe<EngagementOpenChangesetsStatusModel>>;
  entityFinancialCustomFieldDefinitions: CustomFieldDefinitionsModel;
  expense: ExpenseModel;
  expenseCategories: ExpenseCategoriesModel;
  expenseCategory: ExpenseCategoryModel;
  expenses: ExpensesModel;
  explain: DecisionExplanationModel;
  exports: OcExportPageModel;
  fieldConstraintDeclarations: FieldConstraintDeclarationsModel;
  fieldConstraintDefinition?: Maybe<FieldConstraintDefinitionModel>;
  fieldConstraintDefinitions: FieldConstraintDefinitionsModel;
  fieldDefinitions: FieldDefinitionsModel;
  fieldMetadata: FieldMetadataModel;
  fieldMetadataForPaths: CommonFieldDefinitionsModel;
  fieldMetadataTenantOverrides: FieldMetadataModel;
  financialCustomFieldDefinitions: CustomFieldDefinitionsModel;
  financialCustomObjects: FinancialCustomObjectsModel;
  findAllSelfAndChildEngagementsForContract: EngagementsModel;
  findEngagementsByContractUid: EngagementsModel;
  findRateCardsMinMax?: Maybe<RateCardMinMaxModel>;
  findRateCardsMinMaxForSupplier?: Maybe<Array<Maybe<RateCardMinMaxModel>>>;
  focusOrg?: Maybe<OrgModel>;
  gender: GenderModel;
  genders: GendersModel;
  geolocation: LocationModel;
  getDefaultVisibleOrg?: Maybe<OrgModel>;
  getDuplicateWorkers: DuplicateWorkersModel;
  getEngagementsByPage?: Maybe<EngagementsModel>;
  getPermissionsExplainerByExplainID: DecisionExplanationModel;
  getPolicyDecision: GetDecisionModel;
  getTenant: TenantModel;
  getViewHistory: PeopleModel;
  globalIdFormula: GlobalIdFormulaModel;
  globalIdFormulas?: Maybe<Array<Maybe<GlobalIdFormulaModel>>>;
  globalIdPreview: Scalars['String']['output'];
  groupedTimerMetrics?: Maybe<GroupedTimerMetricModel>;
  holidaySchedule: HolidayScheduleModel;
  holidaySchedules: HolidaySchedulesModel;
  import: NotificationModel;
  importColumns: ImportColumnsModel;
  importLogs: ImportLogsModel;
  importStatistics: ImportStatisticsModel;
  inconsistentExports: OcExportPageModel;
  integrationClient: IntegrationClientModel;
  integrationClients: IntegrationClientsModel;
  invoice?: Maybe<InvoiceModel>;
  invoiceBlueprintBatchDefinitionAvailableFilters: BatchDefinitionFiltersModel;
  invoices: InvoicesModel;
  invoicingEngagements: InvoicingEngagementsModel;
  invoicingSuppliers: InvoicingSuppliersModel;
  isParentActivityCompleted?: Maybe<Scalars['Boolean']['output']>;
  isoCountries: CountriesModel;
  jobApplication: JobApplicationModel;
  jobApplicationRevisions: Array<Maybe<JobApplicationRevisionModel>>;
  jobApplicationStage: JobApplicationStageModel;
  jobApplicationStages: JobApplicationStagesModel;
  jobApplications: JobApplicationsModel;
  jobFamilies: JobFamiliesModel;
  jobFamily: JobFamilyModel;
  jobFamilyGroup: JobFamilyGroupModel;
  jobFamilyGroups: JobFamilyGroupsModel;
  jobProfile: JobProfileModel;
  jobProfiles: JobProfilesModel;
  jobRequest: WorkPostingModel;
  jobRequestRevisions: Array<Maybe<WorkPostingRevisionModel>>;
  jobRequests: WorkPostingsModel;
  joinersAndLeavers: JoinersAndLeaversChartModel;
  journalConfig?: Maybe<FinanceJournalScheduleModel>;
  journalConfigs: FinanceJournalSchedulesModel;
  journalExports: FinanceJournalExportJobsModel;
  listReportConfigurations: ReportConfigurationListModel;
  location: LocationModel;
  locationCountries: CountriesModel;
  locations: LocationsModel;
  locationsByQuery: LocationsModel;
  milestone?: Maybe<MilestoneModel>;
  milestones: MilestonesModel;
  msp: MspModel;
  msps: MspsModel;
  myAnalyticsDashboard: MyAnalyticsDashboardModel;
  myAnalyticsDashboards: MyAnalyticsDashboardsModel;
  nationalIdCountries: CountriesModel;
  nationalIdTypes: NationalIdTypesModel;
  notification: NotificationModel;
  notificationHubSettings: NotificationHubSettingsModel;
  notifications: NotificationsModel;
  org: OrgModel;
  orgMembershipDiag: Array<Maybe<OrgMembershipDiagnosticsModel>>;
  orgMembershipRevDiag: Array<Maybe<OrgMembershipRevisionsDiagnosticsModel>>;
  orgs: OrgsModel;
  payment: PaymentModel;
  payments: PaymentsModel;
  people: PeopleModel;
  peopleRevisionsAtTime: Array<Maybe<PersonModel>>;
  permissionNames: Array<Maybe<PermissionNameModel>>;
  personFacetDiag: Array<Maybe<PersonFacetsDiagnosticsModel>>;
  personFacetRevDiag: Array<Maybe<PersonFacetsRevisionsDiagnosticsModel>>;
  personRecordDiag?: Maybe<PersonDiagnosticsModel>;
  personRevisionAtTime?: Maybe<PersonModel>;
  policyGroups: PolicyGroupsModel;
  policyRule: PolicyRuleModel;
  policyRules: PolicyRulesModel;
  process: ProcessModel;
  processCreatorCounts: Array<Maybe<ProcessCreatorCountModel>>;
  processDefinition: ProcessDefinitionModel;
  processDefinitionConfig: ProcessDefinitionConfigModel;
  processDefinitionRevisions: ProcessDefinitionRevisionsModel;
  processDefinitions: ProcessDefinitionsModel;
  processes: ProcessesModel;
  project: ProjectModel;
  projectCustomer: ProjectCustomerModel;
  projectCustomers: ProjectCustomersModel;
  projectExistsByReferenceId?: Maybe<Scalars['Boolean']['output']>;
  projectPlan: ProjectPlanModel;
  projectPlanPhase: ProjectPlanPhaseModel;
  projectPlanTask: ProjectPlanTaskModel;
  projectPlanTasks: ProjectPlanTasksModel;
  projectPlans: ProjectPlansModel;
  projectPosition: ProjectPositionModel;
  projectPositionTaskMapping: ProjectPositionTaskMappingModel;
  projectPositionTaskMappings: ProjectPositionTaskMappingsModel;
  projectPositions: ProjectPositionsModel;
  projectRevisions: Array<Maybe<ProjectRevisionModel>>;
  projectRole: ProjectRoleModel;
  projectRoles: ProjectRolesModel;
  projects: ProjectsModel;
  queryJobApplicationRevisions: Array<Maybe<JobApplicationRevisionModel>>;
  queryJobRequestRevisions: Array<Maybe<WorkPostingRevisionModel>>;
  queryProjectRevisions: Array<Maybe<ProjectRevisionModel>>;
  quickReport: QuickReportModel;
  quickReports: QuickReportsModel;
  rate: RateBillingVariableModel;
  rateCard: RateCardModel;
  rateCards: RateCardsModel;
  recipe: RecipeModel;
  recipes: RecipesModel;
  recommendationDefinition: RecommendationDefinitionModel;
  reportConfiguration: ReportConfigurationResponseModel;
  reportTemplate: ReportTemplateModel;
  reportTemplates: ReportTemplateListModel;
  resourceNode: ResourceNodeModel;
  resourceTypes: ResourceTypesModel;
  revisions?: Maybe<RevisionsModel>;
  role: RoleModel;
  roleAssignments: BulkRoleAssignmentsModel;
  roleAssignmentsWithReferences: RoleAssignmentsWithReferencesModel;
  roles: RolesModel;
  rootLocations: LocationsModel;
  rootOrgs: OrgsModel;
  rootResourceNodes: ResourceNodesModel;
  securityPolicies: SecurityPoliciesModel;
  securityPolicyRuleModelSchema: Scalars['String']['output'];
  self?: Maybe<UserModel>;
  seniorities: SenioritiesModel;
  seniority: SeniorityModel;
  sequenceGenerator: SequenceGeneratorModel;
  sequenceGenerators: SequenceGeneratorsModel;
  sftpDirectories: Array<Maybe<SftpDirectoryModel>>;
  sftpDirectory: SftpDirectoryModel;
  sftpSshKeys: Array<Maybe<SftpSshKeyModel>>;
  sftpUsers: Array<Maybe<SftpUserModel>>;
  /** @deprecated use explain */
  sherlockExplain: Scalars['String']['output'];
  smartFormDefinition?: Maybe<SmartFormDefinitionModel>;
  smartFormDefinitions: SmartFormDefinitionsModel;
  sowResponse: SowResponseModel;
  sowResponses: SowResponsesModel;
  subProcessDefinitionConfig: SubProcessDefinitionConfigModel;
  suggest: SuggestionsModel;
  supplier?: Maybe<SupplierModel>;
  supplierGroup?: Maybe<SupplierGroupModel>;
  supplierGroups?: Maybe<SupplierGroupsModel>;
  supplierTier?: Maybe<SupplierTierModel>;
  suppliers?: Maybe<SuppliersModel>;
  systemActivities: SystemActivitiesModel;
  systemActivity: SystemActivityModel;
  tag: TagModel;
  tagInstance: TagInstanceModel;
  tagInstances: TagInstancesModel;
  tags: TagsModel;
  task: TaskModel;
  taskByProcessUidAndSubProcessType?: Maybe<TaskModel>;
  taskDefinitionTemplates: TaskDefinitionTemplatesModel;
  taskDefinitions: TaskDefinitionRefsModel;
  taskDelegation: TaskDelegationModel;
  taskDelegations: TaskDelegationsModel;
  tasks: TasksModel;
  tasksByTargetEntityUid: TasksModel;
  terminationReason: TerminationReasonModel;
  terminationReasons: TerminationReasonsModel;
  timeCode: TimeCodeModel;
  timeCodes: TimeCodesModel;
  timerEvents?: Maybe<TimerEventsModel>;
  timerMetrics?: Maybe<TimerMetricsModel>;
  timesheet: TimesheetModel;
  timesheetSettings?: Maybe<TimesheetSettingsModel>;
  timesheetSettingsList: TimesheetSettingsListModel;
  timesheets: TimesheetsModel;
  timezones: Array<Maybe<Scalars['String']['output']>>;
  unrestrictedWidgetSettings: UnrestrictedWidgetSettingsPageModel;
  user: PersonModel;
  userActivities: UserActivitiesModel;
  userPreferences: UserPreferencesModel;
  users: UsersModel;
  validateEngagementHasPropertySet: ReferenceIdValidationsModel;
  validatePersonsExist?: Maybe<PeopleModel>;
  validateReferenceIdsColumn: ReferenceIdValidationsModel;
  validateReferenceIdsRow: ReferenceIdValidationsModel;
  validateSmartFormDefinition: SmartFormDefinitionModel;
  validateTimesheetImportRow: ReferenceIdValidationsModel;
  widgetSettings: WidgetSettingPageModel;
  workCalendar: WorkCalendarModel;
  workCalendars: WorkCalendarsModel;
  workPostingSupplierGroupInstance?: Maybe<SupplierGroupInstanceModel>;
  workPostingSupplierInviteRevisions: Array<Maybe<WorkPostingSupplierInviteRevisionModel>>;
  workRequest: WorkRequestModel;
  workRequestRevisions: Array<Maybe<WorkRequestRevisionModel>>;
  workRequests: WorkRequestsModel;
  workSchedule: WorkScheduleModel;
  workSchedules: WorkSchedulesModel;
  workdayReferenceIds: ReferenceIdsModel;
  workdaySecrets: WorkdaySecretsModel;
  workerEngagements: WorkerEngagementsModel;
  workerLocationCountries: CountriesModel;
  workerQualification?: Maybe<WorkerQualificationModel>;
  workerQualificationRevisions: Array<Maybe<WorkerQualificationRevisionModel>>;
  workerQualifications?: Maybe<WorkerQualificationsModel>;
  workerQualificationsByEngagement: WorkerQualificationsModel;
  workerQualificationsByWorker: WorkerQualificationsModel;
  workers: WorkersModel;
  workersTotalCount: WorkersTotalCountModel;
};


export type QueryActiveWorkersArgs = {
  accumulationPeriod: AccumulationPeriodModel;
  classificationTypes: Array<InputMaybe<ClassificationTypeModel>>;
  dateRange?: InputMaybe<DateRangeModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryAllCustomObjectsArgs = {
  customFieldDefinitionReferenceIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryAllFinancialCustomObjectsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryAllInvoicesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page: InvoicePageModelInput;
  q?: InputMaybe<AllInvoicesQueryModelInput>;
};


export type QueryAllowedProjectTasksForTimesheetArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  timesheetUid: Scalars['String']['input'];
};


export type QueryAnalyticsCloudDashboardsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<AnalyticsCloudDashboardsQueryModelInput>;
};


export type QueryAnalyticsDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type QueryAnalyticsDashboardsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<AnalyticsDashboardsQueryModelInput>;
};


export type QueryAnomaliesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<AnomalyQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<AnomalySortModelInput>>>;
};


export type QueryAuditReportsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryAvailableSignalsArgs = {
  flowNodeId?: InputMaybe<Scalars['String']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryBaseUserArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBatchExecutionDownloadLinkArgs = {
  batchExecutionUid: Scalars['String']['input'];
};


export type QueryBatchExecutionSupplierDownloadLinkArgs = {
  batchExecutionUid: Scalars['String']['input'];
};


export type QueryBillingConfigurationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<BillingConfigurationQueryModelInput>;
};


export type QueryBlueprintDefinitionArgs = {
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlueprintDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<InvoicingBlueprintDefinitionPageModelInput>;
  query?: InputMaybe<InvoicingBlueprintDefinitionQueryModelInput>;
};


export type QueryBlueprintExecutionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<InvoicingBlueprintExecutionPageModelInput>;
  query?: InputMaybe<InvoicingBlueprintExecutionQueryModelInput>;
};


export type QueryBlueprintInvoiceArgs = {
  uid: Scalars['String']['input'];
};


export type QueryBlueprintInvoicesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<BlueprintInvoicePageModelInput>;
  query?: InputMaybe<BlueprintInvoiceQueryModelInput>;
};


export type QueryBusinessEventReasonArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryBusinessEventReasonsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<BusinessEventReasonsQueryModelInput>;
};


export type QueryBusinessEventsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<BusinessEventsQueryModelInput>;
};


export type QueryBusinessSiteCitiesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBusinessSiteRegionsArgs = {
  page?: InputMaybe<PageModelInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculateBudgetArgs = {
  budgetCalculationModel: BudgetCalculationModelInput;
};


export type QueryCandidateGlobalSuppliersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryCandidateManagersArgs = {
  org: OrgModelInput;
};


export type QueryCandidateParentOrgsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  org: OrgModelInput;
};


export type QueryCandidateParentSuppliersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryCertificationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryCertificationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
};


export type QueryChangeSetArgs = {
  uid: Scalars['String']['input'];
};


export type QueryClassificationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryClassificationsArgs = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  forceJobProfileRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  jobProfileUid?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ClassificationStatusModel>>>;
  type?: InputMaybe<ClassificationTypeModel>;
};


export type QueryClassificationsForConnectArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: ClassificationQueryModelInput;
};


export type QueryCompaniesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<CompanyQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<CompanySortModelInput>>>;
};


export type QueryCompanyArgs = {
  uid: Scalars['String']['input'];
};


export type QueryComplianceAndRiskDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ComplianceAndRiskDefinitionsQueryModelInput>;
};


export type QueryContractArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryContractRevisionsArgs = {
  changeSetUid?: InputMaybe<Scalars['String']['input']>;
  contractUids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryContractWithDescendantsArgs = {
  uid: Scalars['String']['input'];
};


export type QueryContractsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ContractsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<ContractSortModelInput>>>;
};


export type QueryCostCenterByUidArgs = {
  costCenterNameWithCode?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActive?: Scalars['Boolean']['input'];
  uid: Scalars['String']['input'];
};


export type QueryCostCenterRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryCostCentersArgs = {
  costCenterNameWithCode?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: CostCenterQueryModelInput;
  sort?: InputMaybe<Array<InputMaybe<CostCenterSortModelInput>>>;
};


export type QueryCostCentersRevisionsAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryCostsArgs = {
  cursorPage?: InputMaybe<CursorPageRequestModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  q?: InputMaybe<SpendQueryModelInput>;
};


export type QueryCostsByBatchExecutionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  q?: InputMaybe<SpendByBatchExecutionQueryModelInput>;
};


export type QueryCsvTemplateArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCsvTemplatesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<CsvTemplateQueryModelInput>;
};


export type QueryCurrenciesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryCustomFieldDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCustomFieldDefinitionByIdArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  id: Scalars['String']['input'];
};


export type QueryCustomFieldDefinitionGroupArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCustomFieldDefinitionGroupsArgs = {
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryCustomFieldDefinitionsArgs = {
  financialObject?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentCustomObjectDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  parentEntityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  parentEntityTypes?: InputMaybe<Array<InputMaybe<CustomFieldDefinitionEntityTypeModel>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};


export type QueryCustomObjectArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCustomObjectDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCustomObjectDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<CustomObjectDefinitionQueryModelInput>;
};


export type QueryCustomObjectsArgs = {
  customObjectDefinitionUid: Scalars['String']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<UpdatableStatusModel>>>;
};


export type QueryDailyBriefingArgs = {
  request?: InputMaybe<DailyBriefingRequestModelInput>;
};


export type QueryDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type QueryDashboardsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<DashboardsPageModelInput>;
};


export type QueryDebugDumpOrgTreeFieldArgs = {
  tenantUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDecisionRulesArgs = {
  definitionUid: Scalars['String']['input'];
  ruleUid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDecisionTableDefinitionArgs = {
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDecisionTableDefinitionRevisionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryDecisionTableDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<DecisionTableDefinitionQueryModelInput>;
};


export type QueryDecisionTableReferencesArgs = {
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDecisionsArgs = {
  decisions?: InputMaybe<Array<InputMaybe<DecisionModelInput>>>;
};


export type QueryDeleteAuditReportArgs = {
  reportUid: Scalars['String']['input'];
};


export type QueryDeliveredFieldDefinitionArgs = {
  code: ConfigurableDeliveredFieldsModel;
};


export type QueryEligibilityRequirementArgs = {
  uid: Scalars['String']['input'];
};


export type QueryEligibilityRequirementsArgs = {
  filter?: InputMaybe<EligibilityRequirementRootFilterModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<EligibilityRequirementSortModelInput>>>;
};


export type QueryEnabledInactiveUsersCountArgs = {
  queryModel: InactiveUsersCountQueryModelInput;
};


export type QueryEngagementArgs = {
  uid: Scalars['String']['input'];
};


export type QueryEngagementBillingConfigurationArgs = {
  engagementUid?: InputMaybe<Scalars['String']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryEngagementChangeSetsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  q?: InputMaybe<EngagementChangeSetQueryModelInput>;
};


export type QueryEngagementDiagArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryEngagementRevDiagArgs = {
  engagementUid: Scalars['String']['input'];
};


export type QueryEngagementRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryEngagementsArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryEngagementsOpenChangeSetStatusArgs = {
  engagementIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryEntityFinancialCustomFieldDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query: EntityFinancialCustomFieldDefinitionsQueryModelInput;
};


export type QueryExpenseArgs = {
  uid: Scalars['String']['input'];
};


export type QueryExpenseCategoriesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<ExpenseCategoryQueryModelInput>;
};


export type QueryExpenseCategoryArgs = {
  uid: Scalars['String']['input'];
};


export type QueryExpensesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  includeInvoices?: Scalars['Boolean']['input'];
  page?: InputMaybe<ExpensePageModelInput>;
  q?: InputMaybe<ExpenseQueryModelInput>;
};


export type QueryExplainArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  permissionAction: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceUid?: InputMaybe<Scalars['String']['input']>;
  subjectUid: Scalars['String']['input'];
};


export type QueryExportsArgs = {
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<OcExportQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<OcExportSortModelInput>>>;
};


export type QueryFieldConstraintDeclarationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryFieldConstraintDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryFieldConstraintDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<FieldConstraintDefinitionsQueryModelInput>;
};


export type QueryFieldDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  parentCustomObjectUid?: InputMaybe<Scalars['String']['input']>;
  parentObjectType?: InputMaybe<ObjectTypeModel>;
  parentObjectTypes?: InputMaybe<Array<InputMaybe<ObjectTypeModel>>>;
};


export type QueryFieldMetadataForPathsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  pathUrns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFinancialCustomFieldDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<FinancialCustomFieldDefinitionsQueryModelInput>;
};


export type QueryFinancialCustomObjectsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: FinancialCustomObjectsQueryModelInput;
};


export type QueryFindAllSelfAndChildEngagementsForContractArgs = {
  contractUid: Scalars['String']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryFindEngagementsByContractUidArgs = {
  contractUid: Scalars['String']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryFindRateCardsMinMaxArgs = {
  jobProfileUid: Scalars['String']['input'];
  locationUid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RateTypeModel>;
};


export type QueryFindRateCardsMinMaxForSupplierArgs = {
  jobProfileUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  supplierUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFocusOrgArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryGenderArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGendersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ReferenceDataQueryModelInput>;
};


export type QueryGeolocationArgs = {
  location?: InputMaybe<LocationModelInput>;
};


export type QueryGetDefaultVisibleOrgArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryGetDuplicateWorkersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query: DuplicateWorkerSearchQueryModelInput;
};


export type QueryGetEngagementsByPageArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<EngagementsQueryModelInput>;
};


export type QueryGetPermissionsExplainerByExplainIdArgs = {
  explainId: Scalars['String']['input'];
};


export type QueryGetPolicyDecisionArgs = {
  permissionAction: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceUid: Scalars['String']['input'];
};


export type QueryGetTenantArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetViewHistoryArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGlobalIdFormulaArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGlobalIdPreviewArgs = {
  model: GlobalIdPreviewModelInput;
};


export type QueryGroupedTimerMetricsArgs = {
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<TimerMetricsQueryModelInput>;
};


export type QueryHolidayScheduleArgs = {
  uid: Scalars['String']['input'];
};


export type QueryImportArgs = {
  importSheetMediaUid: Scalars['String']['input'];
  sourceName: Scalars['String']['input'];
};


export type QueryImportColumnsArgs = {
  entityType: ImportEntityTypeModel;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  importTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImportLogsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ImportLogQueryModelInput>;
};


export type QueryImportStatisticsArgs = {
  importSheetMediaUid: Scalars['String']['input'];
  sourceName: Scalars['String']['input'];
};


export type QueryInconsistentExportsArgs = {
  page?: InputMaybe<PageModelInput>;
};


export type QueryIntegrationClientArgs = {
  uid: Scalars['String']['input'];
};


export type QueryIntegrationClientsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};


export type QueryInvoiceArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  q?: InputMaybe<InvoiceQueryModelInput>;
};


export type QueryInvoicingEngagementsArgs = {
  filters: InvoicingBatchFiltersConfigurationModelInput;
};


export type QueryIsParentActivityCompletedArgs = {
  uid: Scalars['String']['input'];
};


export type QueryIsoCountriesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryJobApplicationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobApplicationRevisionsArgs = {
  jobApplicationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryJobApplicationStageArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobApplicationStagesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};


export type QueryJobApplicationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<JobApplicationQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<JobApplicationSortModelInput>>>;
};


export type QueryJobFamiliesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<JobFamilyQueryModelInput>;
};


export type QueryJobFamilyArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobFamilyGroupArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobFamilyGroupsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<JobFamilyGroupQueryModelInput>;
};


export type QueryJobProfileArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobProfilesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<JobProfileQueryModelInput>;
};


export type QueryJobRequestArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJobRequestRevisionsArgs = {
  jobRequestUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryJobRequestsArgs = {
  filter?: InputMaybe<WorkPostingRootFilterModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<WorkPostingQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WorkPostingSortModelInput>>>;
};


export type QueryJoinersAndLeaversArgs = {
  dateRange?: InputMaybe<DateRangeModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryJournalConfigArgs = {
  uid: Scalars['String']['input'];
};


export type QueryJournalExportsArgs = {
  page?: InputMaybe<PageModelInput>;
};


export type QueryListReportConfigurationsArgs = {
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ReportConfigurationsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<ReportConfigurationsSortModelInput>>>;
};


export type QueryLocationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryLocationCountriesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryLocationsArgs = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  constraints?: InputMaybe<Array<InputMaybe<FieldConstraintModelInput>>>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  parentEntityUid?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LocationSortModelInput>>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<LocationTypeModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLocationsByQueryArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: LocationQueryModelInput;
  sort?: InputMaybe<Array<InputMaybe<LocationSortModelInput>>>;
};


export type QueryMilestoneArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  milestoneUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMilestonesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<MilestonesQueryModelInput>;
};


export type QueryMspArgs = {
  uid: Scalars['String']['input'];
};


export type QueryMspsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<MspQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<MspSortModelInput>>>;
};


export type QueryMyAnalyticsDashboardArgs = {
  uid: Scalars['String']['input'];
};


export type QueryMyAnalyticsDashboardsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryNationalIdCountriesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryNationalIdTypesArgs = {
  countryCode: Scalars['String']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryNotificationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryNotificationHubSettingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<NotificationHubSettingsSortModelInput>>>;
};


export type QueryNotificationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<NotificationQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<NotificationSortModelInput>>>;
};


export type QueryOrgArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgMembershipDiagArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryOrgMembershipRevDiagArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryOrgsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<OrgsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<OrgSortModelInput>>>;
};


export type QueryPaymentArgs = {
  uid: Scalars['String']['input'];
};


export type QueryPaymentsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<PaymentsQueryModelInput>;
};


export type QueryPeopleArgs = {
  cursorPage?: InputMaybe<CursorPageRequestModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  keyedPage?: InputMaybe<CursorPageRequestModelInput>;
  page?: InputMaybe<PeoplePageModelInput>;
  q?: InputMaybe<PeopleQueryModelInput>;
  requireLatest?: InputMaybe<Scalars['Boolean']['input']>;
  useLazyPermissionEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeopleRevisionsAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryPersonFacetDiagArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryPersonFacetRevDiagArgs = {
  personUid: Scalars['String']['input'];
};


export type QueryPersonRecordDiagArgs = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryPolicyGroupsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryPolicyRuleArgs = {
  uid: Scalars['String']['input'];
};


export type QueryPolicyRulesArgs = {
  actorUserUid?: InputMaybe<Scalars['String']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  statuses?: InputMaybe<Array<InputMaybe<PolicyRuleStatusModel>>>;
};


export type QueryProcessArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProcessCreatorCountsArgs = {
  query?: InputMaybe<ProcessesQueryModelInput>;
};


export type QueryProcessDefinitionArgs = {
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProcessDefinitionConfigArgs = {
  targetEntityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
};


export type QueryProcessDefinitionRevisionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryProcessDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<ProcessDefinitionsQueryModelInput>;
};


export type QueryProcessesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<ProcessesPageModelInput>;
  query?: InputMaybe<ProcessesQueryModelInput>;
};


export type QueryProjectArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectCustomerArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectCustomersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectCustomerQueryModelInput>;
};


export type QueryProjectExistsByReferenceIdArgs = {
  referenceId: Scalars['String']['input'];
};


export type QueryProjectPlanArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectPlanPhaseArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectPlanTaskArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectPlanTasksArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectPlanTaskQueryModelInput>;
};


export type QueryProjectPlansArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectPlanQueryModelInput>;
};


export type QueryProjectPositionArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectPositionTaskMappingArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectPositionTaskMappingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectPositionTaskMappingQueryModelInput>;
};


export type QueryProjectPositionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectPositionQueryModelInput>;
};


export type QueryProjectRevisionsArgs = {
  projectUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProjectRoleArgs = {
  uid: Scalars['String']['input'];
};


export type QueryProjectRolesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectRoleQueryModelInput>;
};


export type QueryProjectsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ProjectQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<ProjectSortModelInput>>>;
};


export type QueryQueryJobApplicationRevisionsArgs = {
  jobApplicationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};


export type QueryQueryJobRequestRevisionsArgs = {
  jobRequestUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};


export type QueryQueryProjectRevisionsArgs = {
  projectUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};


export type QueryQuickReportArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuickReportsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<QuickReportQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<QuickReportSortModelInput>>>;
};


export type QueryRateArgs = {
  uid: Scalars['String']['input'];
};


export type QueryRateCardArgs = {
  uid: Scalars['String']['input'];
};


export type QueryRateCardsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<RateCardQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<RateCardSortModelInput>>>;
};


export type QueryRecipeArgs = {
  uid: Scalars['String']['input'];
};


export type QueryRecipesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryRecommendationDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type QueryReportConfigurationArgs = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportTemplateArgs = {
  referenceId: Scalars['String']['input'];
  resolutionMode?: Scalars['String']['input'];
};


export type QueryResourceNodeArgs = {
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceTypesArgs = {
  kind: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  uid: Scalars['String']['input'];
};


export type QueryRoleAssignmentsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryRoleAssignmentsWithReferencesArgs = {
  roleReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryRolesArgs = {
  statuses?: InputMaybe<Array<InputMaybe<RoleStatusModel>>>;
};


export type QueryRootLocationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryRootOrgsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryRootResourceNodesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QuerySecurityPoliciesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<SecurityPoliciesQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<SecurityPoliciesSortModelInput>>>;
};


export type QuerySelfArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QuerySenioritiesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QuerySeniorityArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySequenceGeneratorArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySequenceGeneratorsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QuerySftpDirectoryArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySherlockExplainArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  permissionAction: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceUid?: InputMaybe<Scalars['String']['input']>;
  subjectUid: Scalars['String']['input'];
};


export type QuerySmartFormDefinitionArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySmartFormDefinitionsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<SmartFormPageModelInput>;
  q?: InputMaybe<SmartFormQueryModelInput>;
};


export type QuerySowResponseArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySowResponsesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<SowResponseSortModelInput>>>;
};


export type QuerySubProcessDefinitionConfigArgs = {
  subProcessType?: InputMaybe<SubProcessTypeModel>;
  targetEntityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
};


export type QuerySuggestArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyPeopleWithEngagements?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  showPeople?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupplierArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QuerySupplierGroupArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  supplierGroupUid?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierGroupsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<SupplierGroupSortModelInput>>>;
};


export type QuerySupplierTierArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  supplierTierUid?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuppliersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<SuppliersQueryModelInput>;
  sortOrders?: InputMaybe<Array<InputMaybe<SupplierSortModelInput>>>;
};


export type QuerySystemActivitiesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  type?: InputMaybe<SystemActivityTypeModel>;
};


export type QuerySystemActivityArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTagArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTagInstanceArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTagInstancesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: TagInstanceQueryModelInput;
};


export type QueryTagsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: TagQueryModelInput;
  sort?: InputMaybe<Array<InputMaybe<TagSortModelInput>>>;
};


export type QueryTaskArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTaskByProcessUidAndSubProcessTypeArgs = {
  processUid: Scalars['String']['input'];
  subProcessType?: InputMaybe<SubProcessTypeModel>;
};


export type QueryTaskDefinitionTemplatesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryTaskDefinitionsArgs = {
  query?: InputMaybe<TaskDefinitionsQueryModelInput>;
};


export type QueryTaskDelegationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTaskDelegationsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<TaskDelegationsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<TaskDelegationSortModelInput>>>;
};


export type QueryTasksArgs = {
  assigneeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<TasksQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<TaskSortModelInput>>>;
  subProcessType?: InputMaybe<SubProcessTypeModel>;
};


export type QueryTasksByTargetEntityUidArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryTerminationReasonArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTerminationReasonsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<ReferenceDataQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<TerminationReasonSortModelInput>>>;
};


export type QueryTimeCodeArgs = {
  uid: Scalars['String']['input'];
};


export type QueryTimeCodesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  router?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimerEventsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<TimerEventsQueryModelInput>;
};


export type QueryTimerMetricsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<TimerMetricsQueryModelInput>;
};


export type QueryTimesheetArgs = {
  groupAllocationsByReferenceCode?: Scalars['Boolean']['input'];
  uid: Scalars['String']['input'];
};


export type QueryTimesheetSettingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  key: Scalars['String']['input'];
};


export type QueryTimesheetSettingsListArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<TimesheetSettingsPageModelInput>;
  query?: InputMaybe<TimesheetSettingsQueryModelInput>;
};


export type QueryTimesheetsArgs = {
  groupAllocationsByReferenceCode?: Scalars['Boolean']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  includeAllocations?: Scalars['Boolean']['input'];
  includeInvoices?: Scalars['Boolean']['input'];
  page?: InputMaybe<TimesheetPageModelInput>;
  q?: InputMaybe<TimesheetQueryModelInput>;
};


export type QueryUnrestrictedWidgetSettingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WidgetSettingSortModelInput>>>;
};


export type QueryUserArgs = {
  uid: Scalars['String']['input'];
};


export type QueryUserActivitiesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
};


export type QueryUserPreferencesArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<UserQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<PersonSortModelInput>>>;
};


export type QueryValidateEngagementHasPropertySetArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  input: EngagementDateEffectiveValidationQueryModelInput;
};


export type QueryValidatePersonsExistArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  q?: InputMaybe<PeopleQueryModelInput>;
};


export type QueryValidateReferenceIdsColumnArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  input: ReferenceIdColumnValidationQueryModelInput;
};


export type QueryValidateReferenceIdsRowArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  input: ReferenceIdRowValidationQueryModelInput;
};


export type QueryValidateSmartFormDefinitionArgs = {
  uid: Scalars['String']['input'];
};


export type QueryValidateTimesheetImportRowArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  input: TimesheetImportValidationQueryModelInput;
};


export type QueryWidgetSettingsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WidgetSettingSortModelInput>>>;
};


export type QueryWorkCalendarArgs = {
  uid: Scalars['String']['input'];
};


export type QueryWorkCalendarsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  onlyActive?: Scalars['Boolean']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkPostingSupplierGroupInstanceArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  workPostingUid: Scalars['String']['input'];
};


export type QueryWorkPostingSupplierInviteRevisionsArgs = {
  workPostingUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkRequestArgs = {
  uid: Scalars['String']['input'];
};


export type QueryWorkRequestRevisionsArgs = {
  workRequestUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWorkRequestsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  query?: InputMaybe<WorkRequestsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WorkRequestSortModelInput>>>;
};


export type QueryWorkScheduleArgs = {
  uid: Scalars['String']['input'];
};


export type QueryWorkSchedulesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  onlyActive?: Scalars['Boolean']['input'];
};


export type QueryWorkdayReferenceIdsArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query: WorkdayReferenceIdsByTypeQueryModelInput;
};


export type QueryWorkerEngagementsArgs = {
  cursorPage?: InputMaybe<CursorPageRequestModelInput>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<WorkerEngagementsQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WorkerEngagementsSortModelInput>>>;
  useLazyPermissionEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWorkerLocationCountriesArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryWorkerQualificationArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  uid: Scalars['String']['input'];
};


export type QueryWorkerQualificationRevisionsArgs = {
  uid: Scalars['String']['input'];
};


export type QueryWorkerQualificationsArgs = {
  filter?: InputMaybe<WorkerQualificationRootFilterModelInput>;
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
};


export type QueryWorkerQualificationsByEngagementArgs = {
  engagementUid: Scalars['String']['input'];
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
};


export type QueryWorkerQualificationsByWorkerArgs = {
  page?: InputMaybe<PageModelInput>;
  personUid: Scalars['String']['input'];
};


export type QueryWorkersArgs = {
  havingPermissionAction?: InputMaybe<PermissionAction>;
  havingPermissionName?: InputMaybe<PermissionName>;
  page?: InputMaybe<PageModelInput>;
  query?: InputMaybe<PeopleQueryModelInput>;
  sort?: InputMaybe<Array<InputMaybe<WorkerSortModelInput>>>;
};

export type QuickReportCreateModelInput = {
  default: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  quickReportId?: InputMaybe<Scalars['String']['input']>;
  quickReportQuery?: InputMaybe<Scalars['String']['input']>;
  quickReportSort?: InputMaybe<Scalars['String']['input']>;
  quickReportType?: InputMaybe<QuickReportTypeModel>;
  relativePlacement?: InputMaybe<Scalars['Int']['input']>;
};

export type QuickReportCreateUpdateModelInput = {
  default: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  quickReportId?: InputMaybe<Scalars['String']['input']>;
  quickReportQuery?: InputMaybe<Scalars['String']['input']>;
  quickReportSort?: InputMaybe<Scalars['String']['input']>;
  quickReportType?: InputMaybe<QuickReportTypeModel>;
  relativePlacement: Scalars['Int']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QuickReportModel = {
  __typename?: 'QuickReportModel';
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  personUid?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  quickReportId?: Maybe<Scalars['String']['output']>;
  quickReportQuery?: Maybe<Scalars['String']['output']>;
  quickReportSchedule?: Maybe<ReportScheduleModel>;
  quickReportSort?: Maybe<Scalars['String']['output']>;
  quickReportType?: Maybe<QuickReportTypeModel>;
  relativePlacement: Scalars['Int']['output'];
  /** @deprecated Use schedule() instead */
  schedule?: Maybe<QuickReportScheduleModel>;
  uid: Scalars['String']['output'];
};


export type QuickReportModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickReportPatchModelInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  quickReportQuery?: InputMaybe<Scalars['String']['input']>;
  quickReportSort?: InputMaybe<Scalars['String']['input']>;
  relativePlacement?: InputMaybe<Scalars['Int']['input']>;
};

export type QuickReportQueryModelInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  quickReportType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum QuickReportScheduleEntityTypeModel {
  Contracts = 'CONTRACTS',
  Expenses = 'EXPENSES',
  HeadcountReport = 'HEADCOUNT_REPORT',
  Invoices = 'INVOICES',
  JobApplications = 'JOB_APPLICATIONS',
  People = 'PEOPLE',
  Suppliers = 'SUPPLIERS',
  Timesheets = 'TIMESHEETS',
  WorkerEngagements = 'WORKER_ENGAGEMENTS',
  WorkPostings = 'WORK_POSTINGS',
  WorkRequests = 'WORK_REQUESTS'
}

export enum QuickReportScheduleFileFormatModel {
  Csv = 'CSV',
  Google = 'GOOGLE',
  Xlsx = 'XLSX'
}

export type QuickReportScheduleModel = {
  __typename?: 'QuickReportScheduleModel';
  entityType?: Maybe<QuickReportScheduleEntityTypeModel>;
  fileFormat?: Maybe<QuickReportScheduleFileFormatModel>;
  nextTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  quickReportUid?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  timeInterval?: Maybe<QuickReportScheduleTimeIntervalModel>;
  uid: Scalars['String']['output'];
  userUid?: Maybe<Scalars['String']['output']>;
};

export enum QuickReportScheduleTimeIntervalModel {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Every_4Hours = 'EVERY_4_HOURS',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export type QuickReportSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<QuickReportSortTypeModel>;
};

export enum QuickReportSortTypeModel {
  Default = 'DEFAULT',
  Name = 'NAME',
  RelativePlacement = 'RELATIVE_PLACEMENT',
  Type = 'TYPE',
  WorkerUid = 'WORKER_UID'
}

export enum QuickReportTypeModel {
  Contract = 'CONTRACT',
  Expense = 'EXPENSE',
  HeadcountReport = 'HEADCOUNT_REPORT',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  Organization = 'ORGANIZATION',
  Supplier = 'SUPPLIER',
  Timesheet = 'TIMESHEET',
  Worker = 'WORKER',
  WorkerEngagement = 'WORKER_ENGAGEMENT',
  WorkPosting = 'WORK_POSTING',
  WorkRequest = 'WORK_REQUEST'
}

export type QuickReportsCreateUpdateModelInput = {
  personUid?: InputMaybe<Scalars['String']['input']>;
  quickReports?: InputMaybe<Array<InputMaybe<QuickReportCreateUpdateModelInput>>>;
  type?: InputMaybe<QuickReportTypeModel>;
};

export type QuickReportsModel = {
  __typename?: 'QuickReportsModel';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  quickReports?: Maybe<Array<Maybe<QuickReportModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RateBillingVariableCreateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  default: Scalars['Boolean']['input'];
  defaultView?: InputMaybe<RateBillingVariableDefaultViewModel>;
  feesType?: InputMaybe<FeesTypeModel>;
  invoiceMapping?: InputMaybe<RateBillingVariableInvoiceMappingModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  payBillRateType?: InputMaybe<PayBillRateTypeModel>;
  rateType?: InputMaybe<RateTypeModel>;
  status?: InputMaybe<RateBillingVariableStatusModel>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum RateBillingVariableDefaultViewModel {
  Formula = 'FORMULA',
  Static = 'STATIC'
}

export enum RateBillingVariableInvoiceMappingModel {
  Amount = 'AMOUNT',
  Fees = 'FEES',
  Tax = 'TAX'
}

export type RateBillingVariableModel = {
  __typename?: 'RateBillingVariableModel';
  code?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultView?: Maybe<RateBillingVariableDefaultViewModel>;
  feesType?: Maybe<FeesTypeModel>;
  invoiceMapping?: Maybe<RateBillingVariableInvoiceMappingModel>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated SD-32143 pay bill types are going to be deleted */
  payBillRateType?: Maybe<PayBillRateTypeModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  rateType?: Maybe<RateTypeModel>;
  status?: Maybe<RateBillingVariableStatusModel>;
  type?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


export type RateBillingVariableModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateBillingVariablePatchModelInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultView?: InputMaybe<RateBillingVariableDefaultViewModel>;
  feesType?: InputMaybe<FeesTypeModel>;
  invoiceMapping?: InputMaybe<RateBillingVariableInvoiceMappingModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  payBillRateType?: InputMaybe<PayBillRateTypeModel>;
  rateType?: InputMaybe<RateTypeModel>;
  status?: InputMaybe<RateBillingVariableStatusModel>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum RateBillingVariableStatusModel {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type RateCardComplexRateModel = {
  __typename?: 'RateCardComplexRateModel';
  code?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<FormulaRateModel>;
  invoiceMapping?: Maybe<InvoiceMappingModel>;
  name?: Maybe<Scalars['String']['output']>;
  rateType?: Maybe<RateTypeModel>;
  static?: Maybe<StaticRateModel>;
  type?: Maybe<ComplexRateTypeModel>;
};

export type RateCardComplexRateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  formula?: InputMaybe<FormulaRateModelInput>;
  invoiceMapping?: InputMaybe<InvoiceMappingModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  rateType?: InputMaybe<RateTypeModel>;
  static?: InputMaybe<StaticRateModelInput>;
  type?: InputMaybe<ComplexRateTypeModel>;
};

export type RateCardCreateModelInput = {
  billRate?: InputMaybe<RateInputModelInput>;
  businessSiteOverrideReferences?: InputMaybe<Array<InputMaybe<LocationImportableReferenceModelInput>>>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  doubleTimeRateInfo?: InputMaybe<RatesInfoInputModelInput>;
  frequency?: InputMaybe<RatePeriodModel>;
  jobProfileReference?: InputMaybe<JobProfileImportableReferenceModelInput>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overTimeRateInfo?: InputMaybe<RatesInfoInputModelInput>;
  payRate?: InputMaybe<RateInputModelInput>;
  rates?: InputMaybe<RateCardRatesModelInput>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  shiftRateInfo?: InputMaybe<ShiftRatesInfoInputModelInput>;
  supplierReference?: InputMaybe<SupplierImportableReferenceModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RateCardMinMaxModel = {
  __typename?: 'RateCardMinMaxModel';
  currency?: Maybe<Scalars['String']['output']>;
  feesRates?: Maybe<Array<Maybe<ComplexRateModel>>>;
  frequency?: Maybe<RatePeriodModel>;
  maximumRateAmount?: Maybe<Scalars['BigDecimal']['output']>;
  maximumRateCardUid?: Maybe<Scalars['String']['output']>;
  maximumRateCode?: Maybe<Scalars['String']['output']>;
  minimumRateAmount?: Maybe<Scalars['BigDecimal']['output']>;
  minimumRateCardUid?: Maybe<Scalars['String']['output']>;
  minimumRateCode?: Maybe<Scalars['String']['output']>;
  rateType?: Maybe<RateTypeModel>;
  taxRates?: Maybe<Array<Maybe<ComplexRateModel>>>;
};

export type RateCardModel = {
  __typename?: 'RateCardModel';
  billRate?: Maybe<RateModel>;
  businessSiteOverrides?: Maybe<Array<Maybe<LocationModel>>>;
  currency?: Maybe<CurrencyModel>;
  doubleTimeRateInfo?: Maybe<RatesInfoModel>;
  frequency?: Maybe<RatePeriodModel>;
  jobProfile?: Maybe<JobProfileModel>;
  markup?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overTimeRateInfo?: Maybe<RatesInfoModel>;
  payRate?: Maybe<RateModel>;
  rates?: Maybe<RateCardRatesModel>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  remoteWorkAddress?: Maybe<AddressModel>;
  shiftRateInfo?: Maybe<ShiftRatesInfoModel>;
  status?: Maybe<StatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
};


export type RateCardModelRatesArgs = {
  evaluateFormulas?: Scalars['Boolean']['input'];
};


export type RateCardModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type RateCardModelInput = {
  billRate?: InputMaybe<RateModelInput>;
  businessSiteOverrides?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  currency?: InputMaybe<CurrencyModelInput>;
  doubleTimeRateInfo?: InputMaybe<RatesInfoModelInput>;
  frequency?: InputMaybe<RatePeriodModel>;
  jobProfile?: InputMaybe<JobProfileModelInput>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overTimeRateInfo?: InputMaybe<RatesInfoModelInput>;
  payRate?: InputMaybe<RateModelInput>;
  rates?: InputMaybe<RateCardRatesModelInput>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  shiftRateInfo?: InputMaybe<ShiftRatesInfoModelInput>;
  status?: InputMaybe<StatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RateCardPatchModelInput = {
  billRate?: InputMaybe<RateInputModelInput>;
  businessSiteOverrideReferences?: InputMaybe<Array<InputMaybe<LocationImportableReferenceModelInput>>>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  doubleTimeRateInfo?: InputMaybe<RatesInfoInputModelInput>;
  frequency?: InputMaybe<RatePeriodModel>;
  jobProfileReference?: InputMaybe<JobProfileImportableReferenceModelInput>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overTimeRateInfo?: InputMaybe<RatesInfoInputModelInput>;
  payRate?: InputMaybe<RateInputModelInput>;
  rates?: InputMaybe<RateCardRatesModelInput>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  shiftRateInfo?: InputMaybe<ShiftRatesInfoInputModelInput>;
  supplierReference?: InputMaybe<SupplierImportableReferenceModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RateCardQueryModelInput = {
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RateCardRatesModel = {
  __typename?: 'RateCardRatesModel';
  items?: Maybe<Array<Maybe<RateCardComplexRateModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RateCardRatesModelInput = {
  items?: InputMaybe<Array<InputMaybe<RateCardComplexRateModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type RateCardSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<RateCardSortTypeModel>;
};

export enum RateCardSortTypeModel {
  Name = 'NAME',
  ReferenceCode = 'REFERENCE_CODE',
  ReferenceId = 'REFERENCE_ID'
}

export type RateCardsModel = {
  __typename?: 'RateCardsModel';
  elements?: Maybe<Array<Maybe<RateCardModel>>>;
  items?: Maybe<Array<Maybe<RateCardModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum RateDefaultViewModel {
  Formula = 'FORMULA',
  Static = 'STATIC'
}

export type RateDefinitionModel = {
  __typename?: 'RateDefinitionModel';
  rateDefaultView?: Maybe<RateDefaultViewModel>;
  rateInvoiceMapping?: Maybe<RateInvoiceMappingModel>;
  rateType?: Maybe<RateTypeEnumModel>;
};

export type RateDefinitionModelInput = {
  rateDefaultView?: InputMaybe<RateDefaultViewModel>;
  rateInvoiceMapping?: InputMaybe<RateInvoiceMappingModel>;
  rateType?: InputMaybe<RateTypeEnumModel>;
};

export type RateInputModelInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
};

export enum RateInvoiceMappingModel {
  Amount = 'AMOUNT',
  Fees = 'FEES',
  Tax = 'TAX'
}

export type RateModel = {
  __typename?: 'RateModel';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type RateModelInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum RatePeriodModel {
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  OnInvoice = 'ON_INVOICE',
  Weekly = 'WEEKLY'
}

export enum RateTypeEnumModel {
  BillRate = 'BILL_RATE',
  PayRate = 'PAY_RATE'
}

export enum RateTypeModel {
  BillRate = 'BILL_RATE',
  PayRate = 'PAY_RATE'
}

export type RatesInfoInputModelInput = {
  billRate: Scalars['Float']['input'];
  markup: Scalars['Float']['input'];
  payRate: Scalars['Float']['input'];
};

export type RatesInfoModel = {
  __typename?: 'RatesInfoModel';
  billRate?: Maybe<Scalars['Float']['output']>;
  markup?: Maybe<Scalars['Float']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
};

export type RatesInfoModelInput = {
  billRate?: InputMaybe<Scalars['Float']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
};

export type RatesModel = {
  __typename?: 'RatesModel';
  items?: Maybe<Array<Maybe<ComplexRateModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RatesModelInput = {
  items?: InputMaybe<Array<InputMaybe<ComplexRateModelInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeModel = {
  __typename?: 'RecipeModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recipeEncryption?: Maybe<MediaModel>;
  recipeReferences: Scalars['Int']['output'];
  recipeXml?: Maybe<MediaModel>;
  recipeXslts?: Maybe<Array<Maybe<MediaModel>>>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};

export type RecipePatchModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  recipeEncryptionMediaUid?: InputMaybe<Scalars['String']['input']>;
  recipeXmlMediaUid?: InputMaybe<Scalars['String']['input']>;
  recipeXsltMediaUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesModel = {
  __typename?: 'RecipesModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<RecipeModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type RecommendationDefinitionModel = {
  __typename?: 'RecommendationDefinitionModel';
  options?: Maybe<Array<Maybe<RecommendationOptionModel>>>;
  uid: Scalars['String']['output'];
};

export type RecommendationDefinitionMutationModelInput = {
  options?: InputMaybe<Array<InputMaybe<RecommendationOptionModelInput>>>;
};

export enum RecommendationOptionActionModel {
  AssociatedProcess = 'ASSOCIATED_PROCESS',
  ContinuePageFlow = 'CONTINUE_PAGE_FLOW',
  RedirectUrl = 'REDIRECT_URL'
}

export type RecommendationOptionModel = {
  __typename?: 'RecommendationOptionModel';
  action?: Maybe<RecommendationOptionActionModel>;
  description?: Maybe<Scalars['String']['output']>;
  imageUid?: Maybe<Scalars['String']['output']>;
  processDefinitionUid?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RecommendationOptionModelInput = {
  action?: InputMaybe<RecommendationOptionActionModel>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUid?: InputMaybe<Scalars['String']['input']>;
  processDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecordErrorModel = {
  __typename?: 'RecordErrorModel';
  issues?: Maybe<Array<Maybe<RecordIssueModel>>>;
  recordNumber?: Maybe<Scalars['Long']['output']>;
};

export type RecordIssueModel = {
  __typename?: 'RecordIssueModel';
  header?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recordNumber?: Maybe<Scalars['Long']['output']>;
  severity?: Maybe<RecordIssueSeverityModel>;
};

export enum RecordIssueSeverityModel {
  Fatal = 'FATAL',
  Warning = 'WARNING'
}

export type ReferenceDataQueryModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type ReferenceDateOffsetDistributionRuleInstanceModel = {
  __typename?: 'ReferenceDateOffsetDistributionRuleInstanceModel';
  referenceDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  subType?: Maybe<DistributionRuleSubTypeModel>;
  timeOffset?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type ReferenceDateOffsetDistributionRuleModel = {
  __typename?: 'ReferenceDateOffsetDistributionRuleModel';
  referenceDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  subType?: Maybe<DistributionRuleSubTypeModel>;
  timeOffset?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type ReferenceDateOffsetRuleCreateModelInput = {
  referenceDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  subType?: InputMaybe<DistributionRuleSubTypeModel>;
  timeOffset?: InputMaybe<RuleTimeOffsetInputModelInput>;
};

export enum ReferenceEntityTypeModel {
  BusinessSite = 'BUSINESS_SITE',
  Classification = 'CLASSIFICATION',
  Company = 'COMPANY',
  CostCenter = 'COST_CENTER',
  HolidaySchedule = 'HOLIDAY_SCHEDULE',
  JobFamily = 'JOB_FAMILY',
  JobProfile = 'JOB_PROFILE',
  Organization = 'ORGANIZATION',
  Role = 'ROLE',
  Supplier = 'SUPPLIER',
  WorkSchedule = 'WORK_SCHEDULE'
}

export type ReferenceIdColumnValidationQueryModelInput = {
  currentEntityReferenceId?: InputMaybe<Scalars['String']['input']>;
  urn?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<ReferenceIdsColumnValueModelInput>>>;
};

export type ReferenceIdModel = {
  __typename?: 'ReferenceIdModel';
  descriptor?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  wid?: Maybe<Scalars['String']['output']>;
};

export type ReferenceIdRowValidationQueryModelInput = {
  currentEntityReferenceId?: InputMaybe<Scalars['String']['input']>;
  urnToValueMap?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  urnToValuesMap?: InputMaybe<Scalars['Map_String_List_StringScalar']['input']>;
};

export type ReferenceIdValidationModel = {
  __typename?: 'ReferenceIdValidationModel';
  index?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<ReferenceIdValidationResultModel>;
  urn?: Maybe<Scalars['String']['output']>;
};

export type ReferenceIdValidationResultModel = {
  __typename?: 'ReferenceIdValidationResultModel';
  message?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type ReferenceIdValidationsModel = {
  __typename?: 'ReferenceIdValidationsModel';
  validations?: Maybe<Array<Maybe<ReferenceIdValidationModel>>>;
};

export type ReferenceIdsColumnValueModelInput = {
  index: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceIdsModel = {
  __typename?: 'ReferenceIdsModel';
  items?: Maybe<Array<Maybe<ReferenceIdModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReferenceModel = {
  __typename?: 'ReferenceModel';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type ReferencesModel = {
  __typename?: 'ReferencesModel';
  items?: Maybe<Array<Maybe<ReferenceModel>>>;
};

export type RelativeDateRangeModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  offset?: InputMaybe<Scalars['String']['input']>;
  timeFrom?: InputMaybe<Scalars['LocalTime']['input']>;
  timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
  timeUnit?: InputMaybe<TimeUnitModel>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  type?: InputMaybe<DateTypeModel>;
};

export enum RelativeDateTimeUnitModel {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum RelativeDateUnitModel {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type RelativeLocalDateModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['LocalDate']['input']>;
  unit?: InputMaybe<RelativeDateUnitModel>;
};

export type RelativeLocalDateTimeModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['LocalDateTime']['input']>;
  unit?: InputMaybe<RelativeDateTimeUnitModel>;
};

export type RemoteLocationsFilterModelInput = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasGeolocation?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoteWorkAddressFilterModelInput = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportColumnModel = {
  __typename?: 'ReportColumnModel';
  customField?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  fieldType?: Maybe<FieldType>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportColumnModelInput = {
  customField?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  entities?: InputMaybe<Array<InputMaybe<OcExportEntityModel>>>;
  fieldType?: InputMaybe<FieldType>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ReportConfigurationCreateModelInput = {
  columns?: InputMaybe<Array<InputMaybe<ReportColumnModelInput>>>;
  derivedFromUid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<Array<InputMaybe<OcExportEntityModel>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<CustomReportScheduleModelInput>;
  status?: InputMaybe<ReportConfigurationStatus>;
  templateReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type ReportConfigurationListModel = {
  __typename?: 'ReportConfigurationListModel';
  items?: Maybe<Array<Maybe<ReportConfigurationResponseModel>>>;
};

export type ReportConfigurationResponseModel = {
  __typename?: 'ReportConfigurationResponseModel';
  columns?: Maybe<Array<Maybe<ReportColumnModel>>>;
  derivedFromName?: Maybe<Scalars['String']['output']>;
  derivedFromUid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  lastModified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownershipType?: Maybe<OwnershipTypeModel>;
  query?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<ReportScheduleModel>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateReferenceId?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export enum ReportConfigurationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportConfigurationUpdateModelInput = {
  columns?: InputMaybe<Array<InputMaybe<ReportColumnModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<CustomReportScheduleModelInput>;
};

export type ReportConfigurationsCreateModelInput = {
  force: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<InputMaybe<ReportConfigurationCreateModelInput>>>;
  ownershipType?: InputMaybe<OwnershipTypeModel>;
};

export type ReportConfigurationsQueryModelInput = {
  expand?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipTypes?: InputMaybe<Array<InputMaybe<OwnershipTypeModel>>>;
};

export type ReportConfigurationsSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<ReportConfigurationsSortTypeModel>;
};

export enum ReportConfigurationsSortTypeModel {
  LastModified = 'LAST_MODIFIED',
  Name = 'NAME',
  Template = 'TEMPLATE'
}

export type ReportScheduleCreateModelInput = {
  additionalProperties?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  entityType?: InputMaybe<OcExportEntityModel>;
  fileFormat?: InputMaybe<OcExportTypeModel>;
  querySourceUid?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<ScheduleQuerySourceType>;
  startTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  targetSftpDirectoryUid?: InputMaybe<Scalars['String']['input']>;
  timeInterval?: InputMaybe<ScheduleTimeIntervalModel>;
};

export type ReportScheduleModel = {
  __typename?: 'ReportScheduleModel';
  fileFormat?: Maybe<OcExportTypeModel>;
  nextTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  querySourceUid?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<ScheduleQuerySourceType>;
  startTimestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  targetSftpDirectoryUid?: Maybe<Scalars['String']['output']>;
  timeInterval?: Maybe<ScheduleTimeIntervalModel>;
  uid: Scalars['String']['output'];
  userUid?: Maybe<Scalars['String']['output']>;
};

export type ReportScheduleUpdateModelInput = {
  fileFormat?: InputMaybe<OcExportTypeModel>;
  startTimestamp?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  targetSftpDirectoryUid?: InputMaybe<Scalars['String']['input']>;
  timeInterval?: InputMaybe<ScheduleTimeIntervalModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateColumnModel = {
  __typename?: 'ReportTemplateColumnModel';
  customField?: Maybe<Scalars['Boolean']['output']>;
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  /** @deprecated Use plural field instead. */
  entity?: Maybe<OcExportEntityModel>;
  fieldType?: Maybe<FieldType>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateFilterModel = {
  __typename?: 'ReportTemplateFilterModel';
  customField?: Maybe<Scalars['Boolean']['output']>;
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  /** @deprecated use plural version instead */
  entity?: Maybe<OcExportEntityModel>;
  fieldType?: Maybe<FieldType>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateListModel = {
  __typename?: 'ReportTemplateListModel';
  items?: Maybe<Array<Maybe<ReportTemplateModel>>>;
};

export type ReportTemplateModel = {
  __typename?: 'ReportTemplateModel';
  columns?: Maybe<Array<Maybe<ReportTemplateColumnModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<Maybe<OcExportEntityModel>>>;
  filters?: Maybe<Array<Maybe<ReportTemplateFilterModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type RequiresActionReasonModel = {
  __typename?: 'RequiresActionReasonModel';
  costCenter?: Maybe<CostCenterUnavailableModel>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  financialField?: Maybe<FinancialFieldUnavailableModel>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  timeCode?: Maybe<TimeCodeMisconfiguredModel>;
  type?: Maybe<RequiresActionReasonTypeModel>;
};

export type RequiresActionReasonModelInput = {
  costCenter?: InputMaybe<CostCenterUnavailableModelInput>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  financialField?: InputMaybe<FinancialFieldUnavailableModelInput>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  timeCode?: InputMaybe<TimeCodeMisconfiguredModelInput>;
  type?: InputMaybe<RequiresActionReasonTypeModel>;
};

export enum RequiresActionReasonTypeModel {
  CostCenterUnavailable = 'COST_CENTER_UNAVAILABLE',
  FinancialFieldUnavailable = 'FINANCIAL_FIELD_UNAVAILABLE',
  TimeCodeMisconfigured = 'TIME_CODE_MISCONFIGURED'
}

export type ResourceMetadataModel = {
  __typename?: 'ResourceMetadataModel';
  label?: Maybe<Scalars['String']['output']>;
  permissionName?: Maybe<Scalars['String']['output']>;
};

export type ResourceMetadataModelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  permissionName?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceNodeModel = {
  __typename?: 'ResourceNodeModel';
  children?: Maybe<Array<Maybe<ResourceNodeModel>>>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ResourceNodesModel = {
  __typename?: 'ResourceNodesModel';
  resourceNodes?: Maybe<Array<Maybe<ResourceNodeModel>>>;
};

export type ResourceTypesModel = {
  __typename?: 'ResourceTypesModel';
  validTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ResponsibleParty {
  Msp = 'MSP',
  Person = 'PERSON',
  Supplier = 'SUPPLIER',
  Unassigned = 'UNASSIGNED'
}

export type RetroactiveChangeCreateOrUpdateModelInput = {
  requester?: InputMaybe<PersonModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  validTo?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type RetroactiveChangeModel = {
  __typename?: 'RetroactiveChangeModel';
  committed?: Maybe<Scalars['OffsetDateTime']['output']>;
  person?: Maybe<PersonModel>;
  requester?: Maybe<PersonModel>;
  uid: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['LocalDate']['output']>;
  validTo?: Maybe<Scalars['LocalDate']['output']>;
};

export enum RevType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export enum RevisionFieldChangeModel {
  Cleared = 'CLEARED',
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type RevisionFieldChangesModel = {
  __typename?: 'RevisionFieldChangesModel';
  fields?: Maybe<Array<Maybe<FieldReferenceModel>>>;
  type?: Maybe<RevisionFieldChangeModel>;
};

export type RevisionModel = {
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type RevisionQueryModelInput = {
  deliveredfields?: InputMaybe<Array<InputMaybe<FieldKeyModel>>>;
  includeRetroactiveChanges?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedSince?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

export type RevisionsModel = {
  __typename?: 'RevisionsModel';
  engagementRevisions?: Maybe<Array<Maybe<EngagementRevisionModel>>>;
  orgMembershipRevisions?: Maybe<Array<Maybe<OrgMembershipRevisionModel>>>;
  personRevisions?: Maybe<Array<Maybe<PersonRevisionModel>>>;
  queryEngagementRevisions?: Maybe<Array<Maybe<EngagementRevisionModel>>>;
  queryOrgMembershipRevisions?: Maybe<Array<Maybe<OrgMembershipRevisionModel>>>;
  queryPersonRevisions?: Maybe<Array<Maybe<PersonRevisionModel>>>;
};


export type RevisionsModelEngagementRevisionsArgs = {
  changeSetUid?: InputMaybe<Scalars['String']['input']>;
  engagementUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeRetroactiveChanges?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RevisionsModelOrgMembershipRevisionsArgs = {
  engagementUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RevisionsModelPersonRevisionsArgs = {
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RevisionsModelQueryEngagementRevisionsArgs = {
  changeSetUid?: InputMaybe<Scalars['String']['input']>;
  engagementUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};


export type RevisionsModelQueryOrgMembershipRevisionsArgs = {
  engagementUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};


export type RevisionsModelQueryPersonRevisionsArgs = {
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<RevisionQueryModelInput>;
};

export type RoleAssignmentModel = {
  __typename?: 'RoleAssignmentModel';
  assignee?: Maybe<PersonModel>;
  costCenter?: Maybe<CostCenterModel>;
  country?: Maybe<CountryModel>;
  location?: Maybe<LocationModel>;
  org?: Maybe<OrgModel>;
  role?: Maybe<RoleModel>;
};

export enum RoleAssignmentTypeModel {
  Default = 'DEFAULT',
  Explicit = 'EXPLICIT',
  Inherited = 'INHERITED'
}

export type RoleAssignmentWithReferencesModel = {
  __typename?: 'RoleAssignmentWithReferencesModel';
  assignees?: Maybe<Array<Maybe<AssigneeModel>>>;
  businessSiteReferenceId?: Maybe<Scalars['String']['output']>;
  costCenterReferenceId?: Maybe<Scalars['String']['output']>;
  orgReferenceId?: Maybe<Scalars['String']['output']>;
  roleReferenceId?: Maybe<Scalars['String']['output']>;
};

export type RoleAssignmentWithReferencesModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<AssigneeModelInput>>>;
  businessSiteReferenceId?: InputMaybe<Scalars['String']['input']>;
  costCenterReferenceId?: InputMaybe<Scalars['String']['input']>;
  orgReferenceId?: InputMaybe<Scalars['String']['input']>;
  roleReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type RoleAssignmentsModel = {
  __typename?: 'RoleAssignmentsModel';
  assignees?: Maybe<Array<Maybe<PersonModel>>>;
  inheritedFromOrg?: Maybe<OrgModel>;
  role?: Maybe<RoleModel>;
  type?: Maybe<RoleAssignmentTypeModel>;
};

export type RoleAssignmentsModelInput = {
  assignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  inheritedFromOrg?: InputMaybe<OrgModelInput>;
  role?: InputMaybe<RoleModelInput>;
  type?: InputMaybe<RoleAssignmentTypeModel>;
};

export type RoleAssignmentsUpdateError = {
  __typename?: 'RoleAssignmentsUpdateError';
  error?: Maybe<Scalars['String']['output']>;
  incorrectUpdate?: Maybe<RoleAssignmentWithReferencesModel>;
};

export type RoleAssignmentsUpdateResultModel = {
  __typename?: 'RoleAssignmentsUpdateResultModel';
  accepted?: Maybe<Array<Maybe<RoleAssignmentWithReferencesModel>>>;
  incorrectEntityReferenceCountErrors?: Maybe<Array<Maybe<RoleAssignmentsUpdateError>>>;
  missingEntityReferenceErrors?: Maybe<Array<Maybe<RoleAssignmentsUpdateError>>>;
  missingRoleErrors?: Maybe<Array<Maybe<RoleAssignmentsUpdateError>>>;
  missingWorkerErrors?: Maybe<Array<Maybe<RoleAssignmentsUpdateError>>>;
};

export type RoleAssignmentsWithReferencesModel = {
  __typename?: 'RoleAssignmentsWithReferencesModel';
  items?: Maybe<Array<Maybe<RoleAssignmentWithReferencesModel>>>;
};

export type RoleModel = {
  __typename?: 'RoleModel';
  /** @deprecated use referenceId */
  code?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  defaultAssignee?: Maybe<PersonModel>;
  defaultAssignees?: Maybe<Array<Maybe<PersonModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  explicitCostCenterRoleAssignments?: Maybe<Array<Maybe<CostCenterRoleAssignmentsModel>>>;
  explicitCountryRoleAssignments?: Maybe<Array<Maybe<CountryRoleAssignmentsModel>>>;
  explicitLocationRoleAssignments?: Maybe<Array<Maybe<LocationRoleAssignmentsModel>>>;
  explicitOrgRoleAssignments?: Maybe<Array<Maybe<OrgRoleAssignmentsModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  permissionsConfiguration?: Maybe<RolePermissionsConfigurationModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RoleStatusModel>;
  uid: Scalars['String']['output'];
};


export type RoleModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  defaultAssignee?: InputMaybe<PersonModelInput>;
  defaultAssignees?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  explicitCostCenterRoleAssignments?: InputMaybe<Array<InputMaybe<CostCenterRoleAssignmentsModelInput>>>;
  explicitCountryRoleAssignments?: InputMaybe<Array<InputMaybe<CountryRoleAssignmentsModelInput>>>;
  explicitLocationRoleAssignments?: InputMaybe<Array<InputMaybe<LocationRoleAssignmentsModelInput>>>;
  explicitOrgRoleAssignments?: InputMaybe<Array<InputMaybe<OrgRoleAssignmentsModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  permissionsConfiguration?: InputMaybe<RolePermissionsConfigurationModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RoleStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RolePermissionsConfigurationModel = {
  __typename?: 'RolePermissionsConfigurationModel';
  timesheets?: Maybe<TimesheetRolePermissionsConfigurationModel>;
};

export type RolePermissionsConfigurationModelInput = {
  timesheets?: InputMaybe<TimesheetRolePermissionsConfigurationModelInput>;
};

export enum RoleStatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type RolesModel = {
  __typename?: 'RolesModel';
  roles?: Maybe<Array<Maybe<RoleModel>>>;
};

export type RuleReferenceModel = {
  __typename?: 'RuleReferenceModel';
  crossEngagementCalculation: Scalars['Boolean']['output'];
  decisionTableDefinitionUid?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type RuleReferenceModelInput = {
  crossEngagementCalculation: Scalars['Boolean']['input'];
  decisionTableDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

export type RuleTimeOffsetInputModelInput = {
  unit?: InputMaybe<RuleTimeUnitModel>;
  value: Scalars['Long']['input'];
};

export enum RuleTimeUnitModel {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export type SamlIdentityProviderModel = {
  __typename?: 'SamlIdentityProviderModel';
  automaticUserProvisioningEnabled: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  fieldMappings?: Maybe<Array<Maybe<FieldMappingModel>>>;
  metadataUri?: Maybe<Scalars['URI']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  samlProperties?: Maybe<SamlPropertiesModel>;
  uid: Scalars['String']['output'];
  userAccess?: Maybe<UserAccessModel>;
  userLookup?: Maybe<UserLookupModel>;
};

export type SamlIdentityProviderModelInput = {
  automaticUserProvisioningEnabled: Scalars['Boolean']['input'];
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  fieldMappings?: InputMaybe<Array<InputMaybe<FieldMappingModelInput>>>;
  metadataUri?: InputMaybe<Scalars['URI']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  samlProperties?: InputMaybe<SamlPropertiesModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  userAccess?: InputMaybe<UserAccessModelInput>;
  userLookup?: InputMaybe<UserLookupModelInput>;
};

export type SamlPropertiesModel = {
  __typename?: 'SamlPropertiesModel';
  entityId?: Maybe<Scalars['String']['output']>;
  singleLogoutServiceUrl?: Maybe<Scalars['String']['output']>;
  singleSignOnServiceUrl?: Maybe<Scalars['String']['output']>;
  x509Cert?: Maybe<Scalars['String']['output']>;
};

export type SamlPropertiesModelInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  singleLogoutServiceUrl?: InputMaybe<Scalars['String']['input']>;
  singleSignOnServiceUrl?: InputMaybe<Scalars['String']['input']>;
  x509Cert?: InputMaybe<Scalars['String']['input']>;
};

export enum ScheduleQuerySourceType {
  CustomReport = 'CUSTOM_REPORT',
  QuickView = 'QUICK_VIEW'
}

export enum ScheduleTimeIntervalModel {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Every_4Hours = 'EVERY_4_HOURS',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export type ScoredRecommendationOptionModel = {
  __typename?: 'ScoredRecommendationOptionModel';
  option?: Maybe<RecommendationOptionModel>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type ScoredRecommendationOptionModelInput = {
  option?: InputMaybe<RecommendationOptionModelInput>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type SecondaryPersonModel = {
  __typename?: 'SecondaryPersonModel';
  companyWorkerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationalIds?: Maybe<Array<Maybe<NationalIdModel>>>;
  nationalIdsMasked?: Maybe<Array<Maybe<NationalIdMaskedModel>>>;
  personUid?: Maybe<Scalars['String']['output']>;
};

export type SecondaryPersonModelInput = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalIds?: InputMaybe<Array<InputMaybe<NationalIdModelInput>>>;
  nationalIdsMasked?: InputMaybe<Array<InputMaybe<NationalIdMaskedModelInput>>>;
  personUid?: InputMaybe<Scalars['String']['input']>;
};

export type SecurityPoliciesActorUserModelInput = {
  classificationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userRoles?: InputMaybe<Array<InputMaybe<UserRoleModel>>>;
};

export type SecurityPoliciesModel = {
  __typename?: 'SecurityPoliciesModel';
  elements?: Maybe<Array<Maybe<PolicyRuleModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  rules?: Maybe<Array<Maybe<PolicyRuleModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SecurityPoliciesQueryModelInput = {
  actions?: InputMaybe<Array<InputMaybe<PermissionAction>>>;
  actor?: InputMaybe<SecurityPoliciesActorUserModelInput>;
  actorRelationships?: InputMaybe<Array<InputMaybe<PermissionRelationship>>>;
  category?: InputMaybe<PolicyGroupCategoryModel>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdRange?: InputMaybe<DateRangeModelInput>;
  hasAdvancedCondition?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<PolicyRuleKindModel>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedRange?: InputMaybe<DateRangeModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleRelationships?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<PolicyRuleStatusModel>>>;
};

export type SecurityPoliciesSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<SecurityPoliciesSortTypeModel>;
};

export enum SecurityPoliciesSortTypeModel {
  Created = 'CREATED',
  Modified = 'MODIFIED',
  Name = 'NAME',
  Status = 'STATUS'
}

export type SenioritiesModel = {
  __typename?: 'SenioritiesModel';
  items?: Maybe<Array<Maybe<SeniorityModel>>>;
};

export type SeniorityCreateModelInput = {
  assignable: Scalars['Boolean']['input'];
  experienceRange?: InputMaybe<ExperienceRangeModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SeniorityModel = {
  __typename?: 'SeniorityModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  experienceRange?: Maybe<ExperienceRangeModel>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
};

export type SeniorityModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  experienceRange?: InputMaybe<ExperienceRangeModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SeniorityPatchModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  experienceRange?: InputMaybe<ExperienceRangeModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum SentimentModel {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SequenceFlowModel = {
  __typename?: 'SequenceFlowModel';
  fieldConditions?: Maybe<Array<Maybe<FieldConditionModel>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourcePortalIndex?: Maybe<Scalars['Int']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetPortalIndex?: Maybe<Scalars['Int']['output']>;
};

export type SequenceFlowModelInput = {
  fieldConditions?: InputMaybe<Array<InputMaybe<FieldConditionModelInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourcePortalIndex?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetPortalIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type SequenceGeneratorCreateModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SequenceGeneratorModel = {
  __typename?: 'SequenceGeneratorModel';
  code?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
};


export type SequenceGeneratorModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SequenceGeneratorsModel = {
  __typename?: 'SequenceGeneratorsModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SequenceGeneratorModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export enum ServiceProviderFieldModel {
  CompanyWorkerId = 'COMPANY_WORKER_ID',
  CustomField = 'CUSTOM_FIELD',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export enum SexualOrientationModel {
  AnotherSexualOrientation = 'ANOTHER_SEXUAL_ORIENTATION',
  AsexualOrAce = 'ASEXUAL_OR_ACE',
  BisexualOrBi = 'BISEXUAL_OR_BI',
  Gay = 'GAY',
  HeterosexualOrStraight = 'HETEROSEXUAL_OR_STRAIGHT',
  Lesbian = 'LESBIAN',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER'
}

export type SftpDirectoryCreateModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SftpDirectoryModel = {
  __typename?: 'SftpDirectoryModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  sftpUser?: Maybe<SftpUserModel>;
  uid: Scalars['String']['output'];
};


export type SftpDirectoryModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SftpSshKeyModel = {
  __typename?: 'SftpSshKeyModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  daysTillExpiry?: Maybe<Scalars['Int']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  invalidated?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  sftpUser?: Maybe<SftpUserModel>;
  uid: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['LocalDate']['output']>;
};


export type SftpSshKeyModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SftpUserModel = {
  __typename?: 'SftpUserModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};


export type SftpUserModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShiftRatesInfoInputModelInput = {
  billRate: Scalars['Float']['input'];
  factor: Scalars['Float']['input'];
  payRate: Scalars['Float']['input'];
};

export type ShiftRatesInfoModel = {
  __typename?: 'ShiftRatesInfoModel';
  billRate?: Maybe<Scalars['Float']['output']>;
  factor?: Maybe<Scalars['Float']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
};

export type ShiftRatesInfoModelInput = {
  billRate?: InputMaybe<Scalars['Float']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SignalEventDefinitionModel = {
  __typename?: 'SignalEventDefinitionModel';
  id?: Maybe<Scalars['String']['output']>;
  signalName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SignalEventDefinitionTypeModel>;
};

export type SignalEventDefinitionModelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  signalName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SignalEventDefinitionTypeModel>;
};

export enum SignalEventDefinitionTypeModel {
  CancelTask = 'CANCEL_TASK',
  ExitPageflow = 'EXIT_PAGEFLOW',
  RejectTask = 'REJECT_TASK'
}

export type SignalModel = {
  __typename?: 'SignalModel';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SignalEventDefinitionTypeModel>;
};

export type SignalTasksResultModel = {
  __typename?: 'SignalTasksResultModel';
  failed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  missingSignalType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successful?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SignalsModel = {
  __typename?: 'SignalsModel';
  signals?: Maybe<Array<Maybe<SignalModel>>>;
};

export type SkillModel = {
  __typename?: 'SkillModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  escoUri?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  escoUri?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmartFormDefinitionCreationModelInput = {
  availableToEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  availableToSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  schemaVersion: Scalars['Int']['input'];
  scope?: InputMaybe<SmartFormDefinitionScopeModel>;
  status?: InputMaybe<SmartFormDefinitionStatusModel>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SmartFormDefinitionTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SmartFormDefinitionVisibilityModel>;
};

export type SmartFormDefinitionModel = {
  __typename?: 'SmartFormDefinitionModel';
  availableToEnterprise?: Maybe<Scalars['Boolean']['output']>;
  availableToSupplier?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<SmartFormDefinitionStatusModel>;
  structuredTemplate?: Maybe<SmartFormTemplateModel>;
  template?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SmartFormDefinitionTypeModel>;
  uid: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<SmartFormDefinitionVisibilityModel>;
};


export type SmartFormDefinitionModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmartFormDefinitionModelInput = {
  availableToEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  availableToSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SmartFormDefinitionStatusModel>;
  structuredTemplate?: InputMaybe<SmartFormTemplateModelInput>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SmartFormDefinitionTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<SmartFormDefinitionVisibilityModel>;
};

export enum SmartFormDefinitionScopeModel {
  Global = 'GLOBAL',
  Task = 'TASK'
}

export enum SmartFormDefinitionStatusModel {
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum SmartFormDefinitionTypeModel {
  AddContract = 'ADD_CONTRACT',
  AddEngagement = 'ADD_ENGAGEMENT',
  AddMilestone = 'ADD_MILESTONE',
  AddWorker = 'ADD_WORKER',
  AddWorkRequest = 'ADD_WORK_REQUEST',
  CorrectMilestone = 'CORRECT_MILESTONE',
  Engagement = 'ENGAGEMENT',
  JobApplication = 'JOB_APPLICATION',
  JobRequest = 'JOB_REQUEST',
  ManageContract = 'MANAGE_CONTRACT',
  ManageJobApplication = 'MANAGE_JOB_APPLICATION',
  ManageJobRequest = 'MANAGE_JOB_REQUEST',
  ManageMilestone = 'MANAGE_MILESTONE',
  ManageWorkRequest = 'MANAGE_WORK_REQUEST',
  OffboardWorker = 'OFFBOARD_WORKER',
  UpdateEngagement = 'UPDATE_ENGAGEMENT',
  UpdateWorker = 'UPDATE_WORKER',
  Worker = 'WORKER',
  WorkerQualification = 'WORKER_QUALIFICATION',
  WorkRequest = 'WORK_REQUEST'
}

export type SmartFormDefinitionUpdateModelInput = {
  availableToEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  availableToSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  schemaVersion: Scalars['Int']['input'];
  status?: InputMaybe<SmartFormDefinitionStatusModel>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SmartFormDefinitionTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SmartFormDefinitionVisibilityModel>;
};

export enum SmartFormDefinitionVisibilityModel {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SmartFormDefinitionsModel = {
  __typename?: 'SmartFormDefinitionsModel';
  items?: Maybe<Array<Maybe<SmartFormDefinitionModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SmartFormElementModel = {
  __typename?: 'SmartFormElementModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  fields?: Maybe<Array<Maybe<SmartFormFieldModel>>>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  multilineTextField?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SmartFormElementModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  fields?: InputMaybe<Array<InputMaybe<SmartFormFieldModelInput>>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  multilineTextField?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SmartFormFieldModel = {
  __typename?: 'SmartFormFieldModel';
  helpText?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  initialValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  validation?: Maybe<SmartFormValidationModel>;
};

export type SmartFormFieldModelInput = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  readonly: Scalars['Boolean']['input'];
  validation?: InputMaybe<SmartFormValidationModelInput>;
};

export type SmartFormPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<SmartFormSortModelInput>>>;
};

export type SmartFormQueryModelInput = {
  excludeNotAvailableToEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  excludeWorkerProfileSmartForms?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<SmartFormDefinitionScopeModel>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SmartFormDefinitionStatusModel>;
  type?: InputMaybe<SmartFormDefinitionTypeModel>;
  visibility?: InputMaybe<SmartFormDefinitionVisibilityModel>;
};

export type SmartFormSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<SmartFormSortTypeModel>;
};

export enum SmartFormSortTypeModel {
  AvailableToEnterprise = 'AVAILABLE_TO_ENTERPRISE',
  AvailableToSupplier = 'AVAILABLE_TO_SUPPLIER',
  LastUpdated = 'LAST_UPDATED',
  Name = 'NAME',
  Status = 'STATUS',
  Type = 'TYPE',
  Visibility = 'VISIBILITY'
}

export type SmartFormTemplateModel = {
  __typename?: 'SmartFormTemplateModel';
  elements?: Maybe<Array<Maybe<SmartFormElementModel>>>;
};

export type SmartFormTemplateModelInput = {
  elements?: InputMaybe<Array<InputMaybe<SmartFormElementModelInput>>>;
};

export type SmartFormValidationModel = {
  __typename?: 'SmartFormValidationModel';
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type SmartFormValidationModelInput = {
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SourcingTypeModel {
  Payroll = 'PAYROLL',
  PreIdentified = 'PRE_IDENTIFIED',
  Sourced = 'SOURCED'
}

export type SowResponseCreateModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<SowResponseStatusModel>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workPostingUid?: InputMaybe<Scalars['String']['input']>;
};

export type SowResponseModel = {
  __typename?: 'SowResponseModel';
  accountablePerson?: Maybe<PersonModel>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  contact?: Maybe<ContactInfoModel>;
  costCenter?: Maybe<CostCenterModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  deliveredFieldDefinitions?: Maybe<Scalars['Map_ConfigurableDeliveredFieldsModel_DeliveredFieldDefinitionModelScalar']['output']>;
  documents?: Maybe<GwgMediaModelResponse>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  status?: Maybe<SowResponseStatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
  workPosting?: Maybe<WorkPostingModel>;
};


export type SowResponseModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type SowResponseModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SowResponseModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SowResponseModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SowResponseModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SowResponseModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type SowResponseModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  company?: InputMaybe<CompanyModelInput>;
  contact?: InputMaybe<ContactInfoModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  deliveredFieldDefinitions?: InputMaybe<Scalars['DeliveredFieldDefinitionsModelScalar']['input']>;
  documents?: InputMaybe<GwgMediaModelResponseInput>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<SowResponseStatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workPosting?: InputMaybe<WorkPostingModelInput>;
};

export type SowResponsePatchModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<SowResponseStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SowResponseSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<SowResponseSortTypeModel>;
};

export enum SowResponseSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  LastModified = 'LAST_MODIFIED',
  Status = 'STATUS'
}

export enum SowResponseStatusModel {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
  SupplierDraft = 'SUPPLIER_DRAFT'
}

export type SowResponsesModel = {
  __typename?: 'SowResponsesModel';
  items?: Maybe<Array<Maybe<SowResponseModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SpendByBatchExecutionQueryModelInput = {
  batchExecutionUid?: InputMaybe<Scalars['String']['input']>;
};

export type SpendConfigModel = {
  __typename?: 'SpendConfigModel';
  spendApprovalEnabled: Scalars['Boolean']['output'];
};

export type SpendConfigUpdateModelInput = {
  spendApprovalEnabled: Scalars['Boolean']['input'];
};

export type SpendModel = {
  __typename?: 'SpendModel';
  elements?: Maybe<Array<Maybe<CostModel>>>;
  items?: Maybe<Array<Maybe<CostModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfoModel>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SpendQueryModelInput = {
  approvedDateTimeRange?: InputMaybe<RelativeDateRangeModelInput>;
  approvedFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  approvedUntil?: InputMaybe<Scalars['LocalDate']['input']>;
  batchExecutionUid?: InputMaybe<Scalars['String']['input']>;
  contractUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contractingPartyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engagementAccountablePersons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engagementBusinessSites?: InputMaybe<LocationsFilterModelInput>;
  engagementCustomFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  engagementCustomFieldsFilterMatch?: InputMaybe<CollectionFilterModel>;
  engagementHiringManagers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engagementOrganizations?: InputMaybe<Array<InputMaybe<WorkerEngagementOrgQueryModelInput>>>;
  engagementPurchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  engagementSuppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expenseCategoryReferenceId?: InputMaybe<Scalars['String']['input']>;
  expenseVendor?: InputMaybe<Scalars['String']['input']>;
  externalInvoiceDate?: InputMaybe<RelativeDateRangeModelInput>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  lineItem?: InputMaybe<LineItem>;
  lineItems?: InputMaybe<Array<InputMaybe<LineItem>>>;
  spendDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<CostStatus>>>;
  submissionDate?: InputMaybe<RelativeDateRangeModelInput>;
};

export type SsoConfigModel = {
  __typename?: 'SsoConfigModel';
  identityProviders?: Maybe<Array<Maybe<SamlIdentityProviderModel>>>;
};

export type SsoConfigUpdateModelInput = {
  identityProviders?: InputMaybe<Array<InputMaybe<SamlIdentityProviderModelInput>>>;
};

export type StartEventTypeConfigModel = {
  __typename?: 'StartEventTypeConfigModel';
  fieldConditionKeys?: Maybe<Array<Maybe<FieldKeyModel>>>;
  startEventType?: Maybe<StartEventTypeModel>;
};

export enum StartEventTypeModel {
  BatchExecutionStatusChanged = 'BATCH_EXECUTION_STATUS_CHANGED',
  BlueprintExecutionStatusChanged = 'BLUEPRINT_EXECUTION_STATUS_CHANGED',
  ContractChanged = 'CONTRACT_CHANGED',
  ContractCreated = 'CONTRACT_CREATED',
  ContractRelativeDate = 'CONTRACT_RELATIVE_DATE',
  ContractStatusChanged = 'CONTRACT_STATUS_CHANGED',
  EngagementChanged = 'ENGAGEMENT_CHANGED',
  EngagementCreated = 'ENGAGEMENT_CREATED',
  EngagementRelativeDate = 'ENGAGEMENT_RELATIVE_DATE',
  EngagementStatusChanged = 'ENGAGEMENT_STATUS_CHANGED',
  ExpenseRequiresReview = 'EXPENSE_REQUIRES_REVIEW',
  ExpenseStatusChanged = 'EXPENSE_STATUS_CHANGED',
  InvoiceStatusChanged = 'INVOICE_STATUS_CHANGED',
  JobApplicationsCreated = 'JOB_APPLICATIONS_CREATED',
  JobApplicationCreated = 'JOB_APPLICATION_CREATED',
  JobApplicationStageChanged = 'JOB_APPLICATION_STAGE_CHANGED',
  JobApplicationStatusChanged = 'JOB_APPLICATION_STATUS_CHANGED',
  JobProfileNotApplicable = 'JOB_PROFILE_NOT_APPLICABLE',
  JobRequestCreated = 'JOB_REQUEST_CREATED',
  JobRequestStatusChanged = 'JOB_REQUEST_STATUS_CHANGED',
  JobRequestSupplierInvited = 'JOB_REQUEST_SUPPLIER_INVITED',
  MilestoneChanged = 'MILESTONE_CHANGED',
  MilestoneCreated = 'MILESTONE_CREATED',
  MilestoneRelativeDate = 'MILESTONE_RELATIVE_DATE',
  MilestoneStatusChanged = 'MILESTONE_STATUS_CHANGED',
  PersonChanged = 'PERSON_CHANGED',
  SupplierCreated = 'SUPPLIER_CREATED',
  SystemStartConditionMet = 'SYSTEM_START_CONDITION_MET',
  TimesheetRelativeDate = 'TIMESHEET_RELATIVE_DATE',
  TimesheetRequiresReview = 'TIMESHEET_REQUIRES_REVIEW',
  TimesheetStatusChanged = 'TIMESHEET_STATUS_CHANGED',
  UserActionAddEngagement = 'USER_ACTION_ADD_ENGAGEMENT',
  UserActionAddWorker = 'USER_ACTION_ADD_WORKER',
  UserActionCreateContract = 'USER_ACTION_CREATE_CONTRACT',
  UserActionCreateMilestone = 'USER_ACTION_CREATE_MILESTONE',
  UserActionCreateWorkRequest = 'USER_ACTION_CREATE_WORK_REQUEST',
  UserActionEndEngagement = 'USER_ACTION_END_ENGAGEMENT',
  UserActionManageContract = 'USER_ACTION_MANAGE_CONTRACT',
  UserActionManageEngagement = 'USER_ACTION_MANAGE_ENGAGEMENT',
  UserActionManageJobApplication = 'USER_ACTION_MANAGE_JOB_APPLICATION',
  UserActionManageJobRequest = 'USER_ACTION_MANAGE_JOB_REQUEST',
  UserActionManageMilestone = 'USER_ACTION_MANAGE_MILESTONE',
  UserActionManageWorkRequest = 'USER_ACTION_MANAGE_WORK_REQUEST',
  WorkerQualificationRelativeDate = 'WORKER_QUALIFICATION_RELATIVE_DATE',
  WorkRequestCreated = 'WORK_REQUEST_CREATED',
  WorkRequestStatusChanged = 'WORK_REQUEST_STATUS_CHANGED'
}

export type StaticRateModel = {
  __typename?: 'StaticRateModel';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<RatePeriodModel>;
};

export type StaticRateModelInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<RatePeriodModel>;
};

export enum StatusModel {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type StringFilterModelInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<Scalars['String']['input']>;
  notIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubProcessDefinitionConfigModel = {
  __typename?: 'SubProcessDefinitionConfigModel';
  gatewayTypes?: Maybe<Array<Maybe<ProcessDefinitionGatewayTypeModel>>>;
  startEventTypeConfigs?: Maybe<Array<Maybe<StartEventTypeConfigModel>>>;
  startEventTypes?: Maybe<Array<Maybe<StartEventTypeModel>>>;
  subProcessType?: Maybe<SubProcessTypeModel>;
  subProcessTypeConfigs?: Maybe<Array<Maybe<SubProcessTypeConfigModel>>>;
  targetEntityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  taskDefinitionTemplates?: Maybe<Array<Maybe<TaskDefinitionTemplateModel>>>;
};

export type SubProcessDefinitionModel = FlowNodeModel & {
  __typename?: 'SubProcessDefinitionModel';
  eventDefinitions?: Maybe<Array<Maybe<EventDefinitionModel>>>;
  flowNodeType?: Maybe<FlowNodeTypeModel>;
  gatewayDefinitions?: Maybe<Array<Maybe<GatewayDefinitionModel>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequenceFlows?: Maybe<Array<Maybe<SequenceFlowModel>>>;
  subProcessDefinitions?: Maybe<Array<Maybe<SubProcessDefinitionModel>>>;
  subProcessType?: Maybe<SubProcessTypeModel>;
  taskDefinitions?: Maybe<Array<Maybe<TaskDefinitionModel>>>;
};

export type SubProcessDefinitionModelInput = {
  eventDefinitions?: InputMaybe<Array<InputMaybe<EventDefinitionModelInput>>>;
  flowNodeType?: InputMaybe<FlowNodeTypeModel>;
  gatewayDefinitions?: InputMaybe<Array<InputMaybe<GatewayDefinitionModelInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequenceFlows?: InputMaybe<Array<InputMaybe<SequenceFlowModelInput>>>;
  subProcessDefinitions?: InputMaybe<Array<InputMaybe<SubProcessDefinitionModelInput>>>;
  subProcessType?: InputMaybe<SubProcessTypeModel>;
  taskDefinitions?: InputMaybe<Array<InputMaybe<TaskDefinitionModelInput>>>;
};

export type SubProcessTypeConfigModel = {
  __typename?: 'SubProcessTypeConfigModel';
  name?: Maybe<Scalars['String']['output']>;
  subProcessType?: Maybe<SubProcessTypeModel>;
};

export enum SubProcessTypeModel {
  PageFlow = 'PAGE_FLOW'
}

export type SubmissionInfoModel = {
  __typename?: 'SubmissionInfoModel';
  importedByPerson?: Maybe<PersonModel>;
  submissionDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  submissionSource?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<SupplierModel>;
  worker?: Maybe<PersonModel>;
};

export type SubmissionInfoModelInput = {
  importedByPerson?: InputMaybe<PersonModelInput>;
  submissionDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  submissionSource?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<SupplierModelInput>;
  worker?: InputMaybe<PersonModelInput>;
};

export type SubmitJobApplicationPatchModelInput = {
  applicantAddress?: InputMaybe<AddressModelInput>;
  applicantEmail?: InputMaybe<Scalars['String']['input']>;
  applicantPhoneNumber?: InputMaybe<PhoneNumberModelInput>;
  billRate?: InputMaybe<Scalars['Float']['input']>;
  jobApplicationUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workerProfileUid?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitJobApplicationsPatchModelInput = {
  jobApplications?: InputMaybe<Array<InputMaybe<SubmitJobApplicationPatchModelInput>>>;
  jobRequestUid?: InputMaybe<Scalars['String']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  tenantUid?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionModel = {
  uid: Scalars['String']['output'];
};

export type SuggestionsModel = {
  __typename?: 'SuggestionsModel';
  suggestions?: Maybe<Array<Maybe<SuggestionModel>>>;
};

export type SupplierContactInfoModel = {
  __typename?: 'SupplierContactInfoModel';
  address?: Maybe<AddressModel>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<NameModel>;
  phoneNumber?: Maybe<PhoneNumberModel>;
};

export type SupplierContactInfoModelInput = {
  address?: InputMaybe<AddressModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
};

export type SupplierContactModel = {
  __typename?: 'SupplierContactModel';
  businessSites?: Maybe<Array<Maybe<LocationModel>>>;
  comment?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<NameModel>;
  phoneNumber?: Maybe<PhoneNumberModel>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  uid: Scalars['String']['output'];
};

export type SupplierContactModelInput = {
  businessSites?: InputMaybe<Array<InputMaybe<LocationModelInput>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
  phoneNumber?: InputMaybe<PhoneNumberModelInput>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierCreateJobApplicationsModelInput = {
  jobApplications?: InputMaybe<Array<InputMaybe<JobApplicationCreateModelInput>>>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  workPostingUid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGroupCreateModelInput = {
  businessSites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobFamilyGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGroupInstanceModel = {
  __typename?: 'SupplierGroupInstanceModel';
  businessSites?: Maybe<Array<Maybe<LocationModel>>>;
  classifications?: Maybe<Array<Maybe<ClassificationModel>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  jobFamilyGroups?: Maybe<Array<Maybe<JobFamilyGroupModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DistributionGroupInstanceStatusModel>;
  tiers?: Maybe<Array<Maybe<SupplierTierInstanceModel>>>;
  uid: Scalars['String']['output'];
};


export type SupplierGroupInstanceModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierGroupInstancePatchModelInput = {
  businessSites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobFamilyGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGroupInstanceReferenceModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGroupModel = {
  __typename?: 'SupplierGroupModel';
  businessSites?: Maybe<Array<Maybe<LocationModel>>>;
  classifications?: Maybe<Array<Maybe<ClassificationModel>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  jobFamilyGroups?: Maybe<Array<Maybe<JobFamilyGroupModel>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DistributionGroupStatusModel>;
  tiers?: Maybe<Array<Maybe<SupplierTierModel>>>;
  uid: Scalars['String']['output'];
};


export type SupplierGroupModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierGroupPatchModelInput = {
  businessSites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobFamilyGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DistributionGroupStatusModel>;
};

export type SupplierGroupSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<SupplierGroupSortTypeModel>;
};

export enum SupplierGroupSortTypeModel {
  Id = 'ID'
}

export type SupplierGroupsModel = {
  __typename?: 'SupplierGroupsModel';
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SupplierGroupModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SupplierImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierInsuranceInfoModel = {
  __typename?: 'SupplierInsuranceInfoModel';
  insuranceNumber?: Maybe<Scalars['String']['output']>;
  insuranceProvider?: Maybe<Scalars['String']['output']>;
};

export type SupplierInsuranceInfoModelInput = {
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider?: InputMaybe<Scalars['String']['input']>;
};

export enum SupplierInvitationStatusModel {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  Rejected = 'REJECTED'
}

export enum SupplierLegalIncorporationTypeModel {
  CCorp = 'C_CORP',
  Llc = 'LLC',
  Llp = 'LLP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  SCorp = 'S_CORP'
}

export type SupplierLegalInfoModel = {
  __typename?: 'SupplierLegalInfoModel';
  businessLicense?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  incorporationType?: Maybe<SupplierLegalIncorporationTypeModel>;
  legalBusinessName?: Maybe<Scalars['String']['output']>;
};

export type SupplierLegalInfoModelInput = {
  businessLicense?: InputMaybe<Scalars['String']['input']>;
  dba?: InputMaybe<Scalars['String']['input']>;
  incorporationType?: InputMaybe<SupplierLegalIncorporationTypeModel>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierMetadataModel = {
  __typename?: 'SupplierMetadataModel';
  activeWorkerCount?: Maybe<Scalars['Int']['output']>;
  earliestEngagementDate?: Maybe<Scalars['LocalDate']['output']>;
  inactiveWorkerCount?: Maybe<Scalars['Int']['output']>;
  latestEngagementDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type SupplierMetadataModelInput = {
  activeWorkerCount?: InputMaybe<Scalars['Int']['input']>;
  earliestEngagementDate?: InputMaybe<Scalars['LocalDate']['input']>;
  inactiveWorkerCount?: InputMaybe<Scalars['Int']['input']>;
  latestEngagementDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type SupplierModel = {
  __typename?: 'SupplierModel';
  /** @deprecated Deprecated in favour of metadata.activeWorkerCount */
  aggregateActiveWorkerCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated in favour of metadata.inactiveWorkerCount */
  aggregateInactiveWorkerCount?: Maybe<Scalars['Int']['output']>;
  aggregateSubSupplierCount?: Maybe<Scalars['Int']['output']>;
  ancestorSuppliers?: Maybe<SuppliersModel>;
  /** @deprecated POC. Marked for removal */
  boxUploadEmail?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<SupplierContactModel>>>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  generalContact?: Maybe<SupplierContactInfoModel>;
  insuranceInfo?: Maybe<SupplierInsuranceInfoModel>;
  invitationStatus?: Maybe<SupplierInvitationStatusModel>;
  legalEntityUid?: Maybe<Scalars['String']['output']>;
  legalInfo?: Maybe<SupplierLegalInfoModel>;
  logo?: Maybe<MediaModel>;
  metadata?: Maybe<SupplierMetadataModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  msp?: Maybe<MspModel>;
  name?: Maybe<Scalars['String']['output']>;
  parentSupplier?: Maybe<SupplierModel>;
  paymentTerms?: Maybe<SupplierPaymentTermsModel>;
  payments?: Maybe<PaymentsModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  spendSummary?: Maybe<SupplierSpendSummaryModel>;
  status?: Maybe<StatusModel>;
  statusLastModified?: Maybe<Scalars['OffsetDateTime']['output']>;
  subSuppliers?: Maybe<Array<Maybe<SupplierModel>>>;
  supplierAppUserProfiles?: Maybe<Array<Maybe<SupplierUserProfileModel>>>;
  supplierType?: Maybe<SupplierTypeModel>;
  taxInfo?: Maybe<SupplierTaxInfoModel>;
  uid: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
  wid?: Maybe<Scalars['String']['output']>;
};


export type SupplierModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SupplierModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SupplierModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SupplierModelPaymentsArgs = {
  includeSubsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<PaymentsQueryModelInput>;
  sortOrders?: InputMaybe<Array<InputMaybe<PaymentSortModelInput>>>;
};


export type SupplierModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierModelInput = {
  aggregateActiveWorkerCount?: InputMaybe<Scalars['Int']['input']>;
  aggregateInactiveWorkerCount?: InputMaybe<Scalars['Int']['input']>;
  aggregateSubSupplierCount?: InputMaybe<Scalars['Int']['input']>;
  ancestorSuppliers?: InputMaybe<SuppliersModelInput>;
  boxUploadEmail?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<SupplierContactModelInput>>>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CustomFieldDefinitionEntityTypeModel>;
  generalContact?: InputMaybe<SupplierContactInfoModelInput>;
  insuranceInfo?: InputMaybe<SupplierInsuranceInfoModelInput>;
  invitationStatus?: InputMaybe<SupplierInvitationStatusModel>;
  legalEntityUid?: InputMaybe<Scalars['String']['input']>;
  legalInfo?: InputMaybe<SupplierLegalInfoModelInput>;
  logo?: InputMaybe<MediaModelInput>;
  metadata?: InputMaybe<SupplierMetadataModelInput>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifier?: InputMaybe<PersonModelInput>;
  msp?: InputMaybe<MspModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSupplier?: InputMaybe<SupplierModelInput>;
  paymentTerms?: InputMaybe<SupplierPaymentTermsModel>;
  payments?: InputMaybe<PaymentsModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  spendSummary?: InputMaybe<SupplierSpendSummaryModelInput>;
  status?: InputMaybe<StatusModel>;
  statusLastModified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  subSuppliers?: InputMaybe<Array<InputMaybe<SupplierModelInput>>>;
  supplierAppUserProfiles?: InputMaybe<Array<InputMaybe<SupplierUserProfileModelInput>>>;
  supplierType?: InputMaybe<SupplierTypeModel>;
  taxInfo?: InputMaybe<SupplierTaxInfoModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierPatchModelInput = {
  boxUploadEmail?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<SupplierContactModelInput>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  generalContact?: InputMaybe<SupplierContactInfoModelInput>;
  insuranceInfo?: InputMaybe<SupplierInsuranceInfoModelInput>;
  legalInfo?: InputMaybe<SupplierLegalInfoModelInput>;
  logo?: InputMaybe<MediaModelInput>;
  msp?: InputMaybe<MspModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSupplier?: InputMaybe<SupplierModelInput>;
  paymentTerms?: InputMaybe<SupplierPaymentTermsModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  supplierType?: InputMaybe<SupplierTypeModel>;
  taxInfo?: InputMaybe<SupplierTaxInfoModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum SupplierPaymentTermsModel {
  Net_15 = 'NET_15',
  Net_30 = 'NET_30',
  Net_45 = 'NET_45',
  Net_60 = 'NET_60',
  Net_90 = 'NET_90'
}

export type SupplierSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<SupplierSortTypeModel>;
};

export enum SupplierSortTypeModel {
  Name = 'NAME',
  SupplierType = 'SUPPLIER_TYPE',
  WorkerCount = 'WORKER_COUNT'
}

export type SupplierSpendSummaryModel = {
  __typename?: 'SupplierSpendSummaryModel';
  monthSpendToDate?: Maybe<Scalars['Float']['output']>;
  quarterSpendToDate?: Maybe<Scalars['Float']['output']>;
  startOfMonth?: Maybe<Scalars['LocalDate']['output']>;
  startOfQuarter?: Maybe<Scalars['LocalDate']['output']>;
  startOfYear?: Maybe<Scalars['LocalDate']['output']>;
  yearSpendToDate?: Maybe<Scalars['Float']['output']>;
};

export type SupplierSpendSummaryModelInput = {
  monthSpendToDate?: InputMaybe<Scalars['Float']['input']>;
  quarterSpendToDate?: InputMaybe<Scalars['Float']['input']>;
  startOfMonth?: InputMaybe<Scalars['LocalDate']['input']>;
  startOfQuarter?: InputMaybe<Scalars['LocalDate']['input']>;
  startOfYear?: InputMaybe<Scalars['LocalDate']['input']>;
  yearSpendToDate?: InputMaybe<Scalars['Float']['input']>;
};

export type SupplierSubmitJobApplicationsModelInput = {
  jobApplications?: InputMaybe<Array<InputMaybe<JobApplicationPatchModelInput>>>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  workPostingUid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierTaxInfoModel = {
  __typename?: 'SupplierTaxInfoModel';
  ein?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SupplierTaxInfoModelInput = {
  ein?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierTierCreateModelInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<DistributionRuleCreateModelInput>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SupplierTierInstanceModel = {
  __typename?: 'SupplierTierInstanceModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  order: Scalars['Int']['output'];
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  rule?: Maybe<DistributionRuleInstanceModel>;
  status?: Maybe<DistributionTierInstanceStatusModel>;
  suppliers?: Maybe<SuppliersModel>;
  uid: Scalars['String']['output'];
};


export type SupplierTierInstanceModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierTierInstancePatchModelInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<DistributionRuleInstancePatchModelInput>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SupplierTierModel = {
  __typename?: 'SupplierTierModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  modifier?: Maybe<PersonModel>;
  order: Scalars['Int']['output'];
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  rule?: Maybe<DistributionRuleModel>;
  suppliers?: Maybe<SuppliersModel>;
  uid: Scalars['String']['output'];
};


export type SupplierTierModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierTierPatchModelInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<DistributionRulePatchModelInput>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum SupplierTypeModel {
  IndependentContractor = 'INDEPENDENT_CONTRACTOR',
  StaffingSupplier = 'STAFFING_SUPPLIER'
}

export type SupplierUserProfileModel = {
  __typename?: 'SupplierUserProfileModel';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<NameModel>;
};

export type SupplierUserProfileModelInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameModelInput>;
};

export type SuppliersModel = {
  __typename?: 'SuppliersModel';
  elements?: Maybe<Array<Maybe<SupplierModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  suppliers?: Maybe<Array<Maybe<SupplierModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SuppliersModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<SupplierModelInput>>>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type SuppliersQueryModelInput = {
  activeWorkerCount?: InputMaybe<NumberRangeModelInput>;
  aggregatedActiveWorkerCount?: InputMaybe<NumberRangeModelInput>;
  aggregatedInactiveWorkerCount?: InputMaybe<NumberRangeModelInput>;
  aggregatedSubSupplierCount?: InputMaybe<NumberRangeModelInput>;
  customFieldFilter?: InputMaybe<CustomFieldFilterModelInput>;
  earliestEngagementDate?: InputMaybe<DateRangeModelInput>;
  exactNameMatch?: InputMaybe<Scalars['Boolean']['input']>;
  filterableCustomFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  inactiveWorkerCount?: InputMaybe<NumberRangeModelInput>;
  invitationStatuses?: InputMaybe<Array<InputMaybe<SupplierInvitationStatusModel>>>;
  latestEngagementDate?: InputMaybe<DateRangeModelInput>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentSupplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rootSuppliersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
  supplierTypes?: InputMaybe<Array<InputMaybe<SupplierTypeModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SystemActivitiesModel = {
  __typename?: 'SystemActivitiesModel';
  systemActivities?: Maybe<Array<Maybe<SystemActivityModel>>>;
};

export type SystemActivityDetailsModel = {
  detail1?: Maybe<Scalars['String']['output']>;
  detail2?: Maybe<Scalars['String']['output']>;
  detailedType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  processedCount: Scalars['Int']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SystemActivityTypeModel>;
};

export type SystemActivityMediaModel = {
  __typename?: 'SystemActivityMediaModel';
  filename?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link: Scalars['Boolean']['output'];
  uid: Scalars['String']['output'];
};

export type SystemActivityModel = {
  __typename?: 'SystemActivityModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  details?: Maybe<SystemActivityDetailsModel>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  media?: Maybe<Array<Maybe<SystemActivityMediaModel>>>;
  /** @deprecated Deprecated in favour of media */
  mediaUid?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<PersonModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  status?: Maybe<SystemActivityStatusModel>;
  triggerBy?: Maybe<Scalars['String']['output']>;
  triggerType?: Maybe<SystemActivityTriggerTypeModel>;
  type?: Maybe<SystemActivityTypeModel>;
  uid: Scalars['String']['output'];
};


export type SystemActivityModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SystemActivityStatusModel {
  FinishedError = 'FINISHED_ERROR',
  FinishedSuccess = 'FINISHED_SUCCESS',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export enum SystemActivityTriggerTypeModel {
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED',
  SystemActivity = 'SYSTEM_ACTIVITY',
  UserActivity = 'USER_ACTIVITY'
}

export enum SystemActivityTypeModel {
  Import = 'IMPORT',
  InvoiceImport = 'INVOICE_IMPORT',
  UcTransform = 'UC_TRANSFORM',
  UkgImport = 'UKG_IMPORT',
  WorkdayDiffExport = 'WORKDAY_DIFF_EXPORT',
  WorkdayImport = 'WORKDAY_IMPORT',
  WorkdayTimeAllocationImport = 'WORKDAY_TIME_ALLOCATION_IMPORT'
}

export type TagCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  tagEntityType?: InputMaybe<TagEntityTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum TagEntityTypeModel {
  AnomalyDefinition = 'ANOMALY_DEFINITION',
  Engagement = 'ENGAGEMENT'
}

export type TagInstanceAssignmentModelInput = {
  tagUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TagInstanceCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  entityUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  tagUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TagInstanceModel = {
  __typename?: 'TagInstanceModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  entityUid?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  status?: Maybe<StatusModel>;
  tag?: Maybe<TagModel>;
  uid: Scalars['String']['output'];
};


export type TagInstanceModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagInstanceModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  entityUid?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<StatusModel>;
  tag?: InputMaybe<TagModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TagInstanceQueryModelInput = {
  entityUid?: InputMaybe<Scalars['String']['input']>;
  tagUid?: InputMaybe<Scalars['String']['input']>;
};

export type TagInstancesModel = {
  __typename?: 'TagInstancesModel';
  items?: Maybe<Array<Maybe<TagInstanceModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TagModel = {
  __typename?: 'TagModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  status?: Maybe<StatusModel>;
  tagEntityType?: Maybe<TagEntityTypeModel>;
  uid: Scalars['String']['output'];
};


export type TagModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<StatusModel>;
  tagEntityType?: InputMaybe<TagEntityTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TagQueryModelInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  tagEntityType?: InputMaybe<TagEntityTypeModel>;
};

export type TagSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<TagSortTypeModel>;
};

export enum TagSortTypeModel {
  Label = 'LABEL'
}

export type TagUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsModel = {
  __typename?: 'TagsModel';
  items?: Maybe<Array<Maybe<TagModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum TaskAutoCompletionReasonModel {
  AssigneeIsInitiator = 'ASSIGNEE_IS_INITIATOR',
  CorrectionAutoApproved = 'CORRECTION_AUTO_APPROVED',
  InsufficientManagerLevels = 'INSUFFICIENT_MANAGER_LEVELS',
  InsufficientSpendApprovalLimits = 'INSUFFICIENT_SPEND_APPROVAL_LIMITS'
}

export type TaskDefinitionCountModel = {
  __typename?: 'TaskDefinitionCountModel';
  flowNodeId?: Maybe<Scalars['String']['output']>;
  processDefinitionUid?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TaskDefinitionModel = FlowNodeModel & {
  __typename?: 'TaskDefinitionModel';
  assignmentConfiguration?: Maybe<AssignmentConfigurationModel>;
  autoCompleteWhenAssigneeIsInitiator?: Maybe<Scalars['Boolean']['output']>;
  autoCompleteWhenInsufficientManagerLevels?: Maybe<Scalars['Boolean']['output']>;
  dataMappingTable?: Maybe<DataMappingTableModel>;
  decisionTable?: Maybe<DecisionTableModel>;
  decisionTableDefinitionReference?: Maybe<DecisionTableDefinitionReferenceModel>;
  decisionTableDefinitionReferences?: Maybe<Array<Maybe<DecisionTableDefinitionReferenceModel>>>;
  duplicateCheckEnabled?: Maybe<Scalars['Boolean']['output']>;
  entityType?: Maybe<ProcessDefinitionEntityTypeModel>;
  flowNodeType?: Maybe<FlowNodeTypeModel>;
  id?: Maybe<Scalars['String']['output']>;
  inputFields?: Maybe<Array<Maybe<TaskInputFieldDefinitionModel>>>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated notificationsConfiguration should be used since 2021.06 */
  notificationConfiguration?: Maybe<TaskNotificationConfigurationModel>;
  notificationsConfiguration?: Maybe<TaskNotificationsConfigurationModel>;
  properties?: Maybe<Array<Maybe<FlowNodePropertyModel>>>;
  spendApprovalConfiguration?: Maybe<TaskSpendApprovalConfigurationModel>;
  spendApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  taskType?: Maybe<ProcessDefinitionTaskTypeModel>;
  template?: Maybe<TaskDefinitionTemplateModel>;
  updateFields?: Maybe<Array<Maybe<TaskUpdateFieldDefinitionModel>>>;
};

export type TaskDefinitionModelInput = {
  assignmentConfiguration?: InputMaybe<AssignmentConfigurationModelInput>;
  autoCompleteWhenAssigneeIsInitiator?: InputMaybe<Scalars['Boolean']['input']>;
  autoCompleteWhenInsufficientManagerLevels?: InputMaybe<Scalars['Boolean']['input']>;
  dataMappingTable?: InputMaybe<DataMappingTableModelInput>;
  decisionTable?: InputMaybe<DecisionTableModelInput>;
  decisionTableDefinitionReference?: InputMaybe<DecisionTableDefinitionReferenceModelInput>;
  decisionTableDefinitionReferences?: InputMaybe<Array<InputMaybe<DecisionTableDefinitionReferenceModelInput>>>;
  duplicateCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType?: InputMaybe<ProcessDefinitionEntityTypeModel>;
  flowNodeType?: InputMaybe<FlowNodeTypeModel>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputFields?: InputMaybe<Array<InputMaybe<TaskInputFieldDefinitionModelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationConfiguration?: InputMaybe<TaskNotificationConfigurationModelInput>;
  notificationsConfiguration?: InputMaybe<TaskNotificationsConfigurationModelInput>;
  properties?: InputMaybe<Array<InputMaybe<FlowNodePropertyModelInput>>>;
  spendApprovalConfiguration?: InputMaybe<TaskSpendApprovalConfigurationModelInput>;
  spendApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  taskType?: InputMaybe<ProcessDefinitionTaskTypeModel>;
  template?: InputMaybe<TaskDefinitionTemplateModelInput>;
  updateFields?: InputMaybe<Array<InputMaybe<TaskUpdateFieldDefinitionModelInput>>>;
};

export type TaskDefinitionRefModel = {
  __typename?: 'TaskDefinitionRefModel';
  flowNodeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processDefinitionName?: Maybe<Scalars['String']['output']>;
  processDefinitionUid?: Maybe<Scalars['String']['output']>;
};

export type TaskDefinitionRefsModel = {
  __typename?: 'TaskDefinitionRefsModel';
  taskDefinitions?: Maybe<Array<Maybe<TaskDefinitionRefModel>>>;
};

export enum TaskDefinitionTemplateKeyModel {
  ApproveChangeTask = 'APPROVE_CHANGE_TASK',
  ApproveExpenseTask = 'APPROVE_EXPENSE_TASK',
  ApproveInvoiceTask = 'APPROVE_INVOICE_TASK',
  ApproveSmartformTask = 'APPROVE_SMARTFORM_TASK',
  ApproveTimesheetTask = 'APPROVE_TIMESHEET_TASK',
  BusinessRuleTask = 'BUSINESS_RULE_TASK',
  CheckDuplicateWorkerTask = 'CHECK_DUPLICATE_WORKER_TASK',
  CheckGlobalIdTask = 'CHECK_GLOBAL_ID_TASK',
  CreateEngagementTask = 'CREATE_ENGAGEMENT_TASK',
  CreateJobRequestTask = 'CREATE_JOB_REQUEST_TASK',
  DataMappingTask = 'DATA_MAPPING_TASK',
  DemographicInfoTask = 'DEMOGRAPHIC_INFO_TASK',
  ExecuteRecipeTask = 'EXECUTE_RECIPE_TASK',
  ExternalApproveExpenseTask = 'EXTERNAL_APPROVE_EXPENSE_TASK',
  ExternalApproveTimesheetTask = 'EXTERNAL_APPROVE_TIMESHEET_TASK',
  FormInputTask = 'FORM_INPUT_TASK',
  GenerateWorkerIdTask = 'GENERATE_WORKER_ID_TASK',
  HandleDuplicateGlobalIdTask = 'HANDLE_DUPLICATE_GLOBAL_ID_TASK',
  ImportReportedTimeBlocksTask = 'IMPORT_REPORTED_TIME_BLOCKS_TASK',
  ManageJobRequestsTask = 'MANAGE_JOB_REQUESTS_TASK',
  ManageMilestonesTask = 'MANAGE_MILESTONES_TASK',
  ManageWorkerQualificationsTask = 'MANAGE_WORKER_QUALIFICATIONS_TASK',
  NotificationTask = 'NOTIFICATION_TASK',
  NotifyWorkerChangedTask = 'NOTIFY_WORKER_CHANGED_TASK',
  ReceiveTask = 'RECEIVE_TASK',
  RecommendationTask = 'RECOMMENDATION_TASK',
  RunExternalIntegrationTask = 'RUN_EXTERNAL_INTEGRATION_TASK',
  SelectDuplicateWorkerTask = 'SELECT_DUPLICATE_WORKER_TASK',
  SendTaskEmail = 'SEND_TASK_EMAIL',
  SendTaskPlaceholder = 'SEND_TASK_PLACEHOLDER',
  SendWorkerAppInvitationTask = 'SEND_WORKER_APP_INVITATION_TASK',
  ServiceTaskPlaceholder = 'SERVICE_TASK_PLACEHOLDER',
  SmartformTask = 'SMARTFORM_TASK',
  StartSupplierGroupDistributionTask = 'START_SUPPLIER_GROUP_DISTRIBUTION_TASK',
  SubmitTimesheetTask = 'SUBMIT_TIMESHEET_TASK',
  TimesheetRuleTask = 'TIMESHEET_RULE_TASK',
  UpdateDataTask = 'UPDATE_DATA_TASK',
  WorkatoSendTask = 'WORKATO_SEND_TASK',
  WorkatoServiceTask = 'WORKATO_SERVICE_TASK',
  WorkdaySendTask = 'WORKDAY_SEND_TASK',
  WorkdayServiceTask = 'WORKDAY_SERVICE_TASK'
}

export type TaskDefinitionTemplateModel = {
  __typename?: 'TaskDefinitionTemplateModel';
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<TaskDefinitionTemplateKeyModel>;
  labelVariables?: Maybe<LabelVariablesModel>;
  name?: Maybe<Scalars['String']['output']>;
  propertyDefinitions?: Maybe<Array<Maybe<FlowNodePropertyDefinitionModel>>>;
  replaceWith?: Maybe<TaskDefinitionTemplateKeyModel>;
  showAssignmentOptions?: Maybe<Scalars['Boolean']['output']>;
  showAutoCompletionOptions?: Maybe<Scalars['Boolean']['output']>;
  showCancellationOptions?: Maybe<Scalars['Boolean']['output']>;
  showDuplicateCheckOptions?: Maybe<Scalars['Boolean']['output']>;
  showNotificationOptions?: Maybe<Scalars['Boolean']['output']>;
  showSpendApprovalOptions?: Maybe<Scalars['Boolean']['output']>;
  targetEntityTypes?: Maybe<Array<Maybe<ProcessDefinitionEntityTypeModel>>>;
  taskType?: Maybe<ProcessDefinitionTaskTypeModel>;
};

export type TaskDefinitionTemplateModelInput = {
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<TaskDefinitionTemplateKeyModel>;
  labelVariables?: InputMaybe<LabelVariablesModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyDefinitions?: InputMaybe<Array<InputMaybe<FlowNodePropertyDefinitionModelInput>>>;
  replaceWith?: InputMaybe<TaskDefinitionTemplateKeyModel>;
  showAssignmentOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showAutoCompletionOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCancellationOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showDuplicateCheckOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showNotificationOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showSpendApprovalOptions?: InputMaybe<Scalars['Boolean']['input']>;
  targetEntityTypes?: InputMaybe<Array<InputMaybe<ProcessDefinitionEntityTypeModel>>>;
  taskType?: InputMaybe<ProcessDefinitionTaskTypeModel>;
};

export type TaskDefinitionTemplatesModel = {
  __typename?: 'TaskDefinitionTemplatesModel';
  taskDefinitionTemplates?: Maybe<Array<Maybe<TaskDefinitionTemplateModel>>>;
};

export type TaskDefinitionsQueryModelInput = {
  processDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TaskDelegationConfigModel = {
  __typename?: 'TaskDelegationConfigModel';
  maximumDurationDays: Scalars['Long']['output'];
};

export type TaskDelegationConfigUpdateModelInput = {
  maximumDurationDays: Scalars['Long']['input'];
};

export type TaskDelegationCreateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  delegateAssigneeUid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  originalAssigneeUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  processDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  taskUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TaskDelegationModel = {
  __typename?: 'TaskDelegationModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  delegateAssignee?: Maybe<PersonModel>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  originalAssignee?: Maybe<PersonModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  processDefinitions?: Maybe<Array<Maybe<ProcessDefinitionModel>>>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<StatusModel>;
  task?: Maybe<TaskModel>;
  uid: Scalars['String']['output'];
};


export type TaskDelegationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskDelegationModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  delegateAssignee?: InputMaybe<PersonModelInput>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  originalAssignee?: InputMaybe<PersonModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  processDefinitions?: InputMaybe<Array<InputMaybe<ProcessDefinitionModelInput>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<StatusModel>;
  task?: InputMaybe<TaskModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TaskDelegationSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<TaskDelegationSortTypeModel>;
};

export enum TaskDelegationSortTypeModel {
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  Status = 'STATUS'
}

export type TaskDelegationsModel = {
  __typename?: 'TaskDelegationsModel';
  items?: Maybe<Array<Maybe<TaskDelegationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TaskDelegationsQueryModelInput = {
  creatorUid?: InputMaybe<Scalars['String']['input']>;
  delegateAssigneeUid?: InputMaybe<Scalars['String']['input']>;
  endDateRange?: InputMaybe<DateRangeModelInput>;
  originalAssigneeUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDateRange?: InputMaybe<DateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<StatusModel>>>;
};

export type TaskInputFieldDefinitionModel = {
  __typename?: 'TaskInputFieldDefinitionModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<TaskInputFieldKeyModel>;
  label?: Maybe<Scalars['String']['output']>;
};

export type TaskInputFieldDefinitionModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<TaskInputFieldKeyModel>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskInputFieldKeyModel {
  CustomField = 'CUSTOM_FIELD'
}

export type TaskModel = {
  __typename?: 'TaskModel';
  assignedDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  assignee?: Maybe<PersonModel>;
  assigneeCandidates?: Maybe<Array<Maybe<PersonModel>>>;
  attachedMedia?: Maybe<Array<Maybe<MediaModel>>>;
  autoCompletionReason?: Maybe<TaskAutoCompletionReasonModel>;
  availableSignals?: Maybe<Array<Maybe<TaskSignalModel>>>;
  cancellable?: Maybe<Scalars['Boolean']['output']>;
  captureEffectiveDate?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  definitionTemplateKey?: Maybe<TaskDefinitionTemplateKeyModel>;
  delegated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayScore?: Maybe<Scalars['Boolean']['output']>;
  displayZeroScoreOptions?: Maybe<Scalars['Boolean']['output']>;
  duplicateCheckEnabled?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventWid?: Maybe<Scalars['String']['output']>;
  flowNodeId?: Maybe<Scalars['String']['output']>;
  inputParams?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  isDelegated: Scalars['Boolean']['output'];
  maximumJobRequestCount?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<MediaModel>;
  minimumJobRequestCount?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  msp?: Maybe<MspModel>;
  name?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  outputParams?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  parentActivityName?: Maybe<Scalars['String']['output']>;
  parentFlowNodeId?: Maybe<Scalars['String']['output']>;
  process?: Maybe<ProcessModel>;
  /** @deprecated Use process instead */
  processUid?: Maybe<Scalars['String']['output']>;
  proxyingUser?: Maybe<PersonModel>;
  recommendationDefinitionUid?: Maybe<Scalars['String']['output']>;
  resolutionComment?: Maybe<Scalars['String']['output']>;
  resolvable?: Maybe<Scalars['Boolean']['output']>;
  resolver?: Maybe<PersonModel>;
  reviewer?: Maybe<PersonModel>;
  roleUid?: Maybe<Scalars['String']['output']>;
  roleUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slaMinutes?: Maybe<Scalars['Int']['output']>;
  smartFormSubmitButtonText?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<TaskStatusModel>;
  subProcessType?: Maybe<SubProcessTypeModel>;
  supplierAssignee?: Maybe<SupplierModel>;
  supplierResolver?: Maybe<SupplierModel>;
  targetChangeSet?: Maybe<ChangeSetModel>;
  targetContract?: Maybe<ContractModel>;
  targetEngagement?: Maybe<EngagementModel>;
  targetExpense?: Maybe<ExpenseModel>;
  targetJobApplication?: Maybe<JobApplicationModel>;
  targetJobRequest?: Maybe<WorkPostingModel>;
  targetMilestone?: Maybe<MilestoneModel>;
  targetPerson?: Maybe<PersonModel>;
  targetSecondarySmartFormDefinition?: Maybe<SmartFormDefinitionModel>;
  targetSecondarySmartFormDefinitionVersion?: Maybe<Scalars['Int']['output']>;
  targetSmartFormDefinition?: Maybe<SmartFormDefinitionModel>;
  targetSmartFormDefinitionVersion?: Maybe<Scalars['Int']['output']>;
  targetSowResponse?: Maybe<SowResponseModel>;
  targetTimesheet?: Maybe<TimesheetModel>;
  targetWorkRequest?: Maybe<WorkRequestModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  taskDelegations?: Maybe<Array<Maybe<TaskDelegationModel>>>;
  taskType?: Maybe<ProcessDefinitionTaskTypeModel>;
  uid: Scalars['String']['output'];
  warningMessage?: Maybe<Scalars['String']['output']>;
};

export type TaskModelInput = {
  assignedDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  assignee?: InputMaybe<PersonModelInput>;
  assigneeCandidates?: InputMaybe<Array<InputMaybe<PersonModelInput>>>;
  attachedMedia?: InputMaybe<Array<InputMaybe<MediaModelInput>>>;
  autoCompletionReason?: InputMaybe<TaskAutoCompletionReasonModel>;
  availableSignals?: InputMaybe<Array<InputMaybe<TaskSignalModelInput>>>;
  cancellable?: InputMaybe<Scalars['Boolean']['input']>;
  captureEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  definitionTemplateKey?: InputMaybe<TaskDefinitionTemplateKeyModel>;
  delegated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayScore?: InputMaybe<Scalars['Boolean']['input']>;
  displayZeroScoreOptions?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  eventWid?: InputMaybe<Scalars['String']['input']>;
  flowNodeId?: InputMaybe<Scalars['String']['input']>;
  inputParams?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  isDelegated?: InputMaybe<Scalars['Boolean']['input']>;
  maximumJobRequestCount?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<MediaModelInput>;
  minimumJobRequestCount?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  msp?: InputMaybe<MspModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  outputParams?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  parentActivityName?: InputMaybe<Scalars['String']['input']>;
  parentFlowNodeId?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<ProcessModelInput>;
  processUid?: InputMaybe<Scalars['String']['input']>;
  proxyingUser?: InputMaybe<PersonModelInput>;
  recommendationDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  resolutionComment?: InputMaybe<Scalars['String']['input']>;
  resolvable?: InputMaybe<Scalars['Boolean']['input']>;
  resolver?: InputMaybe<PersonModelInput>;
  reviewer?: InputMaybe<PersonModelInput>;
  roleUid?: InputMaybe<Scalars['String']['input']>;
  roleUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slaMinutes?: InputMaybe<Scalars['Int']['input']>;
  smartFormSubmitButtonText?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  status?: InputMaybe<TaskStatusModel>;
  subProcessType?: InputMaybe<SubProcessTypeModel>;
  supplierAssignee?: InputMaybe<SupplierModelInput>;
  supplierResolver?: InputMaybe<SupplierModelInput>;
  targetChangeSet?: InputMaybe<ChangeSetModelInput>;
  targetContract?: InputMaybe<ContractModelInput>;
  targetEngagement?: InputMaybe<EngagementModelInput>;
  targetExpense?: InputMaybe<ExpenseModelInput>;
  targetJobApplication?: InputMaybe<JobApplicationModelInput>;
  targetJobRequest?: InputMaybe<WorkPostingModelInput>;
  targetMilestone?: InputMaybe<MilestoneModelInput>;
  targetPerson?: InputMaybe<PersonModelInput>;
  targetSecondarySmartFormDefinition?: InputMaybe<SmartFormDefinitionModelInput>;
  targetSecondarySmartFormDefinitionVersion?: InputMaybe<Scalars['Int']['input']>;
  targetSmartFormDefinition?: InputMaybe<SmartFormDefinitionModelInput>;
  targetSmartFormDefinitionVersion?: InputMaybe<Scalars['Int']['input']>;
  targetSowResponse?: InputMaybe<SowResponseModelInput>;
  targetTimesheet?: InputMaybe<TimesheetModelInput>;
  targetWorkRequest?: InputMaybe<WorkRequestModelInput>;
  taskDelegation?: InputMaybe<TaskDelegationModelInput>;
  taskDelegations?: InputMaybe<Array<InputMaybe<TaskDelegationModelInput>>>;
  taskType?: InputMaybe<ProcessDefinitionTaskTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  warningMessage?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNotificationConfigurationModel = {
  __typename?: 'TaskNotificationConfigurationModel';
  body?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<NotificationChannelModel>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logo?: Maybe<MediaModel>;
  preferredEmailType?: Maybe<PreferredEmailType>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type TaskNotificationConfigurationModelInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<NotificationChannelModel>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<MediaModelInput>;
  preferredEmailType?: InputMaybe<PreferredEmailType>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNotificationsConfigurationModel = {
  __typename?: 'TaskNotificationsConfigurationModel';
  notifications?: Maybe<Array<Maybe<TaskNotificationConfigurationModel>>>;
};

export type TaskNotificationsConfigurationModelInput = {
  notifications?: InputMaybe<Array<InputMaybe<TaskNotificationConfigurationModelInput>>>;
};

export type TaskSignalModel = {
  __typename?: 'TaskSignalModel';
  executionId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SignalEventDefinitionTypeModel>;
};

export type TaskSignalModelInput = {
  executionId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SignalEventDefinitionTypeModel>;
};

export type TaskSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<TaskSortTypeModel>;
};

export enum TaskSortTypeModel {
  Created = 'CREATED'
}

export type TaskSpendApprovalConfigurationModel = {
  __typename?: 'TaskSpendApprovalConfigurationModel';
  autoRejectionBusinessEventReasonUid?: Maybe<Scalars['String']['output']>;
};

export type TaskSpendApprovalConfigurationModelInput = {
  autoRejectionBusinessEventReasonUid?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskStatusModel {
  Assigned = 'ASSIGNED',
  Deleted = 'DELETED',
  InReview = 'IN_REVIEW',
  NotReady = 'NOT_READY',
  SystemResolved = 'SYSTEM_RESOLVED',
  UserResolved = 'USER_RESOLVED',
  WaitingForMessageCorrelation = 'WAITING_FOR_MESSAGE_CORRELATION'
}

export enum TaskTranscriptStatusModel {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type TaskTranscriptUpdateModelInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<MediaTypeModel>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskTranscriptStatusModel>;
};

export type TaskUpdateFieldDefinitionModel = {
  __typename?: 'TaskUpdateFieldDefinitionModel';
  customFieldDefinition?: Maybe<CustomFieldDefinitionModel>;
  key?: Maybe<TaskUpdateFieldKeyModel>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TaskUpdateFieldDefinitionModelInput = {
  customFieldDefinition?: InputMaybe<CustomFieldDefinitionModelInput>;
  key?: InputMaybe<TaskUpdateFieldKeyModel>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskUpdateFieldKeyModel {
  CustomField = 'CUSTOM_FIELD',
  EngagementStatus = 'ENGAGEMENT_STATUS'
}

export type TasksModel = {
  __typename?: 'TasksModel';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  processDefinitionCounts?: Maybe<Array<Maybe<ProcessDefinitionCountModel>>>;
  taskDefinitionCounts?: Maybe<Array<Maybe<TaskDefinitionCountModel>>>;
  tasks?: Maybe<Array<Maybe<TaskModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TasksQueryModelInput = {
  assigneeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeUid?: InputMaybe<Scalars['String']['input']>;
  createdRange?: InputMaybe<DateRangeModelInput>;
  flowNodeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  processDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subProcessType?: InputMaybe<SubProcessTypeModel>;
  supplierAssigneeUid?: InputMaybe<Scalars['String']['input']>;
  targetEngagementCompanyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetEngagementJobProfileUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetEngagementManagerUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetEngagementOrgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetPersonUid?: InputMaybe<Scalars['String']['input']>;
};

export type TenantAdminCreateModelInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatusModel>;
};

export type TenantAutoDisableUsersConfigurationModel = {
  __typename?: 'TenantAutoDisableUsersConfigurationModel';
  affectedUserRoles?: Maybe<Array<Maybe<UserRoleModel>>>;
  enabled: Scalars['Boolean']['output'];
};

export type TenantAutoDisableUsersConfigurationUpdateModelInput = {
  affectedUserRoles?: InputMaybe<Array<InputMaybe<UserRoleModel>>>;
  enabled: Scalars['Boolean']['input'];
};

export type TenantConfigModel = {
  __typename?: 'TenantConfigModel';
  defaultDateFormat?: Maybe<Scalars['String']['output']>;
  engagementConfig?: Maybe<EngagementConfigModel>;
  environment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Legacy. In use until all tenants are migrated to new FlatFilePlatform */
  flatFileConfig?: Maybe<FlatFileConfigModel>;
  flatFilePlatformConfig?: Maybe<FlatFilePlatformConfigModel>;
  managedSftpServer?: Maybe<ManagedSftpServerModel>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Prefix?: Maybe<Scalars['String']['output']>;
  ukgConfig?: Maybe<UkgConfigModel>;
  webOrigin?: Maybe<Scalars['String']['output']>;
  workdayConfig?: Maybe<WorkdayConfigModel>;
};

export type TenantDuplicateSearchConfigurationModel = {
  __typename?: 'TenantDuplicateSearchConfigurationModel';
  lastNameAndDobSimilarityThreshold: Scalars['Float']['output'];
  nameSimilarityThreshold: Scalars['Float']['output'];
};

export type TenantDuplicateSearchConfigurationUpdateModelInput = {
  lastNameAndDobSimilarityThreshold: Scalars['Float']['input'];
  nameSimilarityThreshold: Scalars['Float']['input'];
};

export type TenantFeatureModel = {
  __typename?: 'TenantFeatureModel';
  config?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  enabled: Scalars['Boolean']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderedFeatures?: Maybe<Array<Maybe<TenantSubFeatureModel>>>;
};

export type TenantFeatureModelInput = {
  config?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  enabled: Scalars['Boolean']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderedFeatures?: InputMaybe<Array<InputMaybe<TenantSubFeatureModelInput>>>;
};

export type TenantModel = {
  __typename?: 'TenantModel';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateTimeFormatConfig?: Maybe<DateTimeFormatConfigModel>;
  dateTimeFormatConfigModel?: Maybe<DateTimeFormatConfigModel>;
  duplicateSearchConfiguration?: Maybe<TenantDuplicateSearchConfigurationModel>;
  features?: Maybe<Scalars['Map_String_TenantFeatureModelScalar']['output']>;
  logo?: Maybe<MediaModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissionsConfiguration?: Maybe<TenantPermissionsConfigurationModel>;
  processSweeperConfig?: Maybe<ProcessSweeperConfigModel>;
  publicFormBaseUrl?: Maybe<Scalars['String']['output']>;
  spendConfig?: Maybe<SpendConfigModel>;
  ssoConfig?: Maybe<SsoConfigModel>;
  taskDelegationConfig?: Maybe<TaskDelegationConfigModel>;
  tenantConfig?: Maybe<TenantConfigModel>;
  tenantLastSuccessfulSyncDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  tenantSyncStatus?: Maybe<TenantSyncStatusModel>;
  uid: Scalars['String']['output'];
  usersConfiguration?: Maybe<TenantUsersConfigurationModel>;
  workdayAuthorizationWebUrl?: Maybe<Scalars['String']['output']>;
  workdayLastSuccessfulSyncDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  workdayRestApiUrl?: Maybe<Scalars['String']['output']>;
  workdaySyncStatus?: Maybe<TenantSyncStatusModel>;
  workdayTokenApiUrl?: Maybe<Scalars['String']['output']>;
  workerConfiguration?: Maybe<TenantWorkerConfigurationModel>;
};

export type TenantPermissionsConfigurationModel = {
  __typename?: 'TenantPermissionsConfigurationModel';
  accountablePersonReadTimesheetAmount: Scalars['Boolean']['output'];
  managerReadTimesheetAmount: Scalars['Boolean']['output'];
  supplierReadTimesheetAmount: Scalars['Boolean']['output'];
};

export type TenantPermissionsConfigurationUpdateModelInput = {
  accountablePersonReadTimesheetAmount: Scalars['Boolean']['input'];
  managerReadTimesheetAmount: Scalars['Boolean']['input'];
  supplierReadTimesheetAmount: Scalars['Boolean']['input'];
};

export type TenantSubFeatureModel = {
  __typename?: 'TenantSubFeatureModel';
  config?: Maybe<Scalars['Map_String_StringScalar']['output']>;
  enabled: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderedFeatures?: Maybe<Array<Maybe<TenantSubFeatureModel>>>;
};

export type TenantSubFeatureModelInput = {
  config?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  enabled: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderedFeatures?: InputMaybe<Array<InputMaybe<TenantSubFeatureModelInput>>>;
};

export enum TenantSyncStatusModel {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Queued = 'QUEUED',
  SyncError = 'SYNC_ERROR',
  SyncSuccess = 'SYNC_SUCCESS'
}

export type TenantUsersConfigurationModel = {
  __typename?: 'TenantUsersConfigurationModel';
  autoDisable?: Maybe<TenantAutoDisableUsersConfigurationModel>;
};

export type TenantUsersConfigurationUpdateModelInput = {
  autoDisable?: InputMaybe<TenantAutoDisableUsersConfigurationUpdateModelInput>;
};

export type TenantWorkerConfigurationModel = {
  __typename?: 'TenantWorkerConfigurationModel';
  retroApplyWorkerIdPrefix: Scalars['Boolean']['output'];
  workerIdPrefix?: Maybe<Scalars['String']['output']>;
};

export type TenantWorkerConfigurationUpdateModelInput = {
  retroApplyWorkerIdPrefix: Scalars['Boolean']['input'];
  workerIdPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type TenureDurationModel = {
  __typename?: 'TenureDurationModel';
  days?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  totalInDays?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type TenureDurationModelInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  totalInDays?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type TerminationReasonCreateModelInput = {
  assignable: Scalars['Boolean']['input'];
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  eligibleForRehire: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TerminationReasonModel = {
  __typename?: 'TerminationReasonModel';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  eligibleForRehire?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onExportMapTo?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatusModel>;
  uid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};


export type TerminationReasonModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TerminationReasonModelInput = {
  assignable?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  eligibleForRehire?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  wid?: InputMaybe<Scalars['String']['input']>;
};

export type TerminationReasonPatchModelInput = {
  assignable: Scalars['Boolean']['input'];
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  eligibleForRehire: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onExportMapTo?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TerminationReasonSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<TerminationReasonSortTypeModel>;
};

export enum TerminationReasonSortTypeModel {
  Created = 'CREATED',
  Modified = 'MODIFIED',
  Name = 'NAME',
  ReferenceId = 'REFERENCE_ID',
  Status = 'STATUS'
}

export type TerminationReasonsModel = {
  __typename?: 'TerminationReasonsModel';
  items?: Maybe<Array<Maybe<TerminationReasonModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TimeCodeConfigurationModel = {
  __typename?: 'TimeCodeConfigurationModel';
  operator?: Maybe<TimeCodeConfigurationOperatorModel>;
  variables?: Maybe<Array<Maybe<BillingVariableModel>>>;
};

export type TimeCodeConfigurationModelInput = {
  operator?: InputMaybe<TimeCodeConfigurationOperatorModel>;
  variables?: InputMaybe<Array<InputMaybe<BillingVariableModelInput>>>;
};

export enum TimeCodeConfigurationOperatorModel {
  Add = 'ADD',
  Multiply = 'MULTIPLY'
}

export type TimeCodeConfigurationUpdateModelInput = {
  operator?: InputMaybe<TimeCodeConfigurationOperatorModel>;
  variables?: InputMaybe<Array<InputMaybe<BillingVariableUpdateModelInput>>>;
};

export type TimeCodeCreationModelInput = {
  billConfiguration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  default: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  payConfiguration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  router?: InputMaybe<Scalars['Boolean']['input']>;
  timeEntryType?: InputMaybe<TimeEntryTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  unitOptions?: InputMaybe<Array<InputMaybe<UnitOptionModel>>>;
};

export type TimeCodeMisconfiguredModel = {
  __typename?: 'TimeCodeMisconfiguredModel';
  timeCodeName?: Maybe<Scalars['String']['output']>;
  timeCodeUid?: Maybe<Scalars['String']['output']>;
};

export type TimeCodeMisconfiguredModelInput = {
  timeCodeName?: InputMaybe<Scalars['String']['input']>;
  timeCodeUid?: InputMaybe<Scalars['String']['input']>;
};

export type TimeCodeModel = {
  __typename?: 'TimeCodeModel';
  /** @deprecated SD-32143 pay bill types are going to be deleted */
  billConfiguration?: Maybe<TimeCodeConfigurationModel>;
  code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favour of payConfiguration. Will be removed after 2023.01.01 */
  configuration?: Maybe<TimeCodeConfigurationModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payConfiguration?: Maybe<TimeCodeConfigurationModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  router?: Maybe<Scalars['Boolean']['output']>;
  timeEntryType?: Maybe<TimeEntryTypeModel>;
  uid: Scalars['String']['output'];
  unitOptions?: Maybe<Array<Maybe<UnitOptionModel>>>;
};


export type TimeCodeModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeCodeModelInput = {
  billConfiguration?: InputMaybe<TimeCodeConfigurationModelInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<TimeCodeConfigurationModelInput>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payConfiguration?: InputMaybe<TimeCodeConfigurationModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  router?: InputMaybe<Scalars['Boolean']['input']>;
  timeEntryType?: InputMaybe<TimeEntryTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  unitOptions?: InputMaybe<Array<InputMaybe<UnitOptionModel>>>;
};

export type TimeCodeUpdateModelInput = {
  billConfiguration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  configuration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  default: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  payConfiguration?: InputMaybe<TimeCodeConfigurationUpdateModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  router?: InputMaybe<Scalars['Boolean']['input']>;
  timeEntryType?: InputMaybe<TimeEntryTypeModel>;
  unitOptions?: InputMaybe<Array<InputMaybe<UnitOptionModel>>>;
};

export type TimeCodesModel = {
  __typename?: 'TimeCodesModel';
  items?: Maybe<Array<Maybe<TimeCodeModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum TimeEntryTypeModel {
  Hours = 'HOURS',
  Units = 'UNITS'
}

export enum TimeExpenseType {
  Expense = 'EXPENSE',
  Timesheet = 'TIMESHEET'
}

export enum TimeUnitModel {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TimerEventDefinitionModel = {
  __typename?: 'TimerEventDefinitionModel';
  timeDuration?: Maybe<Scalars['String']['output']>;
};

export type TimerEventDefinitionModelInput = {
  timeDuration?: InputMaybe<Scalars['String']['input']>;
};

export type TimerEventModel = {
  __typename?: 'TimerEventModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  engagement?: Maybe<EngagementModel>;
  entityUid?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<ExpenseModel>;
  jobApplication?: Maybe<JobApplicationModel>;
  jobPosting?: Maybe<WorkPostingModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  startTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  timesheet?: Maybe<TimesheetModel>;
  type?: Maybe<BusinessEventTypeModel>;
  uid: Scalars['String']['output'];
  workRequest?: Maybe<WorkRequestModel>;
};


export type TimerEventModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TimerEventModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type TimerEventsModel = {
  __typename?: 'TimerEventsModel';
  items?: Maybe<Array<Maybe<TimerEventModel>>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TimerEventsQueryModelInput = {
  createdFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  entityUid?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  type?: InputMaybe<BusinessEventTypeModel>;
};

export type TimerMetricModel = {
  __typename?: 'TimerMetricModel';
  avg?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  type?: Maybe<BusinessEventTypeModel>;
};


export type TimerMetricModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type TimerMetricsModel = {
  __typename?: 'TimerMetricsModel';
  items?: Maybe<Array<Maybe<TimerMetricModel>>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TimerMetricsQueryModelInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  supplierUid?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  type?: InputMaybe<BusinessEventTypeModel>;
};

export type TimesheetApprovalModelInput = {
  approverPersonUid?: InputMaybe<Scalars['String']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  decision?: InputMaybe<TimesheetApprovalStatusModel>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonUid?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum TimesheetApprovalStatusModel {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type TimesheetAttachmentModel = {
  __typename?: 'TimesheetAttachmentModel';
  filename?: Maybe<Scalars['String']['output']>;
  mediaUid?: Maybe<Scalars['String']['output']>;
};

export type TimesheetAttachmentModelInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  mediaUid?: InputMaybe<Scalars['String']['input']>;
};

export type TimesheetCreationAllocationModelInput = {
  action?: InputMaybe<AllocationActionModel>;
  allocationReferenceId?: InputMaybe<Scalars['String']['input']>;
  clockInTime?: InputMaybe<Scalars['LocalTime']['input']>;
  clockOutTime?: InputMaybe<Scalars['LocalTime']['input']>;
  costCenter?: InputMaybe<UidReferenceIdInput>;
  financialFields?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  seconds?: InputMaybe<Scalars['Long']['input']>;
  timeCode?: InputMaybe<UidReferenceIdInput>;
  units?: InputMaybe<Scalars['Float']['input']>;
};

export type TimesheetCreationDailyAllocationModelInput = {
  allocations?: InputMaybe<Array<InputMaybe<TimesheetCreationAllocationModelInput>>>;
  workday?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type TimesheetCreationModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  desiredStatus?: InputMaybe<TimesheetStatusModel>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagementUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  timeAllocations?: InputMaybe<Array<InputMaybe<TimesheetCreationDailyAllocationModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TimesheetImportRowValidationQueryModelInput = {
  index: Scalars['Int']['input'];
  urnToValueMap?: InputMaybe<Scalars['Map_String_StringScalar']['input']>;
  urnToValuesMap?: InputMaybe<Scalars['Map_String_List_StringScalar']['input']>;
};

export type TimesheetImportValidationQueryModelInput = {
  values?: InputMaybe<Array<InputMaybe<TimesheetImportRowValidationQueryModelInput>>>;
};

export type TimesheetInvoiceModel = {
  __typename?: 'TimesheetInvoiceModel';
  consolidatedInvoiceId?: Maybe<Scalars['String']['output']>;
  consolidatedInvoiceUid?: Maybe<Scalars['String']['output']>;
  invoiceBlueprintExecutionUid?: Maybe<Scalars['String']['output']>;
  invoiceExecutionMode?: Maybe<InvoicingBlueprintExecutionModeModel>;
  /** @deprecated Use supplierInvoiceId */
  invoiceNumber?: Maybe<Scalars['Long']['output']>;
  /** @deprecated Use consolidatedInvoiceUid (V2) or supplierInvoiceUid (V1) */
  invoiceUid?: Maybe<Scalars['String']['output']>;
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
  supplierInvoiceUid?: Maybe<Scalars['String']['output']>;
};

export type TimesheetInvoiceModelInput = {
  consolidatedInvoiceId?: InputMaybe<Scalars['String']['input']>;
  consolidatedInvoiceUid?: InputMaybe<Scalars['String']['input']>;
  invoiceBlueprintExecutionUid?: InputMaybe<Scalars['String']['input']>;
  invoiceExecutionMode?: InputMaybe<InvoicingBlueprintExecutionModeModel>;
  invoiceNumber?: InputMaybe<Scalars['Long']['input']>;
  invoiceUid?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceId?: InputMaybe<Scalars['String']['input']>;
  supplierInvoiceUid?: InputMaybe<Scalars['String']['input']>;
};

export enum TimesheetMealBreakAttestationModel {
  No = 'NO',
  Yes = 'YES',
  YesSelfWaived = 'YES_SELF_WAIVED'
}

export type TimesheetModel = {
  __typename?: 'TimesheetModel';
  approvalDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  approvals?: Maybe<Array<Maybe<ApprovalModel>>>;
  approver?: Maybe<PersonModel>;
  attachments?: Maybe<Array<Maybe<TimesheetAttachmentModel>>>;
  /** @deprecated SD-32143 pay bill types are going to be deleted */
  coreTimesheetUid?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creditTimesheet?: Maybe<Scalars['Boolean']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  engagement?: Maybe<EngagementModel>;
  engagementUid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use invoices for full chronological history */
  invoice?: Maybe<TimesheetInvoiceModel>;
  invoices?: Maybe<Array<Maybe<TimesheetInvoiceModel>>>;
  lastExported?: Maybe<Scalars['OffsetDateTime']['output']>;
  mealBreakAttestation?: Maybe<TimesheetMealBreakAttestationModel>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Long']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  previousTimesheet?: Maybe<TimesheetModel>;
  /** @deprecated will be inside approvals elements */
  rejectReason?: Maybe<Scalars['String']['output']>;
  requiresActionReasons?: Maybe<Array<Maybe<RequiresActionReasonModel>>>;
  requiresActions?: Maybe<Scalars['Boolean']['output']>;
  semanticVersion?: Maybe<Scalars['String']['output']>;
  sourceTimeAllocations?: Maybe<Array<Maybe<DailyAllocationModel>>>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  status?: Maybe<TimesheetStatusModel>;
  submission?: Maybe<SubmissionInfoModel>;
  timeAllocations?: Maybe<Array<Maybe<DailyAllocationModel>>>;
  timeAttestationAccepted?: Maybe<Scalars['Boolean']['output']>;
  totalAmount?: Maybe<AmountModel>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  totalOvertime?: Maybe<Scalars['Float']['output']>;
  totalSeconds?: Maybe<Scalars['Long']['output']>;
  totalTimeSeconds?: Maybe<Scalars['Float']['output']>;
  /** @deprecated SD-32143 pay bill types are going to be deleted */
  type?: Maybe<TimesheetPayBillTypeModel>;
  uid: Scalars['String']['output'];
  weekendingDate?: Maybe<Scalars['LocalDate']['output']>;
};


export type TimesheetModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimesheetModelInput = {
  approvalDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  approvals?: InputMaybe<Array<InputMaybe<ApprovalModelInput>>>;
  approver?: InputMaybe<PersonModelInput>;
  attachments?: InputMaybe<Array<InputMaybe<TimesheetAttachmentModelInput>>>;
  coreTimesheetUid?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creditTimesheet?: InputMaybe<Scalars['Boolean']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  engagement?: InputMaybe<EngagementModelInput>;
  engagementUid?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<TimesheetInvoiceModelInput>;
  invoices?: InputMaybe<Array<InputMaybe<TimesheetInvoiceModelInput>>>;
  lastExported?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  mealBreakAttestation?: InputMaybe<TimesheetMealBreakAttestationModel>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Long']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  person?: InputMaybe<PersonModelInput>;
  previousTimesheet?: InputMaybe<TimesheetModelInput>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  requiresActionReasons?: InputMaybe<Array<InputMaybe<RequiresActionReasonModelInput>>>;
  requiresActions?: InputMaybe<Scalars['Boolean']['input']>;
  semanticVersion?: InputMaybe<Scalars['String']['input']>;
  sourceTimeAllocations?: InputMaybe<Array<InputMaybe<DailyAllocationModelInput>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<TimesheetStatusModel>;
  submission?: InputMaybe<SubmissionInfoModelInput>;
  timeAllocations?: InputMaybe<Array<InputMaybe<DailyAllocationModelInput>>>;
  timeAttestationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  totalAmount?: InputMaybe<AmountModelInput>;
  totalHours?: InputMaybe<Scalars['Float']['input']>;
  totalOvertime?: InputMaybe<Scalars['Float']['input']>;
  totalSeconds?: InputMaybe<Scalars['Long']['input']>;
  totalTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TimesheetPayBillTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  weekendingDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type TimesheetPageModelInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<InputMaybe<TimesheetSortModelInput>>>;
};

export type TimesheetPatchModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  timeAllocations?: InputMaybe<Array<InputMaybe<DailyAllocationPatchModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum TimesheetPayBillTypeModel {
  Bill = 'BILL',
  Core = 'CORE',
  None = 'NONE',
  Pay = 'PAY'
}

export type TimesheetQueryModelInput = {
  approvalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  approvalDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  approvedSince?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  approvedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  categories?: InputMaybe<Array<InputMaybe<TimeExpenseType>>>;
  dateWindow?: InputMaybe<RelativeDateRangeModelInput>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  exportSourceTimeAllocations?: InputMaybe<Scalars['Boolean']['input']>;
  exportTimesheetIncludeEmptyAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  mealBreakAttestations?: InputMaybe<Array<InputMaybe<TimesheetMealBreakAttestationModel>>>;
  modifiedSince?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  number?: InputMaybe<Scalars['Long']['input']>;
  onlyAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnexported?: InputMaybe<Scalars['Boolean']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  projectTaskRefIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiresActions?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  semanticVersions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  startDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<TimesheetStatusModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeAttestationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<TimesheetPayBillTypeModel>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workerEngagementsQuery?: InputMaybe<WorkerEngagementsQueryModelInput>;
};

export type TimesheetRolePermissionsConfigurationModel = {
  __typename?: 'TimesheetRolePermissionsConfigurationModel';
  canRead: Scalars['Boolean']['output'];
  canReadAmount: Scalars['Boolean']['output'];
  canUpdateAllocations: Scalars['Boolean']['output'];
  canUpdateStatus: Scalars['Boolean']['output'];
  grantsUnconstrainedByAssignment: Scalars['Boolean']['output'];
};

export type TimesheetRolePermissionsConfigurationModelInput = {
  canRead: Scalars['Boolean']['input'];
  canReadAmount: Scalars['Boolean']['input'];
  canUpdateAllocations: Scalars['Boolean']['input'];
  canUpdateStatus: Scalars['Boolean']['input'];
  grantsUnconstrainedByAssignment: Scalars['Boolean']['input'];
};

export enum TimesheetSettingsGroupModel {
  ApproverView = 'APPROVER_VIEW',
  Expenses = 'EXPENSES',
  ImportExport = 'IMPORT_EXPORT',
  Invoices = 'INVOICES',
  Miscellaneous = 'MISCELLANEOUS',
  PayBill = 'PAY_BILL',
  Rates = 'RATES',
  Rules = 'RULES',
  TimesheetDisplaySettings = 'TIMESHEET_DISPLAY_SETTINGS',
  WorkerView = 'WORKER_VIEW'
}

export type TimesheetSettingsInfoModel = {
  __typename?: 'TimesheetSettingsInfoModel';
  businessSiteRequired?: Maybe<Scalars['Boolean']['output']>;
  expenseSubmittals?: Maybe<ExpenseSubmittalConfigurationModel>;
  globalStartDate?: Maybe<Scalars['LocalDate']['output']>;
  locationRefIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TimesheetSettingsInfoUpdateModelInput = {
  businessSiteRequired?: InputMaybe<Scalars['Boolean']['input']>;
  expenseSubmittals?: InputMaybe<ExpenseSubmittalConfigurationModelInput>;
  globalStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  locationRefIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum TimesheetSettingsKeyModel {
  AllowExpenseSubmittals = 'ALLOW_EXPENSE_SUBMITTALS',
  AllowInvoicesSubmittals = 'ALLOW_INVOICES_SUBMITTALS',
  AmountCalculationEndDateShift = 'AMOUNT_CALCULATION_END_DATE_SHIFT',
  BlankDefaultRateFrequency = 'BLANK_DEFAULT_RATE_FREQUENCY',
  Expenses = 'EXPENSES',
  ExpensesExport = 'EXPENSES_EXPORT',
  ExpensesInWorkerProfile = 'EXPENSES_IN_WORKER_PROFILE',
  ExportFeesAsPositiveValues = 'EXPORT_FEES_AS_POSITIVE_VALUES',
  GlobalStartDate = 'GLOBAL_START_DATE',
  HideDeprecatedRates = 'HIDE_DEPRECATED_RATES',
  Invoices = 'INVOICES',
  MealBreakAttestationRequired = 'MEAL_BREAK_ATTESTATION_REQUIRED',
  NewExpensesImport = 'NEW_EXPENSES_IMPORT',
  OnlyShowRouterTimeCodesOnTimesheets = 'ONLY_SHOW_ROUTER_TIME_CODES_ON_TIMESHEETS',
  PayBill = 'PAY_BILL',
  RequireAttachmentsOnExpense = 'REQUIRE_ATTACHMENTS_ON_EXPENSE',
  RequireAttachmentsOnTimesheet = 'REQUIRE_ATTACHMENTS_ON_TIMESHEET',
  Rules = 'RULES',
  ShowBusinessSiteOnTimesheets = 'SHOW_BUSINESS_SITE_ON_TIMESHEETS',
  ShowTimesheetAmounts = 'SHOW_TIMESHEET_AMOUNTS',
  TimesheetExportEmptyAllocation = 'TIMESHEET_EXPORT_EMPTY_ALLOCATION',
  TimesheetExportRateFrequency = 'TIMESHEET_EXPORT_RATE_FREQUENCY',
  TimeAttestationRequired = 'TIME_ATTESTATION_REQUIRED'
}

export type TimesheetSettingsListModel = {
  __typename?: 'TimesheetSettingsListModel';
  elements?: Maybe<Array<Maybe<TimesheetSettingsModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  timesheetSettings?: Maybe<Array<Maybe<TimesheetSettingsModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TimesheetSettingsModel = {
  __typename?: 'TimesheetSettingsModel';
  cachedTypedUid?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  enabled: Scalars['Boolean']['output'];
  group?: Maybe<TimesheetSettingsGroupModel>;
  info?: Maybe<TimesheetSettingsInfoModel>;
  key?: Maybe<TimesheetSettingsKeyModel>;
  parent?: Maybe<TimesheetSettingsModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  revisionAt?: Maybe<Scalars['Long']['output']>;
  uid: Scalars['String']['output'];
};


export type TimesheetSettingsModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimesheetSettingsPageModelInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type TimesheetSettingsQueryModelInput = {
  keys?: InputMaybe<Array<InputMaybe<TimesheetSettingsKeyModel>>>;
  types?: InputMaybe<Array<InputMaybe<TimesheetSettingsTypeModel>>>;
};

export enum TimesheetSettingsTypeModel {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Timesheet = 'TIMESHEET'
}

export type TimesheetSettingsUpdateModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  enabled: Scalars['Boolean']['input'];
  info?: InputMaybe<TimesheetSettingsInfoUpdateModelInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type TimesheetSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<TimesheetSortTypeModel>;
};

export enum TimesheetSortTypeModel {
  EndDate = 'END_DATE',
  LastUpdated = 'LAST_UPDATED',
  Name = 'NAME',
  Number = 'NUMBER',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  Type = 'TYPE'
}

export enum TimesheetStatusModel {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Invoiced = 'INVOICED',
  InvoicePending = 'INVOICE_PENDING',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  WaitingForSubmission = 'WAITING_FOR_SUBMISSION'
}

export enum TimesheetViewModel {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TimesheetsModel = {
  __typename?: 'TimesheetsModel';
  elements?: Maybe<Array<Maybe<TimesheetModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  timesheets?: Maybe<Array<Maybe<TimesheetModel>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TimestampRangeModelInput = {
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

export enum TransactionFileFormatModel {
  Csv = 'CSV',
  Excel = 'EXCEL'
}

export enum TransgenderStatusModel {
  No = 'NO',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  Yes = 'YES'
}

export enum UkgSyncTypePatchModel {
  Delta = 'DELTA',
  Full = 'FULL'
}

export type UidFilterModelInput = {
  equals?: InputMaybe<Scalars['String']['input']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UidNameModel = {
  __typename?: 'UidNameModel';
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type UidNameModelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UidReferenceIdInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UkgConfigModel = {
  __typename?: 'UkgConfigModel';
  enabled: Scalars['Boolean']['output'];
};

export enum UnitOptionModel {
  Full = 'FULL',
  Half = 'HALF',
  Quarter = 'QUARTER',
  ThreeQuarter = 'THREE_QUARTER'
}

export type UnrestrictedWidgetSettingModel = {
  __typename?: 'UnrestrictedWidgetSettingModel';
  authorised?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Array<Maybe<WidgetSettingConfigModel>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<WidgetSettingNameModel>;
  uid: Scalars['String']['output'];
};

export type UnrestrictedWidgetSettingsPageModel = {
  __typename?: 'UnrestrictedWidgetSettingsPageModel';
  items?: Maybe<Array<Maybe<UnrestrictedWidgetSettingModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum UpdatableStatusModel {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type UserAccessModel = {
  __typename?: 'UserAccessModel';
  signInWithAccessUrl: Scalars['Boolean']['output'];
  userAccessUrl?: Maybe<Scalars['String']['output']>;
};

export type UserAccessModelInput = {
  signInWithAccessUrl: Scalars['Boolean']['input'];
  userAccessUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserActivitiesModel = {
  __typename?: 'UserActivitiesModel';
  activities?: Maybe<Array<Maybe<UserActivityModel>>>;
  elements?: Maybe<Array<Maybe<UserActivityModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserActivityModel = {
  __typename?: 'UserActivityModel';
  activityTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  targetResourceIdentifier?: Maybe<Scalars['String']['output']>;
  targetResourceLabel?: Maybe<Scalars['String']['output']>;
  targetResourceUid?: Maybe<Scalars['String']['output']>;
  targetResourceUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<UserActivityTypeModel>;
  uid: Scalars['String']['output'];
  user?: Maybe<UserModel>;
};

export enum UserActivityTypeModel {
  ImportSheetImported = 'IMPORT_SHEET_IMPORTED',
  UserLogin = 'USER_LOGIN',
  UserLogout = 'USER_LOGOUT',
  UserProxy = 'USER_PROXY',
  UserStatusUpdated = 'USER_STATUS_UPDATED',
  UserUnproxy = 'USER_UNPROXY'
}

export type UserCountModel = {
  __typename?: 'UserCountModel';
  roleToCount?: Maybe<Scalars['Map_UserRoleModel_IntegerScalar']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserCreateModelInput = {
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  msp?: InputMaybe<MspImportableReferenceModelInput>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserCreateRoleModel>;
  status?: InputMaybe<UserStatusModel>;
};

export enum UserCreateRoleModel {
  ExternalApprover = 'EXTERNAL_APPROVER',
  MspAdmin = 'MSP_ADMIN',
  MspUser = 'MSP_USER',
  SupportUser = 'SUPPORT_USER',
  TenantUser = 'TENANT_USER'
}

export type UserDateAttributeModel = {
  __typename?: 'UserDateAttributeModel';
  value?: Maybe<Scalars['LocalDate']['output']>;
};

export type UserDateAttributeModelInput = {
  value?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UserDateTimeAttributeModel = {
  __typename?: 'UserDateTimeAttributeModel';
  value?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type UserDateTimeAttributeModelInput = {
  value?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

export enum UserLookupFieldModel {
  CompanyWorkerId = 'COMPANY_WORKER_ID',
  CustomField = 'CUSTOM_FIELD',
  Email = 'EMAIL'
}

export type UserLookupModel = {
  __typename?: 'UserLookupModel';
  customFieldReferenceId?: Maybe<Scalars['String']['output']>;
  field?: Maybe<UserLookupFieldModel>;
};

export type UserLookupModelInput = {
  customFieldReferenceId?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<UserLookupFieldModel>;
};

export type UserModel = {
  __typename?: 'UserModel';
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  modified?: Maybe<UserDateTimeAttributeModel>;
  msp?: Maybe<MspModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  preferences?: Maybe<UserPreferencesModel>;
  proxyingUser?: Maybe<UserModel>;
  referenceId?: Maybe<Scalars['String']['output']>;
  sitePermissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  status?: Maybe<UserStatusModel>;
  uid: Scalars['String']['output'];
  workdayAccessToken?: Maybe<Scalars['String']['output']>;
  workdayAccessTokenExpiryTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  workdayRefreshToken?: Maybe<Scalars['String']['output']>;
};


export type UserModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserModelInput = {
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  modified?: InputMaybe<UserDateTimeAttributeModelInput>;
  msp?: InputMaybe<MspModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  person?: InputMaybe<PersonModelInput>;
  preferences?: InputMaybe<UserPreferencesModelInput>;
  proxyingUser?: InputMaybe<UserModelInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  sitePermissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  status?: InputMaybe<UserStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workdayAccessToken?: InputMaybe<Scalars['String']['input']>;
  workdayAccessTokenExpiryTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  workdayRefreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferencesModel = {
  __typename?: 'UserPreferencesModel';
  dataTableColumnConfigurations?: Maybe<Array<Maybe<DataTableColumnConfigurationModel>>>;
  dateTimeFormatConfig?: Maybe<DateTimeFormatConfigModel>;
  finishedTutorials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstHomePageLoadDone?: Maybe<Scalars['Boolean']['output']>;
  focusOrgUid?: Maybe<Scalars['String']['output']>;
  homePage?: Maybe<Array<Maybe<HomePageItemModel>>>;
  notificationChannelConfigurations?: Maybe<Array<Maybe<NotificationChannelConfigurationModel>>>;
};

export type UserPreferencesModelInput = {
  dataTableColumnConfigurations?: InputMaybe<Array<InputMaybe<DataTableColumnConfigurationModelInput>>>;
  dateTimeFormatConfig?: InputMaybe<DateTimeFormatConfigModelInput>;
  finishedTutorials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstHomePageLoadDone?: InputMaybe<Scalars['Boolean']['input']>;
  focusOrgUid?: InputMaybe<Scalars['String']['input']>;
  homePage?: InputMaybe<Array<InputMaybe<HomePageItemModelInput>>>;
  notificationChannelConfigurations?: InputMaybe<Array<InputMaybe<NotificationChannelConfigurationModelInput>>>;
};

export type UserQueryModelInput = {
  lastLoginRange?: InputMaybe<TimestampRangeModelInput>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userRole?: InputMaybe<UserRoleModel>;
  userRoles?: InputMaybe<Array<InputMaybe<UserRoleModel>>>;
  userStatus?: InputMaybe<Array<InputMaybe<UserStatusModel>>>;
};

export enum UserRoleModel {
  ExternalApprover = 'EXTERNAL_APPROVER',
  GwgWorker = 'GWG_WORKER',
  IntegrationClient = 'INTEGRATION_CLIENT',
  MspAdmin = 'MSP_ADMIN',
  MspUser = 'MSP_USER',
  Supplier = 'SUPPLIER',
  SupportUser = 'SUPPORT_USER',
  SystemTenantAdmin = 'SYSTEM_TENANT_ADMIN',
  TenantAdmin = 'TENANT_ADMIN',
  TenantUser = 'TENANT_USER'
}

export enum UserStatusChangeModel {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum UserStatusModel {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type UserStringAttributeModel = {
  __typename?: 'UserStringAttributeModel';
  value?: Maybe<Scalars['String']['output']>;
};

export type UserStringAttributeModelInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateModelInput = {
  msp?: InputMaybe<MspImportableReferenceModelInput>;
  role?: InputMaybe<UserCreateRoleModel>;
  status?: InputMaybe<UserStatusModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UsersModel = {
  __typename?: 'UsersModel';
  elements?: Maybe<Array<Maybe<UserModel>>>;
  items?: Maybe<Array<Maybe<UserModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ValueModel = {
  __typename?: 'ValueModel';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ValueModelInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum VerificationDecisionModel {
  Deny = 'DENY',
  Permit = 'PERMIT',
  Unsure = 'UNSURE'
}

export type WeeklyConfigurationModel = {
  __typename?: 'WeeklyConfigurationModel';
  dayOfWeek?: Maybe<DayOfWeek>;
  interval: Scalars['Int']['output'];
};

export type WeeklyConfigurationModelInput = {
  dayOfWeek?: InputMaybe<DayOfWeek>;
  interval: Scalars['Int']['input'];
};

export type WidgetOptionsModel = {
  __typename?: 'WidgetOptionsModel';
  visibleItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WidgetOptionsModelInput = {
  visibleItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WidgetSettingConfigModel = {
  __typename?: 'WidgetSettingConfigModel';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<WidgetSettingConfigNameModel>;
  type?: Maybe<WidgetSettingConfigTypeModel>;
  value?: Maybe<Scalars['String']['output']>;
};

export type WidgetSettingConfigModelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<WidgetSettingConfigNameModel>;
  type?: InputMaybe<WidgetSettingConfigTypeModel>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WidgetSettingConfigNameModel {
  AddWorker = 'ADD_WORKER',
  ChartStyle = 'CHART_STYLE',
  CreateReport = 'CREATE_REPORT',
  DaysAfterPresent = 'DAYS_AFTER_PRESENT',
  DaysBeforePresent = 'DAYS_BEFORE_PRESENT',
  FlatFileImport = 'FLAT_FILE_IMPORT',
  WorkRequest = 'WORK_REQUEST'
}

export enum WidgetSettingConfigTypeModel {
  Boolean = 'BOOLEAN',
  Int = 'INT',
  String = 'STRING'
}

export type WidgetSettingModel = {
  __typename?: 'WidgetSettingModel';
  config?: Maybe<Array<Maybe<WidgetSettingConfigModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<WidgetSettingNameModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  roles?: Maybe<Array<Maybe<RoleModel>>>;
  uid: Scalars['String']['output'];
};


export type WidgetSettingModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WidgetSettingNameModel {
  ActiveSuppliersCount = 'ACTIVE_SUPPLIERS_COUNT',
  ActiveWorkersChart = 'ACTIVE_WORKERS_CHART',
  ActiveWorkersCount = 'ACTIVE_WORKERS_COUNT',
  ComplianceRiskAlertsCount = 'COMPLIANCE_RISK_ALERTS_COUNT',
  ContingentWorkersClassificationPie = 'CONTINGENT_WORKERS_CLASSIFICATION_PIE',
  ContingentWorkersLocationMap = 'CONTINGENT_WORKERS_LOCATION_MAP',
  MyOrganizationChart = 'MY_ORGANIZATION_CHART',
  MyTasksList = 'MY_TASKS_LIST',
  OnBoardedChart = 'ON_BOARDED_CHART',
  QuickActions = 'QUICK_ACTIONS',
  RecentlyViewedList = 'RECENTLY_VIEWED_LIST',
  RecentExports = 'RECENT_EXPORTS',
  TimeToFillCount = 'TIME_TO_FILL_COUNT'
}

export type WidgetSettingPageModel = {
  __typename?: 'WidgetSettingPageModel';
  items?: Maybe<Array<Maybe<WidgetSettingModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WidgetSettingSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<WidgetSettingSortTypeModel>;
};

export enum WidgetSettingSortTypeModel {
  Name = 'NAME'
}

export type WidgetSettingUpdateModelInput = {
  config?: InputMaybe<Array<InputMaybe<WidgetSettingConfigModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  roles?: InputMaybe<Array<InputMaybe<RoleModelInput>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum WidgetTypeModel {
  ActiveContingentWorkersCount = 'ACTIVE_CONTINGENT_WORKERS_COUNT',
  ActiveSuppliersCount = 'ACTIVE_SUPPLIERS_COUNT',
  ActiveWorkersChart = 'ACTIVE_WORKERS_CHART',
  ActiveWorkersCount = 'ACTIVE_WORKERS_COUNT',
  ComplianceRiskAlertsCount = 'COMPLIANCE_RISK_ALERTS_COUNT',
  ContingentWorkersClassificationPie = 'CONTINGENT_WORKERS_CLASSIFICATION_PIE',
  ContingentWorkersLocationMap = 'CONTINGENT_WORKERS_LOCATION_MAP',
  MyOrganizationChart = 'MY_ORGANIZATION_CHART',
  MyTasksList = 'MY_TASKS_LIST',
  OnBoardedChart = 'ON_BOARDED_CHART',
  QuickActions = 'QUICK_ACTIONS',
  RecentlyViewedList = 'RECENTLY_VIEWED_LIST',
  RecentExports = 'RECENT_EXPORTS',
  TimeToFillCount = 'TIME_TO_FILL_COUNT'
}

export type WorkCalendarCreateModelInput = {
  active: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dayWorkingHours?: InputMaybe<EnumMap_DayOfWeek_DoubleInput>;
  dueDayOffset: Scalars['Int']['input'];
  holidays?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  standardDailyHours: Scalars['Float']['input'];
  startDay?: InputMaybe<DayOfWeek>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  year: Scalars['Int']['input'];
};

export type WorkCalendarModel = {
  __typename?: 'WorkCalendarModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  dayWorkingHours?: Maybe<Array<Maybe<DayWorkingHoursEntry>>>;
  dueDayOffset?: Maybe<Scalars['Int']['output']>;
  holidays?: Maybe<Array<Maybe<HolidayEntry>>>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  standardDailyHours?: Maybe<Scalars['Float']['output']>;
  startDay?: Maybe<DayOfWeek>;
  uid: Scalars['String']['output'];
  workingWeekdays?: Maybe<Array<Maybe<DayOfWeek>>>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type WorkCalendarModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCalendarModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  dayWorkingHours?: InputMaybe<Array<InputMaybe<DayWorkingHoursEntryInput>>>;
  dueDayOffset?: InputMaybe<Scalars['Int']['input']>;
  holidays?: InputMaybe<Array<InputMaybe<HolidayEntryInput>>>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  standardDailyHours?: InputMaybe<Scalars['Float']['input']>;
  startDay?: InputMaybe<DayOfWeek>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkCalendarPatchModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dayWorkingHours?: InputMaybe<EnumMap_DayOfWeek_DoubleInput>;
  dueDayOffset?: InputMaybe<Scalars['Int']['input']>;
  holidays?: InputMaybe<Scalars['Map_LocalDate_StringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  standardDailyHours?: InputMaybe<Scalars['Float']['input']>;
  startDay?: InputMaybe<DayOfWeek>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkCalendarsModel = {
  __typename?: 'WorkCalendarsModel';
  items?: Maybe<Array<Maybe<WorkCalendarModel>>>;
};

export type WorkPostingCreateModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  alternateExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  businessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  businessSiteUid?: InputMaybe<Scalars['String']['input']>;
  classificationUid?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUids?: InputMaybe<CostCenterUidsModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  endDate?: InputMaybe<UserDateAttributeModelInput>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  expiryDate?: InputMaybe<UserDateAttributeModelInput>;
  externalDescription?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  jobFamilyUid?: InputMaybe<Scalars['String']['input']>;
  jobProfileUid?: InputMaybe<Scalars['String']['input']>;
  jobSummary?: InputMaybe<Scalars['String']['input']>;
  maximumBillRate?: InputMaybe<Scalars['Float']['input']>;
  maximumPayRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRateCardUid?: InputMaybe<Scalars['String']['input']>;
  maximumRateCode?: InputMaybe<Scalars['String']['input']>;
  minimumBillRate?: InputMaybe<Scalars['Float']['input']>;
  minimumPayRate?: InputMaybe<Scalars['Float']['input']>;
  minimumRate?: InputMaybe<Scalars['Float']['input']>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  projectedCost?: InputMaybe<Scalars['Float']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  requestedWorkers?: InputMaybe<Scalars['Int']['input']>;
  seniorityUid?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  startDate?: InputMaybe<UserDateAttributeModelInput>;
  supervisoryOrgUid?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timesheetView?: InputMaybe<TimesheetViewModel>;
  type?: InputMaybe<WorkPostingTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
  workingHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkPostingFilterModelInput = {
  createdDate?: InputMaybe<DateFilterModelInput>;
  id?: InputMaybe<StringFilterModelInput>;
  jobProfile?: InputMaybe<WorkPostingJobProfileFilterModelInput>;
  modifiedDateTime?: InputMaybe<DateTimeFilterModelInput>;
  mspUid?: InputMaybe<StringFilterModelInput>;
  statuses?: InputMaybe<WorkPostingStatusFilterModelInput>;
  uid?: InputMaybe<StringFilterModelInput>;
};

export type WorkPostingJobProfileFilterModelInput = {
  title?: InputMaybe<StringFilterModelInput>;
};

export type WorkPostingModel = {
  __typename?: 'WorkPostingModel';
  accountablePerson?: Maybe<PersonModel>;
  alternateExternalApprover?: Maybe<PersonModel>;
  budget?: Maybe<BudgetModel>;
  businessReason?: Maybe<JobPostingBusinessReasonModel>;
  businessSite?: Maybe<LocationModel>;
  cancellationComment?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<BusinessEventReasonModel>;
  cancelledBy?: Maybe<PersonModel>;
  cancelledDate?: Maybe<Scalars['LocalDate']['output']>;
  classification?: Maybe<ClassificationModel>;
  comments?: Maybe<CommentsModel>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  costCenter?: Maybe<CostCenterModel>;
  costCenters?: Maybe<CostCentersModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  distributionDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  endDate?: Maybe<UserDateAttributeModel>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  estimatedAdditionalCosts?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<UserDateAttributeModel>;
  externalDescription?: Maybe<Scalars['String']['output']>;
  externalTitle?: Maybe<Scalars['String']['output']>;
  filledDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  hiringManagerDetails?: Maybe<HiringManagerDetailsModel>;
  holidaySchedule?: Maybe<HolidayScheduleModel>;
  idNumber?: Maybe<Scalars['Long']['output']>;
  jobApplicationSmartForm?: Maybe<JobPostingApplicationSmartFormModel>;
  jobFamily?: Maybe<JobFamilyModel>;
  jobProfile?: Maybe<JobProfileModel>;
  jobSummary?: Maybe<Scalars['String']['output']>;
  maximumBillRate?: Maybe<Scalars['Float']['output']>;
  maximumPayRate?: Maybe<Scalars['Float']['output']>;
  maximumRate?: Maybe<Scalars['Float']['output']>;
  maximumRateCard?: Maybe<RateCardModel>;
  maximumRateCode?: Maybe<Scalars['String']['output']>;
  minimumBillRate?: Maybe<Scalars['Float']['output']>;
  minimumPayRate?: Maybe<Scalars['Float']['output']>;
  minimumRate?: Maybe<Scalars['Float']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  msp?: Maybe<MspModel>;
  /** @deprecated Remove after 15.04.2021 */
  number?: Maybe<Scalars['Long']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  primaryExternalApprover?: Maybe<PersonModel>;
  projectedCost?: Maybe<Scalars['Float']['output']>;
  rateCurrency?: Maybe<Scalars['String']['output']>;
  ratePeriod?: Maybe<PayRatePeriodModel>;
  rateType?: Maybe<PayRateTypeModel>;
  remoteWorkAddress?: Maybe<AddressModel>;
  requestedWorkers?: Maybe<Scalars['Int']['output']>;
  seniority?: Maybe<SeniorityModel>;
  /** @deprecated Redundant with the nested seniority object; use seniority.uid instead */
  seniorityUid?: Maybe<Scalars['String']['output']>;
  sourcingType?: Maybe<SourcingTypeModel>;
  startDate?: Maybe<UserDateAttributeModel>;
  status?: Maybe<WorkPostingStatusModel>;
  summary?: Maybe<JobPostingSummaryModel>;
  supervisoryOrg?: Maybe<OrgModel>;
  supplierGroupInstance?: Maybe<SupplierGroupInstanceModel>;
  supplierInvites?: Maybe<WorkPostingSupplierInvitesModel>;
  suppliers?: Maybe<SuppliersModel>;
  suppliersCount?: Maybe<Scalars['Int']['output']>;
  timeToFillDays?: Maybe<Scalars['Int']['output']>;
  timesheetView?: Maybe<TimesheetViewModel>;
  totalBudget?: Maybe<BudgetModel>;
  type?: Maybe<WorkPostingTypeModel>;
  uid: Scalars['String']['output'];
  workRequest?: Maybe<WorkRequestModel>;
  workSchedule?: Maybe<WorkScheduleModel>;
  workingHoursPerWeek?: Maybe<Scalars['Float']['output']>;
};


export type WorkPostingModelBudgetArgs = {
  skipBudgetResolution?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkPostingModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type WorkPostingModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkPostingModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkPostingModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkPostingModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkPostingModelTotalBudgetArgs = {
  skipBudgetResolution?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkPostingModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  alternateExternalApprover?: InputMaybe<PersonModelInput>;
  budget?: InputMaybe<BudgetModelInput>;
  businessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  businessSite?: InputMaybe<LocationModelInput>;
  cancellationComment?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<BusinessEventReasonModelInput>;
  cancelledBy?: InputMaybe<PersonModelInput>;
  cancelledDate?: InputMaybe<Scalars['LocalDate']['input']>;
  classification?: InputMaybe<ClassificationModelInput>;
  comments?: InputMaybe<CommentsModelInput>;
  company?: InputMaybe<CompanyModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  costCenters?: InputMaybe<CostCentersModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  distributionDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  endDate?: InputMaybe<UserDateAttributeModelInput>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  expiryDate?: InputMaybe<UserDateAttributeModelInput>;
  externalDescription?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  filledDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  hiringManagerDetails?: InputMaybe<HiringManagerDetailsModelInput>;
  holidaySchedule?: InputMaybe<HolidayScheduleModelInput>;
  idNumber?: InputMaybe<Scalars['Long']['input']>;
  jobApplicationSmartForm?: InputMaybe<JobPostingApplicationSmartFormModelInput>;
  jobFamily?: InputMaybe<JobFamilyModelInput>;
  jobProfile?: InputMaybe<JobProfileModelInput>;
  jobSummary?: InputMaybe<Scalars['String']['input']>;
  maximumBillRate?: InputMaybe<Scalars['Float']['input']>;
  maximumPayRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRateCard?: InputMaybe<RateCardModelInput>;
  maximumRateCode?: InputMaybe<Scalars['String']['input']>;
  minimumBillRate?: InputMaybe<Scalars['Float']['input']>;
  minimumPayRate?: InputMaybe<Scalars['Float']['input']>;
  minimumRate?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  msp?: InputMaybe<MspModelInput>;
  number?: InputMaybe<Scalars['Long']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryExternalApprover?: InputMaybe<PersonModelInput>;
  projectedCost?: InputMaybe<Scalars['Float']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  requestedWorkers?: InputMaybe<Scalars['Int']['input']>;
  seniority?: InputMaybe<SeniorityModelInput>;
  seniorityUid?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  startDate?: InputMaybe<UserDateAttributeModelInput>;
  status?: InputMaybe<WorkPostingStatusModel>;
  summary?: InputMaybe<JobPostingSummaryModelInput>;
  supervisoryOrg?: InputMaybe<OrgModelInput>;
  supplierGroupInstance?: InputMaybe<SupplierGroupInstanceReferenceModelInput>;
  supplierInvites?: InputMaybe<WorkPostingSupplierInvitesModelInput>;
  suppliers?: InputMaybe<SuppliersModelInput>;
  suppliersCount?: InputMaybe<Scalars['Int']['input']>;
  timeToFillDays?: InputMaybe<Scalars['Int']['input']>;
  timesheetView?: InputMaybe<TimesheetViewModel>;
  totalBudget?: InputMaybe<BudgetModelInput>;
  type?: InputMaybe<WorkPostingTypeModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workRequest?: InputMaybe<WorkRequestModelInput>;
  workSchedule?: InputMaybe<WorkScheduleModelInput>;
  workingHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkPostingOrgQueryModelInput = {
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type WorkPostingPatchModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  alternateExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  businessReason?: InputMaybe<JobPostingBusinessReasonModel>;
  businessSiteUid?: InputMaybe<Scalars['String']['input']>;
  classificationUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUids?: InputMaybe<CostCenterUidsModelInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  distributionDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  endDate?: InputMaybe<UserDateAttributeModelInput>;
  estimatedAdditionalCosts?: InputMaybe<Scalars['Float']['input']>;
  expiryDate?: InputMaybe<UserDateAttributeModelInput>;
  externalDescription?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  filledDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  jobFamilyUid?: InputMaybe<Scalars['String']['input']>;
  jobProfileUid?: InputMaybe<Scalars['String']['input']>;
  jobSummary?: InputMaybe<Scalars['String']['input']>;
  maximumBillRate?: InputMaybe<Scalars['Float']['input']>;
  maximumPayRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRate?: InputMaybe<Scalars['Float']['input']>;
  maximumRateCardUid?: InputMaybe<Scalars['String']['input']>;
  maximumRateCode?: InputMaybe<Scalars['String']['input']>;
  minimumBillRate?: InputMaybe<Scalars['Float']['input']>;
  minimumPayRate?: InputMaybe<Scalars['Float']['input']>;
  minimumRate?: InputMaybe<Scalars['Float']['input']>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  primaryExternalApproverUid?: InputMaybe<Scalars['String']['input']>;
  projectedCost?: InputMaybe<Scalars['Float']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  ratePeriod?: InputMaybe<PayRatePeriodModel>;
  rateType?: InputMaybe<PayRateTypeModel>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  requestedWorkers?: InputMaybe<Scalars['Int']['input']>;
  seniorityUid?: InputMaybe<Scalars['String']['input']>;
  sourcingType?: InputMaybe<SourcingTypeModel>;
  startDate?: InputMaybe<UserDateAttributeModelInput>;
  status?: InputMaybe<WorkPostingStatusModel>;
  supervisoryOrgUid?: InputMaybe<Scalars['String']['input']>;
  timeToFillDays?: InputMaybe<Scalars['Int']['input']>;
  timesheetView?: InputMaybe<TimesheetViewModel>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
  workingHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkPostingQueryModelInput = {
  businessSiteUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  creatorUserUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  distributedDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  filledDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  financialFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  idNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  invitedSupplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedSince?: InputMaybe<Scalars['LocalDateTime']['input']>;
  modifiedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<WorkPostingStatusModel>>>;
  supervisoryOrgFilters?: InputMaybe<Array<InputMaybe<WorkPostingOrgQueryModelInput>>>;
  supervisoryOrgUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WorkPostingRevisionModel = RevisionModel & {
  __typename?: 'WorkPostingRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  indirectChangeReason?: Maybe<IndirectChangeReasonModel>;
  jobRequest?: Maybe<WorkPostingModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousJobRequest?: Maybe<WorkPostingModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type WorkPostingRootFilterModelInput = {
  or?: InputMaybe<Array<InputMaybe<WorkPostingFilterModelInput>>>;
};

export type WorkPostingSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<WorkPostingSortTypeModel>;
};

export enum WorkPostingSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  DistributionDate = 'DISTRIBUTION_DATE',
  EndDate = 'END_DATE',
  ExpiryDate = 'EXPIRY_DATE',
  ExternalDescription = 'EXTERNAL_DESCRIPTION',
  ExternalTitle = 'EXTERNAL_TITLE',
  FilledDate = 'FILLED_DATE',
  JobProfileTitle = 'JOB_PROFILE_TITLE',
  JobRequestNumber = 'JOB_REQUEST_NUMBER',
  LastModified = 'LAST_MODIFIED',
  ProjectedCost = 'PROJECTED_COST',
  RateMaximum = 'RATE_MAXIMUM',
  RateMinimum = 'RATE_MINIMUM',
  RequestedWorkers = 'REQUESTED_WORKERS',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TimeToFillDays = 'TIME_TO_FILL_DAYS'
}

export type WorkPostingStatusFilterModelInput = {
  equals?: InputMaybe<WorkPostingStatusModel>;
  includes?: InputMaybe<Array<InputMaybe<WorkPostingStatusModel>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<WorkPostingStatusModel>;
  notIncludes?: InputMaybe<Array<InputMaybe<WorkPostingStatusModel>>>;
};

export enum WorkPostingStatusModel {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Filled = 'FILLED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type WorkPostingSupplierInviteModel = {
  __typename?: 'WorkPostingSupplierInviteModel';
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  inviteType?: Maybe<WorkPostingSupplierInviteTypeModel>;
  invitedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  status?: Maybe<StatusModel>;
  supplier?: Maybe<SupplierModel>;
  supplierRevisionAtTime?: Maybe<SupplierModel>;
  uid: Scalars['String']['output'];
};


export type WorkPostingSupplierInviteModelSupplierRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};

export type WorkPostingSupplierInviteModelInput = {
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  inviteType?: InputMaybe<WorkPostingSupplierInviteTypeModel>;
  invitedAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  status?: InputMaybe<StatusModel>;
  supplier?: InputMaybe<SupplierModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type WorkPostingSupplierInviteRevisionModel = RevisionModel & {
  __typename?: 'WorkPostingSupplierInviteRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousSupplierInvite?: Maybe<WorkPostingSupplierInviteModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  supplierInvite?: Maybe<WorkPostingSupplierInviteModel>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export enum WorkPostingSupplierInviteTypeModel {
  Manual = 'MANUAL',
  SupplierDistribution = 'SUPPLIER_DISTRIBUTION'
}

export type WorkPostingSupplierInvitesModel = {
  __typename?: 'WorkPostingSupplierInvitesModel';
  items?: Maybe<Array<Maybe<WorkPostingSupplierInviteModel>>>;
};

export type WorkPostingSupplierInvitesModelInput = {
  items?: InputMaybe<Array<InputMaybe<WorkPostingSupplierInviteModelInput>>>;
};

export enum WorkPostingTypeModel {
  Job = 'JOB',
  Sow = 'SOW'
}

export type WorkPostingsModel = {
  __typename?: 'WorkPostingsModel';
  elements?: Maybe<Array<Maybe<WorkPostingModel>>>;
  /** @deprecated Deprecated as part of page model unification */
  endOfResults?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<WorkPostingModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkRequestCreateModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  businessSiteUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUids?: InputMaybe<CostCenterUidsModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  supervisoryOrgUid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workLocationType?: InputMaybe<WorkRequestLocationTypeModel>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
};

export enum WorkRequestLocationTypeModel {
  OnSite = 'ON_SITE',
  Remote = 'REMOTE'
}

export type WorkRequestModel = {
  __typename?: 'WorkRequestModel';
  accountablePerson?: Maybe<PersonModel>;
  approvedDate?: Maybe<Scalars['LocalDate']['output']>;
  approver?: Maybe<PersonModel>;
  businessSite?: Maybe<LocationModel>;
  company?: Maybe<CompanyModel>;
  companyRevisionAtTime?: Maybe<CompanyModel>;
  costCenter?: Maybe<CostCenterModel>;
  costCenters?: Maybe<CostCentersModel>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  creator?: Maybe<PersonModel>;
  customFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  customTimeSeries?: Maybe<Array<Maybe<CustomTimeSeriesModel>>>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CustomFieldDefinitionEntityTypeModel>;
  financialFields?: Maybe<Array<Maybe<CustomFieldModel>>>;
  holidaySchedule?: Maybe<HolidayScheduleModel>;
  idNumber?: Maybe<Scalars['Long']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  msp?: Maybe<MspModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  projectedCost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  remoteWorkAddress?: Maybe<AddressModel>;
  scoredRecommendationOptions?: Maybe<Array<Maybe<ScoredRecommendationOptionModel>>>;
  selectedRecommendationOption?: Maybe<RecommendationOptionModel>;
  status?: Maybe<WorkRequestStatusModel>;
  supervisoryOrg?: Maybe<OrgModel>;
  title?: Maybe<Scalars['String']['output']>;
  totalBudget?: Maybe<BudgetModel>;
  uid: Scalars['String']['output'];
  workLocationType?: Maybe<WorkRequestLocationTypeModel>;
  workPostings?: Maybe<Array<Maybe<WorkPostingModel>>>;
  workSchedule?: Maybe<WorkScheduleModel>;
};


export type WorkRequestModelCompanyRevisionAtTimeArgs = {
  atTime: Scalars['OffsetDateTime']['input'];
};


export type WorkRequestModelCustomFieldsArgs = {
  customFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkRequestModelCustomTimeSeriesArgs = {
  customTimeSeriesFieldDefinitionUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkRequestModelFinancialFieldsArgs = {
  financialFieldDefinitionReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type WorkRequestModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkRequestModelTotalBudgetArgs = {
  skipBudgetResolution?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkRequestModelInput = {
  accountablePerson?: InputMaybe<PersonModelInput>;
  approvedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  approver?: InputMaybe<PersonModelInput>;
  businessSite?: InputMaybe<LocationModelInput>;
  company?: InputMaybe<CompanyModelInput>;
  costCenter?: InputMaybe<CostCenterModelInput>;
  costCenters?: InputMaybe<CostCentersModelInput>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  creator?: InputMaybe<PersonModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  holidaySchedule?: InputMaybe<HolidayScheduleModelInput>;
  idNumber?: InputMaybe<Scalars['Long']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  msp?: InputMaybe<MspModelInput>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  projectedCost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  scoredRecommendationOptions?: InputMaybe<Array<InputMaybe<ScoredRecommendationOptionModelInput>>>;
  selectedRecommendationOption?: InputMaybe<RecommendationOptionModelInput>;
  status?: InputMaybe<WorkRequestStatusModel>;
  supervisoryOrg?: InputMaybe<OrgModelInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalBudget?: InputMaybe<BudgetModelInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workLocationType?: InputMaybe<WorkRequestLocationTypeModel>;
  workPostings?: InputMaybe<Array<InputMaybe<WorkPostingModelInput>>>;
  workSchedule?: InputMaybe<WorkScheduleModelInput>;
};

export type WorkRequestPatchModelInput = {
  accountablePersonUid?: InputMaybe<Scalars['String']['input']>;
  businessSiteUid?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUid?: InputMaybe<Scalars['String']['input']>;
  costCenterUids?: InputMaybe<CostCenterUidsModelInput>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  customTimeSeries?: InputMaybe<Array<InputMaybe<CustomTimeSeriesModelInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialFields?: InputMaybe<Array<InputMaybe<CustomFieldModelInput>>>;
  holidaySchedule?: InputMaybe<HolidayScheduleImportableReferenceModelInput>;
  mspUid?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  remoteWorkAddress?: InputMaybe<AddressModelInput>;
  status?: InputMaybe<WorkRequestStatusModel>;
  supervisoryOrgUid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workLocationType?: InputMaybe<WorkRequestLocationTypeModel>;
  workSchedule?: InputMaybe<WorkScheduleImportableReferenceModelInput>;
};

export type WorkRequestRevisionModel = RevisionModel & {
  __typename?: 'WorkRequestRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  /** @deprecated Does not produce an explicit graphql schema type */
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousWorkRequest?: Maybe<WorkRequestModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
  workRequest?: Maybe<WorkRequestModel>;
};

export type WorkRequestSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<WorkRequestSortTypeModel>;
};

export enum WorkRequestSortTypeModel {
  CreatedDate = 'CREATED_DATE',
  Id = 'ID',
  LastModified = 'LAST_MODIFIED',
  Status = 'STATUS',
  Title = 'TITLE'
}

export enum WorkRequestStatusModel {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Filled = 'FILLED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type WorkRequestsModel = {
  __typename?: 'WorkRequestsModel';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<WorkRequestModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkRequestsQueryModelInput = {
  createdDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modifiedDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkRequestStatusModel>;
  statuses?: InputMaybe<Array<InputMaybe<WorkRequestStatusModel>>>;
};

export type WorkScheduleCreationModelInput = {
  active: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<EnumMap_DayOfWeek_DoubleInput>;
  dueDayOffset: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  standardDailyHours: Scalars['Float']['input'];
  startDay?: InputMaybe<DayOfWeek>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
};

export type WorkScheduleImportableReferenceModelInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type WorkScheduleModel = {
  __typename?: 'WorkScheduleModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['Map_DayOfWeek_DoubleScalar']['output']>;
  created?: Maybe<Scalars['OffsetDateTime']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  dueDayOffset?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['OffsetDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  standardDailyHours?: Maybe<Scalars['Float']['output']>;
  startDay?: Maybe<DayOfWeek>;
  uid: Scalars['String']['output'];
  workingWeekdays?: Maybe<Array<Maybe<DayOfWeek>>>;
};


export type WorkScheduleModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkScheduleModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['Map_DayOfWeek_DoubleScalar']['input']>;
  created?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  customResourcePermissions?: InputMaybe<Scalars['CustomResourcePermissionsModelScalar']['input']>;
  dueDayOffset?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['PermissionsModelScalar']['input']>;
  standardDailyHours?: InputMaybe<Scalars['Float']['input']>;
  startDay?: InputMaybe<DayOfWeek>;
  uid?: InputMaybe<Scalars['String']['input']>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
};

export type WorkScheduleUpdateModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<EnumMap_DayOfWeek_DoubleInput>;
  dueDayOffset?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  standardDailyHours?: InputMaybe<Scalars['Float']['input']>;
  startDay?: InputMaybe<DayOfWeek>;
  workingWeekdays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
};

export type WorkSchedulesModel = {
  __typename?: 'WorkSchedulesModel';
  items?: Maybe<Array<Maybe<WorkScheduleModel>>>;
};

export type WorkdayConfigModel = {
  __typename?: 'WorkdayConfigModel';
  syncReferences?: Maybe<Array<Maybe<WorkdaySyncReferenceConfigModel>>>;
};

export type WorkdayReferenceIdsByTypeQueryModelInput = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type WorkdaySecretsModel = {
  __typename?: 'WorkdaySecretsModel';
  isuPassword?: Maybe<Scalars['String']['output']>;
  isuUsername?: Maybe<Scalars['String']['output']>;
  transactionLogSubscriberWid?: Maybe<Scalars['String']['output']>;
  webServicesEndpoint?: Maybe<Scalars['String']['output']>;
};

export type WorkdaySecretsUpdateModelInput = {
  isuPassword?: InputMaybe<Scalars['String']['input']>;
  isuUsername?: InputMaybe<Scalars['String']['input']>;
  transactionLogSubscriberWid?: InputMaybe<Scalars['String']['input']>;
  webServicesEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export type WorkdaySyncReferenceConfigModel = {
  __typename?: 'WorkdaySyncReferenceConfigModel';
  merge: Scalars['Boolean']['output'];
  referenceIdType?: Maybe<Scalars['String']['output']>;
};

export enum WorkdaySyncTypeModel {
  Delta = 'DELTA',
  Full = 'FULL'
}

export type WorkerCertificationCreateModelInput = {
  attachmentMediaUid?: InputMaybe<Scalars['String']['input']>;
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  certificationUid?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  examinationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  examinationScore?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
  validationBy?: InputMaybe<Scalars['String']['input']>;
  validationComment?: InputMaybe<Scalars['String']['input']>;
  validationDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  validationRequestDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  validationStatus?: InputMaybe<WorkerQualificationValidationStatusModel>;
};

export type WorkerCertificationModel = WorkerQualificationModel & {
  __typename?: 'WorkerCertificationModel';
  attachment?: Maybe<WorkerQualificationAttachmentModel>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  certification?: Maybe<CertificationModel>;
  complianceStatus?: Maybe<ComplianceStatusModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  effectiveEndDate?: Maybe<Scalars['LocalDate']['output']>;
  effectiveStartDate?: Maybe<Scalars['LocalDate']['output']>;
  engagements?: Maybe<Array<Maybe<EngagementModel>>>;
  examinationDate?: Maybe<Scalars['LocalDate']['output']>;
  examinationScore?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  uid: Scalars['String']['output'];
  validationBy?: Maybe<Scalars['String']['output']>;
  validationComment?: Maybe<Scalars['String']['output']>;
  validationDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  validationRequestDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  validationStatus?: Maybe<WorkerQualificationValidationStatusModel>;
};


export type WorkerCertificationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerCertificationPatchModelInput = {
  attachmentMediaUid?: InputMaybe<Scalars['String']['input']>;
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  examinationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  examinationScore?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  validationBy?: InputMaybe<Scalars['String']['input']>;
  validationComment?: InputMaybe<Scalars['String']['input']>;
  validationDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  validationRequestDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  validationStatus?: InputMaybe<WorkerQualificationValidationStatusModel>;
};

export type WorkerDuplicateModel = {
  __typename?: 'WorkerDuplicateModel';
  applicantId?: Maybe<Scalars['String']['output']>;
  businessTitle?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  companyWorkerId?: Maybe<Scalars['String']['output']>;
  contingentWorkerType?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hiringManager?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  matchReason?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Scalars['String']['output']>;
  primaryWorkEmail?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  ssnMasked?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  universalId?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workdayWorkerId?: Maybe<Scalars['String']['output']>;
  workerStatus?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
};

export type WorkerDuplicateModelInput = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
  businessTitle?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  companyWorkerId?: InputMaybe<Scalars['String']['input']>;
  contingentWorkerType?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hiringManager?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  matchReason?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Scalars['String']['input']>;
  primaryWorkEmail?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  ssnMasked?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  universalId?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workdayWorkerId?: InputMaybe<Scalars['String']['input']>;
  workerStatus?: InputMaybe<Scalars['String']['input']>;
  workerType?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerEngagementModel = {
  __typename?: 'WorkerEngagementModel';
  cachedTypedUid?: Maybe<Scalars['String']['output']>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  engagement?: Maybe<EngagementModel>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  uid: Scalars['String']['output'];
  worker?: Maybe<PersonModel>;
};


export type WorkerEngagementModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerEngagementOrgLevelQueryModelInput = {
  level?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerEngagementOrgQueryModelInput = {
  includeSubOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkerEngagementTimeEntryTypeQueryModel {
  Clock = 'CLOCK',
  Hours = 'HOURS'
}

export type WorkerEngagementsModel = {
  __typename?: 'WorkerEngagementsModel';
  elements?: Maybe<Array<Maybe<WorkerEngagementModel>>>;
  /** @deprecated in favour of pageInfo.first */
  limit?: Maybe<Scalars['Int']['output']>;
  /** @deprecated in favour of pageInfo.offset */
  offset?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfoModel>;
  /** @deprecated in favour of pageInfo.totalCount */
  totalCount?: Maybe<Scalars['Int']['output']>;
  workerEngagements?: Maybe<Array<Maybe<WorkerEngagementModel>>>;
};

export type WorkerEngagementsQueryModelInput = {
  accountablePersonUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aggregatedModifiedDates?: InputMaybe<DateRangeModelInput>;
  aggregatedModifiedRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  classificationType?: InputMaybe<ClassificationTypeModel>;
  classificationTypes?: InputMaybe<Array<InputMaybe<ClassificationTypeModel>>>;
  classificationUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  costCenterUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  createdDates?: InputMaybe<DateRangeModelInput>;
  customFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  customFieldsFilterMatch?: InputMaybe<CollectionFilterModel>;
  durations?: InputMaybe<Array<InputMaybe<EngagementDurationFilterModelInput>>>;
  endDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  endDates?: InputMaybe<DateRangeModelInput>;
  financialFieldFilters?: InputMaybe<Array<InputMaybe<CustomFieldFilterModelInput>>>;
  financialFieldsFilterMatch?: InputMaybe<CollectionFilterModel>;
  isManagedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  jobFamilyGroupUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobFamilyUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobProfileUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationFilter?: InputMaybe<LocationsFilterModelInput>;
  managedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  managerUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managingSources?: InputMaybe<Array<InputMaybe<EngagementManagingSourceModel>>>;
  mspUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgFilters?: InputMaybe<Array<InputMaybe<WorkerEngagementOrgQueryModelInput>>>;
  orgLevelFilters?: InputMaybe<Array<InputMaybe<WorkerEngagementOrgLevelQueryModelInput>>>;
  originalStartDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  originalStartDates?: InputMaybe<DateRangeModelInput>;
  personGenderReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  processDefinitionUid?: InputMaybe<Scalars['String']['input']>;
  relativeToDate?: InputMaybe<Scalars['LocalDate']['input']>;
  remoteWorkAddressFilter?: InputMaybe<RemoteWorkAddressFilterModelInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDateRelativeDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  startDates?: InputMaybe<DateRangeModelInput>;
  statuses?: InputMaybe<Array<InputMaybe<EngagementStatusModel>>>;
  supplierUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terminationReasonUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeEntryType?: InputMaybe<WorkerEngagementTimeEntryTypeQueryModel>;
  timesheetSubmissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetView?: InputMaybe<TimesheetViewModel>;
  workLocationType?: InputMaybe<EngagementWorkLocationTypeModel>;
  workdaySyncTime?: InputMaybe<TimestampRangeModelInput>;
};

export type WorkerEngagementsSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<WorkerEngagementsSortTypeModel>;
};

export enum WorkerEngagementsSortTypeModel {
  AccountablePersonName = 'ACCOUNTABLE_PERSON_NAME',
  ClassificationName = 'CLASSIFICATION_NAME',
  CompanyName = 'COMPANY_NAME',
  Created = 'CREATED',
  EndDate = 'END_DATE',
  LastModifiedTime = 'LAST_MODIFIED_TIME',
  LocationName = 'LOCATION_NAME',
  MspName = 'MSP_NAME',
  OrganizationName = 'ORGANIZATION_NAME',
  PersonName = 'PERSON_NAME',
  ProjectName = 'PROJECT_NAME',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  SupplierName = 'SUPPLIER_NAME',
  Title = 'TITLE'
}

export type WorkerOrgLevelFilterModelInput = {
  level?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerQualificationAttachmentModel = {
  __typename?: 'WorkerQualificationAttachmentModel';
  media?: Maybe<MediaModel>;
};

export type WorkerQualificationCreateModelInput = {
  certification?: InputMaybe<WorkerCertificationCreateModelInput>;
};

export type WorkerQualificationEligibilityRequirementFilterModelInput = {
  issuer?: InputMaybe<StringFilterModelInput>;
  name?: InputMaybe<StringFilterModelInput>;
  uid?: InputMaybe<UidFilterModelInput>;
};

export type WorkerQualificationEngagementFilterModelInput = {
  countryCode?: InputMaybe<StringFilterModelInput>;
  jobProfileUid?: InputMaybe<UidFilterModelInput>;
  managerUid?: InputMaybe<UidFilterModelInput>;
  supplierUid?: InputMaybe<UidFilterModelInput>;
  uid?: InputMaybe<UidFilterModelInput>;
};

export type WorkerQualificationFilterModelInput = {
  complianceStatus?: InputMaybe<ComplianceStatusFilterModelInput>;
  effectiveEndDate?: InputMaybe<DateFilterModelInput>;
  effectiveEndDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  effectiveStartDate?: InputMaybe<DateFilterModelInput>;
  effectiveStartDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  eligibilityRequirement?: InputMaybe<WorkerQualificationEligibilityRequirementFilterModelInput>;
  engagement?: InputMaybe<WorkerQualificationEngagementFilterModelInput>;
  expirationDate?: InputMaybe<DateFilterModelInput>;
  expirationDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  issueDate?: InputMaybe<DateFilterModelInput>;
  issueDateRange?: InputMaybe<RelativeDateRangeModelInput>;
  person?: InputMaybe<WorkerQualificationPersonFilterModelInput>;
  uid?: InputMaybe<UidFilterModelInput>;
  validationStatus?: InputMaybe<WorkerQualificationValidationStatusFilterModelInput>;
};

export type WorkerQualificationModel = {
  complianceStatus?: Maybe<ComplianceStatusModel>;
  customResourcePermissions?: Maybe<Scalars['CustomResourcePermissionsModelScalar']['output']>;
  effectiveEndDate?: Maybe<Scalars['LocalDate']['output']>;
  effectiveStartDate?: Maybe<Scalars['LocalDate']['output']>;
  engagements?: Maybe<Array<Maybe<EngagementModel>>>;
  permissions?: Maybe<Scalars['PermissionsModelScalar']['output']>;
  person?: Maybe<PersonModel>;
  uid: Scalars['String']['output'];
  validationBy?: Maybe<Scalars['String']['output']>;
  validationComment?: Maybe<Scalars['String']['output']>;
  validationDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  validationRequestDateTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  validationStatus?: Maybe<WorkerQualificationValidationStatusModel>;
};


export type WorkerQualificationModelPermissionsArgs = {
  skipPermissionsEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerQualificationPatchModelInput = {
  certification?: InputMaybe<WorkerCertificationPatchModelInput>;
};

export type WorkerQualificationPersonFilterModelInput = {
  uid?: InputMaybe<UidFilterModelInput>;
};

export type WorkerQualificationRevisionModel = RevisionModel & {
  __typename?: 'WorkerQualificationRevisionModel';
  actorUser?: Maybe<PersonModel>;
  changeSet?: Maybe<ChangeSetModel>;
  changedFields?: Maybe<Array<Maybe<RevisionFieldChangesModel>>>;
  changes?: Maybe<Scalars['Map_RevisionFieldChangeModel_List_FieldReferenceModelScalar']['output']>;
  currentWorkerQualification?: Maybe<WorkerQualificationModel>;
  originService?: Maybe<OriginServiceEnum>;
  originServiceAuditReferenceId?: Maybe<Scalars['String']['output']>;
  previousWorkerQualification?: Maybe<WorkerQualificationModel>;
  proxyingUser?: Maybe<PersonModel>;
  retroactiveChange?: Maybe<RetroactiveChangeModel>;
  sourceName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskModel>;
  taskDelegation?: Maybe<TaskDelegationModel>;
  timestamp?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type WorkerQualificationRootFilterModelInput = {
  or?: InputMaybe<Array<InputMaybe<WorkerQualificationFilterModelInput>>>;
};

export type WorkerQualificationValidationStatusFilterModelInput = {
  equals?: InputMaybe<WorkerQualificationValidationStatusModel>;
  includes?: InputMaybe<Array<InputMaybe<WorkerQualificationValidationStatusModel>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEquals?: InputMaybe<WorkerQualificationValidationStatusModel>;
  notIncludes?: InputMaybe<Array<InputMaybe<WorkerQualificationValidationStatusModel>>>;
};

export enum WorkerQualificationValidationStatusModel {
  Invalid = 'INVALID',
  InProgress = 'IN_PROGRESS',
  Valid = 'VALID'
}

export type WorkerQualificationsModel = {
  __typename?: 'WorkerQualificationsModel';
  items?: Maybe<Array<Maybe<WorkerQualificationModel>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkerSortModelInput = {
  reversed: Scalars['Boolean']['input'];
  type?: InputMaybe<WorkerSortTypeModel>;
};

export enum WorkerSortTypeModel {
  Company = 'COMPANY',
  ContractEnding = 'CONTRACT_ENDING',
  ContractStarted = 'CONTRACT_STARTED',
  CostCenter = 'COST_CENTER',
  CurrentEngagementsCount = 'CURRENT_ENGAGEMENTS_COUNT',
  JobProfile = 'JOB_PROFILE',
  LastLogin = 'LAST_LOGIN',
  Location = 'LOCATION',
  Name = 'NAME',
  Org = 'ORG',
  PreviousEngagementsCount = 'PREVIOUS_ENGAGEMENTS_COUNT',
  Supplier = 'SUPPLIER',
  TenureDuration = 'TENURE_DURATION',
  TenureStartDate = 'TENURE_START_DATE',
  UnclaimedProfile = 'UNCLAIMED_PROFILE',
  UserRole = 'USER_ROLE',
  WorkerId = 'WORKER_ID',
  WorkerType = 'WORKER_TYPE'
}

export type WorkersModel = {
  __typename?: 'WorkersModel';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  workers?: Maybe<Array<Maybe<PersonModel>>>;
};

export type WorkersTotalCountModel = {
  __typename?: 'WorkersTotalCountModel';
  cachedTypedUid?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  nonEmployees?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  unknown?: Maybe<Scalars['Int']['output']>;
};
